export default {

  /**
   * 城市列表
   */
  pinganChinaAreaList(){
    const  area = [{"children":[{"children":[{"cityId":"110100","label":"东城区","provinceId":"110000","value":"110101"},{"cityId":"110100","label":"西城区","provinceId":"110000","value":"110102"},{"cityId":"110100","label":"崇文区","provinceId":"110000","value":"110103"},{"cityId":"110100","label":"宣武区","provinceId":"110000","value":"110104"},{"cityId":"110100","label":"朝阳区","provinceId":"110000","value":"110105"},{"cityId":"110100","label":"丰台区","provinceId":"110000","value":"110106"},{"cityId":"110100","label":"石景山区","provinceId":"110000","value":"110107"},{"cityId":"110100","label":"海淀区","provinceId":"110000","value":"110108"},{"cityId":"110100","label":"门头沟区","provinceId":"110000","value":"110109"},{"cityId":"110100","label":"房山区","provinceId":"110000","value":"110111"},{"cityId":"110100","label":"通州区","provinceId":"110000","value":"110112"},{"cityId":"110100","label":"顺义区","provinceId":"110000","value":"110113"},{"cityId":"110100","label":"昌平区","provinceId":"110000","value":"110114"},{"cityId":"110100","label":"大兴区","provinceId":"110000","value":"110115"},{"cityId":"110100","label":"怀柔区","provinceId":"110000","value":"110116"},{"cityId":"110100","label":"平谷区","provinceId":"110000","value":"110117"},{"cityId":"110100","label":"密云区","provinceId":"110000","value":"110128"},{"cityId":"110100","label":"延庆区","provinceId":"110000","value":"110129"},{"cityId":"110100","label":"经济技术开发区","provinceId":"110000","value":"110134"}],"label":"北京市","provinceId":"110000","value":"110100"}],"label":"北京市","value":"110000"},{"children":[{"children":[{"cityId":"120100","label":"和平区","provinceId":"120000","value":"120101"},{"cityId":"120100","label":"河东区","provinceId":"120000","value":"120102"},{"cityId":"120100","label":"河西区","provinceId":"120000","value":"120103"},{"cityId":"120100","label":"南开区","provinceId":"120000","value":"120104"},{"cityId":"120100","label":"河北区","provinceId":"120000","value":"120105"},{"cityId":"120100","label":"红桥区","provinceId":"120000","value":"120106"},{"cityId":"120100","label":"塘沽区","provinceId":"120000","value":"120107"},{"cityId":"120100","label":"汉沽区","provinceId":"120000","value":"120108"},{"cityId":"120100","label":"滨海新区","provinceId":"120000","value":"120109"},{"cityId":"120100","label":"东丽区","provinceId":"120000","value":"120110"},{"cityId":"120100","label":"西青区","provinceId":"120000","value":"120111"},{"cityId":"120100","label":"津南区","provinceId":"120000","value":"120112"},{"cityId":"120100","label":"北辰区","provinceId":"120000","value":"120113"},{"cityId":"120100","label":"武清区","provinceId":"120000","value":"120114"},{"cityId":"120100","label":"宝坻区","provinceId":"120000","value":"120115"},{"cityId":"120100","label":"宁河区","provinceId":"120000","value":"120116"},{"cityId":"120100","label":"静海区","provinceId":"120000","value":"120117"},{"cityId":"120100","label":"蓟州区","provinceId":"120000","value":"120118"}],"label":"天津市","provinceId":"120000","value":"120100"}],"label":"天津市","value":"120000"},{"children":[{"children":[{"cityId":"130100","label":"长安区","provinceId":"130000","value":"130102"},{"cityId":"130100","label":"桥东区","provinceId":"130000","value":"130103"},{"cityId":"130100","label":"桥西区","provinceId":"130000","value":"130104"},{"cityId":"130100","label":"新华区","provinceId":"130000","value":"130105"},{"cityId":"130100","label":"井陉矿区","provinceId":"130000","value":"130107"},{"cityId":"130100","label":"裕华区","provinceId":"130000","value":"130108"},{"cityId":"130100","label":"井陉县","provinceId":"130000","value":"130121"},{"cityId":"130100","label":"正定县","provinceId":"130000","value":"130123"},{"cityId":"130100","label":"栾城区","provinceId":"130000","value":"130124"},{"cityId":"130100","label":"行唐县","provinceId":"130000","value":"130125"},{"cityId":"130100","label":"灵寿县","provinceId":"130000","value":"130126"},{"cityId":"130100","label":"高邑县","provinceId":"130000","value":"130127"},{"cityId":"130100","label":"深泽县","provinceId":"130000","value":"130128"},{"cityId":"130100","label":"赞皇县","provinceId":"130000","value":"130129"},{"cityId":"130100","label":"无极县","provinceId":"130000","value":"130130"},{"cityId":"130100","label":"平山县","provinceId":"130000","value":"130131"},{"cityId":"130100","label":"元氏县","provinceId":"130000","value":"130132"},{"cityId":"130100","label":"赵县","provinceId":"130000","value":"130133"},{"cityId":"130100","label":"辛集市","provinceId":"130000","value":"130181"},{"cityId":"130100","label":"藁城区","provinceId":"130000","value":"130182"},{"cityId":"130100","label":"晋州市","provinceId":"130000","value":"130183"},{"cityId":"130100","label":"新乐市","provinceId":"130000","value":"130184"},{"cityId":"130100","label":"鹿泉区","provinceId":"130000","value":"130185"}],"label":"石家庄市","provinceId":"130000","value":"130100"},{"children":[{"cityId":"130200","label":"路南区","provinceId":"130000","value":"130202"},{"cityId":"130200","label":"路北区","provinceId":"130000","value":"130203"},{"cityId":"130200","label":"古冶区","provinceId":"130000","value":"130204"},{"cityId":"130200","label":"开平区","provinceId":"130000","value":"130205"},{"cityId":"130200","label":"丰南区","provinceId":"130000","value":"130207"},{"cityId":"130200","label":"丰润区","provinceId":"130000","value":"130208"},{"cityId":"130200","label":"滦县","provinceId":"130000","value":"130223"},{"cityId":"130200","label":"滦南县","provinceId":"130000","value":"130224"},{"cityId":"130200","label":"乐亭县","provinceId":"130000","value":"130225"},{"cityId":"130200","label":"迁西县","provinceId":"130000","value":"130227"},{"cityId":"130200","label":"玉田县","provinceId":"130000","value":"130229"},{"cityId":"130200","label":"曹妃甸区","provinceId":"130000","value":"130230"},{"cityId":"130200","label":"遵化市","provinceId":"130000","value":"130281"},{"cityId":"130200","label":"迁安市","provinceId":"130000","value":"130283"}],"label":"唐山市","provinceId":"130000","value":"130200"},{"children":[{"cityId":"130300","label":"海港区","provinceId":"130000","value":"130302"},{"cityId":"130300","label":"山海关区","provinceId":"130000","value":"130303"},{"cityId":"130300","label":"北戴河区","provinceId":"130000","value":"130304"},{"cityId":"130300","label":"青龙满族自治县","provinceId":"130000","value":"130321"},{"cityId":"130300","label":"昌黎县","provinceId":"130000","value":"130322"},{"cityId":"130300","label":"抚宁区","provinceId":"130000","value":"130323"},{"cityId":"130300","label":"卢龙县","provinceId":"130000","value":"130324"}],"label":"秦皇岛市","provinceId":"130000","value":"130300"},{"children":[{"cityId":"130400","label":"邯山区","provinceId":"130000","value":"130402"},{"cityId":"130400","label":"丛台区","provinceId":"130000","value":"130403"},{"cityId":"130400","label":"复兴区","provinceId":"130000","value":"130404"},{"cityId":"130400","label":"峰峰矿区","provinceId":"130000","value":"130406"},{"cityId":"130400","label":"邯郸县","provinceId":"130000","value":"130421"},{"cityId":"130400","label":"临漳县","provinceId":"130000","value":"130423"},{"cityId":"130400","label":"成安县","provinceId":"130000","value":"130424"},{"cityId":"130400","label":"大名县","provinceId":"130000","value":"130425"},{"cityId":"130400","label":"涉县","provinceId":"130000","value":"130426"},{"cityId":"130400","label":"磁县","provinceId":"130000","value":"130427"},{"cityId":"130400","label":"肥乡县","provinceId":"130000","value":"130428"},{"cityId":"130400","label":"永年县","provinceId":"130000","value":"130429"},{"cityId":"130400","label":"邱县","provinceId":"130000","value":"130430"},{"cityId":"130400","label":"鸡泽县","provinceId":"130000","value":"130431"},{"cityId":"130400","label":"广平县","provinceId":"130000","value":"130432"},{"cityId":"130400","label":"馆陶县","provinceId":"130000","value":"130433"},{"cityId":"130400","label":"魏县","provinceId":"130000","value":"130434"},{"cityId":"130400","label":"曲周县","provinceId":"130000","value":"130435"},{"cityId":"130400","label":"武安市","provinceId":"130000","value":"130481"}],"label":"邯郸市","provinceId":"130000","value":"130400"},{"children":[{"cityId":"130500","label":"桥东区","provinceId":"130000","value":"130502"},{"cityId":"130500","label":"桥西区","provinceId":"130000","value":"130503"},{"cityId":"130500","label":"邢台县","provinceId":"130000","value":"130521"},{"cityId":"130500","label":"临城县","provinceId":"130000","value":"130522"},{"cityId":"130500","label":"内丘县","provinceId":"130000","value":"130523"},{"cityId":"130500","label":"柏乡县","provinceId":"130000","value":"130524"},{"cityId":"130500","label":"隆尧县","provinceId":"130000","value":"130525"},{"cityId":"130500","label":"任县","provinceId":"130000","value":"130526"},{"cityId":"130500","label":"南和县","provinceId":"130000","value":"130527"},{"cityId":"130500","label":"宁晋县","provinceId":"130000","value":"130528"},{"cityId":"130500","label":"巨鹿县","provinceId":"130000","value":"130529"},{"cityId":"130500","label":"新河县","provinceId":"130000","value":"130530"},{"cityId":"130500","label":"广宗县","provinceId":"130000","value":"130531"},{"cityId":"130500","label":"平乡县","provinceId":"130000","value":"130532"},{"cityId":"130500","label":"威县","provinceId":"130000","value":"130533"},{"cityId":"130500","label":"清河县","provinceId":"130000","value":"130534"},{"cityId":"130500","label":"临西县","provinceId":"130000","value":"130535"},{"cityId":"130500","label":"南宫市","provinceId":"130000","value":"130581"},{"cityId":"130500","label":"沙河市","provinceId":"130000","value":"130582"}],"label":"邢台市","provinceId":"130000","value":"130500"},{"children":[{"cityId":"130600","label":"新市区","provinceId":"130000","value":"130602"},{"cityId":"130600","label":"北市区","provinceId":"130000","value":"130603"},{"cityId":"130600","label":"南市区","provinceId":"130000","value":"130604"},{"cityId":"130600","label":"竞秀区","provinceId":"130000","value":"130605"},{"cityId":"130600","label":"莲池区","provinceId":"130000","value":"130606"},{"cityId":"130600","label":"满城区","provinceId":"130000","value":"130621"},{"cityId":"130600","label":"清苑区","provinceId":"130000","value":"130622"},{"cityId":"130600","label":"涞水县","provinceId":"130000","value":"130623"},{"cityId":"130600","label":"阜平县","provinceId":"130000","value":"130624"},{"cityId":"130600","label":"徐水区","provinceId":"130000","value":"130625"},{"cityId":"130600","label":"定兴县","provinceId":"130000","value":"130626"},{"cityId":"130600","label":"唐县","provinceId":"130000","value":"130627"},{"cityId":"130600","label":"高阳县","provinceId":"130000","value":"130628"},{"cityId":"130600","label":"容城县","provinceId":"130000","value":"130629"},{"cityId":"130600","label":"涞源县","provinceId":"130000","value":"130630"},{"cityId":"130600","label":"望都县","provinceId":"130000","value":"130631"},{"cityId":"130600","label":"安新县","provinceId":"130000","value":"130632"},{"cityId":"130600","label":"易县","provinceId":"130000","value":"130633"},{"cityId":"130600","label":"曲阳县","provinceId":"130000","value":"130634"},{"cityId":"130600","label":"蠡县","provinceId":"130000","value":"130635"},{"cityId":"130600","label":"顺平县","provinceId":"130000","value":"130636"},{"cityId":"130600","label":"博野县","provinceId":"130000","value":"130637"},{"cityId":"130600","label":"雄县","provinceId":"130000","value":"130638"},{"cityId":"130600","label":"涿州市","provinceId":"130000","value":"130681"},{"cityId":"130600","label":"定州市","provinceId":"130000","value":"130682"},{"cityId":"130600","label":"安国市","provinceId":"130000","value":"130683"},{"cityId":"130600","label":"高碑店市","provinceId":"130000","value":"130684"}],"label":"保定市","provinceId":"130000","value":"130600"},{"children":[{"cityId":"130700","label":"桥东区","provinceId":"130000","value":"130702"},{"cityId":"130700","label":"桥西区","provinceId":"130000","value":"130703"},{"cityId":"130700","label":"宣化区","provinceId":"130000","value":"130705"},{"cityId":"130700","label":"下花园区","provinceId":"130000","value":"130706"},{"cityId":"130700","label":"宣化县","provinceId":"130000","value":"130721"},{"cityId":"130700","label":"张北县","provinceId":"130000","value":"130722"},{"cityId":"130700","label":"康保县","provinceId":"130000","value":"130723"},{"cityId":"130700","label":"沽源县","provinceId":"130000","value":"130724"},{"cityId":"130700","label":"尚义县","provinceId":"130000","value":"130725"},{"cityId":"130700","label":"蔚县","provinceId":"130000","value":"130726"},{"cityId":"130700","label":"阳原县","provinceId":"130000","value":"130727"},{"cityId":"130700","label":"怀安县","provinceId":"130000","value":"130728"},{"cityId":"130700","label":"万全区","provinceId":"130000","value":"130729"},{"cityId":"130700","label":"怀来县","provinceId":"130000","value":"130730"},{"cityId":"130700","label":"涿鹿县","provinceId":"130000","value":"130731"},{"cityId":"130700","label":"赤城县","provinceId":"130000","value":"130732"},{"cityId":"130700","label":"崇礼区","provinceId":"130000","value":"130733"}],"label":"张家口市","provinceId":"130000","value":"130700"},{"children":[{"cityId":"130800","label":"双桥区","provinceId":"130000","value":"130802"},{"cityId":"130800","label":"双滦区","provinceId":"130000","value":"130803"},{"cityId":"130800","label":"鹰手营子矿区","provinceId":"130000","value":"130804"},{"cityId":"130800","label":"承德县","provinceId":"130000","value":"130821"},{"cityId":"130800","label":"兴隆县","provinceId":"130000","value":"130822"},{"cityId":"130800","label":"平泉县","provinceId":"130000","value":"130823"},{"cityId":"130800","label":"滦平县","provinceId":"130000","value":"130824"},{"cityId":"130800","label":"隆化县","provinceId":"130000","value":"130825"},{"cityId":"130800","label":"丰宁满族自治县","provinceId":"130000","value":"130826"},{"cityId":"130800","label":"宽城满族自治县","provinceId":"130000","value":"130827"},{"cityId":"130800","label":"围场满族蒙古族自治县","provinceId":"130000","value":"130828"}],"label":"承德市","provinceId":"130000","value":"130800"},{"children":[{"cityId":"130900","label":"新华区","provinceId":"130000","value":"130902"},{"cityId":"130900","label":"运河区","provinceId":"130000","value":"130903"},{"cityId":"130900","label":"沧县","provinceId":"130000","value":"130921"},{"cityId":"130900","label":"青县","provinceId":"130000","value":"130922"},{"cityId":"130900","label":"东光县","provinceId":"130000","value":"130923"},{"cityId":"130900","label":"海兴县","provinceId":"130000","value":"130924"},{"cityId":"130900","label":"盐山县","provinceId":"130000","value":"130925"},{"cityId":"130900","label":"肃宁县","provinceId":"130000","value":"130926"},{"cityId":"130900","label":"南皮县","provinceId":"130000","value":"130927"},{"cityId":"130900","label":"吴桥县","provinceId":"130000","value":"130928"},{"cityId":"130900","label":"献县","provinceId":"130000","value":"130929"},{"cityId":"130900","label":"孟村回族自治县","provinceId":"130000","value":"130930"},{"cityId":"130900","label":"泊头市","provinceId":"130000","value":"130981"},{"cityId":"130900","label":"任丘市","provinceId":"130000","value":"130982"},{"cityId":"130900","label":"黄骅市","provinceId":"130000","value":"130983"},{"cityId":"130900","label":"河间市","provinceId":"130000","value":"130984"}],"label":"沧州市","provinceId":"130000","value":"130900"},{"children":[{"cityId":"131000","label":"安次区","provinceId":"130000","value":"131002"},{"cityId":"131000","label":"广阳区","provinceId":"130000","value":"131003"},{"cityId":"131000","label":"固安县","provinceId":"130000","value":"131022"},{"cityId":"131000","label":"永清县","provinceId":"130000","value":"131023"},{"cityId":"131000","label":"香河县","provinceId":"130000","value":"131024"},{"cityId":"131000","label":"大城县","provinceId":"130000","value":"131025"},{"cityId":"131000","label":"文安县","provinceId":"130000","value":"131026"},{"cityId":"131000","label":"大厂回族自治县","provinceId":"130000","value":"131028"},{"cityId":"131000","label":"霸州市","provinceId":"130000","value":"131081"},{"cityId":"131000","label":"三河市","provinceId":"130000","value":"131082"}],"label":"廊坊市","provinceId":"130000","value":"131000"},{"children":[{"cityId":"131100","label":"桃城区","provinceId":"130000","value":"131101"},{"cityId":"131100","label":"枣强县","provinceId":"130000","value":"131121"},{"cityId":"131100","label":"武邑县","provinceId":"130000","value":"131122"},{"cityId":"131100","label":"武强县","provinceId":"130000","value":"131123"},{"cityId":"131100","label":"饶阳县","provinceId":"130000","value":"131124"},{"cityId":"131100","label":"安平县","provinceId":"130000","value":"131125"},{"cityId":"131100","label":"故城县","provinceId":"130000","value":"131126"},{"cityId":"131100","label":"景县","provinceId":"130000","value":"131127"},{"cityId":"131100","label":"阜城县","provinceId":"130000","value":"131128"},{"cityId":"131100","label":"冀州区","provinceId":"130000","value":"131181"},{"cityId":"131100","label":"深州市","provinceId":"130000","value":"131182"}],"label":"衡水市","provinceId":"130000","value":"131100"}],"label":"河北省","value":"130000"},{"children":[{"children":[{"cityId":"140100","label":"小店区","provinceId":"140000","value":"140105"},{"cityId":"140100","label":"迎泽区","provinceId":"140000","value":"140106"},{"cityId":"140100","label":"杏花岭区","provinceId":"140000","value":"140107"},{"cityId":"140100","label":"尖草坪区","provinceId":"140000","value":"140108"},{"cityId":"140100","label":"万柏林区","provinceId":"140000","value":"140109"},{"cityId":"140100","label":"晋源区","provinceId":"140000","value":"140110"},{"cityId":"140100","label":"清徐县","provinceId":"140000","value":"140121"},{"cityId":"140100","label":"阳曲县","provinceId":"140000","value":"140122"},{"cityId":"140100","label":"娄烦县","provinceId":"140000","value":"140123"},{"cityId":"140100","label":"古交市","provinceId":"140000","value":"140181"},{"cityId":"140100","label":"晋中开发区","provinceId":"140000","value":"140189"}],"label":"太原市","provinceId":"140000","value":"140100"},{"children":[{"cityId":"140200","label":"城区","provinceId":"140000","value":"140202"},{"cityId":"140200","label":"矿区","provinceId":"140000","value":"140203"},{"cityId":"140200","label":"南郊区","provinceId":"140000","value":"140211"},{"cityId":"140200","label":"新荣区","provinceId":"140000","value":"140212"},{"cityId":"140200","label":"阳高县","provinceId":"140000","value":"140221"},{"cityId":"140200","label":"天镇县","provinceId":"140000","value":"140222"},{"cityId":"140200","label":"广灵县","provinceId":"140000","value":"140223"},{"cityId":"140200","label":"灵丘县","provinceId":"140000","value":"140224"},{"cityId":"140200","label":"浑源县","provinceId":"140000","value":"140225"},{"cityId":"140200","label":"左云县","provinceId":"140000","value":"140226"},{"cityId":"140200","label":"大同县","provinceId":"140000","value":"140227"}],"label":"大同市","provinceId":"140000","value":"140200"},{"children":[{"cityId":"140300","label":"城区","provinceId":"140000","value":"140302"},{"cityId":"140300","label":"矿区","provinceId":"140000","value":"140303"},{"cityId":"140300","label":"郊区","provinceId":"140000","value":"140311"},{"cityId":"140300","label":"平定县","provinceId":"140000","value":"140321"},{"cityId":"140300","label":"盂县","provinceId":"140000","value":"140322"}],"label":"阳泉市","provinceId":"140000","value":"140300"},{"children":[{"cityId":"140400","label":"城区","provinceId":"140000","value":"140402"},{"cityId":"140400","label":"郊区","provinceId":"140000","value":"140411"},{"cityId":"140400","label":"长治县","provinceId":"140000","value":"140421"},{"cityId":"140400","label":"襄垣县","provinceId":"140000","value":"140423"},{"cityId":"140400","label":"屯留县","provinceId":"140000","value":"140424"},{"cityId":"140400","label":"平顺县","provinceId":"140000","value":"140425"},{"cityId":"140400","label":"黎城县","provinceId":"140000","value":"140426"},{"cityId":"140400","label":"壶关县","provinceId":"140000","value":"140427"},{"cityId":"140400","label":"长子县","provinceId":"140000","value":"140428"},{"cityId":"140400","label":"武乡县","provinceId":"140000","value":"140429"},{"cityId":"140400","label":"沁县","provinceId":"140000","value":"140430"},{"cityId":"140400","label":"沁源县","provinceId":"140000","value":"140431"},{"cityId":"140400","label":"潞城市","provinceId":"140000","value":"140481"}],"label":"长治市","provinceId":"140000","value":"140400"},{"children":[{"cityId":"140500","label":"城区","provinceId":"140000","value":"140502"},{"cityId":"140500","label":"沁水县","provinceId":"140000","value":"140521"},{"cityId":"140500","label":"阳城县","provinceId":"140000","value":"140522"},{"cityId":"140500","label":"陵川县","provinceId":"140000","value":"140524"},{"cityId":"140500","label":"泽州县","provinceId":"140000","value":"140525"},{"cityId":"140500","label":"高平市","provinceId":"140000","value":"140581"}],"label":"晋城市","provinceId":"140000","value":"140500"},{"children":[{"cityId":"140600","label":"朔城区","provinceId":"140000","value":"140602"},{"cityId":"140600","label":"平鲁区","provinceId":"140000","value":"140603"},{"cityId":"140600","label":"山阴县","provinceId":"140000","value":"140621"},{"cityId":"140600","label":"应县","provinceId":"140000","value":"140622"},{"cityId":"140600","label":"右玉县","provinceId":"140000","value":"140623"},{"cityId":"140600","label":"怀仁县","provinceId":"140000","value":"140624"}],"label":"朔州市","provinceId":"140000","value":"140600"},{"children":[{"cityId":"140700","label":"榆次区","provinceId":"140000","value":"140702"},{"cityId":"140700","label":"榆社县","provinceId":"140000","value":"140721"},{"cityId":"140700","label":"左权县","provinceId":"140000","value":"140722"},{"cityId":"140700","label":"和顺县","provinceId":"140000","value":"140723"},{"cityId":"140700","label":"昔阳县","provinceId":"140000","value":"140724"},{"cityId":"140700","label":"寿阳县","provinceId":"140000","value":"140725"},{"cityId":"140700","label":"太谷县","provinceId":"140000","value":"140726"},{"cityId":"140700","label":"祁县","provinceId":"140000","value":"140727"},{"cityId":"140700","label":"平遥县","provinceId":"140000","value":"140728"},{"cityId":"140700","label":"灵石县","provinceId":"140000","value":"140729"},{"cityId":"140700","label":"介休市","provinceId":"140000","value":"140781"}],"label":"晋中市","provinceId":"140000","value":"140700"},{"children":[{"cityId":"140800","label":"盐湖区","provinceId":"140000","value":"140802"},{"cityId":"140800","label":"临猗县","provinceId":"140000","value":"140821"},{"cityId":"140800","label":"万荣县","provinceId":"140000","value":"140822"},{"cityId":"140800","label":"闻喜县","provinceId":"140000","value":"140823"},{"cityId":"140800","label":"稷山县","provinceId":"140000","value":"140824"},{"cityId":"140800","label":"新绛县","provinceId":"140000","value":"140825"},{"cityId":"140800","label":"绛县","provinceId":"140000","value":"140826"},{"cityId":"140800","label":"垣曲县","provinceId":"140000","value":"140827"},{"cityId":"140800","label":"夏县","provinceId":"140000","value":"140828"},{"cityId":"140800","label":"平陆县","provinceId":"140000","value":"140829"},{"cityId":"140800","label":"芮城县","provinceId":"140000","value":"140830"},{"cityId":"140800","label":"永济市","provinceId":"140000","value":"140881"},{"cityId":"140800","label":"河津市","provinceId":"140000","value":"140882"}],"label":"运城市","provinceId":"140000","value":"140800"},{"children":[{"cityId":"140900","label":"忻府区","provinceId":"140000","value":"140902"},{"cityId":"140900","label":"定襄县","provinceId":"140000","value":"140921"},{"cityId":"140900","label":"五台县","provinceId":"140000","value":"140922"},{"cityId":"140900","label":"代县","provinceId":"140000","value":"140923"},{"cityId":"140900","label":"繁峙县","provinceId":"140000","value":"140924"},{"cityId":"140900","label":"宁武县","provinceId":"140000","value":"140925"},{"cityId":"140900","label":"静乐县","provinceId":"140000","value":"140926"},{"cityId":"140900","label":"神池县","provinceId":"140000","value":"140927"},{"cityId":"140900","label":"五寨县","provinceId":"140000","value":"140928"},{"cityId":"140900","label":"岢岚县","provinceId":"140000","value":"140929"},{"cityId":"140900","label":"河曲县","provinceId":"140000","value":"140930"},{"cityId":"140900","label":"保德县","provinceId":"140000","value":"140931"},{"cityId":"140900","label":"偏关县","provinceId":"140000","value":"140932"},{"cityId":"140900","label":"原平市","provinceId":"140000","value":"140981"}],"label":"忻州市","provinceId":"140000","value":"140900"},{"children":[{"cityId":"141000","label":"尧都区","provinceId":"140000","value":"141002"},{"cityId":"141000","label":"曲沃县","provinceId":"140000","value":"141021"},{"cityId":"141000","label":"翼城县","provinceId":"140000","value":"141022"},{"cityId":"141000","label":"襄汾县","provinceId":"140000","value":"141023"},{"cityId":"141000","label":"洪洞县","provinceId":"140000","value":"141024"},{"cityId":"141000","label":"古县","provinceId":"140000","value":"141025"},{"cityId":"141000","label":"安泽县","provinceId":"140000","value":"141026"},{"cityId":"141000","label":"浮山县","provinceId":"140000","value":"141027"},{"cityId":"141000","label":"吉县","provinceId":"140000","value":"141028"},{"cityId":"141000","label":"乡宁县","provinceId":"140000","value":"141029"},{"cityId":"141000","label":"大宁县","provinceId":"140000","value":"141030"},{"cityId":"141000","label":"隰县","provinceId":"140000","value":"141031"},{"cityId":"141000","label":"永和县","provinceId":"140000","value":"141032"},{"cityId":"141000","label":"蒲　县","provinceId":"140000","value":"141033"},{"cityId":"141000","label":"汾西县","provinceId":"140000","value":"141034"},{"cityId":"141000","label":"侯马市","provinceId":"140000","value":"141081"},{"cityId":"141000","label":"霍州市","provinceId":"140000","value":"141082"}],"label":"临汾市","provinceId":"140000","value":"141000"},{"children":[{"cityId":"141100","label":"离石区","provinceId":"140000","value":"141102"},{"cityId":"141100","label":"文水县","provinceId":"140000","value":"141121"},{"cityId":"141100","label":"交城县","provinceId":"140000","value":"141122"},{"cityId":"141100","label":"兴县","provinceId":"140000","value":"141123"},{"cityId":"141100","label":"临县","provinceId":"140000","value":"141124"},{"cityId":"141100","label":"柳林县","provinceId":"140000","value":"141125"},{"cityId":"141100","label":"石楼县","provinceId":"140000","value":"141126"},{"cityId":"141100","label":"岚县","provinceId":"140000","value":"141127"},{"cityId":"141100","label":"方山县","provinceId":"140000","value":"141128"},{"cityId":"141100","label":"中阳县","provinceId":"140000","value":"141129"},{"cityId":"141100","label":"交口县","provinceId":"140000","value":"141130"},{"cityId":"141100","label":"孝义市","provinceId":"140000","value":"141181"},{"cityId":"141100","label":"汾阳市","provinceId":"140000","value":"141182"}],"label":"吕梁市","provinceId":"140000","value":"141100"}],"label":"山西省","value":"140000"},{"children":[{"children":[{"cityId":"150100","label":"新城区","provinceId":"150000","value":"150102"},{"cityId":"150100","label":"回民区","provinceId":"150000","value":"150103"},{"cityId":"150100","label":"玉泉区","provinceId":"150000","value":"150104"},{"cityId":"150100","label":"赛罕区","provinceId":"150000","value":"150105"},{"cityId":"150100","label":"土默特左旗","provinceId":"150000","value":"150121"},{"cityId":"150100","label":"托克托县","provinceId":"150000","value":"150122"},{"cityId":"150100","label":"和林格尔县","provinceId":"150000","value":"150123"},{"cityId":"150100","label":"清水河县","provinceId":"150000","value":"150124"},{"cityId":"150100","label":"武川县","provinceId":"150000","value":"150125"}],"label":"呼和浩特市","provinceId":"150000","value":"150100"},{"children":[{"cityId":"150200","label":"东河区","provinceId":"150000","value":"150202"},{"cityId":"150200","label":"昆都仑区","provinceId":"150000","value":"150203"},{"cityId":"150200","label":"青山区","provinceId":"150000","value":"150204"},{"cityId":"150200","label":"石拐区","provinceId":"150000","value":"150205"},{"cityId":"150200","label":"白云鄂博矿区","provinceId":"150000","value":"150206"},{"cityId":"150200","label":"九原区","provinceId":"150000","value":"150207"},{"cityId":"150200","label":"土默特右旗","provinceId":"150000","value":"150221"},{"cityId":"150200","label":"固阳县","provinceId":"150000","value":"150222"},{"cityId":"150200","label":"达尔罕茂明安联合旗","provinceId":"150000","value":"150223"}],"label":"包头市","provinceId":"150000","value":"150200"},{"children":[{"cityId":"150300","label":"海勃湾区","provinceId":"150000","value":"150302"},{"cityId":"150300","label":"海南区","provinceId":"150000","value":"150303"},{"cityId":"150300","label":"乌达区","provinceId":"150000","value":"150304"}],"label":"乌海市","provinceId":"150000","value":"150300"},{"children":[{"cityId":"150400","label":"红山区","provinceId":"150000","value":"150402"},{"cityId":"150400","label":"元宝山区","provinceId":"150000","value":"150403"},{"cityId":"150400","label":"松山区","provinceId":"150000","value":"150404"},{"cityId":"150400","label":"新城区","provinceId":"150000","value":"150405"},{"cityId":"150400","label":"阿鲁科尔沁旗","provinceId":"150000","value":"150421"},{"cityId":"150400","label":"巴林左旗","provinceId":"150000","value":"150422"},{"cityId":"150400","label":"巴林右旗","provinceId":"150000","value":"150423"},{"cityId":"150400","label":"林西县","provinceId":"150000","value":"150424"},{"cityId":"150400","label":"克什克腾旗","provinceId":"150000","value":"150425"},{"cityId":"150400","label":"翁牛特旗","provinceId":"150000","value":"150426"},{"cityId":"150400","label":"喀喇沁旗","provinceId":"150000","value":"150428"},{"cityId":"150400","label":"宁城县","provinceId":"150000","value":"150429"},{"cityId":"150400","label":"敖汉旗","provinceId":"150000","value":"150430"}],"label":"赤峰市","provinceId":"150000","value":"150400"},{"children":[{"cityId":"150500","label":"科尔沁区","provinceId":"150000","value":"150502"},{"cityId":"150500","label":"经济技术开发区","provinceId":"150000","value":"150503"},{"cityId":"150500","label":"科尔沁左翼中旗","provinceId":"150000","value":"150521"},{"cityId":"150500","label":"科尔沁左翼后旗","provinceId":"150000","value":"150522"},{"cityId":"150500","label":"开鲁县","provinceId":"150000","value":"150523"},{"cityId":"150500","label":"库伦旗","provinceId":"150000","value":"150524"},{"cityId":"150500","label":"奈曼旗","provinceId":"150000","value":"150525"},{"cityId":"150500","label":"扎鲁特旗","provinceId":"150000","value":"150526"},{"cityId":"150500","label":"霍林郭勒市","provinceId":"150000","value":"150581"}],"label":"通辽市","provinceId":"150000","value":"150500"},{"children":[{"cityId":"150600","label":"东胜区","provinceId":"150000","value":"150602"},{"cityId":"150600","label":"康巴什区","provinceId":"150000","value":"150603"},{"cityId":"150600","label":"达拉特旗","provinceId":"150000","value":"150621"},{"cityId":"150600","label":"准格尔旗","provinceId":"150000","value":"150622"},{"cityId":"150600","label":"鄂托克前旗","provinceId":"150000","value":"150623"},{"cityId":"150600","label":"鄂托克旗","provinceId":"150000","value":"150624"},{"cityId":"150600","label":"杭锦旗","provinceId":"150000","value":"150625"},{"cityId":"150600","label":"乌审旗","provinceId":"150000","value":"150626"},{"cityId":"150600","label":"伊金霍洛旗","provinceId":"150000","value":"150627"}],"label":"鄂尔多斯市","provinceId":"150000","value":"150600"},{"children":[{"cityId":"150700","label":"海拉尔区","provinceId":"150000","value":"150702"},{"cityId":"150700","label":"扎赉诺尔区","provinceId":"150000","value":"150703"},{"cityId":"150700","label":"阿荣旗","provinceId":"150000","value":"150721"},{"cityId":"150700","label":"莫力达瓦达斡尔族自治旗","provinceId":"150000","value":"150722"},{"cityId":"150700","label":"鄂伦春自治旗","provinceId":"150000","value":"150723"},{"cityId":"150700","label":"鄂温克族自治旗","provinceId":"150000","value":"150724"},{"cityId":"150700","label":"陈巴尔虎旗","provinceId":"150000","value":"150725"},{"cityId":"150700","label":"新巴尔虎左旗","provinceId":"150000","value":"150726"},{"cityId":"150700","label":"新巴尔虎右旗","provinceId":"150000","value":"150727"},{"cityId":"150700","label":"满洲里市","provinceId":"150000","value":"150781"},{"cityId":"150700","label":"牙克石市","provinceId":"150000","value":"150782"},{"cityId":"150700","label":"扎兰屯市","provinceId":"150000","value":"150783"},{"cityId":"150700","label":"额尔古纳市","provinceId":"150000","value":"150784"},{"cityId":"150700","label":"根河市","provinceId":"150000","value":"150785"}],"label":"呼伦贝尔市","provinceId":"150000","value":"150700"},{"children":[{"cityId":"150800","label":"临河区","provinceId":"150000","value":"150802"},{"cityId":"150800","label":"五原县","provinceId":"150000","value":"150821"},{"cityId":"150800","label":"磴口县","provinceId":"150000","value":"150822"},{"cityId":"150800","label":"乌拉特前旗","provinceId":"150000","value":"150823"},{"cityId":"150800","label":"乌拉特中旗","provinceId":"150000","value":"150824"},{"cityId":"150800","label":"乌拉特后旗","provinceId":"150000","value":"150825"},{"cityId":"150800","label":"杭锦后旗","provinceId":"150000","value":"150826"}],"label":"巴彦淖尔市","provinceId":"150000","value":"150800"},{"children":[{"cityId":"150900","label":"集宁区","provinceId":"150000","value":"150902"},{"cityId":"150900","label":"卓资县","provinceId":"150000","value":"150921"},{"cityId":"150900","label":"化德县","provinceId":"150000","value":"150922"},{"cityId":"150900","label":"商都县","provinceId":"150000","value":"150923"},{"cityId":"150900","label":"兴和县","provinceId":"150000","value":"150924"},{"cityId":"150900","label":"凉城县","provinceId":"150000","value":"150925"},{"cityId":"150900","label":"察哈尔右翼前旗","provinceId":"150000","value":"150926"},{"cityId":"150900","label":"察哈尔右翼中旗","provinceId":"150000","value":"150927"},{"cityId":"150900","label":"察哈尔右翼后旗","provinceId":"150000","value":"150928"},{"cityId":"150900","label":"四子王旗","provinceId":"150000","value":"150929"},{"cityId":"150900","label":"丰镇市","provinceId":"150000","value":"150981"}],"label":"乌兰察布市","provinceId":"150000","value":"150900"},{"children":[{"cityId":"152200","label":"乌兰浩特市","provinceId":"150000","value":"152201"},{"cityId":"152200","label":"阿尔山市","provinceId":"150000","value":"152202"},{"cityId":"152200","label":"科尔沁右翼前旗","provinceId":"150000","value":"152221"},{"cityId":"152200","label":"科尔沁右翼中旗","provinceId":"150000","value":"152222"},{"cityId":"152200","label":"扎赉特旗","provinceId":"150000","value":"152223"},{"cityId":"152200","label":"突泉县","provinceId":"150000","value":"152224"}],"label":"兴安盟","provinceId":"150000","value":"152200"},{"children":[{"cityId":"152500","label":"二连浩特市","provinceId":"150000","value":"152501"},{"cityId":"152500","label":"锡林浩特市","provinceId":"150000","value":"152502"},{"cityId":"152500","label":"阿巴嘎旗","provinceId":"150000","value":"152522"},{"cityId":"152500","label":"苏尼特左旗","provinceId":"150000","value":"152523"},{"cityId":"152500","label":"苏尼特右旗","provinceId":"150000","value":"152524"},{"cityId":"152500","label":"东乌珠穆沁旗","provinceId":"150000","value":"152525"},{"cityId":"152500","label":"西乌珠穆沁旗","provinceId":"150000","value":"152526"},{"cityId":"152500","label":"太仆寺旗","provinceId":"150000","value":"152527"},{"cityId":"152500","label":"镶黄旗","provinceId":"150000","value":"152528"},{"cityId":"152500","label":"正镶白旗","provinceId":"150000","value":"152529"},{"cityId":"152500","label":"正蓝旗","provinceId":"150000","value":"152530"},{"cityId":"152500","label":"多伦县","provinceId":"150000","value":"152531"}],"label":"锡林郭勒盟","provinceId":"150000","value":"152500"},{"children":[{"cityId":"152600","label":"集宁区","provinceId":"150000","value":"152601"},{"cityId":"152600","label":"卓资县","provinceId":"150000","value":"152602"},{"cityId":"152600","label":"化德县","provinceId":"150000","value":"152603"},{"cityId":"152600","label":"商都县","provinceId":"150000","value":"152604"},{"cityId":"152600","label":"兴和县","provinceId":"150000","value":"152605"},{"cityId":"152600","label":"凉城县","provinceId":"150000","value":"152606"},{"cityId":"152600","label":"四子王旗","provinceId":"150000","value":"152607"},{"cityId":"152600","label":"察哈尔右翼前旗","provinceId":"150000","value":"152608"},{"cityId":"152600","label":"察哈尔右翼中旗","provinceId":"150000","value":"152609"},{"cityId":"152600","label":"察哈尔右翼后旗","provinceId":"150000","value":"152610"},{"cityId":"152600","label":"丰镇市","provinceId":"150000","value":"152611"}],"label":"乌兰察布盟","provinceId":"150000","value":"152600"},{"children":[{"cityId":"152900","label":"阿拉善左旗","provinceId":"150000","value":"152921"},{"cityId":"152900","label":"阿拉善右旗","provinceId":"150000","value":"152922"},{"cityId":"152900","label":"额济纳旗","provinceId":"150000","value":"152923"}],"label":"阿拉善盟","provinceId":"150000","value":"152900"}],"label":"内蒙古自治区","value":"150000"},{"children":[{"children":[{"cityId":"210100","label":"和平区","provinceId":"210000","value":"210102"},{"cityId":"210100","label":"沈河区","provinceId":"210000","value":"210103"},{"cityId":"210100","label":"大东区","provinceId":"210000","value":"210104"},{"cityId":"210100","label":"皇姑区","provinceId":"210000","value":"210105"},{"cityId":"210100","label":"铁西区","provinceId":"210000","value":"210106"},{"cityId":"210100","label":"苏家屯区","provinceId":"210000","value":"210111"},{"cityId":"210100","label":"东陵区","provinceId":"210000","value":"210112"},{"cityId":"210100","label":"沈北新区","provinceId":"210000","value":"210113"},{"cityId":"210100","label":"于洪区","provinceId":"210000","value":"210114"},{"cityId":"210100","label":"浑南区","provinceId":"210000","value":"210115"},{"cityId":"210100","label":"辽中区","provinceId":"210000","value":"210122"},{"cityId":"210100","label":"康平县","provinceId":"210000","value":"210123"},{"cityId":"210100","label":"法库县","provinceId":"210000","value":"210124"},{"cityId":"210100","label":"沈阳市经济技术开发区","provinceId":"210000","value":"210131"},{"cityId":"210100","label":"新民市","provinceId":"210000","value":"210181"}],"label":"沈阳市","provinceId":"210000","value":"210100"},{"children":[{"cityId":"210200","label":"中山区","provinceId":"210000","value":"210202"},{"cityId":"210200","label":"西岗区","provinceId":"210000","value":"210203"},{"cityId":"210200","label":"沙河口区","provinceId":"210000","value":"210204"},{"cityId":"210200","label":"开发区","provinceId":"210000","value":"210205"},{"cityId":"210200","label":"保税区","provinceId":"210000","value":"210206"},{"cityId":"210200","label":"甘井子区","provinceId":"210000","value":"210211"},{"cityId":"210200","label":"旅顺口区","provinceId":"210000","value":"210212"},{"cityId":"210200","label":"金州区","provinceId":"210000","value":"210213"},{"cityId":"210200","label":"经济技术开发区","provinceId":"210000","value":"210214"},{"cityId":"210200","label":"高新园区","provinceId":"210000","value":"210221"},{"cityId":"210200","label":"普湾新区","provinceId":"210000","value":"210222"},{"cityId":"210200","label":"普兰店区","provinceId":"210000","value":"210223"},{"cityId":"210200","label":"长海县","provinceId":"210000","value":"210224"},{"cityId":"210200","label":"花园口经济区","provinceId":"210000","value":"210237"},{"cityId":"210200","label":"瓦房店市","provinceId":"210000","value":"210281"},{"cityId":"210200","label":"普兰店市","provinceId":"210000","value":"210282"},{"cityId":"210200","label":"庄河市","provinceId":"210000","value":"210283"}],"label":"大连市","provinceId":"210000","value":"210200"},{"children":[{"cityId":"210300","label":"铁东区","provinceId":"210000","value":"210302"},{"cityId":"210300","label":"铁西区","provinceId":"210000","value":"210303"},{"cityId":"210300","label":"立山区","provinceId":"210000","value":"210304"},{"cityId":"210300","label":"千山区","provinceId":"210000","value":"210311"},{"cityId":"210300","label":"台安县","provinceId":"210000","value":"210321"},{"cityId":"210300","label":"岫岩满族自治县","provinceId":"210000","value":"210323"},{"cityId":"210300","label":"海城市","provinceId":"210000","value":"210381"}],"label":"鞍山市","provinceId":"210000","value":"210300"},{"children":[{"cityId":"210400","label":"新抚区","provinceId":"210000","value":"210402"},{"cityId":"210400","label":"东洲区","provinceId":"210000","value":"210403"},{"cityId":"210400","label":"望花区","provinceId":"210000","value":"210404"},{"cityId":"210400","label":"顺城区","provinceId":"210000","value":"210411"},{"cityId":"210400","label":"抚顺县","provinceId":"210000","value":"210421"},{"cityId":"210400","label":"新宾满族自治县","provinceId":"210000","value":"210422"},{"cityId":"210400","label":"清原满族自治县","provinceId":"210000","value":"210423"}],"label":"抚顺市","provinceId":"210000","value":"210400"},{"children":[{"cityId":"210500","label":"平山区","provinceId":"210000","value":"210502"},{"cityId":"210500","label":"溪湖区","provinceId":"210000","value":"210503"},{"cityId":"210500","label":"明山区","provinceId":"210000","value":"210504"},{"cityId":"210500","label":"南芬区","provinceId":"210000","value":"210505"},{"cityId":"210500","label":"本溪满族自治县","provinceId":"210000","value":"210521"},{"cityId":"210500","label":"桓仁满族自治县","provinceId":"210000","value":"210522"}],"label":"本溪市","provinceId":"210000","value":"210500"},{"children":[{"cityId":"210600","label":"元宝区","provinceId":"210000","value":"210602"},{"cityId":"210600","label":"振兴区","provinceId":"210000","value":"210603"},{"cityId":"210600","label":"振安区","provinceId":"210000","value":"210604"},{"cityId":"210600","label":"宽甸满族自治县","provinceId":"210000","value":"210624"},{"cityId":"210600","label":"东港市","provinceId":"210000","value":"210681"},{"cityId":"210600","label":"凤城市","provinceId":"210000","value":"210682"}],"label":"丹东市","provinceId":"210000","value":"210600"},{"children":[{"cityId":"210700","label":"古塔区","provinceId":"210000","value":"210702"},{"cityId":"210700","label":"凌河区","provinceId":"210000","value":"210703"},{"cityId":"210700","label":"太和区","provinceId":"210000","value":"210711"},{"cityId":"210700","label":"黑山县","provinceId":"210000","value":"210726"},{"cityId":"210700","label":"义县","provinceId":"210000","value":"210727"},{"cityId":"210700","label":"凌海市","provinceId":"210000","value":"210781"},{"cityId":"210700","label":"北宁市","provinceId":"210000","value":"210782"},{"cityId":"210700","label":"北镇市","provinceId":"210000","value":"210783"}],"label":"锦州市","provinceId":"210000","value":"210700"},{"children":[{"cityId":"210800","label":"站前区","provinceId":"210000","value":"210802"},{"cityId":"210800","label":"西市区","provinceId":"210000","value":"210803"},{"cityId":"210800","label":"鲅鱼圈区","provinceId":"210000","value":"210804"},{"cityId":"210800","label":"老边区","provinceId":"210000","value":"210811"},{"cityId":"210800","label":"盖州市","provinceId":"210000","value":"210881"},{"cityId":"210800","label":"大石桥市","provinceId":"210000","value":"210882"}],"label":"营口市","provinceId":"210000","value":"210800"},{"children":[{"cityId":"210900","label":"海州区","provinceId":"210000","value":"210902"},{"cityId":"210900","label":"新邱区","provinceId":"210000","value":"210903"},{"cityId":"210900","label":"太平区","provinceId":"210000","value":"210904"},{"cityId":"210900","label":"清河门区","provinceId":"210000","value":"210905"},{"cityId":"210900","label":"细河区","provinceId":"210000","value":"210911"},{"cityId":"210900","label":"阜新蒙古族自治县","provinceId":"210000","value":"210921"},{"cityId":"210900","label":"彰武县","provinceId":"210000","value":"210922"}],"label":"阜新市","provinceId":"210000","value":"210900"},{"children":[{"cityId":"211000","label":"白塔区","provinceId":"210000","value":"211002"},{"cityId":"211000","label":"文圣区","provinceId":"210000","value":"211003"},{"cityId":"211000","label":"宏伟区","provinceId":"210000","value":"211004"},{"cityId":"211000","label":"弓长岭区","provinceId":"210000","value":"211005"},{"cityId":"211000","label":"太子河区","provinceId":"210000","value":"211011"},{"cityId":"211000","label":"辽阳县","provinceId":"210000","value":"211021"},{"cityId":"211000","label":"灯塔市","provinceId":"210000","value":"211081"}],"label":"辽阳市","provinceId":"210000","value":"211000"},{"children":[{"cityId":"211100","label":"双台子区","provinceId":"210000","value":"211102"},{"cityId":"211100","label":"兴隆台区","provinceId":"210000","value":"211103"},{"cityId":"211100","label":"辽河区","provinceId":"210000","value":"211110"},{"cityId":"211100","label":"大洼区","provinceId":"210000","value":"211121"},{"cityId":"211100","label":"盘山县","provinceId":"210000","value":"211122"}],"label":"盘锦市","provinceId":"210000","value":"211100"},{"children":[{"cityId":"211200","label":"银州区","provinceId":"210000","value":"211202"},{"cityId":"211200","label":"清河区","provinceId":"210000","value":"211204"},{"cityId":"211200","label":"凡河新区","provinceId":"210000","value":"211210"},{"cityId":"211200","label":"铁岭县","provinceId":"210000","value":"211221"},{"cityId":"211200","label":"西丰县","provinceId":"210000","value":"211223"},{"cityId":"211200","label":"昌图县","provinceId":"210000","value":"211224"},{"cityId":"211200","label":"调兵山市","provinceId":"210000","value":"211281"},{"cityId":"211200","label":"开原市","provinceId":"210000","value":"211282"}],"label":"铁岭市","provinceId":"210000","value":"211200"},{"children":[{"cityId":"211300","label":"双塔区","provinceId":"210000","value":"211302"},{"cityId":"211300","label":"龙城区","provinceId":"210000","value":"211303"},{"cityId":"211300","label":"朝阳县","provinceId":"210000","value":"211321"},{"cityId":"211300","label":"建平县","provinceId":"210000","value":"211322"},{"cityId":"211300","label":"喀喇沁左翼蒙古族自治县","provinceId":"210000","value":"211324"},{"cityId":"211300","label":"北票市","provinceId":"210000","value":"211381"},{"cityId":"211300","label":"凌源市","provinceId":"210000","value":"211382"}],"label":"朝阳市","provinceId":"210000","value":"211300"},{"children":[{"cityId":"211400","label":"连山区","provinceId":"210000","value":"211402"},{"cityId":"211400","label":"龙港区","provinceId":"210000","value":"211403"},{"cityId":"211400","label":"南票区","provinceId":"210000","value":"211404"},{"cityId":"211400","label":"绥中县","provinceId":"210000","value":"211421"},{"cityId":"211400","label":"建昌县","provinceId":"210000","value":"211422"},{"cityId":"211400","label":"兴城市","provinceId":"210000","value":"211481"}],"label":"葫芦岛市","provinceId":"210000","value":"211400"}],"label":"辽宁省","value":"210000"},{"children":[{"children":[{"cityId":"220100","label":"南关区","provinceId":"220000","value":"220102"},{"cityId":"220100","label":"宽城区","provinceId":"220000","value":"220103"},{"cityId":"220100","label":"朝阳区","provinceId":"220000","value":"220104"},{"cityId":"220100","label":"二道区","provinceId":"220000","value":"220105"},{"cityId":"220100","label":"绿园区","provinceId":"220000","value":"220106"},{"cityId":"220100","label":"双阳区","provinceId":"220000","value":"220112"},{"cityId":"220100","label":"净月经济开发区","provinceId":"220000","value":"220113"},{"cityId":"220100","label":"经济技术开发区","provinceId":"220000","value":"220114"},{"cityId":"220100","label":"高新技术产业开发区","provinceId":"220000","value":"220115"},{"cityId":"220100","label":"西新经济技术开发区","provinceId":"220000","value":"220116"},{"cityId":"220100","label":"农安县","provinceId":"220000","value":"220122"},{"cityId":"220100","label":"九台区","provinceId":"220000","value":"220181"},{"cityId":"220100","label":"榆树市","provinceId":"220000","value":"220182"},{"cityId":"220100","label":"德惠市","provinceId":"220000","value":"220183"}],"label":"长春市","provinceId":"220000","value":"220100"},{"children":[{"cityId":"220200","label":"昌邑区","provinceId":"220000","value":"220202"},{"cityId":"220200","label":"龙潭区","provinceId":"220000","value":"220203"},{"cityId":"220200","label":"船营区","provinceId":"220000","value":"220204"},{"cityId":"220200","label":"丰满区","provinceId":"220000","value":"220211"},{"cityId":"220200","label":"高新技术产业开发区","provinceId":"220000","value":"220212"},{"cityId":"220200","label":"经济技术开发区","provinceId":"220000","value":"220213"},{"cityId":"220200","label":"永吉县","provinceId":"220000","value":"220221"},{"cityId":"220200","label":"蛟河市","provinceId":"220000","value":"220281"},{"cityId":"220200","label":"桦甸市","provinceId":"220000","value":"220282"},{"cityId":"220200","label":"舒兰市","provinceId":"220000","value":"220283"},{"cityId":"220200","label":"磐石市","provinceId":"220000","value":"220284"}],"label":"吉林市","provinceId":"220000","value":"220200"},{"children":[{"cityId":"220300","label":"铁西区","provinceId":"220000","value":"220302"},{"cityId":"220300","label":"铁东区","provinceId":"220000","value":"220303"},{"cityId":"220300","label":"梨树县","provinceId":"220000","value":"220322"},{"cityId":"220300","label":"伊通满族自治县","provinceId":"220000","value":"220323"},{"cityId":"220300","label":"公主岭市","provinceId":"220000","value":"220381"},{"cityId":"220300","label":"双辽市","provinceId":"220000","value":"220382"}],"label":"四平市","provinceId":"220000","value":"220300"},{"children":[{"cityId":"220400","label":"龙山区","provinceId":"220000","value":"220402"},{"cityId":"220400","label":"西安区","provinceId":"220000","value":"220403"},{"cityId":"220400","label":"东丰县","provinceId":"220000","value":"220421"},{"cityId":"220400","label":"东辽县","provinceId":"220000","value":"220422"}],"label":"辽源市","provinceId":"220000","value":"220400"},{"children":[{"cityId":"220500","label":"东昌区","provinceId":"220000","value":"220502"},{"cityId":"220500","label":"二道江区","provinceId":"220000","value":"220503"},{"cityId":"220500","label":"通化县","provinceId":"220000","value":"220521"},{"cityId":"220500","label":"辉南县","provinceId":"220000","value":"220523"},{"cityId":"220500","label":"柳河县","provinceId":"220000","value":"220524"},{"cityId":"220500","label":"梅河口市","provinceId":"220000","value":"220581"},{"cityId":"220500","label":"集安市","provinceId":"220000","value":"220582"}],"label":"通化市","provinceId":"220000","value":"220500"},{"children":[{"cityId":"220600","label":"八道江区","provinceId":"220000","value":"220602"},{"cityId":"220600","label":"浑江区","provinceId":"220000","value":"220603"},{"cityId":"220600","label":"江源区","provinceId":"220000","value":"220605"},{"cityId":"220600","label":"抚松县","provinceId":"220000","value":"220621"},{"cityId":"220600","label":"靖宇县","provinceId":"220000","value":"220622"},{"cityId":"220600","label":"长白朝鲜族自治县","provinceId":"220000","value":"220623"},{"cityId":"220600","label":"江源县","provinceId":"220000","value":"220625"},{"cityId":"220600","label":"临江市","provinceId":"220000","value":"220681"}],"label":"白山市","provinceId":"220000","value":"220600"},{"children":[{"cityId":"220700","label":"宁江区","provinceId":"220000","value":"220702"},{"cityId":"220700","label":"经济技术开发区","provinceId":"220000","value":"220711"},{"cityId":"220700","label":"前郭尔罗斯蒙古族自治县","provinceId":"220000","value":"220721"},{"cityId":"220700","label":"长岭县","provinceId":"220000","value":"220722"},{"cityId":"220700","label":"乾安县","provinceId":"220000","value":"220723"},{"cityId":"220700","label":"扶余市","provinceId":"220000","value":"220724"}],"label":"松原市","provinceId":"220000","value":"220700"},{"children":[{"cityId":"220800","label":"洮北区","provinceId":"220000","value":"220802"},{"cityId":"220800","label":"镇赉县","provinceId":"220000","value":"220821"},{"cityId":"220800","label":"通榆县","provinceId":"220000","value":"220822"},{"cityId":"220800","label":"洮南市","provinceId":"220000","value":"220881"},{"cityId":"220800","label":"大安市","provinceId":"220000","value":"220882"}],"label":"白城市","provinceId":"220000","value":"220800"},{"children":[{"cityId":"222400","label":"延吉市","provinceId":"220000","value":"222401"},{"cityId":"222400","label":"图们市","provinceId":"220000","value":"222402"},{"cityId":"222400","label":"敦化市","provinceId":"220000","value":"222403"},{"cityId":"222400","label":"珲春市","provinceId":"220000","value":"222404"},{"cityId":"222400","label":"龙井市","provinceId":"220000","value":"222405"},{"cityId":"222400","label":"和龙市","provinceId":"220000","value":"222406"},{"cityId":"222400","label":"汪清县","provinceId":"220000","value":"222424"},{"cityId":"222400","label":"安图县","provinceId":"220000","value":"222426"}],"label":"延边朝鲜族自治州","provinceId":"220000","value":"222400"}],"label":"吉林省","value":"220000"},{"children":[{"children":[{"cityId":"230100","label":"道里区","provinceId":"230000","value":"230102"},{"cityId":"230100","label":"南岗区","provinceId":"230000","value":"230103"},{"cityId":"230100","label":"道外区","provinceId":"230000","value":"230104"},{"cityId":"230100","label":"平房区","provinceId":"230000","value":"230108"},{"cityId":"230100","label":"松北区","provinceId":"230000","value":"230109"},{"cityId":"230100","label":"香坊区","provinceId":"230000","value":"230110"},{"cityId":"230100","label":"呼兰区","provinceId":"230000","value":"230111"},{"cityId":"230100","label":"阿城区","provinceId":"230000","value":"230112"},{"cityId":"230100","label":"依兰县","provinceId":"230000","value":"230123"},{"cityId":"230100","label":"方正县","provinceId":"230000","value":"230124"},{"cityId":"230100","label":"宾县","provinceId":"230000","value":"230125"},{"cityId":"230100","label":"巴彦县","provinceId":"230000","value":"230126"},{"cityId":"230100","label":"木兰县","provinceId":"230000","value":"230127"},{"cityId":"230100","label":"通河县","provinceId":"230000","value":"230128"},{"cityId":"230100","label":"延寿县","provinceId":"230000","value":"230129"},{"cityId":"230100","label":"阿城市","provinceId":"230000","value":"230181"},{"cityId":"230100","label":"双城区","provinceId":"230000","value":"230182"},{"cityId":"230100","label":"尚志市","provinceId":"230000","value":"230183"},{"cityId":"230100","label":"五常市","provinceId":"230000","value":"230184"}],"label":"哈尔滨市","provinceId":"230000","value":"230100"},{"children":[{"cityId":"230200","label":"龙沙区","provinceId":"230000","value":"230202"},{"cityId":"230200","label":"建华区","provinceId":"230000","value":"230203"},{"cityId":"230200","label":"铁锋区","provinceId":"230000","value":"230204"},{"cityId":"230200","label":"昂昂溪区","provinceId":"230000","value":"230205"},{"cityId":"230200","label":"富拉尔基区","provinceId":"230000","value":"230206"},{"cityId":"230200","label":"碾子山区","provinceId":"230000","value":"230207"},{"cityId":"230200","label":"梅里斯达斡尔族区","provinceId":"230000","value":"230208"},{"cityId":"230200","label":"龙江县","provinceId":"230000","value":"230221"},{"cityId":"230200","label":"依安县","provinceId":"230000","value":"230223"},{"cityId":"230200","label":"泰来县","provinceId":"230000","value":"230224"},{"cityId":"230200","label":"甘南县","provinceId":"230000","value":"230225"},{"cityId":"230200","label":"富裕县","provinceId":"230000","value":"230227"},{"cityId":"230200","label":"克山县","provinceId":"230000","value":"230229"},{"cityId":"230200","label":"克东县","provinceId":"230000","value":"230230"},{"cityId":"230200","label":"拜泉县","provinceId":"230000","value":"230231"},{"cityId":"230200","label":"讷河市","provinceId":"230000","value":"230281"}],"label":"齐齐哈尔市","provinceId":"230000","value":"230200"},{"children":[{"cityId":"230300","label":"鸡冠区","provinceId":"230000","value":"230302"},{"cityId":"230300","label":"恒山区","provinceId":"230000","value":"230303"},{"cityId":"230300","label":"滴道区","provinceId":"230000","value":"230304"},{"cityId":"230300","label":"梨树区","provinceId":"230000","value":"230305"},{"cityId":"230300","label":"城子河区","provinceId":"230000","value":"230306"},{"cityId":"230300","label":"麻山区","provinceId":"230000","value":"230307"},{"cityId":"230300","label":"鸡东县","provinceId":"230000","value":"230321"},{"cityId":"230300","label":"虎林市","provinceId":"230000","value":"230381"},{"cityId":"230300","label":"密山市","provinceId":"230000","value":"230382"}],"label":"鸡西市","provinceId":"230000","value":"230300"},{"children":[{"cityId":"230400","label":"向阳区","provinceId":"230000","value":"230402"},{"cityId":"230400","label":"工农区","provinceId":"230000","value":"230403"},{"cityId":"230400","label":"南山区","provinceId":"230000","value":"230404"},{"cityId":"230400","label":"兴安区","provinceId":"230000","value":"230405"},{"cityId":"230400","label":"东山区","provinceId":"230000","value":"230406"},{"cityId":"230400","label":"兴山区","provinceId":"230000","value":"230407"},{"cityId":"230400","label":"萝北县","provinceId":"230000","value":"230421"},{"cityId":"230400","label":"绥滨县","provinceId":"230000","value":"230422"}],"label":"鹤岗市","provinceId":"230000","value":"230400"},{"children":[{"cityId":"230500","label":"尖山区","provinceId":"230000","value":"230502"},{"cityId":"230500","label":"岭东区","provinceId":"230000","value":"230503"},{"cityId":"230500","label":"四方台区","provinceId":"230000","value":"230505"},{"cityId":"230500","label":"宝山区","provinceId":"230000","value":"230506"},{"cityId":"230500","label":"集贤县","provinceId":"230000","value":"230521"},{"cityId":"230500","label":"友谊县","provinceId":"230000","value":"230522"},{"cityId":"230500","label":"宝清县","provinceId":"230000","value":"230523"},{"cityId":"230500","label":"饶河县","provinceId":"230000","value":"230524"}],"label":"双鸭山市","provinceId":"230000","value":"230500"},{"children":[{"cityId":"230600","label":"萨尔图区","provinceId":"230000","value":"230602"},{"cityId":"230600","label":"龙凤区","provinceId":"230000","value":"230603"},{"cityId":"230600","label":"让胡路区","provinceId":"230000","value":"230604"},{"cityId":"230600","label":"红岗区","provinceId":"230000","value":"230605"},{"cityId":"230600","label":"大同区","provinceId":"230000","value":"230606"},{"cityId":"230600","label":"肇州县","provinceId":"230000","value":"230621"},{"cityId":"230600","label":"肇源县","provinceId":"230000","value":"230622"},{"cityId":"230600","label":"林甸县","provinceId":"230000","value":"230623"},{"cityId":"230600","label":"杜尔伯特蒙古族自治县","provinceId":"230000","value":"230624"}],"label":"大庆市","provinceId":"230000","value":"230600"},{"children":[{"cityId":"230700","label":"伊春区","provinceId":"230000","value":"230702"},{"cityId":"230700","label":"南岔区","provinceId":"230000","value":"230703"},{"cityId":"230700","label":"友好区","provinceId":"230000","value":"230704"},{"cityId":"230700","label":"西林区","provinceId":"230000","value":"230705"},{"cityId":"230700","label":"翠峦区","provinceId":"230000","value":"230706"},{"cityId":"230700","label":"新青区","provinceId":"230000","value":"230707"},{"cityId":"230700","label":"美溪区","provinceId":"230000","value":"230708"},{"cityId":"230700","label":"金山屯区","provinceId":"230000","value":"230709"},{"cityId":"230700","label":"五营区","provinceId":"230000","value":"230710"},{"cityId":"230700","label":"乌马河区","provinceId":"230000","value":"230711"},{"cityId":"230700","label":"汤旺河区","provinceId":"230000","value":"230712"},{"cityId":"230700","label":"带岭区","provinceId":"230000","value":"230713"},{"cityId":"230700","label":"乌伊岭区","provinceId":"230000","value":"230714"},{"cityId":"230700","label":"红星区","provinceId":"230000","value":"230715"},{"cityId":"230700","label":"上甘岭区","provinceId":"230000","value":"230716"},{"cityId":"230700","label":"嘉荫县","provinceId":"230000","value":"230722"},{"cityId":"230700","label":"铁力市","provinceId":"230000","value":"230781"}],"label":"伊春市","provinceId":"230000","value":"230700"},{"children":[{"cityId":"230800","label":"向阳区","provinceId":"230000","value":"230803"},{"cityId":"230800","label":"前进区","provinceId":"230000","value":"230804"},{"cityId":"230800","label":"东风区","provinceId":"230000","value":"230805"},{"cityId":"230800","label":"郊区","provinceId":"230000","value":"230811"},{"cityId":"230800","label":"桦南县","provinceId":"230000","value":"230822"},{"cityId":"230800","label":"桦川县","provinceId":"230000","value":"230826"},{"cityId":"230800","label":"汤原县","provinceId":"230000","value":"230828"},{"cityId":"230800","label":"抚远市","provinceId":"230000","value":"230833"},{"cityId":"230800","label":"同江市","provinceId":"230000","value":"230881"},{"cityId":"230800","label":"富锦市","provinceId":"230000","value":"230882"}],"label":"佳木斯市","provinceId":"230000","value":"230800"},{"children":[{"cityId":"230900","label":"新兴区","provinceId":"230000","value":"230902"},{"cityId":"230900","label":"桃山区","provinceId":"230000","value":"230903"},{"cityId":"230900","label":"茄子河区","provinceId":"230000","value":"230904"},{"cityId":"230900","label":"勃利县","provinceId":"230000","value":"230921"}],"label":"七台河市","provinceId":"230000","value":"230900"},{"children":[{"cityId":"231000","label":"东安区","provinceId":"230000","value":"231002"},{"cityId":"231000","label":"阳明区","provinceId":"230000","value":"231003"},{"cityId":"231000","label":"爱民区","provinceId":"230000","value":"231004"},{"cityId":"231000","label":"西安区","provinceId":"230000","value":"231005"},{"cityId":"231000","label":"东宁市","provinceId":"230000","value":"231024"},{"cityId":"231000","label":"林口县","provinceId":"230000","value":"231025"},{"cityId":"231000","label":"绥芬河市","provinceId":"230000","value":"231081"},{"cityId":"231000","label":"海林市","provinceId":"230000","value":"231083"},{"cityId":"231000","label":"宁安市","provinceId":"230000","value":"231084"},{"cityId":"231000","label":"穆棱市","provinceId":"230000","value":"231085"}],"label":"牡丹江市","provinceId":"230000","value":"231000"},{"children":[{"cityId":"231100","label":"爱辉区","provinceId":"230000","value":"231102"},{"cityId":"231100","label":"嫩江县","provinceId":"230000","value":"231121"},{"cityId":"231100","label":"逊克县","provinceId":"230000","value":"231123"},{"cityId":"231100","label":"孙吴县","provinceId":"230000","value":"231124"},{"cityId":"231100","label":"北安市","provinceId":"230000","value":"231181"},{"cityId":"231100","label":"五大连池市","provinceId":"230000","value":"231182"}],"label":"黑河市","provinceId":"230000","value":"231100"},{"children":[{"cityId":"231200","label":"北林区","provinceId":"230000","value":"231202"},{"cityId":"231200","label":"望奎县","provinceId":"230000","value":"231221"},{"cityId":"231200","label":"兰西县","provinceId":"230000","value":"231222"},{"cityId":"231200","label":"青冈县","provinceId":"230000","value":"231223"},{"cityId":"231200","label":"庆安县","provinceId":"230000","value":"231224"},{"cityId":"231200","label":"明水县","provinceId":"230000","value":"231225"},{"cityId":"231200","label":"绥棱县","provinceId":"230000","value":"231226"},{"cityId":"231200","label":"安达市","provinceId":"230000","value":"231281"},{"cityId":"231200","label":"肇东市","provinceId":"230000","value":"231282"},{"cityId":"231200","label":"海伦市","provinceId":"230000","value":"231283"}],"label":"绥化市","provinceId":"230000","value":"231200"},{"children":[{"cityId":"232700","label":"加格达奇区","provinceId":"230000","value":"232701"},{"cityId":"232700","label":"松岭区","provinceId":"230000","value":"232702"},{"cityId":"232700","label":"新林区","provinceId":"230000","value":"232703"},{"cityId":"232700","label":"呼中区","provinceId":"230000","value":"232704"},{"cityId":"232700","label":"呼玛县","provinceId":"230000","value":"232721"},{"cityId":"232700","label":"塔河县","provinceId":"230000","value":"232722"},{"cityId":"232700","label":"漠河县","provinceId":"230000","value":"232723"}],"label":"大兴安岭地区","provinceId":"230000","value":"232700"}],"label":"黑龙江省","value":"230000"},{"children":[{"children":[{"cityId":"310100","label":"黄浦区","provinceId":"310000","value":"310101"},{"cityId":"310100","label":"卢湾区","provinceId":"310000","value":"310103"},{"cityId":"310100","label":"徐汇区","provinceId":"310000","value":"310104"},{"cityId":"310100","label":"长宁区","provinceId":"310000","value":"310105"},{"cityId":"310100","label":"静安区","provinceId":"310000","value":"310106"},{"cityId":"310100","label":"普陀区","provinceId":"310000","value":"310107"},{"cityId":"310100","label":"闸北区","provinceId":"310000","value":"310108"},{"cityId":"310100","label":"虹口区","provinceId":"310000","value":"310109"},{"cityId":"310100","label":"杨浦区","provinceId":"310000","value":"310110"},{"cityId":"310100","label":"闵行区","provinceId":"310000","value":"310112"},{"cityId":"310100","label":"宝山区","provinceId":"310000","value":"310113"},{"cityId":"310100","label":"嘉定区","provinceId":"310000","value":"310114"},{"cityId":"310100","label":"浦东新区","provinceId":"310000","value":"310115"},{"cityId":"310100","label":"金山区","provinceId":"310000","value":"310116"},{"cityId":"310100","label":"松江区","provinceId":"310000","value":"310117"},{"cityId":"310100","label":"青浦区","provinceId":"310000","value":"310118"},{"cityId":"310100","label":"南汇区","provinceId":"310000","value":"310119"},{"cityId":"310100","label":"奉贤区","provinceId":"310000","value":"310120"},{"cityId":"310100","label":"崇明区","provinceId":"310000","value":"310121"}],"label":"上海市","provinceId":"310000","value":"310100"}],"label":"上海市","value":"310000"},{"children":[{"children":[{"cityId":"320100","label":"玄武区","provinceId":"320000","value":"320102"},{"cityId":"320100","label":"白下区","provinceId":"320000","value":"320103"},{"cityId":"320100","label":"秦淮区","provinceId":"320000","value":"320104"},{"cityId":"320100","label":"建邺区","provinceId":"320000","value":"320105"},{"cityId":"320100","label":"鼓楼区","provinceId":"320000","value":"320106"},{"cityId":"320100","label":"下关区","provinceId":"320000","value":"320107"},{"cityId":"320100","label":"浦口区","provinceId":"320000","value":"320111"},{"cityId":"320100","label":"大厂区","provinceId":"320000","value":"320112"},{"cityId":"320100","label":"栖霞区","provinceId":"320000","value":"320113"},{"cityId":"320100","label":"雨花台区","provinceId":"320000","value":"320114"},{"cityId":"320100","label":"江宁区","provinceId":"320000","value":"320115"},{"cityId":"320100","label":"六合区","provinceId":"320000","value":"320116"},{"cityId":"320100","label":"溧水区","provinceId":"320000","value":"320124"},{"cityId":"320100","label":"高淳区","provinceId":"320000","value":"320125"}],"label":"南京市","provinceId":"320000","value":"320100"},{"children":[{"cityId":"320200","label":"崇安区","provinceId":"320000","value":"320202"},{"cityId":"320200","label":"南长区","provinceId":"320000","value":"320203"},{"cityId":"320200","label":"北塘区","provinceId":"320000","value":"320204"},{"cityId":"320200","label":"锡山区","provinceId":"320000","value":"320205"},{"cityId":"320200","label":"惠山区","provinceId":"320000","value":"320206"},{"cityId":"320200","label":"滨湖区","provinceId":"320000","value":"320211"},{"cityId":"320200","label":"梁溪区","provinceId":"320000","value":"320212"},{"cityId":"320200","label":"新吴区","provinceId":"320000","value":"320213"},{"cityId":"320200","label":"江阴市","provinceId":"320000","value":"320281"},{"cityId":"320200","label":"宜兴市","provinceId":"320000","value":"320282"}],"label":"无锡市","provinceId":"320000","value":"320200"},{"children":[{"cityId":"320300","label":"鼓楼区","provinceId":"320000","value":"320302"},{"cityId":"320300","label":"云龙区","provinceId":"320000","value":"320303"},{"cityId":"320300","label":"九里区","provinceId":"320000","value":"320304"},{"cityId":"320300","label":"贾汪区","provinceId":"320000","value":"320305"},{"cityId":"320300","label":"徐州开发区","provinceId":"320000","value":"320308"},{"cityId":"320300","label":"泉山区","provinceId":"320000","value":"320311"},{"cityId":"320300","label":"丰县","provinceId":"320000","value":"320321"},{"cityId":"320300","label":"沛县","provinceId":"320000","value":"320322"},{"cityId":"320300","label":"铜山区","provinceId":"320000","value":"320323"},{"cityId":"320300","label":"睢宁县","provinceId":"320000","value":"320324"},{"cityId":"320300","label":"新沂市","provinceId":"320000","value":"320381"},{"cityId":"320300","label":"邳州市","provinceId":"320000","value":"320382"}],"label":"徐州市","provinceId":"320000","value":"320300"},{"children":[{"cityId":"320400","label":"天宁区","provinceId":"320000","value":"320402"},{"cityId":"320400","label":"钟楼区","provinceId":"320000","value":"320404"},{"cityId":"320400","label":"戚墅堰区","provinceId":"320000","value":"320405"},{"cityId":"320400","label":"新北区","provinceId":"320000","value":"320411"},{"cityId":"320400","label":"武进区","provinceId":"320000","value":"320412"},{"cityId":"320400","label":"溧阳市","provinceId":"320000","value":"320481"},{"cityId":"320400","label":"金坛区","provinceId":"320000","value":"320482"}],"label":"常州市","provinceId":"320000","value":"320400"},{"children":[{"cityId":"320500","label":"沧浪区","provinceId":"320000","value":"320502"},{"cityId":"320500","label":"平江区","provinceId":"320000","value":"320503"},{"cityId":"320500","label":"金阊区","provinceId":"320000","value":"320504"},{"cityId":"320500","label":"虎丘区","provinceId":"320000","value":"320505"},{"cityId":"320500","label":"吴中区","provinceId":"320000","value":"320506"},{"cityId":"320500","label":"相城区","provinceId":"320000","value":"320507"},{"cityId":"320500","label":"高新区","provinceId":"320000","value":"320508"},{"cityId":"320500","label":"工业园区","provinceId":"320000","value":"320509"},{"cityId":"320500","label":"姑苏区","provinceId":"320000","value":"320510"},{"cityId":"320500","label":"常熟市","provinceId":"320000","value":"320581"},{"cityId":"320500","label":"张家港市","provinceId":"320000","value":"320582"},{"cityId":"320500","label":"昆山市","provinceId":"320000","value":"320583"},{"cityId":"320500","label":"吴江区","provinceId":"320000","value":"320584"},{"cityId":"320500","label":"太仓市","provinceId":"320000","value":"320585"}],"label":"苏州市","provinceId":"320000","value":"320500"},{"children":[{"cityId":"320600","label":"崇川区","provinceId":"320000","value":"320602"},{"cityId":"320600","label":"港闸区","provinceId":"320000","value":"320611"},{"cityId":"320600","label":"开发区","provinceId":"320000","value":"320612"},{"cityId":"320600","label":"海安县","provinceId":"320000","value":"320621"},{"cityId":"320600","label":"如东县","provinceId":"320000","value":"320623"},{"cityId":"320600","label":"启东市","provinceId":"320000","value":"320681"},{"cityId":"320600","label":"如皋市","provinceId":"320000","value":"320682"},{"cityId":"320600","label":"通州区","provinceId":"320000","value":"320683"},{"cityId":"320600","label":"海门市","provinceId":"320000","value":"320684"}],"label":"南通市","provinceId":"320000","value":"320600"},{"children":[{"cityId":"320700","label":"连云区","provinceId":"320000","value":"320703"},{"cityId":"320700","label":"新浦区","provinceId":"320000","value":"320705"},{"cityId":"320700","label":"海州区","provinceId":"320000","value":"320706"},{"cityId":"320700","label":"赣榆区","provinceId":"320000","value":"320721"},{"cityId":"320700","label":"东海县","provinceId":"320000","value":"320722"},{"cityId":"320700","label":"灌云县","provinceId":"320000","value":"320723"},{"cityId":"320700","label":"灌南县","provinceId":"320000","value":"320724"}],"label":"连云港市","provinceId":"320000","value":"320700"},{"children":[{"cityId":"320800","label":"清河区","provinceId":"320000","value":"320802"},{"cityId":"320800","label":"楚州区","provinceId":"320000","value":"320803"},{"cityId":"320800","label":"淮阴区","provinceId":"320000","value":"320804"},{"cityId":"320800","label":"淮安区","provinceId":"320000","value":"320805"},{"cityId":"320800","label":"清江浦区","provinceId":"320000","value":"320811"},{"cityId":"320800","label":"涟水县","provinceId":"320000","value":"320826"},{"cityId":"320800","label":"洪泽区","provinceId":"320000","value":"320829"},{"cityId":"320800","label":"盱眙县","provinceId":"320000","value":"320830"},{"cityId":"320800","label":"金湖县","provinceId":"320000","value":"320831"}],"label":"淮安市","provinceId":"320000","value":"320800"},{"children":[{"cityId":"320900","label":"亭湖区","provinceId":"320000","value":"320902"},{"cityId":"320900","label":"盐都区","provinceId":"320000","value":"320903"},{"cityId":"320900","label":"响水县","provinceId":"320000","value":"320921"},{"cityId":"320900","label":"滨海县","provinceId":"320000","value":"320922"},{"cityId":"320900","label":"阜宁县","provinceId":"320000","value":"320923"},{"cityId":"320900","label":"射阳县","provinceId":"320000","value":"320924"},{"cityId":"320900","label":"建湖县","provinceId":"320000","value":"320925"},{"cityId":"320900","label":"东台市","provinceId":"320000","value":"320981"},{"cityId":"320900","label":"大丰区","provinceId":"320000","value":"320982"}],"label":"盐城市","provinceId":"320000","value":"320900"},{"children":[{"cityId":"321000","label":"广陵区","provinceId":"320000","value":"321002"},{"cityId":"321000","label":"邗江区","provinceId":"320000","value":"321003"},{"cityId":"321000","label":"维扬区","provinceId":"320000","value":"321011"},{"cityId":"321000","label":"江都区","provinceId":"320000","value":"321012"},{"cityId":"321000","label":"宝应县","provinceId":"320000","value":"321023"},{"cityId":"321000","label":"仪征市","provinceId":"320000","value":"321081"},{"cityId":"321000","label":"高邮市","provinceId":"320000","value":"321084"}],"label":"扬州市","provinceId":"320000","value":"321000"},{"children":[{"cityId":"321100","label":"京口区","provinceId":"320000","value":"321102"},{"cityId":"321100","label":"润州区","provinceId":"320000","value":"321111"},{"cityId":"321100","label":"丹徒区","provinceId":"320000","value":"321112"},{"cityId":"321100","label":"镇江新区","provinceId":"320000","value":"321113"},{"cityId":"321100","label":"丹阳市","provinceId":"320000","value":"321181"},{"cityId":"321100","label":"扬中市","provinceId":"320000","value":"321182"},{"cityId":"321100","label":"句容市","provinceId":"320000","value":"321183"}],"label":"镇江市","provinceId":"320000","value":"321100"},{"children":[{"cityId":"321200","label":"海陵区","provinceId":"320000","value":"321202"},{"cityId":"321200","label":"高港区","provinceId":"320000","value":"321203"},{"cityId":"321200","label":"兴化市","provinceId":"320000","value":"321281"},{"cityId":"321200","label":"靖江市","provinceId":"320000","value":"321282"},{"cityId":"321200","label":"泰兴市","provinceId":"320000","value":"321283"},{"cityId":"321200","label":"姜堰区","provinceId":"320000","value":"321284"}],"label":"泰州市","provinceId":"320000","value":"321200"},{"children":[{"cityId":"321300","label":"宿城区","provinceId":"320000","value":"321302"},{"cityId":"321300","label":"宿豫区","provinceId":"320000","value":"321311"},{"cityId":"321300","label":"沭阳县","provinceId":"320000","value":"321322"},{"cityId":"321300","label":"泗阳县","provinceId":"320000","value":"321323"},{"cityId":"321300","label":"泗洪县","provinceId":"320000","value":"321324"}],"label":"宿迁市","provinceId":"320000","value":"321300"}],"label":"江苏省","value":"320000"},{"children":[{"children":[{"cityId":"330100","label":"上城区","provinceId":"330000","value":"330102"},{"cityId":"330100","label":"下城区","provinceId":"330000","value":"330103"},{"cityId":"330100","label":"江干区","provinceId":"330000","value":"330104"},{"cityId":"330100","label":"拱墅区","provinceId":"330000","value":"330105"},{"cityId":"330100","label":"西湖区","provinceId":"330000","value":"330106"},{"cityId":"330100","label":"滨江区","provinceId":"330000","value":"330108"},{"cityId":"330100","label":"萧山区","provinceId":"330000","value":"330109"},{"cityId":"330100","label":"余杭区","provinceId":"330000","value":"330110"},{"cityId":"330100","label":"萧山义蓬","provinceId":"330000","value":"330111"},{"cityId":"330100","label":"大禹(老余杭)","provinceId":"330000","value":"330112"},{"cityId":"330100","label":"瓶窑","provinceId":"330000","value":"330113"},{"cityId":"330100","label":"临平","provinceId":"330000","value":"330114"},{"cityId":"330100","label":"新登","provinceId":"330000","value":"330115"},{"cityId":"330100","label":"桐庐县","provinceId":"330000","value":"330122"},{"cityId":"330100","label":"淳安县","provinceId":"330000","value":"330127"},{"cityId":"330100","label":"建德市","provinceId":"330000","value":"330182"},{"cityId":"330100","label":"富阳区","provinceId":"330000","value":"330183"},{"cityId":"330100","label":"临安区","provinceId":"330000","value":"330185"}],"label":"杭州市","provinceId":"330000","value":"330100"},{"children":[{"cityId":"330200","label":"海曙区","provinceId":"330000","value":"330203"},{"cityId":"330200","label":"江东区","provinceId":"330000","value":"330204"},{"cityId":"330200","label":"江北区","provinceId":"330000","value":"330205"},{"cityId":"330200","label":"北仑区","provinceId":"330000","value":"330206"},{"cityId":"330200","label":"镇海区","provinceId":"330000","value":"330211"},{"cityId":"330200","label":"鄞州区","provinceId":"330000","value":"330212"},{"cityId":"330200","label":"象山县","provinceId":"330000","value":"330225"},{"cityId":"330200","label":"宁海县","provinceId":"330000","value":"330226"},{"cityId":"330200","label":"余姚市","provinceId":"330000","value":"330281"},{"cityId":"330200","label":"慈溪市","provinceId":"330000","value":"330282"},{"cityId":"330200","label":"奉化市","provinceId":"330000","value":"330283"}],"label":"宁波市","provinceId":"330000","value":"330200"},{"children":[{"cityId":"330300","label":"鹿城区","provinceId":"330000","value":"330302"},{"cityId":"330300","label":"龙湾区","provinceId":"330000","value":"330303"},{"cityId":"330300","label":"瓯海区","provinceId":"330000","value":"330304"},{"cityId":"330300","label":"洞头区","provinceId":"330000","value":"330322"},{"cityId":"330300","label":"永嘉县","provinceId":"330000","value":"330324"},{"cityId":"330300","label":"平阳县","provinceId":"330000","value":"330326"},{"cityId":"330300","label":"苍南县","provinceId":"330000","value":"330327"},{"cityId":"330300","label":"文成县","provinceId":"330000","value":"330328"},{"cityId":"330300","label":"泰顺县","provinceId":"330000","value":"330329"},{"cityId":"330300","label":"瑞安市","provinceId":"330000","value":"330381"},{"cityId":"330300","label":"乐清市","provinceId":"330000","value":"330382"}],"label":"温州市","provinceId":"330000","value":"330300"},{"children":[{"cityId":"330400","label":"南湖区","provinceId":"330000","value":"330402"},{"cityId":"330400","label":"秀洲区","provinceId":"330000","value":"330411"},{"cityId":"330400","label":"嘉善县","provinceId":"330000","value":"330421"},{"cityId":"330400","label":"海盐县","provinceId":"330000","value":"330424"},{"cityId":"330400","label":"海宁市","provinceId":"330000","value":"330481"},{"cityId":"330400","label":"平湖市","provinceId":"330000","value":"330482"},{"cityId":"330400","label":"桐乡市","provinceId":"330000","value":"330483"}],"label":"嘉兴市","provinceId":"330000","value":"330400"},{"children":[{"cityId":"330500","label":"吴兴区","provinceId":"330000","value":"330502"},{"cityId":"330500","label":"南浔区","provinceId":"330000","value":"330503"},{"cityId":"330500","label":"德清县","provinceId":"330000","value":"330521"},{"cityId":"330500","label":"长兴县","provinceId":"330000","value":"330522"},{"cityId":"330500","label":"安吉县","provinceId":"330000","value":"330523"},{"cityId":"330500","label":"湖州新市","provinceId":"330000","value":"330524"}],"label":"湖州市","provinceId":"330000","value":"330500"},{"children":[{"cityId":"330600","label":"越城区","provinceId":"330000","value":"330602"},{"cityId":"330600","label":"柯桥区","provinceId":"330000","value":"330603"},{"cityId":"330600","label":"绍兴县","provinceId":"330000","value":"330621"},{"cityId":"330600","label":"新昌县","provinceId":"330000","value":"330624"},{"cityId":"330600","label":"诸暨市","provinceId":"330000","value":"330681"},{"cityId":"330600","label":"上虞区","provinceId":"330000","value":"330682"},{"cityId":"330600","label":"嵊州市","provinceId":"330000","value":"330683"}],"label":"绍兴市","provinceId":"330000","value":"330600"},{"children":[{"cityId":"330700","label":"婺城区","provinceId":"330000","value":"330702"},{"cityId":"330700","label":"金东区","provinceId":"330000","value":"330703"},{"cityId":"330700","label":"武义县","provinceId":"330000","value":"330723"},{"cityId":"330700","label":"浦江县","provinceId":"330000","value":"330726"},{"cityId":"330700","label":"磐安县","provinceId":"330000","value":"330727"},{"cityId":"330700","label":"兰溪市","provinceId":"330000","value":"330781"},{"cityId":"330700","label":"义乌市","provinceId":"330000","value":"330782"},{"cityId":"330700","label":"东阳市","provinceId":"330000","value":"330783"},{"cityId":"330700","label":"永康市","provinceId":"330000","value":"330784"},{"cityId":"330700","label":"金华仙桥","provinceId":"330000","value":"330785"}],"label":"金华市","provinceId":"330000","value":"330700"},{"children":[{"cityId":"330800","label":"柯城区","provinceId":"330000","value":"330802"},{"cityId":"330800","label":"衢江区","provinceId":"330000","value":"330803"},{"cityId":"330800","label":"常山县","provinceId":"330000","value":"330822"},{"cityId":"330800","label":"开化县","provinceId":"330000","value":"330824"},{"cityId":"330800","label":"龙游县","provinceId":"330000","value":"330825"},{"cityId":"330800","label":"江山市","provinceId":"330000","value":"330881"}],"label":"衢州市","provinceId":"330000","value":"330800"},{"children":[{"cityId":"330900","label":"定海区","provinceId":"330000","value":"330902"},{"cityId":"330900","label":"普陀区","provinceId":"330000","value":"330903"},{"cityId":"330900","label":"岱山县","provinceId":"330000","value":"330921"},{"cityId":"330900","label":"嵊泗县","provinceId":"330000","value":"330922"}],"label":"舟山市","provinceId":"330000","value":"330900"},{"children":[{"cityId":"331000","label":"椒江区","provinceId":"330000","value":"331002"},{"cityId":"331000","label":"黄岩区","provinceId":"330000","value":"331003"},{"cityId":"331000","label":"路桥区","provinceId":"330000","value":"331004"},{"cityId":"331000","label":"玉环县","provinceId":"330000","value":"331021"},{"cityId":"331000","label":"三门县","provinceId":"330000","value":"331022"},{"cityId":"331000","label":"天台县","provinceId":"330000","value":"331023"},{"cityId":"331000","label":"仙居县","provinceId":"330000","value":"331024"},{"cityId":"331000","label":"温岭市","provinceId":"330000","value":"331081"},{"cityId":"331000","label":"临海市","provinceId":"330000","value":"331082"},{"cityId":"331000","label":"台州东辉","provinceId":"330000","value":"331083"},{"cityId":"331000","label":"台州泽国","provinceId":"330000","value":"331084"},{"cityId":"331000","label":"台州杜桥","provinceId":"330000","value":"331085"}],"label":"台州市","provinceId":"330000","value":"331000"},{"children":[{"cityId":"331100","label":"莲都区","provinceId":"330000","value":"331102"},{"cityId":"331100","label":"青田县","provinceId":"330000","value":"331121"},{"cityId":"331100","label":"缙云县","provinceId":"330000","value":"331122"},{"cityId":"331100","label":"遂昌县","provinceId":"330000","value":"331123"},{"cityId":"331100","label":"松阳县","provinceId":"330000","value":"331124"},{"cityId":"331100","label":"云和县","provinceId":"330000","value":"331125"},{"cityId":"331100","label":"庆元县","provinceId":"330000","value":"331126"},{"cityId":"331100","label":"景宁畲族自治县","provinceId":"330000","value":"331127"},{"cityId":"331100","label":"龙泉市","provinceId":"330000","value":"331181"}],"label":"丽水市","provinceId":"330000","value":"331100"}],"label":"浙江省","value":"330000"},{"children":[{"children":[{"cityId":"340100","label":"瑶海区","provinceId":"340000","value":"340102"},{"cityId":"340100","label":"庐阳区","provinceId":"340000","value":"340103"},{"cityId":"340100","label":"蜀山区","provinceId":"340000","value":"340104"},{"cityId":"340100","label":"新站区","provinceId":"340000","value":"340107"},{"cityId":"340100","label":"高新区","provinceId":"340000","value":"340108"},{"cityId":"340100","label":"经开区","provinceId":"340000","value":"340109"},{"cityId":"340100","label":"包河区","provinceId":"340000","value":"340111"},{"cityId":"340100","label":"巢湖市","provinceId":"340000","value":"340112"},{"cityId":"340100","label":"长丰县","provinceId":"340000","value":"340121"},{"cityId":"340100","label":"肥东县","provinceId":"340000","value":"340122"},{"cityId":"340100","label":"肥西县","provinceId":"340000","value":"340123"},{"cityId":"340100","label":"庐江县","provinceId":"340000","value":"340124"},{"cityId":"340100","label":"滨湖新区","provinceId":"340000","value":"340148"}],"label":"合肥市","provinceId":"340000","value":"340100"},{"children":[{"cityId":"340200","label":"镜湖区","provinceId":"340000","value":"340202"},{"cityId":"340200","label":"弋江区","provinceId":"340000","value":"340203"},{"cityId":"340200","label":"鸠江区","provinceId":"340000","value":"340207"},{"cityId":"340200","label":"三山区","provinceId":"340000","value":"340208"},{"cityId":"340200","label":"芜湖县","provinceId":"340000","value":"340221"},{"cityId":"340200","label":"繁昌县","provinceId":"340000","value":"340222"},{"cityId":"340200","label":"南陵县","provinceId":"340000","value":"340223"},{"cityId":"340200","label":"无为县","provinceId":"340000","value":"340224"}],"label":"芜湖市","provinceId":"340000","value":"340200"},{"children":[{"cityId":"340300","label":"龙子湖区","provinceId":"340000","value":"340302"},{"cityId":"340300","label":"蚌山区","provinceId":"340000","value":"340303"},{"cityId":"340300","label":"禹会区","provinceId":"340000","value":"340304"},{"cityId":"340300","label":"淮上区","provinceId":"340000","value":"340311"},{"cityId":"340300","label":"怀远县","provinceId":"340000","value":"340321"},{"cityId":"340300","label":"五河县","provinceId":"340000","value":"340322"},{"cityId":"340300","label":"固镇县","provinceId":"340000","value":"340323"}],"label":"蚌埠市","provinceId":"340000","value":"340300"},{"children":[{"cityId":"340400","label":"大通区","provinceId":"340000","value":"340402"},{"cityId":"340400","label":"田家庵区","provinceId":"340000","value":"340403"},{"cityId":"340400","label":"谢家集区","provinceId":"340000","value":"340404"},{"cityId":"340400","label":"八公山区","provinceId":"340000","value":"340405"},{"cityId":"340400","label":"潘集区","provinceId":"340000","value":"340406"},{"cityId":"340400","label":"凤台县","provinceId":"340000","value":"340421"},{"cityId":"340400","label":"寿县","provinceId":"340000","value":"340422"}],"label":"淮南市","provinceId":"340000","value":"340400"},{"children":[{"cityId":"340500","label":"金家庄区","provinceId":"340000","value":"340502"},{"cityId":"340500","label":"花山区","provinceId":"340000","value":"340503"},{"cityId":"340500","label":"雨山区","provinceId":"340000","value":"340504"},{"cityId":"340500","label":"博望区","provinceId":"340000","value":"340506"},{"cityId":"340500","label":"当涂县","provinceId":"340000","value":"340521"},{"cityId":"340500","label":"含山县","provinceId":"340000","value":"340522"},{"cityId":"340500","label":"和县","provinceId":"340000","value":"340523"}],"label":"马鞍山市","provinceId":"340000","value":"340500"},{"children":[{"cityId":"340600","label":"杜集区","provinceId":"340000","value":"340602"},{"cityId":"340600","label":"相山区","provinceId":"340000","value":"340603"},{"cityId":"340600","label":"烈山区","provinceId":"340000","value":"340604"},{"cityId":"340600","label":"濉溪县","provinceId":"340000","value":"340621"}],"label":"淮北市","provinceId":"340000","value":"340600"},{"children":[{"cityId":"340700","label":"铜官区","provinceId":"340000","value":"340702"},{"cityId":"340700","label":"狮子山区","provinceId":"340000","value":"340703"},{"cityId":"340700","label":"义安区","provinceId":"340000","value":"340706"},{"cityId":"340700","label":"郊区","provinceId":"340000","value":"340711"},{"cityId":"340700","label":"铜陵县","provinceId":"340000","value":"340721"},{"cityId":"340700","label":"枞阳县","provinceId":"340000","value":"340722"}],"label":"铜陵市","provinceId":"340000","value":"340700"},{"children":[{"cityId":"340800","label":"迎江区","provinceId":"340000","value":"340802"},{"cityId":"340800","label":"大观区","provinceId":"340000","value":"340803"},{"cityId":"340800","label":"宜秀区","provinceId":"340000","value":"340811"},{"cityId":"340800","label":"怀宁县","provinceId":"340000","value":"340822"},{"cityId":"340800","label":"潜山县","provinceId":"340000","value":"340824"},{"cityId":"340800","label":"太湖县","provinceId":"340000","value":"340825"},{"cityId":"340800","label":"宿松县","provinceId":"340000","value":"340826"},{"cityId":"340800","label":"望江县","provinceId":"340000","value":"340827"},{"cityId":"340800","label":"岳西县","provinceId":"340000","value":"340828"},{"cityId":"340800","label":"桐城市","provinceId":"340000","value":"340881"}],"label":"安庆市","provinceId":"340000","value":"340800"},{"children":[{"cityId":"341000","label":"屯溪区","provinceId":"340000","value":"341002"},{"cityId":"341000","label":"黄山区","provinceId":"340000","value":"341003"},{"cityId":"341000","label":"徽州区","provinceId":"340000","value":"341004"},{"cityId":"341000","label":"歙县","provinceId":"340000","value":"341021"},{"cityId":"341000","label":"休宁县","provinceId":"340000","value":"341022"},{"cityId":"341000","label":"黟县","provinceId":"340000","value":"341023"},{"cityId":"341000","label":"祁门县","provinceId":"340000","value":"341024"}],"label":"黄山市","provinceId":"340000","value":"341000"},{"children":[{"cityId":"341100","label":"琅琊区","provinceId":"340000","value":"341102"},{"cityId":"341100","label":"南谯区","provinceId":"340000","value":"341103"},{"cityId":"341100","label":"来安县","provinceId":"340000","value":"341122"},{"cityId":"341100","label":"全椒县","provinceId":"340000","value":"341124"},{"cityId":"341100","label":"定远县","provinceId":"340000","value":"341125"},{"cityId":"341100","label":"凤阳县","provinceId":"340000","value":"341126"},{"cityId":"341100","label":"天长市","provinceId":"340000","value":"341181"},{"cityId":"341100","label":"明光市","provinceId":"340000","value":"341182"}],"label":"滁州市","provinceId":"340000","value":"341100"},{"children":[{"cityId":"341200","label":"颍州区","provinceId":"340000","value":"341202"},{"cityId":"341200","label":"颍东区","provinceId":"340000","value":"341203"},{"cityId":"341200","label":"颍泉区","provinceId":"340000","value":"341204"},{"cityId":"341200","label":"临泉县","provinceId":"340000","value":"341221"},{"cityId":"341200","label":"太和县","provinceId":"340000","value":"341222"},{"cityId":"341200","label":"阜南县","provinceId":"340000","value":"341225"},{"cityId":"341200","label":"颍上县","provinceId":"340000","value":"341226"},{"cityId":"341200","label":"界首市","provinceId":"340000","value":"341282"}],"label":"阜阳市","provinceId":"340000","value":"341200"},{"children":[{"cityId":"341300","label":"埇桥区","provinceId":"340000","value":"341302"},{"cityId":"341300","label":"砀山县","provinceId":"340000","value":"341321"},{"cityId":"341300","label":"萧县","provinceId":"340000","value":"341322"},{"cityId":"341300","label":"灵璧县","provinceId":"340000","value":"341323"},{"cityId":"341300","label":"泗县","provinceId":"340000","value":"341324"}],"label":"宿州市","provinceId":"340000","value":"341300"},{"children":[{"cityId":"341400","label":"居巢区","provinceId":"340000","value":"341402"},{"cityId":"341400","label":"庐江县","provinceId":"340000","value":"341421"},{"cityId":"341400","label":"无为县","provinceId":"340000","value":"341422"},{"cityId":"341400","label":"含山县","provinceId":"340000","value":"341423"},{"cityId":"341400","label":"和　县","provinceId":"340000","value":"341424"}],"label":"巢湖市","provinceId":"340000","value":"341400"},{"children":[{"cityId":"341500","label":"金安区","provinceId":"340000","value":"341502"},{"cityId":"341500","label":"裕安区","provinceId":"340000","value":"341503"},{"cityId":"341500","label":"叶集区","provinceId":"340000","value":"341504"},{"cityId":"341500","label":"霍邱县","provinceId":"340000","value":"341522"},{"cityId":"341500","label":"舒城县","provinceId":"340000","value":"341523"},{"cityId":"341500","label":"金寨县","provinceId":"340000","value":"341524"},{"cityId":"341500","label":"霍山县","provinceId":"340000","value":"341525"}],"label":"六安市","provinceId":"340000","value":"341500"},{"children":[{"cityId":"341600","label":"谯城区","provinceId":"340000","value":"341602"},{"cityId":"341600","label":"涡阳县","provinceId":"340000","value":"341621"},{"cityId":"341600","label":"蒙城县","provinceId":"340000","value":"341622"},{"cityId":"341600","label":"利辛县","provinceId":"340000","value":"341623"}],"label":"亳州市","provinceId":"340000","value":"341600"},{"children":[{"cityId":"341700","label":"贵池区","provinceId":"340000","value":"341702"},{"cityId":"341700","label":"东至县","provinceId":"340000","value":"341721"},{"cityId":"341700","label":"石台县","provinceId":"340000","value":"341722"},{"cityId":"341700","label":"青阳县","provinceId":"340000","value":"341723"}],"label":"池州市","provinceId":"340000","value":"341700"},{"children":[{"cityId":"341800","label":"宣州区","provinceId":"340000","value":"341802"},{"cityId":"341800","label":"郎溪县","provinceId":"340000","value":"341821"},{"cityId":"341800","label":"广德县","provinceId":"340000","value":"341822"},{"cityId":"341800","label":"泾县","provinceId":"340000","value":"341823"},{"cityId":"341800","label":"绩溪县","provinceId":"340000","value":"341824"},{"cityId":"341800","label":"旌德县","provinceId":"340000","value":"341825"},{"cityId":"341800","label":"宁国市","provinceId":"340000","value":"341881"}],"label":"宣城市","provinceId":"340000","value":"341800"}],"label":"安徽省","value":"340000"},{"children":[{"children":[{"cityId":"350100","label":"鼓楼区","provinceId":"350000","value":"350102"},{"cityId":"350100","label":"台江区","provinceId":"350000","value":"350103"},{"cityId":"350100","label":"仓山区","provinceId":"350000","value":"350104"},{"cityId":"350100","label":"马尾区","provinceId":"350000","value":"350105"},{"cityId":"350100","label":"晋安区","provinceId":"350000","value":"350111"},{"cityId":"350100","label":"闽侯县","provinceId":"350000","value":"350121"},{"cityId":"350100","label":"连江县","provinceId":"350000","value":"350122"},{"cityId":"350100","label":"罗源县","provinceId":"350000","value":"350123"},{"cityId":"350100","label":"闽清县","provinceId":"350000","value":"350124"},{"cityId":"350100","label":"永泰县","provinceId":"350000","value":"350125"},{"cityId":"350100","label":"平潭县","provinceId":"350000","value":"350128"},{"cityId":"350100","label":"福清市","provinceId":"350000","value":"350181"},{"cityId":"350100","label":"长乐市","provinceId":"350000","value":"350182"}],"label":"福州市","provinceId":"350000","value":"350100"},{"children":[{"cityId":"350200","label":"思明区","provinceId":"350000","value":"350203"},{"cityId":"350200","label":"海沧区","provinceId":"350000","value":"350205"},{"cityId":"350200","label":"湖里区","provinceId":"350000","value":"350206"},{"cityId":"350200","label":"集美区","provinceId":"350000","value":"350211"},{"cityId":"350200","label":"同安区","provinceId":"350000","value":"350212"},{"cityId":"350200","label":"翔安区","provinceId":"350000","value":"350213"},{"cityId":"350200","label":"杏林区","provinceId":"350000","value":"350214"}],"label":"厦门市","provinceId":"350000","value":"350200"},{"children":[{"cityId":"350300","label":"城厢区","provinceId":"350000","value":"350302"},{"cityId":"350300","label":"涵江区","provinceId":"350000","value":"350303"},{"cityId":"350300","label":"荔城区","provinceId":"350000","value":"350304"},{"cityId":"350300","label":"秀屿区","provinceId":"350000","value":"350305"},{"cityId":"350300","label":"仙游县","provinceId":"350000","value":"350322"}],"label":"莆田市","provinceId":"350000","value":"350300"},{"children":[{"cityId":"350400","label":"梅列区","provinceId":"350000","value":"350402"},{"cityId":"350400","label":"三元区","provinceId":"350000","value":"350403"},{"cityId":"350400","label":"明溪县","provinceId":"350000","value":"350421"},{"cityId":"350400","label":"清流县","provinceId":"350000","value":"350423"},{"cityId":"350400","label":"宁化县","provinceId":"350000","value":"350424"},{"cityId":"350400","label":"大田县","provinceId":"350000","value":"350425"},{"cityId":"350400","label":"尤溪县","provinceId":"350000","value":"350426"},{"cityId":"350400","label":"沙县","provinceId":"350000","value":"350427"},{"cityId":"350400","label":"将乐县","provinceId":"350000","value":"350428"},{"cityId":"350400","label":"泰宁县","provinceId":"350000","value":"350429"},{"cityId":"350400","label":"建宁县","provinceId":"350000","value":"350430"},{"cityId":"350400","label":"永安市","provinceId":"350000","value":"350481"}],"label":"三明市","provinceId":"350000","value":"350400"},{"children":[{"cityId":"350500","label":"鲤城区","provinceId":"350000","value":"350502"},{"cityId":"350500","label":"丰泽区","provinceId":"350000","value":"350503"},{"cityId":"350500","label":"洛江区","provinceId":"350000","value":"350504"},{"cityId":"350500","label":"泉港区","provinceId":"350000","value":"350505"},{"cityId":"350500","label":"惠安县","provinceId":"350000","value":"350521"},{"cityId":"350500","label":"安溪县","provinceId":"350000","value":"350524"},{"cityId":"350500","label":"永春县","provinceId":"350000","value":"350525"},{"cityId":"350500","label":"德化县","provinceId":"350000","value":"350526"},{"cityId":"350500","label":"金门县","provinceId":"350000","value":"350527"},{"cityId":"350500","label":"石狮市","provinceId":"350000","value":"350581"},{"cityId":"350500","label":"晋江市","provinceId":"350000","value":"350582"},{"cityId":"350500","label":"南安市","provinceId":"350000","value":"350583"},{"cityId":"350500","label":"水头","provinceId":"350000","value":"350584"}],"label":"泉州市","provinceId":"350000","value":"350500"},{"children":[{"cityId":"350600","label":"芗城区","provinceId":"350000","value":"350602"},{"cityId":"350600","label":"龙文区","provinceId":"350000","value":"350603"},{"cityId":"350600","label":"云霄县","provinceId":"350000","value":"350622"},{"cityId":"350600","label":"漳浦县","provinceId":"350000","value":"350623"},{"cityId":"350600","label":"诏安县","provinceId":"350000","value":"350624"},{"cityId":"350600","label":"长泰县","provinceId":"350000","value":"350625"},{"cityId":"350600","label":"东山县","provinceId":"350000","value":"350626"},{"cityId":"350600","label":"南靖县","provinceId":"350000","value":"350627"},{"cityId":"350600","label":"平和县","provinceId":"350000","value":"350628"},{"cityId":"350600","label":"华安县","provinceId":"350000","value":"350629"},{"cityId":"350600","label":"龙海市","provinceId":"350000","value":"350681"}],"label":"漳州市","provinceId":"350000","value":"350600"},{"children":[{"cityId":"350700","label":"延平区","provinceId":"350000","value":"350702"},{"cityId":"350700","label":"顺昌县","provinceId":"350000","value":"350721"},{"cityId":"350700","label":"浦城县","provinceId":"350000","value":"350722"},{"cityId":"350700","label":"光泽县","provinceId":"350000","value":"350723"},{"cityId":"350700","label":"松溪县","provinceId":"350000","value":"350724"},{"cityId":"350700","label":"政和县","provinceId":"350000","value":"350725"},{"cityId":"350700","label":"邵武市","provinceId":"350000","value":"350781"},{"cityId":"350700","label":"武夷山市","provinceId":"350000","value":"350782"},{"cityId":"350700","label":"建瓯市","provinceId":"350000","value":"350783"},{"cityId":"350700","label":"建阳区","provinceId":"350000","value":"350784"}],"label":"南平市","provinceId":"350000","value":"350700"},{"children":[{"cityId":"350800","label":"新罗区","provinceId":"350000","value":"350802"},{"cityId":"350800","label":"长汀县","provinceId":"350000","value":"350821"},{"cityId":"350800","label":"永定区","provinceId":"350000","value":"350822"},{"cityId":"350800","label":"上杭县","provinceId":"350000","value":"350823"},{"cityId":"350800","label":"武平县","provinceId":"350000","value":"350824"},{"cityId":"350800","label":"连城县","provinceId":"350000","value":"350825"},{"cityId":"350800","label":"漳平市","provinceId":"350000","value":"350881"},{"cityId":"350800","label":"龙门","provinceId":"350000","value":"350882"},{"cityId":"350800","label":"坎市","provinceId":"350000","value":"350883"}],"label":"龙岩市","provinceId":"350000","value":"350800"},{"children":[{"cityId":"350900","label":"蕉城区","provinceId":"350000","value":"350902"},{"cityId":"350900","label":"霞浦县","provinceId":"350000","value":"350921"},{"cityId":"350900","label":"古田县","provinceId":"350000","value":"350922"},{"cityId":"350900","label":"屏南县","provinceId":"350000","value":"350923"},{"cityId":"350900","label":"寿宁县","provinceId":"350000","value":"350924"},{"cityId":"350900","label":"周宁县","provinceId":"350000","value":"350925"},{"cityId":"350900","label":"柘荣县","provinceId":"350000","value":"350926"},{"cityId":"350900","label":"福安市","provinceId":"350000","value":"350981"},{"cityId":"350900","label":"福鼎市","provinceId":"350000","value":"350982"}],"label":"宁德市","provinceId":"350000","value":"350900"}],"label":"福建省","value":"350000"},{"children":[{"children":[{"cityId":"360100","label":"东湖区","provinceId":"360000","value":"360102"},{"cityId":"360100","label":"西湖区","provinceId":"360000","value":"360103"},{"cityId":"360100","label":"青云谱区","provinceId":"360000","value":"360104"},{"cityId":"360100","label":"湾里区","provinceId":"360000","value":"360105"},{"cityId":"360100","label":"红谷滩县","provinceId":"360000","value":"360106"},{"cityId":"360100","label":"青山湖区","provinceId":"360000","value":"360111"},{"cityId":"360100","label":"红谷滩新区","provinceId":"360000","value":"360112"},{"cityId":"360100","label":"高新开发区","provinceId":"360000","value":"360113"},{"cityId":"360100","label":"南昌县","provinceId":"360000","value":"360121"},{"cityId":"360100","label":"新建区","provinceId":"360000","value":"360122"},{"cityId":"360100","label":"安义县","provinceId":"360000","value":"360123"},{"cityId":"360100","label":"进贤县","provinceId":"360000","value":"360124"},{"cityId":"360100","label":"南昌市经济技术开发区","provinceId":"360000","value":"360131"}],"label":"南昌市","provinceId":"360000","value":"360100"},{"children":[{"cityId":"360200","label":"昌江区","provinceId":"360000","value":"360202"},{"cityId":"360200","label":"珠山区","provinceId":"360000","value":"360203"},{"cityId":"360200","label":"浮梁县","provinceId":"360000","value":"360222"},{"cityId":"360200","label":"乐平市","provinceId":"360000","value":"360281"}],"label":"景德镇市","provinceId":"360000","value":"360200"},{"children":[{"cityId":"360300","label":"安源区","provinceId":"360000","value":"360302"},{"cityId":"360300","label":"湘东区","provinceId":"360000","value":"360313"},{"cityId":"360300","label":"莲花县","provinceId":"360000","value":"360321"},{"cityId":"360300","label":"上栗县","provinceId":"360000","value":"360322"},{"cityId":"360300","label":"芦溪县","provinceId":"360000","value":"360323"}],"label":"萍乡市","provinceId":"360000","value":"360300"},{"children":[{"cityId":"360400","label":"庐山区","provinceId":"360000","value":"360402"},{"cityId":"360400","label":"浔阳区","provinceId":"360000","value":"360403"},{"cityId":"360400","label":"濂溪区","provinceId":"360000","value":"360410"},{"cityId":"360400","label":"共青城市","provinceId":"360000","value":"360411"},{"cityId":"360400","label":"庐山市","provinceId":"360000","value":"360412"},{"cityId":"360400","label":"九江县","provinceId":"360000","value":"360421"},{"cityId":"360400","label":"武宁县","provinceId":"360000","value":"360423"},{"cityId":"360400","label":"修水县","provinceId":"360000","value":"360424"},{"cityId":"360400","label":"永修县","provinceId":"360000","value":"360425"},{"cityId":"360400","label":"德安县","provinceId":"360000","value":"360426"},{"cityId":"360400","label":"星子县","provinceId":"360000","value":"360427"},{"cityId":"360400","label":"都昌县","provinceId":"360000","value":"360428"},{"cityId":"360400","label":"湖口县","provinceId":"360000","value":"360429"},{"cityId":"360400","label":"彭泽县","provinceId":"360000","value":"360430"},{"cityId":"360400","label":"瑞昌市","provinceId":"360000","value":"360481"}],"label":"九江市","provinceId":"360000","value":"360400"},{"children":[{"cityId":"360500","label":"渝水区","provinceId":"360000","value":"360502"},{"cityId":"360500","label":"分宜县","provinceId":"360000","value":"360521"}],"label":"新余市","provinceId":"360000","value":"360500"},{"children":[{"cityId":"360600","label":"月湖区","provinceId":"360000","value":"360602"},{"cityId":"360600","label":"余江县","provinceId":"360000","value":"360622"},{"cityId":"360600","label":"贵溪市","provinceId":"360000","value":"360681"}],"label":"鹰潭市","provinceId":"360000","value":"360600"},{"children":[{"cityId":"360700","label":"章贡区","provinceId":"360000","value":"360702"},{"cityId":"360700","label":"赣州市经济技术开发区","provinceId":"360000","value":"360711"},{"cityId":"360700","label":"赣县","provinceId":"360000","value":"360721"},{"cityId":"360700","label":"信丰县","provinceId":"360000","value":"360722"},{"cityId":"360700","label":"大余县","provinceId":"360000","value":"360723"},{"cityId":"360700","label":"上犹县","provinceId":"360000","value":"360724"},{"cityId":"360700","label":"崇义县","provinceId":"360000","value":"360725"},{"cityId":"360700","label":"安远县","provinceId":"360000","value":"360726"},{"cityId":"360700","label":"龙南县","provinceId":"360000","value":"360727"},{"cityId":"360700","label":"定南县","provinceId":"360000","value":"360728"},{"cityId":"360700","label":"全南县","provinceId":"360000","value":"360729"},{"cityId":"360700","label":"宁都县","provinceId":"360000","value":"360730"},{"cityId":"360700","label":"于都县","provinceId":"360000","value":"360731"},{"cityId":"360700","label":"兴国县","provinceId":"360000","value":"360732"},{"cityId":"360700","label":"会昌县","provinceId":"360000","value":"360733"},{"cityId":"360700","label":"寻乌县","provinceId":"360000","value":"360734"},{"cityId":"360700","label":"石城县","provinceId":"360000","value":"360735"},{"cityId":"360700","label":"瑞金市","provinceId":"360000","value":"360781"},{"cityId":"360700","label":"南康区","provinceId":"360000","value":"360782"}],"label":"赣州市","provinceId":"360000","value":"360700"},{"children":[{"cityId":"360800","label":"吉州区","provinceId":"360000","value":"360802"},{"cityId":"360800","label":"青原区","provinceId":"360000","value":"360803"},{"cityId":"360800","label":"吉安县","provinceId":"360000","value":"360821"},{"cityId":"360800","label":"吉水县","provinceId":"360000","value":"360822"},{"cityId":"360800","label":"峡江县","provinceId":"360000","value":"360823"},{"cityId":"360800","label":"新干县","provinceId":"360000","value":"360824"},{"cityId":"360800","label":"永丰县","provinceId":"360000","value":"360825"},{"cityId":"360800","label":"泰和县","provinceId":"360000","value":"360826"},{"cityId":"360800","label":"遂川县","provinceId":"360000","value":"360827"},{"cityId":"360800","label":"万安县","provinceId":"360000","value":"360828"},{"cityId":"360800","label":"安福县","provinceId":"360000","value":"360829"},{"cityId":"360800","label":"永新县","provinceId":"360000","value":"360830"},{"cityId":"360800","label":"井冈山市","provinceId":"360000","value":"360881"}],"label":"吉安市","provinceId":"360000","value":"360800"},{"children":[{"cityId":"360900","label":"袁州区","provinceId":"360000","value":"360902"},{"cityId":"360900","label":"奉新县","provinceId":"360000","value":"360921"},{"cityId":"360900","label":"万载县","provinceId":"360000","value":"360922"},{"cityId":"360900","label":"上高县","provinceId":"360000","value":"360923"},{"cityId":"360900","label":"宜丰县","provinceId":"360000","value":"360924"},{"cityId":"360900","label":"靖安县","provinceId":"360000","value":"360925"},{"cityId":"360900","label":"铜鼓县","provinceId":"360000","value":"360926"},{"cityId":"360900","label":"丰城市","provinceId":"360000","value":"360981"},{"cityId":"360900","label":"樟树市","provinceId":"360000","value":"360982"},{"cityId":"360900","label":"高安市","provinceId":"360000","value":"360983"}],"label":"宜春市","provinceId":"360000","value":"360900"},{"children":[{"cityId":"361000","label":"临川区","provinceId":"360000","value":"361002"},{"cityId":"361000","label":"南城县","provinceId":"360000","value":"361021"},{"cityId":"361000","label":"黎川县","provinceId":"360000","value":"361022"},{"cityId":"361000","label":"南丰县","provinceId":"360000","value":"361023"},{"cityId":"361000","label":"崇仁县","provinceId":"360000","value":"361024"},{"cityId":"361000","label":"乐安县","provinceId":"360000","value":"361025"},{"cityId":"361000","label":"宜黄县","provinceId":"360000","value":"361026"},{"cityId":"361000","label":"金溪县","provinceId":"360000","value":"361027"},{"cityId":"361000","label":"资溪县","provinceId":"360000","value":"361028"},{"cityId":"361000","label":"东乡县","provinceId":"360000","value":"361029"},{"cityId":"361000","label":"广昌县","provinceId":"360000","value":"361030"}],"label":"抚州市","provinceId":"360000","value":"361000"},{"children":[{"cityId":"361100","label":"信州区","provinceId":"360000","value":"361102"},{"cityId":"361100","label":"上饶县","provinceId":"360000","value":"361121"},{"cityId":"361100","label":"广丰区","provinceId":"360000","value":"361122"},{"cityId":"361100","label":"玉山县","provinceId":"360000","value":"361123"},{"cityId":"361100","label":"铅山县","provinceId":"360000","value":"361124"},{"cityId":"361100","label":"横峰县","provinceId":"360000","value":"361125"},{"cityId":"361100","label":"弋阳县","provinceId":"360000","value":"361126"},{"cityId":"361100","label":"余干县","provinceId":"360000","value":"361127"},{"cityId":"361100","label":"鄱阳县","provinceId":"360000","value":"361128"},{"cityId":"361100","label":"万年县","provinceId":"360000","value":"361129"},{"cityId":"361100","label":"婺源县","provinceId":"360000","value":"361130"},{"cityId":"361100","label":"德兴市","provinceId":"360000","value":"361181"}],"label":"上饶市","provinceId":"360000","value":"361100"}],"label":"江西省","value":"360000"},{"children":[{"children":[{"cityId":"370100","label":"历下区","provinceId":"370000","value":"370102"},{"cityId":"370100","label":"市中区","provinceId":"370000","value":"370103"},{"cityId":"370100","label":"槐荫区","provinceId":"370000","value":"370104"},{"cityId":"370100","label":"天桥区","provinceId":"370000","value":"370105"},{"cityId":"370100","label":"历城区","provinceId":"370000","value":"370112"},{"cityId":"370100","label":"长清区","provinceId":"370000","value":"370113"},{"cityId":"370100","label":"平阴县","provinceId":"370000","value":"370124"},{"cityId":"370100","label":"济阳县","provinceId":"370000","value":"370125"},{"cityId":"370100","label":"商河县","provinceId":"370000","value":"370126"},{"cityId":"370100","label":"章丘市","provinceId":"370000","value":"370181"}],"label":"济南市","provinceId":"370000","value":"370100"},{"children":[{"cityId":"370200","label":"市南区","provinceId":"370000","value":"370202"},{"cityId":"370200","label":"市北区","provinceId":"370000","value":"370203"},{"cityId":"370200","label":"四方区","provinceId":"370000","value":"370205"},{"cityId":"370200","label":"黄岛区","provinceId":"370000","value":"370211"},{"cityId":"370200","label":"崂山区","provinceId":"370000","value":"370212"},{"cityId":"370200","label":"李沧区","provinceId":"370000","value":"370213"},{"cityId":"370200","label":"城阳区","provinceId":"370000","value":"370214"},{"cityId":"370200","label":"胶州市","provinceId":"370000","value":"370281"},{"cityId":"370200","label":"即墨市","provinceId":"370000","value":"370282"},{"cityId":"370200","label":"平度市","provinceId":"370000","value":"370283"},{"cityId":"370200","label":"胶南市","provinceId":"370000","value":"370284"},{"cityId":"370200","label":"莱西市","provinceId":"370000","value":"370285"},{"cityId":"370200","label":"开发区","provinceId":"370000","value":"370287"}],"label":"青岛市","provinceId":"370000","value":"370200"},{"children":[{"cityId":"370300","label":"淄川区","provinceId":"370000","value":"370302"},{"cityId":"370300","label":"张店区","provinceId":"370000","value":"370303"},{"cityId":"370300","label":"博山区","provinceId":"370000","value":"370304"},{"cityId":"370300","label":"临淄区","provinceId":"370000","value":"370305"},{"cityId":"370300","label":"周村区","provinceId":"370000","value":"370306"},{"cityId":"370300","label":"桓台县","provinceId":"370000","value":"370321"},{"cityId":"370300","label":"高青县","provinceId":"370000","value":"370322"},{"cityId":"370300","label":"沂源县","provinceId":"370000","value":"370323"}],"label":"淄博市","provinceId":"370000","value":"370300"},{"children":[{"cityId":"370400","label":"市中区","provinceId":"370000","value":"370402"},{"cityId":"370400","label":"薛城区","provinceId":"370000","value":"370403"},{"cityId":"370400","label":"峄城区","provinceId":"370000","value":"370404"},{"cityId":"370400","label":"台儿庄区","provinceId":"370000","value":"370405"},{"cityId":"370400","label":"山亭区","provinceId":"370000","value":"370406"},{"cityId":"370400","label":"滕州市","provinceId":"370000","value":"370481"}],"label":"枣庄市","provinceId":"370000","value":"370400"},{"children":[{"cityId":"370500","label":"东城","provinceId":"370000","value":"370501"},{"cityId":"370500","label":"东营区","provinceId":"370000","value":"370502"},{"cityId":"370500","label":"河口区","provinceId":"370000","value":"370503"},{"cityId":"370500","label":"东营港","provinceId":"370000","value":"370504"},{"cityId":"370500","label":"西城","provinceId":"370000","value":"370505"},{"cityId":"370500","label":"垦利区","provinceId":"370000","value":"370521"},{"cityId":"370500","label":"利津县","provinceId":"370000","value":"370522"},{"cityId":"370500","label":"广饶县","provinceId":"370000","value":"370523"}],"label":"东营市","provinceId":"370000","value":"370500"},{"children":[{"cityId":"370600","label":"芝罘区","provinceId":"370000","value":"370602"},{"cityId":"370600","label":"福山区","provinceId":"370000","value":"370611"},{"cityId":"370600","label":"牟平区","provinceId":"370000","value":"370612"},{"cityId":"370600","label":"莱山区","provinceId":"370000","value":"370613"},{"cityId":"370600","label":"开发区","provinceId":"370000","value":"370614"},{"cityId":"370600","label":"长岛县","provinceId":"370000","value":"370634"},{"cityId":"370600","label":"龙口市","provinceId":"370000","value":"370681"},{"cityId":"370600","label":"莱阳市","provinceId":"370000","value":"370682"},{"cityId":"370600","label":"莱州市","provinceId":"370000","value":"370683"},{"cityId":"370600","label":"蓬莱市","provinceId":"370000","value":"370684"},{"cityId":"370600","label":"招远市","provinceId":"370000","value":"370685"},{"cityId":"370600","label":"栖霞市","provinceId":"370000","value":"370686"},{"cityId":"370600","label":"海阳市","provinceId":"370000","value":"370687"}],"label":"烟台市","provinceId":"370000","value":"370600"},{"children":[{"cityId":"370700","label":"潍城区","provinceId":"370000","value":"370702"},{"cityId":"370700","label":"寒亭区","provinceId":"370000","value":"370703"},{"cityId":"370700","label":"坊子区","provinceId":"370000","value":"370704"},{"cityId":"370700","label":"奎文区","provinceId":"370000","value":"370705"},{"cityId":"370700","label":"海化","provinceId":"370000","value":"370706"},{"cityId":"370700","label":"高新技术产业开发区","provinceId":"370000","value":"370710"},{"cityId":"370700","label":"临朐县","provinceId":"370000","value":"370724"},{"cityId":"370700","label":"昌乐县","provinceId":"370000","value":"370725"},{"cityId":"370700","label":"青州市","provinceId":"370000","value":"370781"},{"cityId":"370700","label":"诸城市","provinceId":"370000","value":"370782"},{"cityId":"370700","label":"寿光市","provinceId":"370000","value":"370783"},{"cityId":"370700","label":"安丘市","provinceId":"370000","value":"370784"},{"cityId":"370700","label":"高密市","provinceId":"370000","value":"370785"},{"cityId":"370700","label":"昌邑市","provinceId":"370000","value":"370786"}],"label":"潍坊市","provinceId":"370000","value":"370700"},{"children":[{"cityId":"370800","label":"市中区","provinceId":"370000","value":"370802"},{"cityId":"370800","label":"任城区","provinceId":"370000","value":"370811"},{"cityId":"370800","label":"微山县","provinceId":"370000","value":"370826"},{"cityId":"370800","label":"鱼台县","provinceId":"370000","value":"370827"},{"cityId":"370800","label":"金乡县","provinceId":"370000","value":"370828"},{"cityId":"370800","label":"嘉祥县","provinceId":"370000","value":"370829"},{"cityId":"370800","label":"汶上县","provinceId":"370000","value":"370830"},{"cityId":"370800","label":"泗水县","provinceId":"370000","value":"370831"},{"cityId":"370800","label":"梁山县","provinceId":"370000","value":"370832"},{"cityId":"370800","label":"曲阜市","provinceId":"370000","value":"370881"},{"cityId":"370800","label":"兖州区","provinceId":"370000","value":"370882"},{"cityId":"370800","label":"邹城市","provinceId":"370000","value":"370883"}],"label":"济宁市","provinceId":"370000","value":"370800"},{"children":[{"cityId":"370900","label":"泰山区","provinceId":"370000","value":"370902"},{"cityId":"370900","label":"岱岳区","provinceId":"370000","value":"370911"},{"cityId":"370900","label":"宁阳县","provinceId":"370000","value":"370921"},{"cityId":"370900","label":"东平县","provinceId":"370000","value":"370923"},{"cityId":"370900","label":"新泰市","provinceId":"370000","value":"370982"},{"cityId":"370900","label":"肥城市","provinceId":"370000","value":"370983"}],"label":"泰安市","provinceId":"370000","value":"370900"},{"children":[{"cityId":"371000","label":"环翠区","provinceId":"370000","value":"371002"},{"cityId":"371000","label":"经济技术开发区","provinceId":"370000","value":"371010"},{"cityId":"371000","label":"火炬高技术产业开发区","provinceId":"370000","value":"371011"},{"cityId":"371000","label":"文登区","provinceId":"370000","value":"371081"},{"cityId":"371000","label":"荣成市","provinceId":"370000","value":"371082"},{"cityId":"371000","label":"乳山市","provinceId":"370000","value":"371083"},{"cityId":"371000","label":"石岛","provinceId":"370000","value":"371084"}],"label":"威海市","provinceId":"370000","value":"371000"},{"children":[{"cityId":"371100","label":"东港区","provinceId":"370000","value":"371102"},{"cityId":"371100","label":"岚山区","provinceId":"370000","value":"371103"},{"cityId":"371100","label":"经济技术开发区","provinceId":"370000","value":"371110"},{"cityId":"371100","label":"五莲县","provinceId":"370000","value":"371121"},{"cityId":"371100","label":"莒县","provinceId":"370000","value":"371122"}],"label":"日照市","provinceId":"370000","value":"371100"},{"children":[{"cityId":"371200","label":"莱城区","provinceId":"370000","value":"371202"},{"cityId":"371200","label":"钢城区","provinceId":"370000","value":"371203"}],"label":"莱芜市","provinceId":"370000","value":"371200"},{"children":[{"cityId":"371300","label":"兰山区","provinceId":"370000","value":"371302"},{"cityId":"371300","label":"北城新区","provinceId":"370000","value":"371305"},{"cityId":"371300","label":"临港经济开发区","provinceId":"370000","value":"371306"},{"cityId":"371300","label":"高新技术开发区","provinceId":"370000","value":"371307"},{"cityId":"371300","label":"河东经济开发区","provinceId":"370000","value":"371308"},{"cityId":"371300","label":"罗庄区","provinceId":"370000","value":"371311"},{"cityId":"371300","label":"河东区","provinceId":"370000","value":"371312"},{"cityId":"371300","label":"沂南县","provinceId":"370000","value":"371321"},{"cityId":"371300","label":"郯城县","provinceId":"370000","value":"371322"},{"cityId":"371300","label":"沂水县","provinceId":"370000","value":"371323"},{"cityId":"371300","label":"苍山县","provinceId":"370000","value":"371324"},{"cityId":"371300","label":"费县","provinceId":"370000","value":"371325"},{"cityId":"371300","label":"平邑县","provinceId":"370000","value":"371326"},{"cityId":"371300","label":"莒南县","provinceId":"370000","value":"371327"},{"cityId":"371300","label":"蒙阴县","provinceId":"370000","value":"371328"},{"cityId":"371300","label":"临沭县","provinceId":"370000","value":"371329"},{"cityId":"371300","label":"兰陵县","provinceId":"370000","value":"371330"}],"label":"临沂市","provinceId":"370000","value":"371300"},{"children":[{"cityId":"371400","label":"德城区","provinceId":"370000","value":"371402"},{"cityId":"371400","label":"陵城区","provinceId":"370000","value":"371421"},{"cityId":"371400","label":"宁津县","provinceId":"370000","value":"371422"},{"cityId":"371400","label":"庆云县","provinceId":"370000","value":"371423"},{"cityId":"371400","label":"临邑县","provinceId":"370000","value":"371424"},{"cityId":"371400","label":"齐河县","provinceId":"370000","value":"371425"},{"cityId":"371400","label":"平原县","provinceId":"370000","value":"371426"},{"cityId":"371400","label":"夏津县","provinceId":"370000","value":"371427"},{"cityId":"371400","label":"武城县","provinceId":"370000","value":"371428"},{"cityId":"371400","label":"乐陵市","provinceId":"370000","value":"371481"},{"cityId":"371400","label":"禹城市","provinceId":"370000","value":"371482"}],"label":"德州市","provinceId":"370000","value":"371400"},{"children":[{"cityId":"371500","label":"东昌府区","provinceId":"370000","value":"371502"},{"cityId":"371500","label":"阳谷县","provinceId":"370000","value":"371521"},{"cityId":"371500","label":"莘县","provinceId":"370000","value":"371522"},{"cityId":"371500","label":"茌平县","provinceId":"370000","value":"371523"},{"cityId":"371500","label":"东阿县","provinceId":"370000","value":"371524"},{"cityId":"371500","label":"冠县","provinceId":"370000","value":"371525"},{"cityId":"371500","label":"高唐县","provinceId":"370000","value":"371526"},{"cityId":"371500","label":"临清市","provinceId":"370000","value":"371581"}],"label":"聊城市","provinceId":"370000","value":"371500"},{"children":[{"cityId":"371600","label":"滨城区","provinceId":"370000","value":"371602"},{"cityId":"371600","label":"惠民县","provinceId":"370000","value":"371621"},{"cityId":"371600","label":"阳信县","provinceId":"370000","value":"371622"},{"cityId":"371600","label":"无棣县","provinceId":"370000","value":"371623"},{"cityId":"371600","label":"沾化区","provinceId":"370000","value":"371624"},{"cityId":"371600","label":"博兴县","provinceId":"370000","value":"371625"},{"cityId":"371600","label":"邹平县","provinceId":"370000","value":"371626"},{"cityId":"371600","label":"滨州高新技术产业开发区","provinceId":"370000","value":"371698"},{"cityId":"371600","label":"滨州高新技术产业开发区","provinceId":"370000","value":"371699"}],"label":"滨州市","provinceId":"370000","value":"371600"},{"children":[{"cityId":"371700","label":"牡丹区","provinceId":"370000","value":"371702"},{"cityId":"371700","label":"曹县","provinceId":"370000","value":"371721"},{"cityId":"371700","label":"单县","provinceId":"370000","value":"371722"},{"cityId":"371700","label":"成武县","provinceId":"370000","value":"371723"},{"cityId":"371700","label":"巨野县","provinceId":"370000","value":"371724"},{"cityId":"371700","label":"郓城县","provinceId":"370000","value":"371725"},{"cityId":"371700","label":"鄄城县","provinceId":"370000","value":"371726"},{"cityId":"371700","label":"定陶区","provinceId":"370000","value":"371727"},{"cityId":"371700","label":"东明县","provinceId":"370000","value":"371728"},{"cityId":"371700","label":"开发区","provinceId":"370000","value":"371790"},{"cityId":"371700","label":"高新区","provinceId":"370000","value":"371798"}],"label":"菏泽市","provinceId":"370000","value":"371700"}],"label":"山东省","value":"370000"},{"children":[{"children":[{"cityId":"410100","label":"中原区","provinceId":"410000","value":"410102"},{"cityId":"410100","label":"二七区","provinceId":"410000","value":"410103"},{"cityId":"410100","label":"管城回族区","provinceId":"410000","value":"410104"},{"cityId":"410100","label":"金水区","provinceId":"410000","value":"410105"},{"cityId":"410100","label":"上街区","provinceId":"410000","value":"410106"},{"cityId":"410100","label":"惠济区","provinceId":"410000","value":"410108"},{"cityId":"410100","label":"中牟县","provinceId":"410000","value":"410122"},{"cityId":"410100","label":"郑东新区","provinceId":"410000","value":"410144"},{"cityId":"410100","label":"巩义市","provinceId":"410000","value":"410181"},{"cityId":"410100","label":"荥阳市","provinceId":"410000","value":"410182"},{"cityId":"410100","label":"新密市","provinceId":"410000","value":"410183"},{"cityId":"410100","label":"新郑市","provinceId":"410000","value":"410184"},{"cityId":"410100","label":"登封市","provinceId":"410000","value":"410185"}],"label":"郑州市","provinceId":"410000","value":"410100"},{"children":[{"cityId":"410200","label":"龙亭区","provinceId":"410000","value":"410202"},{"cityId":"410200","label":"顺河回族区","provinceId":"410000","value":"410203"},{"cityId":"410200","label":"鼓楼区","provinceId":"410000","value":"410204"},{"cityId":"410200","label":"禹王台区","provinceId":"410000","value":"410205"},{"cityId":"410200","label":"金明区","provinceId":"410000","value":"410211"},{"cityId":"410200","label":"杞县","provinceId":"410000","value":"410221"},{"cityId":"410200","label":"通许县","provinceId":"410000","value":"410222"},{"cityId":"410200","label":"尉氏县","provinceId":"410000","value":"410223"},{"cityId":"410200","label":"开封县","provinceId":"410000","value":"410224"},{"cityId":"410200","label":"兰考县","provinceId":"410000","value":"410225"}],"label":"开封市","provinceId":"410000","value":"410200"},{"children":[{"cityId":"410300","label":"老城区","provinceId":"410000","value":"410302"},{"cityId":"410300","label":"西工区","provinceId":"410000","value":"410303"},{"cityId":"410300","label":"瀍河回族区","provinceId":"410000","value":"410304"},{"cityId":"410300","label":"涧西区","provinceId":"410000","value":"410305"},{"cityId":"410300","label":"吉利区","provinceId":"410000","value":"410306"},{"cityId":"410300","label":"洛龙区","provinceId":"410000","value":"410311"},{"cityId":"410300","label":"孟津县","provinceId":"410000","value":"410322"},{"cityId":"410300","label":"新安县","provinceId":"410000","value":"410323"},{"cityId":"410300","label":"栾川县","provinceId":"410000","value":"410324"},{"cityId":"410300","label":"嵩县","provinceId":"410000","value":"410325"},{"cityId":"410300","label":"汝阳县","provinceId":"410000","value":"410326"},{"cityId":"410300","label":"宜阳县","provinceId":"410000","value":"410327"},{"cityId":"410300","label":"洛宁县","provinceId":"410000","value":"410328"},{"cityId":"410300","label":"伊川县","provinceId":"410000","value":"410329"},{"cityId":"410300","label":"偃师市","provinceId":"410000","value":"410381"}],"label":"洛阳市","provinceId":"410000","value":"410300"},{"children":[{"cityId":"410400","label":"新华区","provinceId":"410000","value":"410402"},{"cityId":"410400","label":"卫东区","provinceId":"410000","value":"410403"},{"cityId":"410400","label":"石龙区","provinceId":"410000","value":"410404"},{"cityId":"410400","label":"湛河区","provinceId":"410000","value":"410411"},{"cityId":"410400","label":"宝丰县","provinceId":"410000","value":"410421"},{"cityId":"410400","label":"叶县","provinceId":"410000","value":"410422"},{"cityId":"410400","label":"鲁山县","provinceId":"410000","value":"410423"},{"cityId":"410400","label":"郏县","provinceId":"410000","value":"410425"},{"cityId":"410400","label":"舞钢市","provinceId":"410000","value":"410481"},{"cityId":"410400","label":"汝州市","provinceId":"410000","value":"410482"}],"label":"平顶山市","provinceId":"410000","value":"410400"},{"children":[{"cityId":"410500","label":"文峰区","provinceId":"410000","value":"410502"},{"cityId":"410500","label":"北关区","provinceId":"410000","value":"410503"},{"cityId":"410500","label":"殷都区","provinceId":"410000","value":"410505"},{"cityId":"410500","label":"龙安区","provinceId":"410000","value":"410506"},{"cityId":"410500","label":"安阳县","provinceId":"410000","value":"410522"},{"cityId":"410500","label":"汤阴县","provinceId":"410000","value":"410523"},{"cityId":"410500","label":"滑县","provinceId":"410000","value":"410526"},{"cityId":"410500","label":"内黄县","provinceId":"410000","value":"410527"},{"cityId":"410500","label":"林州市","provinceId":"410000","value":"410581"}],"label":"安阳市","provinceId":"410000","value":"410500"},{"children":[{"cityId":"410600","label":"鹤山区","provinceId":"410000","value":"410602"},{"cityId":"410600","label":"山城区","provinceId":"410000","value":"410603"},{"cityId":"410600","label":"淇滨区","provinceId":"410000","value":"410611"},{"cityId":"410600","label":"浚县","provinceId":"410000","value":"410621"},{"cityId":"410600","label":"淇县","provinceId":"410000","value":"410622"}],"label":"鹤壁市","provinceId":"410000","value":"410600"},{"children":[{"cityId":"410700","label":"红旗区","provinceId":"410000","value":"410702"},{"cityId":"410700","label":"卫滨区","provinceId":"410000","value":"410703"},{"cityId":"410700","label":"凤泉区","provinceId":"410000","value":"410704"},{"cityId":"410700","label":"牧野区","provinceId":"410000","value":"410711"},{"cityId":"410700","label":"新乡县","provinceId":"410000","value":"410721"},{"cityId":"410700","label":"获嘉县","provinceId":"410000","value":"410724"},{"cityId":"410700","label":"原阳县","provinceId":"410000","value":"410725"},{"cityId":"410700","label":"延津县","provinceId":"410000","value":"410726"},{"cityId":"410700","label":"封丘县","provinceId":"410000","value":"410727"},{"cityId":"410700","label":"长垣县","provinceId":"410000","value":"410728"},{"cityId":"410700","label":"卫辉市","provinceId":"410000","value":"410781"},{"cityId":"410700","label":"辉县市","provinceId":"410000","value":"410782"}],"label":"新乡市","provinceId":"410000","value":"410700"},{"children":[{"cityId":"410800","label":"解放区","provinceId":"410000","value":"410802"},{"cityId":"410800","label":"中站区","provinceId":"410000","value":"410803"},{"cityId":"410800","label":"马村区","provinceId":"410000","value":"410804"},{"cityId":"410800","label":"山阳区","provinceId":"410000","value":"410811"},{"cityId":"410800","label":"修武县","provinceId":"410000","value":"410821"},{"cityId":"410800","label":"博爱县","provinceId":"410000","value":"410822"},{"cityId":"410800","label":"武陟县","provinceId":"410000","value":"410823"},{"cityId":"410800","label":"温县","provinceId":"410000","value":"410825"},{"cityId":"410800","label":"沁阳市","provinceId":"410000","value":"410882"},{"cityId":"410800","label":"孟州市","provinceId":"410000","value":"410883"}],"label":"焦作市","provinceId":"410000","value":"410800"},{"children":[{"cityId":"410900","label":"华龙区","provinceId":"410000","value":"410902"},{"cityId":"410900","label":"清丰县","provinceId":"410000","value":"410922"},{"cityId":"410900","label":"南乐县","provinceId":"410000","value":"410923"},{"cityId":"410900","label":"范县","provinceId":"410000","value":"410926"},{"cityId":"410900","label":"台前县","provinceId":"410000","value":"410927"},{"cityId":"410900","label":"濮阳县","provinceId":"410000","value":"410928"}],"label":"濮阳市","provinceId":"410000","value":"410900"},{"children":[{"cityId":"411000","label":"魏都区","provinceId":"410000","value":"411002"},{"cityId":"411000","label":"许昌县","provinceId":"410000","value":"411023"},{"cityId":"411000","label":"鄢陵县","provinceId":"410000","value":"411024"},{"cityId":"411000","label":"襄城县","provinceId":"410000","value":"411025"},{"cityId":"411000","label":"禹州市","provinceId":"410000","value":"411081"},{"cityId":"411000","label":"长葛市","provinceId":"410000","value":"411082"}],"label":"许昌市","provinceId":"410000","value":"411000"},{"children":[{"cityId":"411100","label":"源汇区","provinceId":"410000","value":"411102"},{"cityId":"411100","label":"郾城区","provinceId":"410000","value":"411103"},{"cityId":"411100","label":"召陵区","provinceId":"410000","value":"411104"},{"cityId":"411100","label":"舞阳县","provinceId":"410000","value":"411121"},{"cityId":"411100","label":"临颍县","provinceId":"410000","value":"411122"}],"label":"漯河市","provinceId":"410000","value":"411100"},{"children":[{"cityId":"411200","label":"湖滨区","provinceId":"410000","value":"411202"},{"cityId":"411200","label":"陕州区","provinceId":"410000","value":"411203"},{"cityId":"411200","label":"渑池县","provinceId":"410000","value":"411221"},{"cityId":"411200","label":"陕　县","provinceId":"410000","value":"411222"},{"cityId":"411200","label":"卢氏县","provinceId":"410000","value":"411224"},{"cityId":"411200","label":"义马市","provinceId":"410000","value":"411281"},{"cityId":"411200","label":"灵宝市","provinceId":"410000","value":"411282"}],"label":"三门峡市","provinceId":"410000","value":"411200"},{"children":[{"cityId":"411300","label":"宛城区","provinceId":"410000","value":"411302"},{"cityId":"411300","label":"卧龙区","provinceId":"410000","value":"411303"},{"cityId":"411300","label":"南召县","provinceId":"410000","value":"411321"},{"cityId":"411300","label":"方城县","provinceId":"410000","value":"411322"},{"cityId":"411300","label":"西峡县","provinceId":"410000","value":"411323"},{"cityId":"411300","label":"镇平县","provinceId":"410000","value":"411324"},{"cityId":"411300","label":"内乡县","provinceId":"410000","value":"411325"},{"cityId":"411300","label":"淅川县","provinceId":"410000","value":"411326"},{"cityId":"411300","label":"社旗县","provinceId":"410000","value":"411327"},{"cityId":"411300","label":"唐河县","provinceId":"410000","value":"411328"},{"cityId":"411300","label":"新野县","provinceId":"410000","value":"411329"},{"cityId":"411300","label":"桐柏县","provinceId":"410000","value":"411330"},{"cityId":"411300","label":"邓州市","provinceId":"410000","value":"411381"}],"label":"南阳市","provinceId":"410000","value":"411300"},{"children":[{"cityId":"411400","label":"梁园区","provinceId":"410000","value":"411402"},{"cityId":"411400","label":"睢阳区","provinceId":"410000","value":"411403"},{"cityId":"411400","label":"民权县","provinceId":"410000","value":"411421"},{"cityId":"411400","label":"睢县","provinceId":"410000","value":"411422"},{"cityId":"411400","label":"宁陵县","provinceId":"410000","value":"411423"},{"cityId":"411400","label":"柘城县","provinceId":"410000","value":"411424"},{"cityId":"411400","label":"虞城县","provinceId":"410000","value":"411425"},{"cityId":"411400","label":"夏邑县","provinceId":"410000","value":"411426"},{"cityId":"411400","label":"永城市","provinceId":"410000","value":"411481"}],"label":"商丘市","provinceId":"410000","value":"411400"},{"children":[{"cityId":"411500","label":"浉河区","provinceId":"410000","value":"411502"},{"cityId":"411500","label":"平桥区","provinceId":"410000","value":"411503"},{"cityId":"411500","label":"罗山县","provinceId":"410000","value":"411521"},{"cityId":"411500","label":"光山县","provinceId":"410000","value":"411522"},{"cityId":"411500","label":"新县","provinceId":"410000","value":"411523"},{"cityId":"411500","label":"商城县","provinceId":"410000","value":"411524"},{"cityId":"411500","label":"固始县","provinceId":"410000","value":"411525"},{"cityId":"411500","label":"潢川县","provinceId":"410000","value":"411526"},{"cityId":"411500","label":"淮滨县","provinceId":"410000","value":"411527"},{"cityId":"411500","label":"息县","provinceId":"410000","value":"411528"},{"cityId":"411500","label":"羊山新区","provinceId":"410000","value":"411530"}],"label":"信阳市","provinceId":"410000","value":"411500"},{"children":[{"cityId":"411600","label":"川汇区","provinceId":"410000","value":"411602"},{"cityId":"411600","label":"扶沟县","provinceId":"410000","value":"411621"},{"cityId":"411600","label":"西华县","provinceId":"410000","value":"411622"},{"cityId":"411600","label":"商水县","provinceId":"410000","value":"411623"},{"cityId":"411600","label":"沈丘县","provinceId":"410000","value":"411624"},{"cityId":"411600","label":"郸城县","provinceId":"410000","value":"411625"},{"cityId":"411600","label":"淮阳县","provinceId":"410000","value":"411626"},{"cityId":"411600","label":"太康县","provinceId":"410000","value":"411627"},{"cityId":"411600","label":"鹿邑县","provinceId":"410000","value":"411628"},{"cityId":"411600","label":"项城市","provinceId":"410000","value":"411681"}],"label":"周口市","provinceId":"410000","value":"411600"},{"children":[{"cityId":"411700","label":"驿城区","provinceId":"410000","value":"411702"},{"cityId":"411700","label":"西平县","provinceId":"410000","value":"411721"},{"cityId":"411700","label":"上蔡县","provinceId":"410000","value":"411722"},{"cityId":"411700","label":"平舆县","provinceId":"410000","value":"411723"},{"cityId":"411700","label":"正阳县","provinceId":"410000","value":"411724"},{"cityId":"411700","label":"确山县","provinceId":"410000","value":"411725"},{"cityId":"411700","label":"泌阳县","provinceId":"410000","value":"411726"},{"cityId":"411700","label":"汝南县","provinceId":"410000","value":"411727"},{"cityId":"411700","label":"遂平县","provinceId":"410000","value":"411728"},{"cityId":"411700","label":"新蔡县","provinceId":"410000","value":"411729"}],"label":"驻马店市","provinceId":"410000","value":"411700"},{"children":[{"cityId":"419000","label":"济源市","provinceId":"410000","value":"419001"}],"label":"省直辖县级行政区划","provinceId":"410000","value":"419000"}],"label":"河南省","value":"410000"},{"children":[{"children":[{"cityId":"420100","label":"江岸区","provinceId":"420000","value":"420102"},{"cityId":"420100","label":"江汉区","provinceId":"420000","value":"420103"},{"cityId":"420100","label":"硚口区","provinceId":"420000","value":"420104"},{"cityId":"420100","label":"汉阳区","provinceId":"420000","value":"420105"},{"cityId":"420100","label":"武昌区","provinceId":"420000","value":"420106"},{"cityId":"420100","label":"青山区","provinceId":"420000","value":"420107"},{"cityId":"420100","label":"洪山区","provinceId":"420000","value":"420111"},{"cityId":"420100","label":"东西湖区","provinceId":"420000","value":"420112"},{"cityId":"420100","label":"汉南区","provinceId":"420000","value":"420113"},{"cityId":"420100","label":"蔡甸区","provinceId":"420000","value":"420114"},{"cityId":"420100","label":"江夏区","provinceId":"420000","value":"420115"},{"cityId":"420100","label":"黄陂区","provinceId":"420000","value":"420116"},{"cityId":"420100","label":"新洲区","provinceId":"420000","value":"420117"}],"label":"武汉市","provinceId":"420000","value":"420100"},{"children":[{"cityId":"420200","label":"黄石港区","provinceId":"420000","value":"420202"},{"cityId":"420200","label":"西塞山区","provinceId":"420000","value":"420203"},{"cityId":"420200","label":"下陆区","provinceId":"420000","value":"420204"},{"cityId":"420200","label":"铁山区","provinceId":"420000","value":"420205"},{"cityId":"420200","label":"阳新县","provinceId":"420000","value":"420222"},{"cityId":"420200","label":"大冶市","provinceId":"420000","value":"420281"}],"label":"黄石市","provinceId":"420000","value":"420200"},{"children":[{"cityId":"420300","label":"茅箭区","provinceId":"420000","value":"420302"},{"cityId":"420300","label":"张湾区","provinceId":"420000","value":"420303"},{"cityId":"420300","label":"郧阳区","provinceId":"420000","value":"420310"},{"cityId":"420300","label":"郧　县","provinceId":"420000","value":"420321"},{"cityId":"420300","label":"郧西县","provinceId":"420000","value":"420322"},{"cityId":"420300","label":"竹山县","provinceId":"420000","value":"420323"},{"cityId":"420300","label":"竹溪县","provinceId":"420000","value":"420324"},{"cityId":"420300","label":"房县","provinceId":"420000","value":"420325"},{"cityId":"420300","label":"丹江口市","provinceId":"420000","value":"420381"}],"label":"十堰市","provinceId":"420000","value":"420300"},{"children":[{"cityId":"420500","label":"西陵区","provinceId":"420000","value":"420502"},{"cityId":"420500","label":"伍家岗区","provinceId":"420000","value":"420503"},{"cityId":"420500","label":"点军区","provinceId":"420000","value":"420504"},{"cityId":"420500","label":"猇亭区","provinceId":"420000","value":"420505"},{"cityId":"420500","label":"夷陵区","provinceId":"420000","value":"420506"},{"cityId":"420500","label":"远安县","provinceId":"420000","value":"420525"},{"cityId":"420500","label":"兴山县","provinceId":"420000","value":"420526"},{"cityId":"420500","label":"秭归县","provinceId":"420000","value":"420527"},{"cityId":"420500","label":"长阳土家族自治县","provinceId":"420000","value":"420528"},{"cityId":"420500","label":"五峰土家族自治县","provinceId":"420000","value":"420529"},{"cityId":"420500","label":"宜都市","provinceId":"420000","value":"420581"},{"cityId":"420500","label":"当阳市","provinceId":"420000","value":"420582"},{"cityId":"420500","label":"枝江市","provinceId":"420000","value":"420583"}],"label":"宜昌市","provinceId":"420000","value":"420500"},{"children":[{"cityId":"420600","label":"襄城区","provinceId":"420000","value":"420602"},{"cityId":"420600","label":"樊城区","provinceId":"420000","value":"420606"},{"cityId":"420600","label":"襄州区","provinceId":"420000","value":"420607"},{"cityId":"420600","label":"南漳县","provinceId":"420000","value":"420624"},{"cityId":"420600","label":"谷城县","provinceId":"420000","value":"420625"},{"cityId":"420600","label":"保康县","provinceId":"420000","value":"420626"},{"cityId":"420600","label":"老河口市","provinceId":"420000","value":"420682"},{"cityId":"420600","label":"枣阳市","provinceId":"420000","value":"420683"},{"cityId":"420600","label":"宜城市","provinceId":"420000","value":"420684"}],"label":"襄阳市","provinceId":"420000","value":"420600"},{"children":[{"cityId":"420700","label":"梁子湖区","provinceId":"420000","value":"420702"},{"cityId":"420700","label":"华容区","provinceId":"420000","value":"420703"},{"cityId":"420700","label":"鄂城区","provinceId":"420000","value":"420704"}],"label":"鄂州市","provinceId":"420000","value":"420700"},{"children":[{"cityId":"420800","label":"东宝区","provinceId":"420000","value":"420802"},{"cityId":"420800","label":"掇刀区","provinceId":"420000","value":"420804"},{"cityId":"420800","label":"京山县","provinceId":"420000","value":"420821"},{"cityId":"420800","label":"沙洋县","provinceId":"420000","value":"420822"},{"cityId":"420800","label":"钟祥市","provinceId":"420000","value":"420881"}],"label":"荆门市","provinceId":"420000","value":"420800"},{"children":[{"cityId":"420900","label":"孝南区","provinceId":"420000","value":"420902"},{"cityId":"420900","label":"孝昌县","provinceId":"420000","value":"420921"},{"cityId":"420900","label":"大悟县","provinceId":"420000","value":"420922"},{"cityId":"420900","label":"云梦县","provinceId":"420000","value":"420923"},{"cityId":"420900","label":"应城市","provinceId":"420000","value":"420981"},{"cityId":"420900","label":"安陆市","provinceId":"420000","value":"420982"},{"cityId":"420900","label":"汉川市","provinceId":"420000","value":"420984"}],"label":"孝感市","provinceId":"420000","value":"420900"},{"children":[{"cityId":"421000","label":"沙市区","provinceId":"420000","value":"421002"},{"cityId":"421000","label":"荆州区","provinceId":"420000","value":"421003"},{"cityId":"421000","label":"公安县","provinceId":"420000","value":"421022"},{"cityId":"421000","label":"监利县","provinceId":"420000","value":"421023"},{"cityId":"421000","label":"江陵县","provinceId":"420000","value":"421024"},{"cityId":"421000","label":"石首市","provinceId":"420000","value":"421081"},{"cityId":"421000","label":"洪湖市","provinceId":"420000","value":"421083"},{"cityId":"421000","label":"松滋市","provinceId":"420000","value":"421087"}],"label":"荆州市","provinceId":"420000","value":"421000"},{"children":[{"cityId":"421100","label":"黄州区","provinceId":"420000","value":"421102"},{"cityId":"421100","label":"团风县","provinceId":"420000","value":"421121"},{"cityId":"421100","label":"红安县","provinceId":"420000","value":"421122"},{"cityId":"421100","label":"罗田县","provinceId":"420000","value":"421123"},{"cityId":"421100","label":"英山县","provinceId":"420000","value":"421124"},{"cityId":"421100","label":"浠水县","provinceId":"420000","value":"421125"},{"cityId":"421100","label":"蕲春县","provinceId":"420000","value":"421126"},{"cityId":"421100","label":"黄梅县","provinceId":"420000","value":"421127"},{"cityId":"421100","label":"麻城市","provinceId":"420000","value":"421181"},{"cityId":"421100","label":"武穴市","provinceId":"420000","value":"421182"}],"label":"黄冈市","provinceId":"420000","value":"421100"},{"children":[{"cityId":"421200","label":"咸安区","provinceId":"420000","value":"421202"},{"cityId":"421200","label":"嘉鱼县","provinceId":"420000","value":"421221"},{"cityId":"421200","label":"通城县","provinceId":"420000","value":"421222"},{"cityId":"421200","label":"崇阳县","provinceId":"420000","value":"421223"},{"cityId":"421200","label":"通山县","provinceId":"420000","value":"421224"},{"cityId":"421200","label":"赤壁市","provinceId":"420000","value":"421281"}],"label":"咸宁市","provinceId":"420000","value":"421200"},{"children":[{"cityId":"421300","label":"曾都区","provinceId":"420000","value":"421302"},{"cityId":"421300","label":"随县","provinceId":"420000","value":"421321"},{"cityId":"421300","label":"广水市","provinceId":"420000","value":"421381"}],"label":"随州市","provinceId":"420000","value":"421300"},{"children":[{"cityId":"422800","label":"恩施市","provinceId":"420000","value":"422801"},{"cityId":"422800","label":"利川市","provinceId":"420000","value":"422802"},{"cityId":"422800","label":"建始县","provinceId":"420000","value":"422822"},{"cityId":"422800","label":"巴东县","provinceId":"420000","value":"422823"},{"cityId":"422800","label":"宣恩县","provinceId":"420000","value":"422825"},{"cityId":"422800","label":"咸丰县","provinceId":"420000","value":"422826"},{"cityId":"422800","label":"来凤县","provinceId":"420000","value":"422827"},{"cityId":"422800","label":"鹤峰县","provinceId":"420000","value":"422828"}],"label":"恩施土家族苗族自治州","provinceId":"420000","value":"422800"},{"children":[{"cityId":"429000","label":"仙桃市","provinceId":"420000","value":"429004"},{"cityId":"429000","label":"潜江市","provinceId":"420000","value":"429005"},{"cityId":"429000","label":"天门市","provinceId":"420000","value":"429006"},{"cityId":"429000","label":"神农架林区","provinceId":"420000","value":"429021"}],"label":"省直辖县级行政区划","provinceId":"420000","value":"429000"}],"label":"湖北省","value":"420000"},{"children":[{"children":[{"cityId":"430100","label":"芙蓉区","provinceId":"430000","value":"430102"},{"cityId":"430100","label":"天心区","provinceId":"430000","value":"430103"},{"cityId":"430100","label":"岳麓区","provinceId":"430000","value":"430104"},{"cityId":"430100","label":"开福区","provinceId":"430000","value":"430105"},{"cityId":"430100","label":"雨花区","provinceId":"430000","value":"430111"},{"cityId":"430100","label":"长沙县","provinceId":"430000","value":"430121"},{"cityId":"430100","label":"望城区","provinceId":"430000","value":"430122"},{"cityId":"430100","label":"宁乡县","provinceId":"430000","value":"430124"},{"cityId":"430100","label":"浏阳市","provinceId":"430000","value":"430181"},{"cityId":"430100","label":"浏阳大瑶","provinceId":"430000","value":"430182"}],"label":"长沙市","provinceId":"430000","value":"430100"},{"children":[{"cityId":"430200","label":"荷塘区","provinceId":"430000","value":"430202"},{"cityId":"430200","label":"芦淞区","provinceId":"430000","value":"430203"},{"cityId":"430200","label":"石峰区","provinceId":"430000","value":"430204"},{"cityId":"430200","label":"天元区","provinceId":"430000","value":"430211"},{"cityId":"430200","label":"株洲县","provinceId":"430000","value":"430221"},{"cityId":"430200","label":"攸县","provinceId":"430000","value":"430223"},{"cityId":"430200","label":"茶陵县","provinceId":"430000","value":"430224"},{"cityId":"430200","label":"炎陵县","provinceId":"430000","value":"430225"},{"cityId":"430200","label":"醴陵市","provinceId":"430000","value":"430281"}],"label":"株洲市","provinceId":"430000","value":"430200"},{"children":[{"cityId":"430300","label":"雨湖区","provinceId":"430000","value":"430302"},{"cityId":"430300","label":"岳塘区","provinceId":"430000","value":"430304"},{"cityId":"430300","label":"湘潭县","provinceId":"430000","value":"430321"},{"cityId":"430300","label":"湘乡市","provinceId":"430000","value":"430381"},{"cityId":"430300","label":"韶山市","provinceId":"430000","value":"430382"}],"label":"湘潭市","provinceId":"430000","value":"430300"},{"children":[{"cityId":"430400","label":"珠晖区","provinceId":"430000","value":"430405"},{"cityId":"430400","label":"雁峰区","provinceId":"430000","value":"430406"},{"cityId":"430400","label":"石鼓区","provinceId":"430000","value":"430407"},{"cityId":"430400","label":"蒸湘区","provinceId":"430000","value":"430408"},{"cityId":"430400","label":"南岳区","provinceId":"430000","value":"430412"},{"cityId":"430400","label":"衡阳县","provinceId":"430000","value":"430421"},{"cityId":"430400","label":"衡南县","provinceId":"430000","value":"430422"},{"cityId":"430400","label":"衡山县","provinceId":"430000","value":"430423"},{"cityId":"430400","label":"衡东县","provinceId":"430000","value":"430424"},{"cityId":"430400","label":"祁东县","provinceId":"430000","value":"430426"},{"cityId":"430400","label":"耒阳市","provinceId":"430000","value":"430481"},{"cityId":"430400","label":"常宁市","provinceId":"430000","value":"430482"}],"label":"衡阳市","provinceId":"430000","value":"430400"},{"children":[{"cityId":"430500","label":"双清区","provinceId":"430000","value":"430502"},{"cityId":"430500","label":"大祥区","provinceId":"430000","value":"430503"},{"cityId":"430500","label":"北塔区","provinceId":"430000","value":"430511"},{"cityId":"430500","label":"邵东县","provinceId":"430000","value":"430521"},{"cityId":"430500","label":"新邵县","provinceId":"430000","value":"430522"},{"cityId":"430500","label":"邵阳县","provinceId":"430000","value":"430523"},{"cityId":"430500","label":"隆回县","provinceId":"430000","value":"430524"},{"cityId":"430500","label":"洞口县","provinceId":"430000","value":"430525"},{"cityId":"430500","label":"绥宁县","provinceId":"430000","value":"430527"},{"cityId":"430500","label":"新宁县","provinceId":"430000","value":"430528"},{"cityId":"430500","label":"城步苗族自治县","provinceId":"430000","value":"430529"},{"cityId":"430500","label":"武冈市","provinceId":"430000","value":"430581"}],"label":"邵阳市","provinceId":"430000","value":"430500"},{"children":[{"cityId":"430600","label":"岳阳楼区","provinceId":"430000","value":"430602"},{"cityId":"430600","label":"云溪区","provinceId":"430000","value":"430603"},{"cityId":"430600","label":"君山区","provinceId":"430000","value":"430611"},{"cityId":"430600","label":"岳阳县","provinceId":"430000","value":"430621"},{"cityId":"430600","label":"华容县","provinceId":"430000","value":"430623"},{"cityId":"430600","label":"湘阴县","provinceId":"430000","value":"430624"},{"cityId":"430600","label":"长炼","provinceId":"430000","value":"430625"},{"cityId":"430600","label":"平江县","provinceId":"430000","value":"430626"},{"cityId":"430600","label":"汨罗市","provinceId":"430000","value":"430681"},{"cityId":"430600","label":"临湘市","provinceId":"430000","value":"430682"}],"label":"岳阳市","provinceId":"430000","value":"430600"},{"children":[{"cityId":"430700","label":"武陵区","provinceId":"430000","value":"430702"},{"cityId":"430700","label":"鼎城区","provinceId":"430000","value":"430703"},{"cityId":"430700","label":"安乡县","provinceId":"430000","value":"430721"},{"cityId":"430700","label":"汉寿县","provinceId":"430000","value":"430722"},{"cityId":"430700","label":"澧县","provinceId":"430000","value":"430723"},{"cityId":"430700","label":"临澧县","provinceId":"430000","value":"430724"},{"cityId":"430700","label":"桃源县","provinceId":"430000","value":"430725"},{"cityId":"430700","label":"石门县","provinceId":"430000","value":"430726"},{"cityId":"430700","label":"津市市","provinceId":"430000","value":"430781"}],"label":"常德市","provinceId":"430000","value":"430700"},{"children":[{"cityId":"430800","label":"永定区","provinceId":"430000","value":"430802"},{"cityId":"430800","label":"武陵源区","provinceId":"430000","value":"430811"},{"cityId":"430800","label":"慈利县","provinceId":"430000","value":"430821"},{"cityId":"430800","label":"桑植县","provinceId":"430000","value":"430822"}],"label":"张家界市","provinceId":"430000","value":"430800"},{"children":[{"cityId":"430900","label":"资阳区","provinceId":"430000","value":"430902"},{"cityId":"430900","label":"赫山区","provinceId":"430000","value":"430903"},{"cityId":"430900","label":"高新区","provinceId":"430000","value":"430904"},{"cityId":"430900","label":"南县","provinceId":"430000","value":"430921"},{"cityId":"430900","label":"桃江县","provinceId":"430000","value":"430922"},{"cityId":"430900","label":"安化县","provinceId":"430000","value":"430923"},{"cityId":"430900","label":"沅江市","provinceId":"430000","value":"430981"}],"label":"益阳市","provinceId":"430000","value":"430900"},{"children":[{"cityId":"431000","label":"北湖区","provinceId":"430000","value":"431002"},{"cityId":"431000","label":"苏仙区","provinceId":"430000","value":"431003"},{"cityId":"431000","label":"桂阳县","provinceId":"430000","value":"431021"},{"cityId":"431000","label":"宜章县","provinceId":"430000","value":"431022"},{"cityId":"431000","label":"永兴县","provinceId":"430000","value":"431023"},{"cityId":"431000","label":"嘉禾县","provinceId":"430000","value":"431024"},{"cityId":"431000","label":"临武县","provinceId":"430000","value":"431025"},{"cityId":"431000","label":"汝城县","provinceId":"430000","value":"431026"},{"cityId":"431000","label":"桂东县","provinceId":"430000","value":"431027"},{"cityId":"431000","label":"安仁县","provinceId":"430000","value":"431028"},{"cityId":"431000","label":"资兴市","provinceId":"430000","value":"431081"}],"label":"郴州市","provinceId":"430000","value":"431000"},{"children":[{"cityId":"431100","label":"零陵区","provinceId":"430000","value":"431102"},{"cityId":"431100","label":"冷水滩区","provinceId":"430000","value":"431103"},{"cityId":"431100","label":"祁阳县","provinceId":"430000","value":"431121"},{"cityId":"431100","label":"东安县","provinceId":"430000","value":"431122"},{"cityId":"431100","label":"双牌县","provinceId":"430000","value":"431123"},{"cityId":"431100","label":"道县","provinceId":"430000","value":"431124"},{"cityId":"431100","label":"江永县","provinceId":"430000","value":"431125"},{"cityId":"431100","label":"宁远县","provinceId":"430000","value":"431126"},{"cityId":"431100","label":"蓝山县","provinceId":"430000","value":"431127"},{"cityId":"431100","label":"新田县","provinceId":"430000","value":"431128"},{"cityId":"431100","label":"江华瑶族自治县","provinceId":"430000","value":"431129"}],"label":"永州市","provinceId":"430000","value":"431100"},{"children":[{"cityId":"431200","label":"鹤城区","provinceId":"430000","value":"431202"},{"cityId":"431200","label":"中方县","provinceId":"430000","value":"431221"},{"cityId":"431200","label":"沅陵县","provinceId":"430000","value":"431222"},{"cityId":"431200","label":"辰溪县","provinceId":"430000","value":"431223"},{"cityId":"431200","label":"溆浦县","provinceId":"430000","value":"431224"},{"cityId":"431200","label":"会同县","provinceId":"430000","value":"431225"},{"cityId":"431200","label":"麻阳苗族自治县","provinceId":"430000","value":"431226"},{"cityId":"431200","label":"新晃侗族自治县","provinceId":"430000","value":"431227"},{"cityId":"431200","label":"芷江侗族自治县","provinceId":"430000","value":"431228"},{"cityId":"431200","label":"靖州苗族侗族自治县","provinceId":"430000","value":"431229"},{"cityId":"431200","label":"通道侗族自治县","provinceId":"430000","value":"431230"},{"cityId":"431200","label":"洪江市","provinceId":"430000","value":"431281"}],"label":"怀化市","provinceId":"430000","value":"431200"},{"children":[{"cityId":"431300","label":"娄星区","provinceId":"430000","value":"431302"},{"cityId":"431300","label":"双峰县","provinceId":"430000","value":"431321"},{"cityId":"431300","label":"新化县","provinceId":"430000","value":"431322"},{"cityId":"431300","label":"冷水江市","provinceId":"430000","value":"431381"},{"cityId":"431300","label":"涟源市","provinceId":"430000","value":"431382"}],"label":"娄底市","provinceId":"430000","value":"431300"},{"children":[{"cityId":"433100","label":"吉首市","provinceId":"430000","value":"433101"},{"cityId":"433100","label":"泸溪县","provinceId":"430000","value":"433122"},{"cityId":"433100","label":"凤凰县","provinceId":"430000","value":"433123"},{"cityId":"433100","label":"花垣县","provinceId":"430000","value":"433124"},{"cityId":"433100","label":"保靖县","provinceId":"430000","value":"433125"},{"cityId":"433100","label":"古丈县","provinceId":"430000","value":"433126"},{"cityId":"433100","label":"永顺县","provinceId":"430000","value":"433127"},{"cityId":"433100","label":"龙山县","provinceId":"430000","value":"433130"}],"label":"湘西土家族苗族自治州","provinceId":"430000","value":"433100"}],"label":"湖南省","value":"430000"},{"children":[{"children":[{"cityId":"440100","label":"荔湾区","provinceId":"440000","value":"440103"},{"cityId":"440100","label":"越秀区","provinceId":"440000","value":"440104"},{"cityId":"440100","label":"海珠区","provinceId":"440000","value":"440105"},{"cityId":"440100","label":"天河区","provinceId":"440000","value":"440106"},{"cityId":"440100","label":"白云区","provinceId":"440000","value":"440111"},{"cityId":"440100","label":"黄埔区","provinceId":"440000","value":"440112"},{"cityId":"440100","label":"番禺区","provinceId":"440000","value":"440113"},{"cityId":"440100","label":"花都区","provinceId":"440000","value":"440114"},{"cityId":"440100","label":"南沙区","provinceId":"440000","value":"440115"},{"cityId":"440100","label":"萝岗区","provinceId":"440000","value":"440116"},{"cityId":"440100","label":"开发区","provinceId":"440000","value":"440117"},{"cityId":"440100","label":"增城区","provinceId":"440000","value":"440183"},{"cityId":"440100","label":"从化区","provinceId":"440000","value":"440184"},{"cityId":"440100","label":"新塘","provinceId":"440000","value":"440185"}],"label":"广州市","provinceId":"440000","value":"440100"},{"children":[{"cityId":"440200","label":"武江区","provinceId":"440000","value":"440203"},{"cityId":"440200","label":"浈江区","provinceId":"440000","value":"440204"},{"cityId":"440200","label":"曲江区","provinceId":"440000","value":"440205"},{"cityId":"440200","label":"始兴县","provinceId":"440000","value":"440222"},{"cityId":"440200","label":"仁化县","provinceId":"440000","value":"440224"},{"cityId":"440200","label":"翁源县","provinceId":"440000","value":"440229"},{"cityId":"440200","label":"乳源瑶族自治县","provinceId":"440000","value":"440232"},{"cityId":"440200","label":"新丰县","provinceId":"440000","value":"440233"},{"cityId":"440200","label":"乐昌市","provinceId":"440000","value":"440281"},{"cityId":"440200","label":"南雄市","provinceId":"440000","value":"440282"}],"label":"韶关市","provinceId":"440000","value":"440200"},{"children":[{"cityId":"440300","label":"罗湖区","provinceId":"440000","value":"440303"},{"cityId":"440300","label":"福田区","provinceId":"440000","value":"440304"},{"cityId":"440300","label":"南山区","provinceId":"440000","value":"440305"},{"cityId":"440300","label":"宝安区","provinceId":"440000","value":"440306"},{"cityId":"440300","label":"龙岗区","provinceId":"440000","value":"440307"},{"cityId":"440300","label":"盐田区","provinceId":"440000","value":"440308"},{"cityId":"440300","label":"光明新区","provinceId":"440000","value":"440310"},{"cityId":"440300","label":"龙华新区","provinceId":"440000","value":"440311"},{"cityId":"440300","label":"坪山新区","provinceId":"440000","value":"440312"},{"cityId":"440300","label":"大鹏新区","provinceId":"440000","value":"440313"},{"cityId":"440300","label":"前海区","provinceId":"440000","value":"440314"}],"label":"深圳市","provinceId":"440000","value":"440300"},{"children":[{"cityId":"440400","label":"香洲区","provinceId":"440000","value":"440402"},{"cityId":"440400","label":"斗门区","provinceId":"440000","value":"440403"},{"cityId":"440400","label":"金湾区","provinceId":"440000","value":"440404"}],"label":"珠海市","provinceId":"440000","value":"440400"},{"children":[{"cityId":"440500","label":"龙湖区","provinceId":"440000","value":"440507"},{"cityId":"440500","label":"金平区","provinceId":"440000","value":"440511"},{"cityId":"440500","label":"濠江区","provinceId":"440000","value":"440512"},{"cityId":"440500","label":"潮阳区","provinceId":"440000","value":"440513"},{"cityId":"440500","label":"潮南区","provinceId":"440000","value":"440514"},{"cityId":"440500","label":"澄海区","provinceId":"440000","value":"440515"},{"cityId":"440500","label":"南澳县","provinceId":"440000","value":"440523"}],"label":"汕头市","provinceId":"440000","value":"440500"},{"children":[{"cityId":"440600","label":"禅城区","provinceId":"440000","value":"440604"},{"cityId":"440600","label":"南海区","provinceId":"440000","value":"440605"},{"cityId":"440600","label":"顺德区","provinceId":"440000","value":"440606"},{"cityId":"440600","label":"三水区","provinceId":"440000","value":"440607"},{"cityId":"440600","label":"高明区","provinceId":"440000","value":"440608"}],"label":"佛山市","provinceId":"440000","value":"440600"},{"children":[{"cityId":"440700","label":"蓬江区","provinceId":"440000","value":"440703"},{"cityId":"440700","label":"江海区","provinceId":"440000","value":"440704"},{"cityId":"440700","label":"新会区","provinceId":"440000","value":"440705"},{"cityId":"440700","label":"台山市","provinceId":"440000","value":"440781"},{"cityId":"440700","label":"开平市","provinceId":"440000","value":"440783"},{"cityId":"440700","label":"鹤山市","provinceId":"440000","value":"440784"},{"cityId":"440700","label":"恩平市","provinceId":"440000","value":"440785"}],"label":"江门市","provinceId":"440000","value":"440700"},{"children":[{"cityId":"440800","label":"赤坎区","provinceId":"440000","value":"440802"},{"cityId":"440800","label":"霞山区","provinceId":"440000","value":"440803"},{"cityId":"440800","label":"坡头区","provinceId":"440000","value":"440804"},{"cityId":"440800","label":"麻章区","provinceId":"440000","value":"440811"},{"cityId":"440800","label":"开发区","provinceId":"440000","value":"440812"},{"cityId":"440800","label":"遂溪县","provinceId":"440000","value":"440823"},{"cityId":"440800","label":"徐闻县","provinceId":"440000","value":"440825"},{"cityId":"440800","label":"廉江市","provinceId":"440000","value":"440881"},{"cityId":"440800","label":"雷州市","provinceId":"440000","value":"440882"},{"cityId":"440800","label":"吴川市","provinceId":"440000","value":"440883"}],"label":"湛江市","provinceId":"440000","value":"440800"},{"children":[{"cityId":"440900","label":"茂南区","provinceId":"440000","value":"440902"},{"cityId":"440900","label":"茂港区","provinceId":"440000","value":"440903"},{"cityId":"440900","label":"电白区","provinceId":"440000","value":"440923"},{"cityId":"440900","label":"高州市","provinceId":"440000","value":"440981"},{"cityId":"440900","label":"化州市","provinceId":"440000","value":"440982"},{"cityId":"440900","label":"信宜市","provinceId":"440000","value":"440983"}],"label":"茂名市","provinceId":"440000","value":"440900"},{"children":[{"cityId":"441200","label":"端州区","provinceId":"440000","value":"441202"},{"cityId":"441200","label":"鼎湖区","provinceId":"440000","value":"441203"},{"cityId":"441200","label":"广宁县","provinceId":"440000","value":"441223"},{"cityId":"441200","label":"怀集县","provinceId":"440000","value":"441224"},{"cityId":"441200","label":"封开县","provinceId":"440000","value":"441225"},{"cityId":"441200","label":"德庆县","provinceId":"440000","value":"441226"},{"cityId":"441200","label":"高要区","provinceId":"440000","value":"441283"},{"cityId":"441200","label":"四会市","provinceId":"440000","value":"441284"}],"label":"肇庆市","provinceId":"440000","value":"441200"},{"children":[{"cityId":"441300","label":"平南","provinceId":"440000","value":"441301"},{"cityId":"441300","label":"惠城区","provinceId":"440000","value":"441302"},{"cityId":"441300","label":"惠阳区","provinceId":"440000","value":"441303"},{"cityId":"441300","label":"博罗县","provinceId":"440000","value":"441322"},{"cityId":"441300","label":"惠东县","provinceId":"440000","value":"441323"},{"cityId":"441300","label":"龙门县","provinceId":"440000","value":"441324"}],"label":"惠州市","provinceId":"440000","value":"441300"},{"children":[{"cityId":"441400","label":"梅江区","provinceId":"440000","value":"441402"},{"cityId":"441400","label":"梅县区","provinceId":"440000","value":"441421"},{"cityId":"441400","label":"大埔县","provinceId":"440000","value":"441422"},{"cityId":"441400","label":"丰顺县","provinceId":"440000","value":"441423"},{"cityId":"441400","label":"五华县","provinceId":"440000","value":"441424"},{"cityId":"441400","label":"平远县","provinceId":"440000","value":"441426"},{"cityId":"441400","label":"蕉岭县","provinceId":"440000","value":"441427"},{"cityId":"441400","label":"兴宁市","provinceId":"440000","value":"441481"}],"label":"梅州市","provinceId":"440000","value":"441400"},{"children":[{"cityId":"441500","label":"城区","provinceId":"440000","value":"441502"},{"cityId":"441500","label":"海丰县","provinceId":"440000","value":"441521"},{"cityId":"441500","label":"陆河县","provinceId":"440000","value":"441523"},{"cityId":"441500","label":"陆丰市","provinceId":"440000","value":"441581"}],"label":"汕尾市","provinceId":"440000","value":"441500"},{"children":[{"cityId":"441600","label":"源城区","provinceId":"440000","value":"441602"},{"cityId":"441600","label":"紫金县","provinceId":"440000","value":"441621"},{"cityId":"441600","label":"龙川县","provinceId":"440000","value":"441622"},{"cityId":"441600","label":"连平县","provinceId":"440000","value":"441623"},{"cityId":"441600","label":"和平县","provinceId":"440000","value":"441624"},{"cityId":"441600","label":"东源县","provinceId":"440000","value":"441625"}],"label":"河源市","provinceId":"440000","value":"441600"},{"children":[{"cityId":"441700","label":"江城区","provinceId":"440000","value":"441702"},{"cityId":"441700","label":"阳西县","provinceId":"440000","value":"441721"},{"cityId":"441700","label":"阳东区","provinceId":"440000","value":"441723"},{"cityId":"441700","label":"阳春市","provinceId":"440000","value":"441781"}],"label":"阳江市","provinceId":"440000","value":"441700"},{"children":[{"cityId":"441800","label":"清城区","provinceId":"440000","value":"441802"},{"cityId":"441800","label":"佛冈县","provinceId":"440000","value":"441821"},{"cityId":"441800","label":"阳山县","provinceId":"440000","value":"441823"},{"cityId":"441800","label":"连山壮族瑶族自治县","provinceId":"440000","value":"441825"},{"cityId":"441800","label":"连南瑶族自治县","provinceId":"440000","value":"441826"},{"cityId":"441800","label":"清新区","provinceId":"440000","value":"441827"},{"cityId":"441800","label":"英德市","provinceId":"440000","value":"441881"},{"cityId":"441800","label":"连州市","provinceId":"440000","value":"441882"}],"label":"清远市","provinceId":"440000","value":"441800"},{"children":[{"cityId":"441900","label":"东城区","provinceId":"440000","value":"441901"},{"cityId":"441900","label":"南城区","provinceId":"440000","value":"441902"},{"cityId":"441900","label":"莞城区","provinceId":"440000","value":"441903"},{"cityId":"441900","label":"万江区","provinceId":"440000","value":"441904"},{"cityId":"441900","label":"洪梅镇","provinceId":"440000","value":"441905"},{"cityId":"441900","label":"望牛墩镇","provinceId":"440000","value":"441906"},{"cityId":"441900","label":"高埗镇","provinceId":"440000","value":"441907"},{"cityId":"441900","label":"石龙镇","provinceId":"440000","value":"441908"},{"cityId":"441900","label":"东坑镇","provinceId":"440000","value":"441909"},{"cityId":"441900","label":"企石镇","provinceId":"440000","value":"441910"},{"cityId":"441900","label":"常平镇","provinceId":"440000","value":"441911"},{"cityId":"441900","label":"樟木头镇","provinceId":"440000","value":"441912"},{"cityId":"441900","label":"凤岗镇","provinceId":"440000","value":"441913"},{"cityId":"441900","label":"黄江镇","provinceId":"440000","value":"441914"},{"cityId":"441900","label":"大岭山镇","provinceId":"440000","value":"441915"},{"cityId":"441900","label":"虎门镇","provinceId":"440000","value":"441916"},{"cityId":"441900","label":"沙田镇","provinceId":"440000","value":"441917"},{"cityId":"441900","label":"寮步镇","provinceId":"440000","value":"441918"},{"cityId":"441900","label":"麻涌镇","provinceId":"440000","value":"441919"},{"cityId":"441900","label":"道滘镇","provinceId":"440000","value":"441920"},{"cityId":"441900","label":"中堂镇","provinceId":"440000","value":"441921"},{"cityId":"441900","label":"石碣镇","provinceId":"440000","value":"441922"},{"cityId":"441900","label":"茶山镇","provinceId":"440000","value":"441923"},{"cityId":"441900","label":"横沥镇","provinceId":"440000","value":"441924"},{"cityId":"441900","label":"桥头镇","provinceId":"440000","value":"441925"},{"cityId":"441900","label":"谢岗镇","provinceId":"440000","value":"441926"},{"cityId":"441900","label":"清溪镇","provinceId":"440000","value":"441927"},{"cityId":"441900","label":"塘厦镇","provinceId":"440000","value":"441928"},{"cityId":"441900","label":"大朗镇","provinceId":"440000","value":"441929"},{"cityId":"441900","label":"长安镇","provinceId":"440000","value":"441930"},{"cityId":"441900","label":"厚街镇","provinceId":"440000","value":"441931"},{"cityId":"441900","label":"石排镇","provinceId":"440000","value":"441932"},{"cityId":"441900","label":"松山湖","provinceId":"440000","value":"441933"}],"label":"东莞市","provinceId":"440000","value":"441900"},{"children":[{"cityId":"442000","label":"古镇","provinceId":"440000","value":"442001"},{"cityId":"442000","label":"小榄","provinceId":"440000","value":"442002"},{"cityId":"442000","label":"三乡","provinceId":"440000","value":"442003"},{"cityId":"442000","label":"火炬高技术产业开发区","provinceId":"440000","value":"442004"},{"cityId":"442000","label":"沙溪","provinceId":"440000","value":"442005"},{"cityId":"442000","label":"石岐区","provinceId":"440000","value":"442006"},{"cityId":"442000","label":"五桂山","provinceId":"440000","value":"442007"},{"cityId":"442000","label":"东凤镇","provinceId":"440000","value":"442008"},{"cityId":"442000","label":"东升镇","provinceId":"440000","value":"442009"},{"cityId":"442000","label":"南头镇","provinceId":"440000","value":"442010"},{"cityId":"442000","label":"黄圃镇","provinceId":"440000","value":"442011"},{"cityId":"442000","label":"三角镇","provinceId":"440000","value":"442012"},{"cityId":"442000","label":"阜沙镇","provinceId":"440000","value":"442013"},{"cityId":"442000","label":"民众镇","provinceId":"440000","value":"442014"},{"cityId":"442000","label":"港口镇","provinceId":"440000","value":"442015"},{"cityId":"442000","label":"横栏镇","provinceId":"440000","value":"442016"},{"cityId":"442000","label":"大涌镇","provinceId":"440000","value":"442017"},{"cityId":"442000","label":"板芙镇","provinceId":"440000","value":"442018"},{"cityId":"442000","label":"南朗镇","provinceId":"440000","value":"442019"},{"cityId":"442000","label":"坦洲镇","provinceId":"440000","value":"442020"},{"cityId":"442000","label":"神湾镇","provinceId":"440000","value":"442021"},{"cityId":"442000","label":"西区","provinceId":"440000","value":"442022"},{"cityId":"442000","label":"东区","provinceId":"440000","value":"442023"},{"cityId":"442000","label":"南区","provinceId":"440000","value":"442024"}],"label":"中山市","provinceId":"440000","value":"442000"},{"children":[{"cityId":"445100","label":"湘桥区","provinceId":"440000","value":"445102"},{"cityId":"445100","label":"潮安区","provinceId":"440000","value":"445121"},{"cityId":"445100","label":"饶平县","provinceId":"440000","value":"445122"}],"label":"潮州市","provinceId":"440000","value":"445100"},{"children":[{"cityId":"445200","label":"榕城区","provinceId":"440000","value":"445202"},{"cityId":"445200","label":"揭东区","provinceId":"440000","value":"445221"},{"cityId":"445200","label":"揭西县","provinceId":"440000","value":"445222"},{"cityId":"445200","label":"惠来县","provinceId":"440000","value":"445224"},{"cityId":"445200","label":"普宁市","provinceId":"440000","value":"445281"}],"label":"揭阳市","provinceId":"440000","value":"445200"},{"children":[{"cityId":"445300","label":"云城区","provinceId":"440000","value":"445302"},{"cityId":"445300","label":"新兴县","provinceId":"440000","value":"445321"},{"cityId":"445300","label":"郁南县","provinceId":"440000","value":"445322"},{"cityId":"445300","label":"云安区","provinceId":"440000","value":"445323"},{"cityId":"445300","label":"罗定市","provinceId":"440000","value":"445381"}],"label":"云浮市","provinceId":"440000","value":"445300"}],"label":"广东省","value":"440000"},{"children":[{"children":[{"cityId":"450100","label":"兴宁区","provinceId":"450000","value":"450102"},{"cityId":"450100","label":"青秀区","provinceId":"450000","value":"450103"},{"cityId":"450100","label":"江南区","provinceId":"450000","value":"450105"},{"cityId":"450100","label":"西乡塘区","provinceId":"450000","value":"450107"},{"cityId":"450100","label":"良庆区","provinceId":"450000","value":"450108"},{"cityId":"450100","label":"邕宁区","provinceId":"450000","value":"450109"},{"cityId":"450100","label":"武鸣区","provinceId":"450000","value":"450122"},{"cityId":"450100","label":"隆安县","provinceId":"450000","value":"450123"},{"cityId":"450100","label":"马山县","provinceId":"450000","value":"450124"},{"cityId":"450100","label":"上林县","provinceId":"450000","value":"450125"},{"cityId":"450100","label":"宾阳县","provinceId":"450000","value":"450126"},{"cityId":"450100","label":"横县","provinceId":"450000","value":"450127"}],"label":"南宁市","provinceId":"450000","value":"450100"},{"children":[{"cityId":"450200","label":"城中区","provinceId":"450000","value":"450202"},{"cityId":"450200","label":"鱼峰区","provinceId":"450000","value":"450203"},{"cityId":"450200","label":"柳南区","provinceId":"450000","value":"450204"},{"cityId":"450200","label":"柳北区","provinceId":"450000","value":"450205"},{"cityId":"450200","label":"柳江区","provinceId":"450000","value":"450221"},{"cityId":"450200","label":"柳城县","provinceId":"450000","value":"450222"},{"cityId":"450200","label":"鹿寨县","provinceId":"450000","value":"450223"},{"cityId":"450200","label":"融安县","provinceId":"450000","value":"450224"},{"cityId":"450200","label":"融水苗族自治县","provinceId":"450000","value":"450225"},{"cityId":"450200","label":"三江侗族自治县","provinceId":"450000","value":"450226"}],"label":"柳州市","provinceId":"450000","value":"450200"},{"children":[{"cityId":"450300","label":"秀峰区","provinceId":"450000","value":"450302"},{"cityId":"450300","label":"叠彩区","provinceId":"450000","value":"450303"},{"cityId":"450300","label":"象山区","provinceId":"450000","value":"450304"},{"cityId":"450300","label":"七星区","provinceId":"450000","value":"450305"},{"cityId":"450300","label":"雁山区","provinceId":"450000","value":"450311"},{"cityId":"450300","label":"阳朔县","provinceId":"450000","value":"450321"},{"cityId":"450300","label":"临桂区","provinceId":"450000","value":"450322"},{"cityId":"450300","label":"灵川县","provinceId":"450000","value":"450323"},{"cityId":"450300","label":"全州县","provinceId":"450000","value":"450324"},{"cityId":"450300","label":"兴安县","provinceId":"450000","value":"450325"},{"cityId":"450300","label":"永福县","provinceId":"450000","value":"450326"},{"cityId":"450300","label":"灌阳县","provinceId":"450000","value":"450327"},{"cityId":"450300","label":"龙胜各族自治县","provinceId":"450000","value":"450328"},{"cityId":"450300","label":"资源县","provinceId":"450000","value":"450329"},{"cityId":"450300","label":"平乐县","provinceId":"450000","value":"450330"},{"cityId":"450300","label":"荔浦县","provinceId":"450000","value":"450331"},{"cityId":"450300","label":"恭城瑶族自治县","provinceId":"450000","value":"450332"}],"label":"桂林市","provinceId":"450000","value":"450300"},{"children":[{"cityId":"450400","label":"万秀区","provinceId":"450000","value":"450403"},{"cityId":"450400","label":"蝶山区","provinceId":"450000","value":"450404"},{"cityId":"450400","label":"长洲区","provinceId":"450000","value":"450405"},{"cityId":"450400","label":"龙圩区","provinceId":"450000","value":"450406"},{"cityId":"450400","label":"苍梧县","provinceId":"450000","value":"450421"},{"cityId":"450400","label":"藤县","provinceId":"450000","value":"450422"},{"cityId":"450400","label":"蒙山县","provinceId":"450000","value":"450423"},{"cityId":"450400","label":"岑溪市","provinceId":"450000","value":"450481"}],"label":"梧州市","provinceId":"450000","value":"450400"},{"children":[{"cityId":"450500","label":"海城区","provinceId":"450000","value":"450502"},{"cityId":"450500","label":"银海区","provinceId":"450000","value":"450503"},{"cityId":"450500","label":"铁山港区","provinceId":"450000","value":"450512"},{"cityId":"450500","label":"合浦县","provinceId":"450000","value":"450521"}],"label":"北海市","provinceId":"450000","value":"450500"},{"children":[{"cityId":"450600","label":"港口区","provinceId":"450000","value":"450602"},{"cityId":"450600","label":"防城区","provinceId":"450000","value":"450603"},{"cityId":"450600","label":"上思县","provinceId":"450000","value":"450621"},{"cityId":"450600","label":"东兴市","provinceId":"450000","value":"450681"}],"label":"防城港市","provinceId":"450000","value":"450600"},{"children":[{"cityId":"450700","label":"钦南区","provinceId":"450000","value":"450702"},{"cityId":"450700","label":"钦北区","provinceId":"450000","value":"450703"},{"cityId":"450700","label":"灵山县","provinceId":"450000","value":"450721"},{"cityId":"450700","label":"浦北县","provinceId":"450000","value":"450722"}],"label":"钦州市","provinceId":"450000","value":"450700"},{"children":[{"cityId":"450800","label":"港北区","provinceId":"450000","value":"450802"},{"cityId":"450800","label":"港南区","provinceId":"450000","value":"450803"},{"cityId":"450800","label":"覃塘区","provinceId":"450000","value":"450804"},{"cityId":"450800","label":"平南县","provinceId":"450000","value":"450821"},{"cityId":"450800","label":"桂平市","provinceId":"450000","value":"450881"}],"label":"贵港市","provinceId":"450000","value":"450800"},{"children":[{"cityId":"450900","label":"玉州区","provinceId":"450000","value":"450902"},{"cityId":"450900","label":"福绵区","provinceId":"450000","value":"450903"},{"cityId":"450900","label":"容县","provinceId":"450000","value":"450921"},{"cityId":"450900","label":"陆川县","provinceId":"450000","value":"450922"},{"cityId":"450900","label":"博白县","provinceId":"450000","value":"450923"},{"cityId":"450900","label":"兴业县","provinceId":"450000","value":"450924"},{"cityId":"450900","label":"北流市","provinceId":"450000","value":"450981"}],"label":"玉林市","provinceId":"450000","value":"450900"},{"children":[{"cityId":"451000","label":"右江区","provinceId":"450000","value":"451002"},{"cityId":"451000","label":"田阳县","provinceId":"450000","value":"451021"},{"cityId":"451000","label":"田东县","provinceId":"450000","value":"451022"},{"cityId":"451000","label":"平果县","provinceId":"450000","value":"451023"},{"cityId":"451000","label":"德保县","provinceId":"450000","value":"451024"},{"cityId":"451000","label":"靖西市","provinceId":"450000","value":"451025"},{"cityId":"451000","label":"那坡县","provinceId":"450000","value":"451026"},{"cityId":"451000","label":"凌云县","provinceId":"450000","value":"451027"},{"cityId":"451000","label":"乐业县","provinceId":"450000","value":"451028"},{"cityId":"451000","label":"田林县","provinceId":"450000","value":"451029"},{"cityId":"451000","label":"西林县","provinceId":"450000","value":"451030"},{"cityId":"451000","label":"隆林各族自治县","provinceId":"450000","value":"451031"}],"label":"百色市","provinceId":"450000","value":"451000"},{"children":[{"cityId":"451100","label":"八步区","provinceId":"450000","value":"451102"},{"cityId":"451100","label":"平桂区","provinceId":"450000","value":"451103"},{"cityId":"451100","label":"昭平县","provinceId":"450000","value":"451121"},{"cityId":"451100","label":"钟山县","provinceId":"450000","value":"451122"},{"cityId":"451100","label":"富川瑶族自治县","provinceId":"450000","value":"451123"}],"label":"贺州市","provinceId":"450000","value":"451100"},{"children":[{"cityId":"451200","label":"金城江区","provinceId":"450000","value":"451202"},{"cityId":"451200","label":"南丹县","provinceId":"450000","value":"451221"},{"cityId":"451200","label":"天峨县","provinceId":"450000","value":"451222"},{"cityId":"451200","label":"凤山县","provinceId":"450000","value":"451223"},{"cityId":"451200","label":"东兰县","provinceId":"450000","value":"451224"},{"cityId":"451200","label":"罗城仫佬族自治县","provinceId":"450000","value":"451225"},{"cityId":"451200","label":"环江毛南族自治县","provinceId":"450000","value":"451226"},{"cityId":"451200","label":"巴马瑶族自治县","provinceId":"450000","value":"451227"},{"cityId":"451200","label":"都安瑶族自治县","provinceId":"450000","value":"451228"},{"cityId":"451200","label":"大化瑶族自治县","provinceId":"450000","value":"451229"},{"cityId":"451200","label":"宜州市","provinceId":"450000","value":"451281"}],"label":"河池市","provinceId":"450000","value":"451200"},{"children":[{"cityId":"451300","label":"兴宾区","provinceId":"450000","value":"451302"},{"cityId":"451300","label":"忻城县","provinceId":"450000","value":"451321"},{"cityId":"451300","label":"象州县","provinceId":"450000","value":"451322"},{"cityId":"451300","label":"武宣县","provinceId":"450000","value":"451323"},{"cityId":"451300","label":"金秀瑶族自治县","provinceId":"450000","value":"451324"},{"cityId":"451300","label":"合山市","provinceId":"450000","value":"451381"}],"label":"来宾市","provinceId":"450000","value":"451300"},{"children":[{"cityId":"451400","label":"江州区","provinceId":"450000","value":"451402"},{"cityId":"451400","label":"扶绥县","provinceId":"450000","value":"451421"},{"cityId":"451400","label":"宁明县","provinceId":"450000","value":"451422"},{"cityId":"451400","label":"龙州县","provinceId":"450000","value":"451423"},{"cityId":"451400","label":"大新县","provinceId":"450000","value":"451424"},{"cityId":"451400","label":"天等县","provinceId":"450000","value":"451425"},{"cityId":"451400","label":"凭祥市","provinceId":"450000","value":"451481"}],"label":"崇左市","provinceId":"450000","value":"451400"}],"label":"广西壮族自治区","value":"450000"},{"children":[{"children":[{"cityId":"460100","label":"秀英区","provinceId":"460000","value":"460105"},{"cityId":"460100","label":"龙华区","provinceId":"460000","value":"460106"},{"cityId":"460100","label":"琼山区","provinceId":"460000","value":"460107"},{"cityId":"460100","label":"美兰区","provinceId":"460000","value":"460108"}],"label":"海口市","provinceId":"460000","value":"460100"},{"children":[{"cityId":"460200","label":"市辖区","provinceId":"460000","value":"460201"},{"cityId":"460200","label":"海棠区","provinceId":"460000","value":"460202"},{"cityId":"460200","label":"吉阳区","provinceId":"460000","value":"460203"},{"cityId":"460200","label":"天涯区","provinceId":"460000","value":"460204"},{"cityId":"460200","label":"崖州区","provinceId":"460000","value":"460205"}],"label":"三亚市","provinceId":"460000","value":"460200"},{"children":[{"cityId":"460300","label":"西沙群岛","provinceId":"460000","value":"460321"}],"label":"三沙市","provinceId":"460000","value":"460300"},{"children":[{"cityId":"469000","label":"五指山市","provinceId":"460000","value":"469001"},{"cityId":"469000","label":"琼海市","provinceId":"460000","value":"469002"},{"cityId":"469000","label":"儋州市","provinceId":"460000","value":"469003"},{"cityId":"469000","label":"文昌市","provinceId":"460000","value":"469005"},{"cityId":"469000","label":"万宁市","provinceId":"460000","value":"469006"},{"cityId":"469000","label":"东方市","provinceId":"460000","value":"469007"},{"cityId":"469000","label":"澄迈县","provinceId":"460000","value":"469023"},{"cityId":"469000","label":"定安县","provinceId":"460000","value":"469025"},{"cityId":"469000","label":"屯昌县","provinceId":"460000","value":"469026"},{"cityId":"469000","label":"临高县","provinceId":"460000","value":"469028"},{"cityId":"469000","label":"洋浦","provinceId":"460000","value":"469029"},{"cityId":"469000","label":"白沙黎族自治县","provinceId":"460000","value":"469030"},{"cityId":"469000","label":"昌江黎族自治县","provinceId":"460000","value":"469031"},{"cityId":"469000","label":"乐东黎族自治县","provinceId":"460000","value":"469033"},{"cityId":"469000","label":"陵水黎族自治县","provinceId":"460000","value":"469034"},{"cityId":"469000","label":"保亭黎族苗族自治县","provinceId":"460000","value":"469035"},{"cityId":"469000","label":"琼中黎族苗族自治县","provinceId":"460000","value":"469036"},{"cityId":"469000","label":"西沙群岛","provinceId":"460000","value":"469037"},{"cityId":"469000","label":"南沙群岛","provinceId":"460000","value":"469038"},{"cityId":"469000","label":"中沙群岛的岛礁及其海域","provinceId":"460000","value":"469039"}],"label":"省直辖县级行政区划(*)","provinceId":"460000","value":"469000"}],"label":"海南省","value":"460000"},{"children":[{"children":[{"cityId":"500100","label":"万州区","provinceId":"500000","value":"500101"},{"cityId":"500100","label":"涪陵区","provinceId":"500000","value":"500102"},{"cityId":"500100","label":"渝中区","provinceId":"500000","value":"500103"},{"cityId":"500100","label":"大渡口区","provinceId":"500000","value":"500104"},{"cityId":"500100","label":"江北区","provinceId":"500000","value":"500105"},{"cityId":"500100","label":"沙坪坝区","provinceId":"500000","value":"500106"},{"cityId":"500100","label":"九龙坡区","provinceId":"500000","value":"500107"},{"cityId":"500100","label":"南岸区","provinceId":"500000","value":"500108"},{"cityId":"500100","label":"北碚区","provinceId":"500000","value":"500109"},{"cityId":"500100","label":"万盛区","provinceId":"500000","value":"500110"},{"cityId":"500100","label":"双桥区","provinceId":"500000","value":"500111"},{"cityId":"500100","label":"渝北区","provinceId":"500000","value":"500112"},{"cityId":"500100","label":"巴南区","provinceId":"500000","value":"500113"},{"cityId":"500100","label":"黔江区","provinceId":"500000","value":"500114"},{"cityId":"500100","label":"长寿区","provinceId":"500000","value":"500115"},{"cityId":"500100","label":"江津区","provinceId":"500000","value":"500116"},{"cityId":"500100","label":"合川区","provinceId":"500000","value":"500117"},{"cityId":"500100","label":"永川区","provinceId":"500000","value":"500118"},{"cityId":"500100","label":"南川区","provinceId":"500000","value":"500119"},{"cityId":"500100","label":"两江新区","provinceId":"500000","value":"500121"},{"cityId":"500100","label":"北部新区","provinceId":"500000","value":"500122"},{"cityId":"500100","label":"武隆区","provinceId":"500000","value":"500131"},{"cityId":"500100","label":"潼南区","provinceId":"500000","value":"500132"},{"cityId":"500100","label":"铜梁区","provinceId":"500000","value":"500133"},{"cityId":"500100","label":"荣昌区","provinceId":"500000","value":"500134"},{"cityId":"500100","label":"綦江区","provinceId":"500000","value":"500135"},{"cityId":"500100","label":"梁平区","provinceId":"500000","value":"500136"},{"cityId":"500100","label":"大足区","provinceId":"500000","value":"500139"},{"cityId":"500100","label":"璧山区","provinceId":"500000","value":"500140"},{"cityId":"500100","label":"綦江县","provinceId":"500000","value":"500152"},{"cityId":"500100","label":"潼南县","provinceId":"500000","value":"500153"},{"cityId":"500100","label":"铜梁县","provinceId":"500000","value":"500154"},{"cityId":"500100","label":"大足县","provinceId":"500000","value":"500155"},{"cityId":"500100","label":"荣昌县","provinceId":"500000","value":"500156"},{"cityId":"500100","label":"璧山县","provinceId":"500000","value":"500157"},{"cityId":"500100","label":"梁平县","provinceId":"500000","value":"500158"},{"cityId":"500100","label":"城口县","provinceId":"500000","value":"500159"},{"cityId":"500100","label":"丰都县","provinceId":"500000","value":"500160"},{"cityId":"500100","label":"垫江县","provinceId":"500000","value":"500161"},{"cityId":"500100","label":"武隆县","provinceId":"500000","value":"500162"},{"cityId":"500100","label":"忠县","provinceId":"500000","value":"500163"},{"cityId":"500100","label":"开州区","provinceId":"500000","value":"500164"},{"cityId":"500100","label":"云阳县","provinceId":"500000","value":"500165"},{"cityId":"500100","label":"奉节县","provinceId":"500000","value":"500166"},{"cityId":"500100","label":"巫山县","provinceId":"500000","value":"500167"},{"cityId":"500100","label":"巫溪县","provinceId":"500000","value":"500168"},{"cityId":"500100","label":"石柱土家族自治县","provinceId":"500000","value":"500169"},{"cityId":"500100","label":"秀山土家族苗族自治县","provinceId":"500000","value":"500170"},{"cityId":"500100","label":"酉阳土家族苗族自治县","provinceId":"500000","value":"500171"},{"cityId":"500100","label":"彭水苗族土家族自治县","provinceId":"500000","value":"500172"}],"label":"重庆市","provinceId":"500000","value":"500100"}],"label":"重庆市","value":"500000"},{"children":[{"children":[{"cityId":"510100","label":"锦江区","provinceId":"510000","value":"510104"},{"cityId":"510100","label":"青羊区","provinceId":"510000","value":"510105"},{"cityId":"510100","label":"金牛区","provinceId":"510000","value":"510106"},{"cityId":"510100","label":"武侯区","provinceId":"510000","value":"510107"},{"cityId":"510100","label":"成华区","provinceId":"510000","value":"510108"},{"cityId":"510100","label":"龙泉驿区","provinceId":"510000","value":"510112"},{"cityId":"510100","label":"青白江区","provinceId":"510000","value":"510113"},{"cityId":"510100","label":"新都区","provinceId":"510000","value":"510114"},{"cityId":"510100","label":"温江区","provinceId":"510000","value":"510115"},{"cityId":"510100","label":"金堂县","provinceId":"510000","value":"510121"},{"cityId":"510100","label":"双流区","provinceId":"510000","value":"510122"},{"cityId":"510100","label":"郫县","provinceId":"510000","value":"510124"},{"cityId":"510100","label":"大邑县","provinceId":"510000","value":"510129"},{"cityId":"510100","label":"蒲江县","provinceId":"510000","value":"510131"},{"cityId":"510100","label":"新津县","provinceId":"510000","value":"510132"},{"cityId":"510100","label":"简阳市","provinceId":"510000","value":"510141"},{"cityId":"510100","label":"都江堰市","provinceId":"510000","value":"510181"},{"cityId":"510100","label":"彭州市","provinceId":"510000","value":"510182"},{"cityId":"510100","label":"邛崃市","provinceId":"510000","value":"510183"},{"cityId":"510100","label":"崇州市","provinceId":"510000","value":"510184"},{"cityId":"510100","label":"高新区","provinceId":"510000","value":"510185"},{"cityId":"510100","label":"华阳镇","provinceId":"510000","value":"510186"},{"cityId":"510100","label":"新繁镇","provinceId":"510000","value":"510187"}],"label":"成都市","provinceId":"510000","value":"510100"},{"children":[{"cityId":"510300","label":"自流井区","provinceId":"510000","value":"510302"},{"cityId":"510300","label":"贡井区","provinceId":"510000","value":"510303"},{"cityId":"510300","label":"大安区","provinceId":"510000","value":"510304"},{"cityId":"510300","label":"沿滩区","provinceId":"510000","value":"510311"},{"cityId":"510300","label":"荣县","provinceId":"510000","value":"510321"},{"cityId":"510300","label":"富顺县","provinceId":"510000","value":"510322"}],"label":"自贡市","provinceId":"510000","value":"510300"},{"children":[{"cityId":"510400","label":"东区","provinceId":"510000","value":"510402"},{"cityId":"510400","label":"西区","provinceId":"510000","value":"510403"},{"cityId":"510400","label":"仁和区","provinceId":"510000","value":"510411"},{"cityId":"510400","label":"米易县","provinceId":"510000","value":"510421"},{"cityId":"510400","label":"盐边县","provinceId":"510000","value":"510422"}],"label":"攀枝花市","provinceId":"510000","value":"510400"},{"children":[{"cityId":"510500","label":"江阳区","provinceId":"510000","value":"510502"},{"cityId":"510500","label":"纳溪区","provinceId":"510000","value":"510503"},{"cityId":"510500","label":"龙马潭区","provinceId":"510000","value":"510504"},{"cityId":"510500","label":"泸县","provinceId":"510000","value":"510521"},{"cityId":"510500","label":"合江县","provinceId":"510000","value":"510522"},{"cityId":"510500","label":"叙永县","provinceId":"510000","value":"510524"},{"cityId":"510500","label":"古蔺县","provinceId":"510000","value":"510525"}],"label":"泸州市","provinceId":"510000","value":"510500"},{"children":[{"cityId":"510600","label":"旌阳区","provinceId":"510000","value":"510603"},{"cityId":"510600","label":"河东区","provinceId":"510000","value":"510604"},{"cityId":"510600","label":"经开区","provinceId":"510000","value":"510605"},{"cityId":"510600","label":"中江县","provinceId":"510000","value":"510623"},{"cityId":"510600","label":"罗江县","provinceId":"510000","value":"510626"},{"cityId":"510600","label":"广汉市","provinceId":"510000","value":"510681"},{"cityId":"510600","label":"什邡市","provinceId":"510000","value":"510682"},{"cityId":"510600","label":"绵竹市","provinceId":"510000","value":"510683"}],"label":"德阳市","provinceId":"510000","value":"510600"},{"children":[{"cityId":"510700","label":"涪城区","provinceId":"510000","value":"510703"},{"cityId":"510700","label":"游仙区","provinceId":"510000","value":"510704"},{"cityId":"510700","label":"高新区","provinceId":"510000","value":"510705"},{"cityId":"510700","label":"经开区","provinceId":"510000","value":"510706"},{"cityId":"510700","label":"三台县","provinceId":"510000","value":"510722"},{"cityId":"510700","label":"盐亭县","provinceId":"510000","value":"510723"},{"cityId":"510700","label":"安州区","provinceId":"510000","value":"510724"},{"cityId":"510700","label":"梓潼县","provinceId":"510000","value":"510725"},{"cityId":"510700","label":"北川羌族自治县","provinceId":"510000","value":"510726"},{"cityId":"510700","label":"平武县","provinceId":"510000","value":"510727"},{"cityId":"510700","label":"江油市","provinceId":"510000","value":"510781"}],"label":"绵阳市","provinceId":"510000","value":"510700"},{"children":[{"cityId":"510800","label":"市中区","provinceId":"510000","value":"510802"},{"cityId":"510800","label":"元坝区","provinceId":"510000","value":"510811"},{"cityId":"510800","label":"朝天区","provinceId":"510000","value":"510812"},{"cityId":"510800","label":"旺苍县","provinceId":"510000","value":"510821"},{"cityId":"510800","label":"青川县","provinceId":"510000","value":"510822"},{"cityId":"510800","label":"剑阁县","provinceId":"510000","value":"510823"},{"cityId":"510800","label":"苍溪县","provinceId":"510000","value":"510824"},{"cityId":"510800","label":"利州区","provinceId":"510000","value":"510831"},{"cityId":"510800","label":"昭化区","provinceId":"510000","value":"510832"}],"label":"广元市","provinceId":"510000","value":"510800"},{"children":[{"cityId":"510900","label":"船山区","provinceId":"510000","value":"510903"},{"cityId":"510900","label":"安居区","provinceId":"510000","value":"510904"},{"cityId":"510900","label":"蓬溪县","provinceId":"510000","value":"510921"},{"cityId":"510900","label":"射洪县","provinceId":"510000","value":"510922"},{"cityId":"510900","label":"大英县","provinceId":"510000","value":"510923"}],"label":"遂宁市","provinceId":"510000","value":"510900"},{"children":[{"cityId":"511000","label":"市中区","provinceId":"510000","value":"511002"},{"cityId":"511000","label":"东兴区","provinceId":"510000","value":"511011"},{"cityId":"511000","label":"威远县","provinceId":"510000","value":"511024"},{"cityId":"511000","label":"资中县","provinceId":"510000","value":"511025"},{"cityId":"511000","label":"隆昌县","provinceId":"510000","value":"511028"}],"label":"内江市","provinceId":"510000","value":"511000"},{"children":[{"cityId":"511100","label":"市中区","provinceId":"510000","value":"511102"},{"cityId":"511100","label":"沙湾区","provinceId":"510000","value":"511111"},{"cityId":"511100","label":"五通桥区","provinceId":"510000","value":"511112"},{"cityId":"511100","label":"金口河区","provinceId":"510000","value":"511113"},{"cityId":"511100","label":"犍为县","provinceId":"510000","value":"511123"},{"cityId":"511100","label":"井研县","provinceId":"510000","value":"511124"},{"cityId":"511100","label":"夹江县","provinceId":"510000","value":"511126"},{"cityId":"511100","label":"沐川县","provinceId":"510000","value":"511129"},{"cityId":"511100","label":"峨边彝族自治县","provinceId":"510000","value":"511132"},{"cityId":"511100","label":"马边彝族自治县","provinceId":"510000","value":"511133"},{"cityId":"511100","label":"峨眉山市","provinceId":"510000","value":"511181"}],"label":"乐山市","provinceId":"510000","value":"511100"},{"children":[{"cityId":"511300","label":"顺庆区","provinceId":"510000","value":"511302"},{"cityId":"511300","label":"高坪区","provinceId":"510000","value":"511303"},{"cityId":"511300","label":"嘉陵区","provinceId":"510000","value":"511304"},{"cityId":"511300","label":"南部县","provinceId":"510000","value":"511321"},{"cityId":"511300","label":"营山县","provinceId":"510000","value":"511322"},{"cityId":"511300","label":"蓬安县","provinceId":"510000","value":"511323"},{"cityId":"511300","label":"仪陇县","provinceId":"510000","value":"511324"},{"cityId":"511300","label":"西充县","provinceId":"510000","value":"511325"},{"cityId":"511300","label":"阆中市","provinceId":"510000","value":"511381"}],"label":"南充市","provinceId":"510000","value":"511300"},{"children":[{"cityId":"511400","label":"东坡区","provinceId":"510000","value":"511402"},{"cityId":"511400","label":"仁寿县","provinceId":"510000","value":"511421"},{"cityId":"511400","label":"彭山区","provinceId":"510000","value":"511422"},{"cityId":"511400","label":"洪雅县","provinceId":"510000","value":"511423"},{"cityId":"511400","label":"丹棱县","provinceId":"510000","value":"511424"},{"cityId":"511400","label":"青神县","provinceId":"510000","value":"511425"}],"label":"眉山市","provinceId":"510000","value":"511400"},{"children":[{"cityId":"511500","label":"翠屏区","provinceId":"510000","value":"511502"},{"cityId":"511500","label":"宜宾县","provinceId":"510000","value":"511521"},{"cityId":"511500","label":"南溪区","provinceId":"510000","value":"511522"},{"cityId":"511500","label":"江安县","provinceId":"510000","value":"511523"},{"cityId":"511500","label":"长宁县","provinceId":"510000","value":"511524"},{"cityId":"511500","label":"高县","provinceId":"510000","value":"511525"},{"cityId":"511500","label":"珙县","provinceId":"510000","value":"511526"},{"cityId":"511500","label":"筠连县","provinceId":"510000","value":"511527"},{"cityId":"511500","label":"兴文县","provinceId":"510000","value":"511528"},{"cityId":"511500","label":"屏山县","provinceId":"510000","value":"511529"}],"label":"宜宾市","provinceId":"510000","value":"511500"},{"children":[{"cityId":"511600","label":"广安区","provinceId":"510000","value":"511602"},{"cityId":"511600","label":"前锋区","provinceId":"510000","value":"511603"},{"cityId":"511600","label":"岳池县","provinceId":"510000","value":"511621"},{"cityId":"511600","label":"武胜县","provinceId":"510000","value":"511622"},{"cityId":"511600","label":"邻水县","provinceId":"510000","value":"511623"},{"cityId":"511600","label":"华蓥市","provinceId":"510000","value":"511681"}],"label":"广安市","provinceId":"510000","value":"511600"},{"children":[{"cityId":"511700","label":"通川区","provinceId":"510000","value":"511702"},{"cityId":"511700","label":"达川区","provinceId":"510000","value":"511703"},{"cityId":"511700","label":"达　县","provinceId":"510000","value":"511721"},{"cityId":"511700","label":"宣汉县","provinceId":"510000","value":"511722"},{"cityId":"511700","label":"开江县","provinceId":"510000","value":"511723"},{"cityId":"511700","label":"大竹县","provinceId":"510000","value":"511724"},{"cityId":"511700","label":"渠县","provinceId":"510000","value":"511725"},{"cityId":"511700","label":"万源市","provinceId":"510000","value":"511781"}],"label":"达州市","provinceId":"510000","value":"511700"},{"children":[{"cityId":"511800","label":"雨城区","provinceId":"510000","value":"511802"},{"cityId":"511800","label":"名山区","provinceId":"510000","value":"511821"},{"cityId":"511800","label":"荥经县","provinceId":"510000","value":"511822"},{"cityId":"511800","label":"汉源县","provinceId":"510000","value":"511823"},{"cityId":"511800","label":"石棉县","provinceId":"510000","value":"511824"},{"cityId":"511800","label":"天全县","provinceId":"510000","value":"511825"},{"cityId":"511800","label":"芦山县","provinceId":"510000","value":"511826"},{"cityId":"511800","label":"宝兴县","provinceId":"510000","value":"511827"}],"label":"雅安市","provinceId":"510000","value":"511800"},{"children":[{"cityId":"511900","label":"巴州区","provinceId":"510000","value":"511902"},{"cityId":"511900","label":"恩阳区","provinceId":"510000","value":"511903"},{"cityId":"511900","label":"通江县","provinceId":"510000","value":"511921"},{"cityId":"511900","label":"南江县","provinceId":"510000","value":"511922"},{"cityId":"511900","label":"平昌县","provinceId":"510000","value":"511923"}],"label":"巴中市","provinceId":"510000","value":"511900"},{"children":[{"cityId":"512000","label":"雁江区","provinceId":"510000","value":"512002"},{"cityId":"512000","label":"安岳县","provinceId":"510000","value":"512021"},{"cityId":"512000","label":"乐至县","provinceId":"510000","value":"512022"},{"cityId":"512000","label":"简阳市","provinceId":"510000","value":"512081"}],"label":"资阳市","provinceId":"510000","value":"512000"},{"children":[{"cityId":"513200","label":"汶川县","provinceId":"510000","value":"513221"},{"cityId":"513200","label":"理县","provinceId":"510000","value":"513222"},{"cityId":"513200","label":"茂县","provinceId":"510000","value":"513223"},{"cityId":"513200","label":"松潘县","provinceId":"510000","value":"513224"},{"cityId":"513200","label":"九寨沟县","provinceId":"510000","value":"513225"},{"cityId":"513200","label":"金川县","provinceId":"510000","value":"513226"},{"cityId":"513200","label":"小金县","provinceId":"510000","value":"513227"},{"cityId":"513200","label":"黑水县","provinceId":"510000","value":"513228"},{"cityId":"513200","label":"马尔康市","provinceId":"510000","value":"513229"},{"cityId":"513200","label":"壤塘县","provinceId":"510000","value":"513230"},{"cityId":"513200","label":"阿坝县","provinceId":"510000","value":"513231"},{"cityId":"513200","label":"若尔盖县","provinceId":"510000","value":"513232"},{"cityId":"513200","label":"红原县","provinceId":"510000","value":"513233"}],"label":"阿坝藏族羌族自治州","provinceId":"510000","value":"513200"},{"children":[{"cityId":"513300","label":"康定市","provinceId":"510000","value":"513321"},{"cityId":"513300","label":"泸定县","provinceId":"510000","value":"513322"},{"cityId":"513300","label":"丹巴县","provinceId":"510000","value":"513323"},{"cityId":"513300","label":"九龙县","provinceId":"510000","value":"513324"},{"cityId":"513300","label":"雅江县","provinceId":"510000","value":"513325"},{"cityId":"513300","label":"道孚县","provinceId":"510000","value":"513326"},{"cityId":"513300","label":"炉霍县","provinceId":"510000","value":"513327"},{"cityId":"513300","label":"甘孜县","provinceId":"510000","value":"513328"},{"cityId":"513300","label":"新龙县","provinceId":"510000","value":"513329"},{"cityId":"513300","label":"德格县","provinceId":"510000","value":"513330"},{"cityId":"513300","label":"白玉县","provinceId":"510000","value":"513331"},{"cityId":"513300","label":"石渠县","provinceId":"510000","value":"513332"},{"cityId":"513300","label":"色达县","provinceId":"510000","value":"513333"},{"cityId":"513300","label":"理塘县","provinceId":"510000","value":"513334"},{"cityId":"513300","label":"巴塘县","provinceId":"510000","value":"513335"},{"cityId":"513300","label":"乡城县","provinceId":"510000","value":"513336"},{"cityId":"513300","label":"稻城县","provinceId":"510000","value":"513337"},{"cityId":"513300","label":"得荣县","provinceId":"510000","value":"513338"}],"label":"甘孜藏族自治州","provinceId":"510000","value":"513300"},{"children":[{"cityId":"513400","label":"西昌市","provinceId":"510000","value":"513401"},{"cityId":"513400","label":"木里藏族自治县","provinceId":"510000","value":"513422"},{"cityId":"513400","label":"盐源县","provinceId":"510000","value":"513423"},{"cityId":"513400","label":"德昌县","provinceId":"510000","value":"513424"},{"cityId":"513400","label":"会理县","provinceId":"510000","value":"513425"},{"cityId":"513400","label":"会东县","provinceId":"510000","value":"513426"},{"cityId":"513400","label":"宁南县","provinceId":"510000","value":"513427"},{"cityId":"513400","label":"普格县","provinceId":"510000","value":"513428"},{"cityId":"513400","label":"布拖县","provinceId":"510000","value":"513429"},{"cityId":"513400","label":"金阳县","provinceId":"510000","value":"513430"},{"cityId":"513400","label":"昭觉县","provinceId":"510000","value":"513431"},{"cityId":"513400","label":"喜德县","provinceId":"510000","value":"513432"},{"cityId":"513400","label":"冕宁县","provinceId":"510000","value":"513433"},{"cityId":"513400","label":"越西县","provinceId":"510000","value":"513434"},{"cityId":"513400","label":"甘洛县","provinceId":"510000","value":"513435"},{"cityId":"513400","label":"美姑县","provinceId":"510000","value":"513436"},{"cityId":"513400","label":"雷波县","provinceId":"510000","value":"513437"}],"label":"凉山彝族自治州","provinceId":"510000","value":"513400"}],"label":"四川省","value":"510000"},{"children":[{"children":[{"cityId":"520100","label":"南明区","provinceId":"520000","value":"520102"},{"cityId":"520100","label":"云岩区","provinceId":"520000","value":"520103"},{"cityId":"520100","label":"观山湖区","provinceId":"520000","value":"520105"},{"cityId":"520100","label":"花溪区","provinceId":"520000","value":"520111"},{"cityId":"520100","label":"乌当区","provinceId":"520000","value":"520112"},{"cityId":"520100","label":"白云区","provinceId":"520000","value":"520113"},{"cityId":"520100","label":"小河区","provinceId":"520000","value":"520114"},{"cityId":"520100","label":"开阳县","provinceId":"520000","value":"520121"},{"cityId":"520100","label":"息烽县","provinceId":"520000","value":"520122"},{"cityId":"520100","label":"修文县","provinceId":"520000","value":"520123"},{"cityId":"520100","label":"清镇市","provinceId":"520000","value":"520181"},{"cityId":"520100","label":"金阳新区管理委员会","provinceId":"520000","value":"520190"}],"label":"贵阳市","provinceId":"520000","value":"520100"},{"children":[{"cityId":"520200","label":"钟山区","provinceId":"520000","value":"520201"},{"cityId":"520200","label":"六枝特区","provinceId":"520000","value":"520203"},{"cityId":"520200","label":"水城县","provinceId":"520000","value":"520221"},{"cityId":"520200","label":"盘县","provinceId":"520000","value":"520222"}],"label":"六盘水市","provinceId":"520000","value":"520200"},{"children":[{"cityId":"520300","label":"红花岗区","provinceId":"520000","value":"520302"},{"cityId":"520300","label":"汇川区","provinceId":"520000","value":"520303"},{"cityId":"520300","label":"播州区","provinceId":"520000","value":"520310"},{"cityId":"520300","label":"遵义县","provinceId":"520000","value":"520321"},{"cityId":"520300","label":"桐梓县","provinceId":"520000","value":"520322"},{"cityId":"520300","label":"绥阳县","provinceId":"520000","value":"520323"},{"cityId":"520300","label":"正安县","provinceId":"520000","value":"520324"},{"cityId":"520300","label":"道真仡佬族苗族自治县","provinceId":"520000","value":"520325"},{"cityId":"520300","label":"务川仡佬族苗族自治县","provinceId":"520000","value":"520326"},{"cityId":"520300","label":"凤冈县","provinceId":"520000","value":"520327"},{"cityId":"520300","label":"湄潭县","provinceId":"520000","value":"520328"},{"cityId":"520300","label":"余庆县","provinceId":"520000","value":"520329"},{"cityId":"520300","label":"习水县","provinceId":"520000","value":"520330"},{"cityId":"520300","label":"赤水市","provinceId":"520000","value":"520381"},{"cityId":"520300","label":"仁怀市","provinceId":"520000","value":"520382"}],"label":"遵义市","provinceId":"520000","value":"520300"},{"children":[{"cityId":"520400","label":"西秀区","provinceId":"520000","value":"520402"},{"cityId":"520400","label":"平坝区","provinceId":"520000","value":"520410"},{"cityId":"520400","label":"平坝县","provinceId":"520000","value":"520421"},{"cityId":"520400","label":"普定县","provinceId":"520000","value":"520422"},{"cityId":"520400","label":"镇宁布依族苗族自治县","provinceId":"520000","value":"520423"},{"cityId":"520400","label":"关岭布依族苗族自治县","provinceId":"520000","value":"520424"},{"cityId":"520400","label":"紫云苗族布依族自治县","provinceId":"520000","value":"520425"}],"label":"安顺市","provinceId":"520000","value":"520400"},{"children":[{"cityId":"520500","label":"市辖区","provinceId":"520000","value":"520501"},{"cityId":"520500","label":"七星关区","provinceId":"520000","value":"520502"},{"cityId":"520500","label":"大方县","provinceId":"520000","value":"520521"},{"cityId":"520500","label":"黔西县","provinceId":"520000","value":"520522"},{"cityId":"520500","label":"金沙县","provinceId":"520000","value":"520523"},{"cityId":"520500","label":"织金县","provinceId":"520000","value":"520524"},{"cityId":"520500","label":"纳雍县","provinceId":"520000","value":"520525"},{"cityId":"520500","label":"威宁彝族回族苗族自治县","provinceId":"520000","value":"520526"},{"cityId":"520500","label":"赫章县","provinceId":"520000","value":"520527"}],"label":"毕节市","provinceId":"520000","value":"520500"},{"children":[{"cityId":"520600","label":"碧江区","provinceId":"520000","value":"520602"}],"label":"铜仁市","provinceId":"520000","value":"520600"},{"children":[{"cityId":"522200","label":"铜仁市","provinceId":"520000","value":"522201"},{"cityId":"522200","label":"江口县","provinceId":"520000","value":"522222"},{"cityId":"522200","label":"玉屏侗族自治县","provinceId":"520000","value":"522223"},{"cityId":"522200","label":"石阡县","provinceId":"520000","value":"522224"},{"cityId":"522200","label":"思南县","provinceId":"520000","value":"522225"},{"cityId":"522200","label":"印江土家族苗族自治县","provinceId":"520000","value":"522226"},{"cityId":"522200","label":"德江县","provinceId":"520000","value":"522227"},{"cityId":"522200","label":"沿河土家族自治县","provinceId":"520000","value":"522228"},{"cityId":"522200","label":"松桃苗族自治县","provinceId":"520000","value":"522229"},{"cityId":"522200","label":"万山特区","provinceId":"520000","value":"522230"}],"label":"铜仁地区","provinceId":"520000","value":"522200"},{"children":[{"cityId":"522300","label":"兴义市","provinceId":"520000","value":"522301"},{"cityId":"522300","label":"兴仁县","provinceId":"520000","value":"522322"},{"cityId":"522300","label":"普安县","provinceId":"520000","value":"522323"},{"cityId":"522300","label":"晴隆县","provinceId":"520000","value":"522324"},{"cityId":"522300","label":"贞丰县","provinceId":"520000","value":"522325"},{"cityId":"522300","label":"望谟县","provinceId":"520000","value":"522326"},{"cityId":"522300","label":"册亨县","provinceId":"520000","value":"522327"},{"cityId":"522300","label":"安龙县","provinceId":"520000","value":"522328"}],"label":"黔西南布依族苗族自治州","provinceId":"520000","value":"522300"},{"children":[{"cityId":"522600","label":"凯里市","provinceId":"520000","value":"522601"},{"cityId":"522600","label":"黄平县","provinceId":"520000","value":"522622"},{"cityId":"522600","label":"施秉县","provinceId":"520000","value":"522623"},{"cityId":"522600","label":"三穗县","provinceId":"520000","value":"522624"},{"cityId":"522600","label":"镇远县","provinceId":"520000","value":"522625"},{"cityId":"522600","label":"岑巩县","provinceId":"520000","value":"522626"},{"cityId":"522600","label":"天柱县","provinceId":"520000","value":"522627"},{"cityId":"522600","label":"锦屏县","provinceId":"520000","value":"522628"},{"cityId":"522600","label":"剑河县","provinceId":"520000","value":"522629"},{"cityId":"522600","label":"台江县","provinceId":"520000","value":"522630"},{"cityId":"522600","label":"黎平县","provinceId":"520000","value":"522631"},{"cityId":"522600","label":"榕江县","provinceId":"520000","value":"522632"},{"cityId":"522600","label":"从江县","provinceId":"520000","value":"522633"},{"cityId":"522600","label":"雷山县","provinceId":"520000","value":"522634"},{"cityId":"522600","label":"麻江县","provinceId":"520000","value":"522635"},{"cityId":"522600","label":"丹寨县","provinceId":"520000","value":"522636"}],"label":"黔东南苗族侗族自治州","provinceId":"520000","value":"522600"},{"children":[{"cityId":"522700","label":"都匀市","provinceId":"520000","value":"522701"},{"cityId":"522700","label":"福泉市","provinceId":"520000","value":"522702"},{"cityId":"522700","label":"荔波县","provinceId":"520000","value":"522722"},{"cityId":"522700","label":"贵定县","provinceId":"520000","value":"522723"},{"cityId":"522700","label":"瓮安县","provinceId":"520000","value":"522725"},{"cityId":"522700","label":"独山县","provinceId":"520000","value":"522726"},{"cityId":"522700","label":"平塘县","provinceId":"520000","value":"522727"},{"cityId":"522700","label":"罗甸县","provinceId":"520000","value":"522728"},{"cityId":"522700","label":"长顺县","provinceId":"520000","value":"522729"},{"cityId":"522700","label":"龙里县","provinceId":"520000","value":"522730"},{"cityId":"522700","label":"惠水县","provinceId":"520000","value":"522731"},{"cityId":"522700","label":"三都水族自治县","provinceId":"520000","value":"522732"}],"label":"黔南布依族苗族自治州","provinceId":"520000","value":"522700"}],"label":"贵州省","value":"520000"},{"children":[{"children":[{"cityId":"530100","label":"五华区","provinceId":"530000","value":"530102"},{"cityId":"530100","label":"盘龙区","provinceId":"530000","value":"530103"},{"cityId":"530100","label":"官渡区","provinceId":"530000","value":"530111"},{"cityId":"530100","label":"西山区","provinceId":"530000","value":"530112"},{"cityId":"530100","label":"东川区","provinceId":"530000","value":"530113"},{"cityId":"530100","label":"呈贡区","provinceId":"530000","value":"530121"},{"cityId":"530100","label":"晋宁县","provinceId":"530000","value":"530122"},{"cityId":"530100","label":"富民县","provinceId":"530000","value":"530124"},{"cityId":"530100","label":"宜良县","provinceId":"530000","value":"530125"},{"cityId":"530100","label":"石林彝族自治县","provinceId":"530000","value":"530126"},{"cityId":"530100","label":"嵩明县","provinceId":"530000","value":"530127"},{"cityId":"530100","label":"禄劝彝族苗族自治县","provinceId":"530000","value":"530128"},{"cityId":"530100","label":"寻甸回族彝族自治县","provinceId":"530000","value":"530129"},{"cityId":"530100","label":"安宁市","provinceId":"530000","value":"530181"}],"label":"昆明市","provinceId":"530000","value":"530100"},{"children":[{"cityId":"530300","label":"麒麟区","provinceId":"530000","value":"530302"},{"cityId":"530300","label":"马龙县","provinceId":"530000","value":"530321"},{"cityId":"530300","label":"陆良县","provinceId":"530000","value":"530322"},{"cityId":"530300","label":"师宗县","provinceId":"530000","value":"530323"},{"cityId":"530300","label":"罗平县","provinceId":"530000","value":"530324"},{"cityId":"530300","label":"富源县","provinceId":"530000","value":"530325"},{"cityId":"530300","label":"会泽县","provinceId":"530000","value":"530326"},{"cityId":"530300","label":"沾益区","provinceId":"530000","value":"530328"},{"cityId":"530300","label":"宣威市","provinceId":"530000","value":"530381"}],"label":"曲靖市","provinceId":"530000","value":"530300"},{"children":[{"cityId":"530400","label":"红塔区","provinceId":"530000","value":"530402"},{"cityId":"530400","label":"江川区","provinceId":"530000","value":"530421"},{"cityId":"530400","label":"澄江县","provinceId":"530000","value":"530422"},{"cityId":"530400","label":"通海县","provinceId":"530000","value":"530423"},{"cityId":"530400","label":"华宁县","provinceId":"530000","value":"530424"},{"cityId":"530400","label":"易门县","provinceId":"530000","value":"530425"},{"cityId":"530400","label":"峨山彝族自治县","provinceId":"530000","value":"530426"},{"cityId":"530400","label":"新平彝族傣族自治县","provinceId":"530000","value":"530427"},{"cityId":"530400","label":"元江哈尼族彝族傣族自治县","provinceId":"530000","value":"530428"}],"label":"玉溪市","provinceId":"530000","value":"530400"},{"children":[{"cityId":"530500","label":"隆阳区","provinceId":"530000","value":"530502"},{"cityId":"530500","label":"施甸县","provinceId":"530000","value":"530521"},{"cityId":"530500","label":"腾冲市","provinceId":"530000","value":"530522"},{"cityId":"530500","label":"龙陵县","provinceId":"530000","value":"530523"},{"cityId":"530500","label":"昌宁县","provinceId":"530000","value":"530524"}],"label":"保山市","provinceId":"530000","value":"530500"},{"children":[{"cityId":"530600","label":"昭阳区","provinceId":"530000","value":"530602"},{"cityId":"530600","label":"鲁甸县","provinceId":"530000","value":"530621"},{"cityId":"530600","label":"巧家县","provinceId":"530000","value":"530622"},{"cityId":"530600","label":"盐津县","provinceId":"530000","value":"530623"},{"cityId":"530600","label":"大关县","provinceId":"530000","value":"530624"},{"cityId":"530600","label":"永善县","provinceId":"530000","value":"530625"},{"cityId":"530600","label":"绥江县","provinceId":"530000","value":"530626"},{"cityId":"530600","label":"镇雄县","provinceId":"530000","value":"530627"},{"cityId":"530600","label":"彝良县","provinceId":"530000","value":"530628"},{"cityId":"530600","label":"威信县","provinceId":"530000","value":"530629"},{"cityId":"530600","label":"水富县","provinceId":"530000","value":"530630"}],"label":"昭通市","provinceId":"530000","value":"530600"},{"children":[{"cityId":"530700","label":"古城区","provinceId":"530000","value":"530702"},{"cityId":"530700","label":"玉龙纳西族自治县","provinceId":"530000","value":"530721"},{"cityId":"530700","label":"永胜县","provinceId":"530000","value":"530722"},{"cityId":"530700","label":"华坪县","provinceId":"530000","value":"530723"},{"cityId":"530700","label":"宁蒗彝族自治县","provinceId":"530000","value":"530724"}],"label":"丽江市","provinceId":"530000","value":"530700"},{"children":[{"cityId":"530800","label":"思茅区","provinceId":"530000","value":"530802"},{"cityId":"530800","label":"宁洱哈尼族彝族自治县","provinceId":"530000","value":"530821"},{"cityId":"530800","label":"墨江哈尼族自治县","provinceId":"530000","value":"530822"},{"cityId":"530800","label":"景东彝族自治县","provinceId":"530000","value":"530823"},{"cityId":"530800","label":"景谷傣族彝族自治县","provinceId":"530000","value":"530824"},{"cityId":"530800","label":"镇沅彝族哈尼族拉祜族自治县","provinceId":"530000","value":"530825"},{"cityId":"530800","label":"江城哈尼族彝族自治县","provinceId":"530000","value":"530826"},{"cityId":"530800","label":"孟连傣族拉祜族佤族自治县","provinceId":"530000","value":"530827"},{"cityId":"530800","label":"澜沧拉祜族自治县","provinceId":"530000","value":"530828"},{"cityId":"530800","label":"西盟佤族自治县","provinceId":"530000","value":"530829"}],"label":"普洱市","provinceId":"530000","value":"530800"},{"children":[{"cityId":"530900","label":"临翔区","provinceId":"530000","value":"530902"},{"cityId":"530900","label":"凤庆县","provinceId":"530000","value":"530921"},{"cityId":"530900","label":"云县","provinceId":"530000","value":"530922"},{"cityId":"530900","label":"永德县","provinceId":"530000","value":"530923"},{"cityId":"530900","label":"镇康县","provinceId":"530000","value":"530924"},{"cityId":"530900","label":"双江拉祜族佤族布朗族傣族自治县","provinceId":"530000","value":"530925"},{"cityId":"530900","label":"耿马傣族佤族自治县","provinceId":"530000","value":"530926"},{"cityId":"530900","label":"沧源佤族自治县","provinceId":"530000","value":"530927"}],"label":"临沧市","provinceId":"530000","value":"530900"},{"children":[{"cityId":"532300","label":"楚雄市","provinceId":"530000","value":"532301"},{"cityId":"532300","label":"双柏县","provinceId":"530000","value":"532322"},{"cityId":"532300","label":"牟定县","provinceId":"530000","value":"532323"},{"cityId":"532300","label":"南华县","provinceId":"530000","value":"532324"},{"cityId":"532300","label":"姚安县","provinceId":"530000","value":"532325"},{"cityId":"532300","label":"大姚县","provinceId":"530000","value":"532326"},{"cityId":"532300","label":"永仁县","provinceId":"530000","value":"532327"},{"cityId":"532300","label":"元谋县","provinceId":"530000","value":"532328"},{"cityId":"532300","label":"武定县","provinceId":"530000","value":"532329"},{"cityId":"532300","label":"禄丰县","provinceId":"530000","value":"532331"}],"label":"楚雄彝族自治州","provinceId":"530000","value":"532300"},{"children":[{"cityId":"532500","label":"个旧市","provinceId":"530000","value":"532501"},{"cityId":"532500","label":"开远市","provinceId":"530000","value":"532502"},{"cityId":"532500","label":"蒙自市","provinceId":"530000","value":"532522"},{"cityId":"532500","label":"屏边苗族自治县","provinceId":"530000","value":"532523"},{"cityId":"532500","label":"建水县","provinceId":"530000","value":"532524"},{"cityId":"532500","label":"石屏县","provinceId":"530000","value":"532525"},{"cityId":"532500","label":"弥勒市","provinceId":"530000","value":"532526"},{"cityId":"532500","label":"泸西县","provinceId":"530000","value":"532527"},{"cityId":"532500","label":"元阳县","provinceId":"530000","value":"532528"},{"cityId":"532500","label":"红河县","provinceId":"530000","value":"532529"},{"cityId":"532500","label":"金平苗族瑶族傣族自治县","provinceId":"530000","value":"532530"},{"cityId":"532500","label":"绿春县","provinceId":"530000","value":"532531"},{"cityId":"532500","label":"河口瑶族自治县","provinceId":"530000","value":"532532"}],"label":"红河哈尼族彝族自治州","provinceId":"530000","value":"532500"},{"children":[{"cityId":"532600","label":"文山市","provinceId":"530000","value":"532621"},{"cityId":"532600","label":"砚山县","provinceId":"530000","value":"532622"},{"cityId":"532600","label":"西畴县","provinceId":"530000","value":"532623"},{"cityId":"532600","label":"麻栗坡县","provinceId":"530000","value":"532624"},{"cityId":"532600","label":"马关县","provinceId":"530000","value":"532625"},{"cityId":"532600","label":"丘北县","provinceId":"530000","value":"532626"},{"cityId":"532600","label":"广南县","provinceId":"530000","value":"532627"},{"cityId":"532600","label":"富宁县","provinceId":"530000","value":"532628"}],"label":"文山壮族苗族自治州","provinceId":"530000","value":"532600"},{"children":[{"cityId":"532800","label":"景洪市","provinceId":"530000","value":"532801"},{"cityId":"532800","label":"勐海县","provinceId":"530000","value":"532822"},{"cityId":"532800","label":"勐腊县","provinceId":"530000","value":"532823"}],"label":"西双版纳傣族自治州","provinceId":"530000","value":"532800"},{"children":[{"cityId":"532900","label":"大理市","provinceId":"530000","value":"532901"},{"cityId":"532900","label":"漾濞彝族自治县","provinceId":"530000","value":"532922"},{"cityId":"532900","label":"祥云县","provinceId":"530000","value":"532923"},{"cityId":"532900","label":"宾川县","provinceId":"530000","value":"532924"},{"cityId":"532900","label":"弥渡县","provinceId":"530000","value":"532925"},{"cityId":"532900","label":"南涧彝族自治县","provinceId":"530000","value":"532926"},{"cityId":"532900","label":"巍山彝族回族自治县","provinceId":"530000","value":"532927"},{"cityId":"532900","label":"永平县","provinceId":"530000","value":"532928"},{"cityId":"532900","label":"云龙县","provinceId":"530000","value":"532929"},{"cityId":"532900","label":"洱源县","provinceId":"530000","value":"532930"},{"cityId":"532900","label":"剑川县","provinceId":"530000","value":"532931"},{"cityId":"532900","label":"鹤庆县","provinceId":"530000","value":"532932"}],"label":"大理白族自治州","provinceId":"530000","value":"532900"},{"children":[{"cityId":"533100","label":"瑞丽市","provinceId":"530000","value":"533102"},{"cityId":"533100","label":"芒市","provinceId":"530000","value":"533104"},{"cityId":"533100","label":"梁河县","provinceId":"530000","value":"533122"},{"cityId":"533100","label":"盈江县","provinceId":"530000","value":"533123"},{"cityId":"533100","label":"陇川县","provinceId":"530000","value":"533124"}],"label":"德宏傣族景颇族自治州","provinceId":"530000","value":"533100"},{"children":[{"cityId":"533300","label":"泸水市","provinceId":"530000","value":"533301"},{"cityId":"533300","label":"泸水县","provinceId":"530000","value":"533321"},{"cityId":"533300","label":"福贡县","provinceId":"530000","value":"533323"},{"cityId":"533300","label":"贡山独龙族怒族自治县","provinceId":"530000","value":"533324"},{"cityId":"533300","label":"兰坪白族普米族自治县","provinceId":"530000","value":"533325"}],"label":"怒江傈僳族自治州","provinceId":"530000","value":"533300"},{"children":[{"cityId":"533400","label":"香格里拉市","provinceId":"530000","value":"533421"},{"cityId":"533400","label":"德钦县","provinceId":"530000","value":"533422"},{"cityId":"533400","label":"维西傈僳族自治县","provinceId":"530000","value":"533423"}],"label":"迪庆藏族自治州","provinceId":"530000","value":"533400"}],"label":"云南省","value":"530000"},{"children":[{"children":[{"cityId":"540100","label":"城关区","provinceId":"540000","value":"540102"},{"cityId":"540100","label":"林周县","provinceId":"540000","value":"540121"},{"cityId":"540100","label":"当雄县","provinceId":"540000","value":"540122"},{"cityId":"540100","label":"尼木县","provinceId":"540000","value":"540123"},{"cityId":"540100","label":"曲水县","provinceId":"540000","value":"540124"},{"cityId":"540100","label":"堆龙德庆区","provinceId":"540000","value":"540125"},{"cityId":"540100","label":"达孜县","provinceId":"540000","value":"540126"},{"cityId":"540100","label":"墨竹工卡县","provinceId":"540000","value":"540127"}],"label":"拉萨市","provinceId":"540000","value":"540100"},{"children":[{"cityId":"540200","label":"桑珠孜区","provinceId":"540000","value":"540202"}],"label":"日喀则市","provinceId":"540000","value":"540200"},{"children":[{"cityId":"540300","label":"卡若区","provinceId":"540000","value":"540302"}],"label":"昌都市","provinceId":"540000","value":"540300"},{"children":[{"cityId":"540400","label":"巴宜区","provinceId":"540000","value":"540402"}],"label":"林芝市","provinceId":"540000","value":"540400"},{"children":[{"cityId":"540500","label":"乃东区","provinceId":"540000","value":"540502"}],"label":"山南市","provinceId":"540000","value":"540500"},{"children":[{"cityId":"542100","label":"昌都县","provinceId":"540000","value":"542121"},{"cityId":"542100","label":"江达县","provinceId":"540000","value":"542122"},{"cityId":"542100","label":"贡觉县","provinceId":"540000","value":"542123"},{"cityId":"542100","label":"类乌齐县","provinceId":"540000","value":"542124"},{"cityId":"542100","label":"丁青县","provinceId":"540000","value":"542125"},{"cityId":"542100","label":"察雅县","provinceId":"540000","value":"542126"},{"cityId":"542100","label":"八宿县","provinceId":"540000","value":"542127"},{"cityId":"542100","label":"左贡县","provinceId":"540000","value":"542128"},{"cityId":"542100","label":"芒康县","provinceId":"540000","value":"542129"},{"cityId":"542100","label":"洛隆县","provinceId":"540000","value":"542132"},{"cityId":"542100","label":"边坝县","provinceId":"540000","value":"542133"}],"label":"昌都地区","provinceId":"540000","value":"542100"},{"children":[{"cityId":"542200","label":"乃东县","provinceId":"540000","value":"542221"},{"cityId":"542200","label":"扎囊县","provinceId":"540000","value":"542222"},{"cityId":"542200","label":"贡嘎县","provinceId":"540000","value":"542223"},{"cityId":"542200","label":"桑日县","provinceId":"540000","value":"542224"},{"cityId":"542200","label":"琼结县","provinceId":"540000","value":"542225"},{"cityId":"542200","label":"曲松县","provinceId":"540000","value":"542226"},{"cityId":"542200","label":"措美县","provinceId":"540000","value":"542227"},{"cityId":"542200","label":"洛扎县","provinceId":"540000","value":"542228"},{"cityId":"542200","label":"加查县","provinceId":"540000","value":"542229"},{"cityId":"542200","label":"隆子县","provinceId":"540000","value":"542231"},{"cityId":"542200","label":"错那县","provinceId":"540000","value":"542232"},{"cityId":"542200","label":"浪卡子县","provinceId":"540000","value":"542233"}],"label":"山南地区","provinceId":"540000","value":"542200"},{"children":[{"cityId":"542300","label":"南木林县","provinceId":"540000","value":"542322"},{"cityId":"542300","label":"江孜县","provinceId":"540000","value":"542323"},{"cityId":"542300","label":"定日县","provinceId":"540000","value":"542324"},{"cityId":"542300","label":"萨迦县","provinceId":"540000","value":"542325"},{"cityId":"542300","label":"拉孜县","provinceId":"540000","value":"542326"},{"cityId":"542300","label":"昂仁县","provinceId":"540000","value":"542327"},{"cityId":"542300","label":"谢通门县","provinceId":"540000","value":"542328"},{"cityId":"542300","label":"白朗县","provinceId":"540000","value":"542329"},{"cityId":"542300","label":"仁布县","provinceId":"540000","value":"542330"},{"cityId":"542300","label":"康马县","provinceId":"540000","value":"542331"},{"cityId":"542300","label":"定结县","provinceId":"540000","value":"542332"},{"cityId":"542300","label":"仲巴县","provinceId":"540000","value":"542333"},{"cityId":"542300","label":"亚东县","provinceId":"540000","value":"542334"},{"cityId":"542300","label":"吉隆县","provinceId":"540000","value":"542335"},{"cityId":"542300","label":"聂拉木县","provinceId":"540000","value":"542336"},{"cityId":"542300","label":"萨嘎县","provinceId":"540000","value":"542337"},{"cityId":"542300","label":"岗巴县","provinceId":"540000","value":"542338"}],"label":"日喀则地区","provinceId":"540000","value":"542300"},{"children":[{"cityId":"542400","label":"那曲县","provinceId":"540000","value":"542421"},{"cityId":"542400","label":"嘉黎县","provinceId":"540000","value":"542422"},{"cityId":"542400","label":"比如县","provinceId":"540000","value":"542423"},{"cityId":"542400","label":"聂荣县","provinceId":"540000","value":"542424"},{"cityId":"542400","label":"安多县","provinceId":"540000","value":"542425"},{"cityId":"542400","label":"申扎县","provinceId":"540000","value":"542426"},{"cityId":"542400","label":"索县","provinceId":"540000","value":"542427"},{"cityId":"542400","label":"班戈县","provinceId":"540000","value":"542428"},{"cityId":"542400","label":"巴青县","provinceId":"540000","value":"542429"},{"cityId":"542400","label":"尼玛县","provinceId":"540000","value":"542430"},{"cityId":"542400","label":"双湖县","provinceId":"540000","value":"542431"}],"label":"那曲地区","provinceId":"540000","value":"542400"},{"children":[{"cityId":"542500","label":"普兰县","provinceId":"540000","value":"542521"},{"cityId":"542500","label":"札达县","provinceId":"540000","value":"542522"},{"cityId":"542500","label":"噶尔县","provinceId":"540000","value":"542523"},{"cityId":"542500","label":"日土县","provinceId":"540000","value":"542524"},{"cityId":"542500","label":"革吉县","provinceId":"540000","value":"542525"},{"cityId":"542500","label":"改则县","provinceId":"540000","value":"542526"},{"cityId":"542500","label":"措勤县","provinceId":"540000","value":"542527"}],"label":"阿里地区","provinceId":"540000","value":"542500"},{"children":[{"cityId":"542600","label":"林芝县","provinceId":"540000","value":"542621"},{"cityId":"542600","label":"工布江达县","provinceId":"540000","value":"542622"},{"cityId":"542600","label":"米林县","provinceId":"540000","value":"542623"},{"cityId":"542600","label":"墨脱县","provinceId":"540000","value":"542624"},{"cityId":"542600","label":"波密县","provinceId":"540000","value":"542625"},{"cityId":"542600","label":"察隅县","provinceId":"540000","value":"542626"},{"cityId":"542600","label":"朗　县","provinceId":"540000","value":"542627"}],"label":"林芝地区","provinceId":"540000","value":"542600"}],"label":"西藏自治区","value":"540000"},{"children":[{"children":[{"cityId":"610100","label":"新城区","provinceId":"610000","value":"610102"},{"cityId":"610100","label":"碑林区","provinceId":"610000","value":"610103"},{"cityId":"610100","label":"莲湖区","provinceId":"610000","value":"610104"},{"cityId":"610100","label":"灞桥区","provinceId":"610000","value":"610111"},{"cityId":"610100","label":"未央区","provinceId":"610000","value":"610112"},{"cityId":"610100","label":"雁塔区","provinceId":"610000","value":"610113"},{"cityId":"610100","label":"阎良区","provinceId":"610000","value":"610114"},{"cityId":"610100","label":"临潼区","provinceId":"610000","value":"610115"},{"cityId":"610100","label":"长安区","provinceId":"610000","value":"610116"},{"cityId":"610100","label":"蓝田县","provinceId":"610000","value":"610122"},{"cityId":"610100","label":"周至县","provinceId":"610000","value":"610124"},{"cityId":"610100","label":"户县","provinceId":"610000","value":"610125"},{"cityId":"610100","label":"高陵区","provinceId":"610000","value":"610126"}],"label":"西安市","provinceId":"610000","value":"610100"},{"children":[{"cityId":"610200","label":"王益区","provinceId":"610000","value":"610202"},{"cityId":"610200","label":"印台区","provinceId":"610000","value":"610203"},{"cityId":"610200","label":"耀州区","provinceId":"610000","value":"610204"},{"cityId":"610200","label":"宜君县","provinceId":"610000","value":"610222"}],"label":"铜川市","provinceId":"610000","value":"610200"},{"children":[{"cityId":"610300","label":"渭滨区","provinceId":"610000","value":"610302"},{"cityId":"610300","label":"金台区","provinceId":"610000","value":"610303"},{"cityId":"610300","label":"陈仓区","provinceId":"610000","value":"610304"},{"cityId":"610300","label":"凤翔县","provinceId":"610000","value":"610322"},{"cityId":"610300","label":"岐山县","provinceId":"610000","value":"610323"},{"cityId":"610300","label":"扶风县","provinceId":"610000","value":"610324"},{"cityId":"610300","label":"眉县","provinceId":"610000","value":"610326"},{"cityId":"610300","label":"陇县","provinceId":"610000","value":"610327"},{"cityId":"610300","label":"千阳县","provinceId":"610000","value":"610328"},{"cityId":"610300","label":"麟游县","provinceId":"610000","value":"610329"},{"cityId":"610300","label":"凤县","provinceId":"610000","value":"610330"},{"cityId":"610300","label":"太白县","provinceId":"610000","value":"610331"}],"label":"宝鸡市","provinceId":"610000","value":"610300"},{"children":[{"cityId":"610400","label":"秦都区","provinceId":"610000","value":"610402"},{"cityId":"610400","label":"杨陵区","provinceId":"610000","value":"610403"},{"cityId":"610400","label":"渭城区","provinceId":"610000","value":"610404"},{"cityId":"610400","label":"三原县","provinceId":"610000","value":"610422"},{"cityId":"610400","label":"泾阳县","provinceId":"610000","value":"610423"},{"cityId":"610400","label":"乾县","provinceId":"610000","value":"610424"},{"cityId":"610400","label":"礼泉县","provinceId":"610000","value":"610425"},{"cityId":"610400","label":"永寿县","provinceId":"610000","value":"610426"},{"cityId":"610400","label":"彬县","provinceId":"610000","value":"610427"},{"cityId":"610400","label":"长武县","provinceId":"610000","value":"610428"},{"cityId":"610400","label":"旬邑县","provinceId":"610000","value":"610429"},{"cityId":"610400","label":"淳化县","provinceId":"610000","value":"610430"},{"cityId":"610400","label":"武功县","provinceId":"610000","value":"610431"},{"cityId":"610400","label":"兴平市","provinceId":"610000","value":"610481"}],"label":"咸阳市","provinceId":"610000","value":"610400"},{"children":[{"cityId":"610500","label":"临渭区","provinceId":"610000","value":"610502"},{"cityId":"610500","label":"华州区","provinceId":"610000","value":"610521"},{"cityId":"610500","label":"潼关县","provinceId":"610000","value":"610522"},{"cityId":"610500","label":"大荔县","provinceId":"610000","value":"610523"},{"cityId":"610500","label":"合阳县","provinceId":"610000","value":"610524"},{"cityId":"610500","label":"澄城县","provinceId":"610000","value":"610525"},{"cityId":"610500","label":"蒲城县","provinceId":"610000","value":"610526"},{"cityId":"610500","label":"白水县","provinceId":"610000","value":"610527"},{"cityId":"610500","label":"富平县","provinceId":"610000","value":"610528"},{"cityId":"610500","label":"韩城市","provinceId":"610000","value":"610581"},{"cityId":"610500","label":"华阴市","provinceId":"610000","value":"610582"}],"label":"渭南市","provinceId":"610000","value":"610500"},{"children":[{"cityId":"610600","label":"宝塔区","provinceId":"610000","value":"610602"},{"cityId":"610600","label":"延长县","provinceId":"610000","value":"610621"},{"cityId":"610600","label":"延川县","provinceId":"610000","value":"610622"},{"cityId":"610600","label":"子长县","provinceId":"610000","value":"610623"},{"cityId":"610600","label":"安塞区","provinceId":"610000","value":"610624"},{"cityId":"610600","label":"志丹县","provinceId":"610000","value":"610625"},{"cityId":"610600","label":"吴起县","provinceId":"610000","value":"610626"},{"cityId":"610600","label":"甘泉县","provinceId":"610000","value":"610627"},{"cityId":"610600","label":"富县","provinceId":"610000","value":"610628"},{"cityId":"610600","label":"洛川县","provinceId":"610000","value":"610629"},{"cityId":"610600","label":"宜川县","provinceId":"610000","value":"610630"},{"cityId":"610600","label":"黄龙县","provinceId":"610000","value":"610631"},{"cityId":"610600","label":"黄陵县","provinceId":"610000","value":"610632"}],"label":"延安市","provinceId":"610000","value":"610600"},{"children":[{"cityId":"610700","label":"汉台区","provinceId":"610000","value":"610702"},{"cityId":"610700","label":"南郑县","provinceId":"610000","value":"610721"},{"cityId":"610700","label":"城固县","provinceId":"610000","value":"610722"},{"cityId":"610700","label":"洋县","provinceId":"610000","value":"610723"},{"cityId":"610700","label":"西乡县","provinceId":"610000","value":"610724"},{"cityId":"610700","label":"勉县","provinceId":"610000","value":"610725"},{"cityId":"610700","label":"宁强县","provinceId":"610000","value":"610726"},{"cityId":"610700","label":"略阳县","provinceId":"610000","value":"610727"},{"cityId":"610700","label":"镇巴县","provinceId":"610000","value":"610728"},{"cityId":"610700","label":"留坝县","provinceId":"610000","value":"610729"},{"cityId":"610700","label":"佛坪县","provinceId":"610000","value":"610730"}],"label":"汉中市","provinceId":"610000","value":"610700"},{"children":[{"cityId":"610800","label":"榆阳区","provinceId":"610000","value":"610802"},{"cityId":"610800","label":"神木县","provinceId":"610000","value":"610821"},{"cityId":"610800","label":"府谷县","provinceId":"610000","value":"610822"},{"cityId":"610800","label":"横山区","provinceId":"610000","value":"610823"},{"cityId":"610800","label":"靖边县","provinceId":"610000","value":"610824"},{"cityId":"610800","label":"定边县","provinceId":"610000","value":"610825"},{"cityId":"610800","label":"绥德县","provinceId":"610000","value":"610826"},{"cityId":"610800","label":"米脂县","provinceId":"610000","value":"610827"},{"cityId":"610800","label":"佳县","provinceId":"610000","value":"610828"},{"cityId":"610800","label":"吴堡县","provinceId":"610000","value":"610829"},{"cityId":"610800","label":"清涧县","provinceId":"610000","value":"610830"},{"cityId":"610800","label":"子洲县","provinceId":"610000","value":"610831"}],"label":"榆林市","provinceId":"610000","value":"610800"},{"children":[{"cityId":"610900","label":"汉滨区","provinceId":"610000","value":"610902"},{"cityId":"610900","label":"汉阴县","provinceId":"610000","value":"610921"},{"cityId":"610900","label":"石泉县","provinceId":"610000","value":"610922"},{"cityId":"610900","label":"宁陕县","provinceId":"610000","value":"610923"},{"cityId":"610900","label":"紫阳县","provinceId":"610000","value":"610924"},{"cityId":"610900","label":"岚皋县","provinceId":"610000","value":"610925"},{"cityId":"610900","label":"平利县","provinceId":"610000","value":"610926"},{"cityId":"610900","label":"镇坪县","provinceId":"610000","value":"610927"},{"cityId":"610900","label":"旬阳县","provinceId":"610000","value":"610928"},{"cityId":"610900","label":"白河县","provinceId":"610000","value":"610929"}],"label":"安康市","provinceId":"610000","value":"610900"},{"children":[{"cityId":"611000","label":"商州区","provinceId":"610000","value":"611002"},{"cityId":"611000","label":"洛南县","provinceId":"610000","value":"611021"},{"cityId":"611000","label":"丹凤县","provinceId":"610000","value":"611022"},{"cityId":"611000","label":"商南县","provinceId":"610000","value":"611023"},{"cityId":"611000","label":"山阳县","provinceId":"610000","value":"611024"},{"cityId":"611000","label":"镇安县","provinceId":"610000","value":"611025"},{"cityId":"611000","label":"柞水县","provinceId":"610000","value":"611026"}],"label":"商洛市","provinceId":"610000","value":"611000"}],"label":"陕西省","value":"610000"},{"children":[{"children":[{"cityId":"620100","label":"城关区","provinceId":"620000","value":"620102"},{"cityId":"620100","label":"七里河区","provinceId":"620000","value":"620103"},{"cityId":"620100","label":"西固区","provinceId":"620000","value":"620104"},{"cityId":"620100","label":"安宁区","provinceId":"620000","value":"620105"},{"cityId":"620100","label":"红古区","provinceId":"620000","value":"620111"},{"cityId":"620100","label":"兰州新区","provinceId":"620000","value":"620112"},{"cityId":"620100","label":"永登县","provinceId":"620000","value":"620121"},{"cityId":"620100","label":"皋兰县","provinceId":"620000","value":"620122"},{"cityId":"620100","label":"榆中县","provinceId":"620000","value":"620123"}],"label":"兰州市","provinceId":"620000","value":"620100"},{"children":[{"cityId":"620200","label":"雄关区","provinceId":"620000","value":"620201"},{"cityId":"620200","label":"长城区","provinceId":"620000","value":"620202"},{"cityId":"620200","label":"镜铁区","provinceId":"620000","value":"620203"}],"label":"嘉峪关市","provinceId":"620000","value":"620200"},{"children":[{"cityId":"620300","label":"金川区","provinceId":"620000","value":"620302"},{"cityId":"620300","label":"永昌县","provinceId":"620000","value":"620321"}],"label":"金昌市","provinceId":"620000","value":"620300"},{"children":[{"cityId":"620400","label":"白银区","provinceId":"620000","value":"620402"},{"cityId":"620400","label":"平川区","provinceId":"620000","value":"620403"},{"cityId":"620400","label":"靖远县","provinceId":"620000","value":"620421"},{"cityId":"620400","label":"会宁县","provinceId":"620000","value":"620422"},{"cityId":"620400","label":"景泰县","provinceId":"620000","value":"620423"}],"label":"白银市","provinceId":"620000","value":"620400"},{"children":[{"cityId":"620500","label":"秦州区","provinceId":"620000","value":"620502"},{"cityId":"620500","label":"麦积区","provinceId":"620000","value":"620503"},{"cityId":"620500","label":"清水县","provinceId":"620000","value":"620521"},{"cityId":"620500","label":"秦安县","provinceId":"620000","value":"620522"},{"cityId":"620500","label":"甘谷县","provinceId":"620000","value":"620523"},{"cityId":"620500","label":"武山县","provinceId":"620000","value":"620524"},{"cityId":"620500","label":"张家川回族自治县","provinceId":"620000","value":"620525"}],"label":"天水市","provinceId":"620000","value":"620500"},{"children":[{"cityId":"620600","label":"凉州区","provinceId":"620000","value":"620602"},{"cityId":"620600","label":"民勤县","provinceId":"620000","value":"620621"},{"cityId":"620600","label":"古浪县","provinceId":"620000","value":"620622"},{"cityId":"620600","label":"天祝藏族自治县","provinceId":"620000","value":"620623"}],"label":"武威市","provinceId":"620000","value":"620600"},{"children":[{"cityId":"620700","label":"甘州区","provinceId":"620000","value":"620702"},{"cityId":"620700","label":"肃南裕固族自治县","provinceId":"620000","value":"620721"},{"cityId":"620700","label":"民乐县","provinceId":"620000","value":"620722"},{"cityId":"620700","label":"临泽县","provinceId":"620000","value":"620723"},{"cityId":"620700","label":"高台县","provinceId":"620000","value":"620724"},{"cityId":"620700","label":"山丹县","provinceId":"620000","value":"620725"}],"label":"张掖市","provinceId":"620000","value":"620700"},{"children":[{"cityId":"620800","label":"崆峒区","provinceId":"620000","value":"620802"},{"cityId":"620800","label":"泾川县","provinceId":"620000","value":"620821"},{"cityId":"620800","label":"灵台县","provinceId":"620000","value":"620822"},{"cityId":"620800","label":"崇信县","provinceId":"620000","value":"620823"},{"cityId":"620800","label":"华亭县","provinceId":"620000","value":"620824"},{"cityId":"620800","label":"庄浪县","provinceId":"620000","value":"620825"},{"cityId":"620800","label":"静宁县","provinceId":"620000","value":"620826"}],"label":"平凉市","provinceId":"620000","value":"620800"},{"children":[{"cityId":"620900","label":"肃州区","provinceId":"620000","value":"620902"},{"cityId":"620900","label":"金塔县","provinceId":"620000","value":"620921"},{"cityId":"620900","label":"安西县","provinceId":"620000","value":"620922"},{"cityId":"620900","label":"肃北蒙古族自治县","provinceId":"620000","value":"620923"},{"cityId":"620900","label":"阿克塞哈萨克族自治县","provinceId":"620000","value":"620924"},{"cityId":"620900","label":"瓜州县","provinceId":"620000","value":"620932"},{"cityId":"620900","label":"玉门市","provinceId":"620000","value":"620981"},{"cityId":"620900","label":"敦煌市","provinceId":"620000","value":"620982"}],"label":"酒泉市","provinceId":"620000","value":"620900"},{"children":[{"cityId":"621000","label":"西峰区","provinceId":"620000","value":"621002"},{"cityId":"621000","label":"庆城县","provinceId":"620000","value":"621021"},{"cityId":"621000","label":"环县","provinceId":"620000","value":"621022"},{"cityId":"621000","label":"华池县","provinceId":"620000","value":"621023"},{"cityId":"621000","label":"合水县","provinceId":"620000","value":"621024"},{"cityId":"621000","label":"正宁县","provinceId":"620000","value":"621025"},{"cityId":"621000","label":"宁县","provinceId":"620000","value":"621026"},{"cityId":"621000","label":"镇原县","provinceId":"620000","value":"621027"}],"label":"庆阳市","provinceId":"620000","value":"621000"},{"children":[{"cityId":"621100","label":"安定区","provinceId":"620000","value":"621102"},{"cityId":"621100","label":"通渭县","provinceId":"620000","value":"621121"},{"cityId":"621100","label":"陇西县","provinceId":"620000","value":"621122"},{"cityId":"621100","label":"渭源县","provinceId":"620000","value":"621123"},{"cityId":"621100","label":"临洮县","provinceId":"620000","value":"621124"},{"cityId":"621100","label":"漳县","provinceId":"620000","value":"621125"},{"cityId":"621100","label":"岷县","provinceId":"620000","value":"621126"}],"label":"定西市","provinceId":"620000","value":"621100"},{"children":[{"cityId":"621200","label":"武都区","provinceId":"620000","value":"621202"},{"cityId":"621200","label":"成县","provinceId":"620000","value":"621221"},{"cityId":"621200","label":"文县","provinceId":"620000","value":"621222"},{"cityId":"621200","label":"宕昌县","provinceId":"620000","value":"621223"},{"cityId":"621200","label":"康县","provinceId":"620000","value":"621224"},{"cityId":"621200","label":"西和县","provinceId":"620000","value":"621225"},{"cityId":"621200","label":"礼县","provinceId":"620000","value":"621226"},{"cityId":"621200","label":"徽县","provinceId":"620000","value":"621227"},{"cityId":"621200","label":"两当县","provinceId":"620000","value":"621228"}],"label":"陇南市","provinceId":"620000","value":"621200"},{"children":[{"cityId":"622900","label":"临夏市","provinceId":"620000","value":"622901"},{"cityId":"622900","label":"临夏县","provinceId":"620000","value":"622921"},{"cityId":"622900","label":"康乐县","provinceId":"620000","value":"622922"},{"cityId":"622900","label":"永靖县","provinceId":"620000","value":"622923"},{"cityId":"622900","label":"广河县","provinceId":"620000","value":"622924"},{"cityId":"622900","label":"和政县","provinceId":"620000","value":"622925"},{"cityId":"622900","label":"东乡族自治县","provinceId":"620000","value":"622926"},{"cityId":"622900","label":"积石山保安族东乡族撒拉族自治县","provinceId":"620000","value":"622927"}],"label":"临夏回族自治州","provinceId":"620000","value":"622900"},{"children":[{"cityId":"623000","label":"合作市","provinceId":"620000","value":"623001"},{"cityId":"623000","label":"临潭县","provinceId":"620000","value":"623021"},{"cityId":"623000","label":"卓尼县","provinceId":"620000","value":"623022"},{"cityId":"623000","label":"舟曲县","provinceId":"620000","value":"623023"},{"cityId":"623000","label":"迭部县","provinceId":"620000","value":"623024"},{"cityId":"623000","label":"玛曲县","provinceId":"620000","value":"623025"},{"cityId":"623000","label":"碌曲县","provinceId":"620000","value":"623026"},{"cityId":"623000","label":"夏河县","provinceId":"620000","value":"623027"}],"label":"甘南藏族自治州","provinceId":"620000","value":"623000"}],"label":"甘肃省","value":"620000"},{"children":[{"children":[{"cityId":"630100","label":"城东区","provinceId":"630000","value":"630102"},{"cityId":"630100","label":"城中区","provinceId":"630000","value":"630103"},{"cityId":"630100","label":"城西区","provinceId":"630000","value":"630104"},{"cityId":"630100","label":"城北区","provinceId":"630000","value":"630105"},{"cityId":"630100","label":"海湖新区","provinceId":"630000","value":"630106"},{"cityId":"630100","label":"大通回族土族自治县","provinceId":"630000","value":"630121"},{"cityId":"630100","label":"湟中县","provinceId":"630000","value":"630122"},{"cityId":"630100","label":"湟源县","provinceId":"630000","value":"630123"}],"label":"西宁市","provinceId":"630000","value":"630100"},{"children":[{"cityId":"630200","label":"乐都区","provinceId":"630000","value":"630202"},{"cityId":"630200","label":"平安区","provinceId":"630000","value":"630203"}],"label":"海东市","provinceId":"630000","value":"630200"},{"children":[{"cityId":"632100","label":"平安县","provinceId":"630000","value":"632121"},{"cityId":"632100","label":"民和回族土族自治县","provinceId":"630000","value":"632122"},{"cityId":"632100","label":"乐都县","provinceId":"630000","value":"632123"},{"cityId":"632100","label":"互助土族自治县","provinceId":"630000","value":"632126"},{"cityId":"632100","label":"化隆回族自治县","provinceId":"630000","value":"632127"},{"cityId":"632100","label":"循化撒拉族自治县","provinceId":"630000","value":"632128"}],"label":"海东地区","provinceId":"630000","value":"632100"},{"children":[{"cityId":"632200","label":"门源回族自治县","provinceId":"630000","value":"632221"},{"cityId":"632200","label":"祁连县","provinceId":"630000","value":"632222"},{"cityId":"632200","label":"海晏县","provinceId":"630000","value":"632223"},{"cityId":"632200","label":"刚察县","provinceId":"630000","value":"632224"},{"cityId":"632200","label":"西海","provinceId":"630000","value":"632225"}],"label":"海北藏族自治州","provinceId":"630000","value":"632200"},{"children":[{"cityId":"632300","label":"同仁县","provinceId":"630000","value":"632321"},{"cityId":"632300","label":"尖扎县","provinceId":"630000","value":"632322"},{"cityId":"632300","label":"泽库县","provinceId":"630000","value":"632323"},{"cityId":"632300","label":"河南蒙古族自治县","provinceId":"630000","value":"632324"}],"label":"黄南藏族自治州","provinceId":"630000","value":"632300"},{"children":[{"cityId":"632500","label":"共和县","provinceId":"630000","value":"632521"},{"cityId":"632500","label":"同德县","provinceId":"630000","value":"632522"},{"cityId":"632500","label":"贵德县","provinceId":"630000","value":"632523"},{"cityId":"632500","label":"兴海县","provinceId":"630000","value":"632524"},{"cityId":"632500","label":"贵南县","provinceId":"630000","value":"632525"}],"label":"海南藏族自治州","provinceId":"630000","value":"632500"},{"children":[{"cityId":"632600","label":"玛沁县","provinceId":"630000","value":"632621"},{"cityId":"632600","label":"班玛县","provinceId":"630000","value":"632622"},{"cityId":"632600","label":"甘德县","provinceId":"630000","value":"632623"},{"cityId":"632600","label":"达日县","provinceId":"630000","value":"632624"},{"cityId":"632600","label":"久治县","provinceId":"630000","value":"632625"},{"cityId":"632600","label":"玛多县","provinceId":"630000","value":"632626"}],"label":"果洛藏族自治州","provinceId":"630000","value":"632600"},{"children":[{"cityId":"632700","label":"玉树市","provinceId":"630000","value":"632721"},{"cityId":"632700","label":"杂多县","provinceId":"630000","value":"632722"},{"cityId":"632700","label":"称多县","provinceId":"630000","value":"632723"},{"cityId":"632700","label":"治多县","provinceId":"630000","value":"632724"},{"cityId":"632700","label":"囊谦县","provinceId":"630000","value":"632725"},{"cityId":"632700","label":"曲麻莱县","provinceId":"630000","value":"632726"}],"label":"玉树藏族自治州","provinceId":"630000","value":"632700"},{"children":[{"cityId":"632800","label":"格尔木市","provinceId":"630000","value":"632801"},{"cityId":"632800","label":"德令哈市","provinceId":"630000","value":"632802"},{"cityId":"632800","label":"乌兰县","provinceId":"630000","value":"632821"},{"cityId":"632800","label":"都兰县","provinceId":"630000","value":"632822"},{"cityId":"632800","label":"天峻县","provinceId":"630000","value":"632823"}],"label":"海西蒙古族藏族自治州","provinceId":"630000","value":"632800"}],"label":"青海省","value":"630000"},{"children":[{"children":[{"cityId":"640100","label":"宁东镇","provinceId":"640000","value":"640102"},{"cityId":"640100","label":"兴庆区","provinceId":"640000","value":"640104"},{"cityId":"640100","label":"西夏区","provinceId":"640000","value":"640105"},{"cityId":"640100","label":"金凤区","provinceId":"640000","value":"640106"},{"cityId":"640100","label":"永宁县","provinceId":"640000","value":"640121"},{"cityId":"640100","label":"贺兰县","provinceId":"640000","value":"640122"},{"cityId":"640100","label":"灵武市","provinceId":"640000","value":"640181"}],"label":"银川市","provinceId":"640000","value":"640100"},{"children":[{"cityId":"640200","label":"大武口区","provinceId":"640000","value":"640202"},{"cityId":"640200","label":"惠农区","provinceId":"640000","value":"640205"},{"cityId":"640200","label":"平罗县","provinceId":"640000","value":"640221"}],"label":"石嘴山市","provinceId":"640000","value":"640200"},{"children":[{"cityId":"640300","label":"利通区","provinceId":"640000","value":"640302"},{"cityId":"640300","label":"盐池县","provinceId":"640000","value":"640323"},{"cityId":"640300","label":"同心县","provinceId":"640000","value":"640324"},{"cityId":"640300","label":"红寺堡区","provinceId":"640000","value":"640355"},{"cityId":"640300","label":"青铜峡市","provinceId":"640000","value":"640381"}],"label":"吴忠市","provinceId":"640000","value":"640300"},{"children":[{"cityId":"640400","label":"原州区","provinceId":"640000","value":"640402"},{"cityId":"640400","label":"西吉县","provinceId":"640000","value":"640422"},{"cityId":"640400","label":"隆德县","provinceId":"640000","value":"640423"},{"cityId":"640400","label":"泾源县","provinceId":"640000","value":"640424"},{"cityId":"640400","label":"彭阳县","provinceId":"640000","value":"640425"}],"label":"固原市","provinceId":"640000","value":"640400"},{"children":[{"cityId":"640500","label":"沙坡头区","provinceId":"640000","value":"640502"},{"cityId":"640500","label":"中宁县","provinceId":"640000","value":"640521"},{"cityId":"640500","label":"海原县","provinceId":"640000","value":"640522"}],"label":"中卫市","provinceId":"640000","value":"640500"}],"label":"宁夏回族自治区","value":"640000"},{"children":[{"children":[{"cityId":"650100","label":"天山区","provinceId":"650000","value":"650102"},{"cityId":"650100","label":"沙依巴克区","provinceId":"650000","value":"650103"},{"cityId":"650100","label":"新市区","provinceId":"650000","value":"650104"},{"cityId":"650100","label":"水磨沟区","provinceId":"650000","value":"650105"},{"cityId":"650100","label":"头屯河区","provinceId":"650000","value":"650106"},{"cityId":"650100","label":"达坂城区","provinceId":"650000","value":"650107"},{"cityId":"650100","label":"米东区","provinceId":"650000","value":"650109"},{"cityId":"650100","label":"乌鲁木齐县","provinceId":"650000","value":"650121"}],"label":"乌鲁木齐市","provinceId":"650000","value":"650100"},{"children":[{"cityId":"650200","label":"独山子区","provinceId":"650000","value":"650202"},{"cityId":"650200","label":"克拉玛依区","provinceId":"650000","value":"650203"},{"cityId":"650200","label":"白碱滩区","provinceId":"650000","value":"650204"},{"cityId":"650200","label":"乌尔禾区","provinceId":"650000","value":"650205"}],"label":"克拉玛依市","provinceId":"650000","value":"650200"},{"children":[{"cityId":"650400","label":"高昌区","provinceId":"650000","value":"650402"}],"label":"吐鲁番市","provinceId":"650000","value":"650400"},{"children":[{"cityId":"650500","label":"伊州区","provinceId":"650000","value":"650502"}],"label":"哈密市","provinceId":"650000","value":"650500"},{"children":[{"cityId":"652100","label":"吐鲁番市","provinceId":"650000","value":"652101"},{"cityId":"652100","label":"鄯善县","provinceId":"650000","value":"652122"},{"cityId":"652100","label":"托克逊县","provinceId":"650000","value":"652123"}],"label":"吐鲁番地区","provinceId":"650000","value":"652100"},{"children":[{"cityId":"652200","label":"哈密市","provinceId":"650000","value":"652201"},{"cityId":"652200","label":"巴里坤哈萨克自治县","provinceId":"650000","value":"652222"},{"cityId":"652200","label":"伊吾县","provinceId":"650000","value":"652223"}],"label":"哈密地区","provinceId":"650000","value":"652200"},{"children":[{"cityId":"652300","label":"昌吉市","provinceId":"650000","value":"652301"},{"cityId":"652300","label":"阜康市","provinceId":"650000","value":"652302"},{"cityId":"652300","label":"米泉市","provinceId":"650000","value":"652303"},{"cityId":"652300","label":"准东","provinceId":"650000","value":"652304"},{"cityId":"652300","label":"呼图壁县","provinceId":"650000","value":"652323"},{"cityId":"652300","label":"玛纳斯县","provinceId":"650000","value":"652324"},{"cityId":"652300","label":"奇台县","provinceId":"650000","value":"652325"},{"cityId":"652300","label":"吉木萨尔县","provinceId":"650000","value":"652327"},{"cityId":"652300","label":"木垒哈萨克自治县","provinceId":"650000","value":"652328"}],"label":"昌吉回族自治州","provinceId":"650000","value":"652300"},{"children":[{"cityId":"652700","label":"博乐市","provinceId":"650000","value":"652701"},{"cityId":"652700","label":"阿拉山口市","provinceId":"650000","value":"652702"},{"cityId":"652700","label":"精河县","provinceId":"650000","value":"652722"},{"cityId":"652700","label":"温泉县","provinceId":"650000","value":"652723"}],"label":"博尔塔拉蒙古自治州","provinceId":"650000","value":"652700"},{"children":[{"cityId":"652800","label":"库尔勒市","provinceId":"650000","value":"652801"},{"cityId":"652800","label":"轮台县","provinceId":"650000","value":"652822"},{"cityId":"652800","label":"尉犁县","provinceId":"650000","value":"652823"},{"cityId":"652800","label":"若羌县","provinceId":"650000","value":"652824"},{"cityId":"652800","label":"且末县","provinceId":"650000","value":"652825"},{"cityId":"652800","label":"焉耆回族自治县","provinceId":"650000","value":"652826"},{"cityId":"652800","label":"和静县","provinceId":"650000","value":"652827"},{"cityId":"652800","label":"和硕县","provinceId":"650000","value":"652828"},{"cityId":"652800","label":"博湖县","provinceId":"650000","value":"652829"}],"label":"巴音郭楞蒙古自治州","provinceId":"650000","value":"652800"},{"children":[{"cityId":"652900","label":"阿克苏市","provinceId":"650000","value":"652901"},{"cityId":"652900","label":"温宿县","provinceId":"650000","value":"652922"},{"cityId":"652900","label":"库车县","provinceId":"650000","value":"652923"},{"cityId":"652900","label":"沙雅县","provinceId":"650000","value":"652924"},{"cityId":"652900","label":"新和县","provinceId":"650000","value":"652925"},{"cityId":"652900","label":"拜城县","provinceId":"650000","value":"652926"},{"cityId":"652900","label":"乌什县","provinceId":"650000","value":"652927"},{"cityId":"652900","label":"阿瓦提县","provinceId":"650000","value":"652928"},{"cityId":"652900","label":"柯坪县","provinceId":"650000","value":"652929"}],"label":"阿克苏地区","provinceId":"650000","value":"652900"},{"children":[{"cityId":"653000","label":"阿图什市","provinceId":"650000","value":"653001"},{"cityId":"653000","label":"阿克陶县","provinceId":"650000","value":"653022"},{"cityId":"653000","label":"阿合奇县","provinceId":"650000","value":"653023"},{"cityId":"653000","label":"乌恰县","provinceId":"650000","value":"653024"}],"label":"克孜勒苏柯尔克孜自治州","provinceId":"650000","value":"653000"},{"children":[{"cityId":"653100","label":"喀什市","provinceId":"650000","value":"653101"},{"cityId":"653100","label":"疏附县","provinceId":"650000","value":"653121"},{"cityId":"653100","label":"疏勒县","provinceId":"650000","value":"653122"},{"cityId":"653100","label":"英吉沙县","provinceId":"650000","value":"653123"},{"cityId":"653100","label":"泽普县","provinceId":"650000","value":"653124"},{"cityId":"653100","label":"莎车县","provinceId":"650000","value":"653125"},{"cityId":"653100","label":"叶城县","provinceId":"650000","value":"653126"},{"cityId":"653100","label":"麦盖提县","provinceId":"650000","value":"653127"},{"cityId":"653100","label":"岳普湖县","provinceId":"650000","value":"653128"},{"cityId":"653100","label":"伽师县","provinceId":"650000","value":"653129"},{"cityId":"653100","label":"巴楚县","provinceId":"650000","value":"653130"},{"cityId":"653100","label":"塔什库尔干塔吉克自治县","provinceId":"650000","value":"653131"}],"label":"喀什地区","provinceId":"650000","value":"653100"},{"children":[{"cityId":"653200","label":"和田市","provinceId":"650000","value":"653201"},{"cityId":"653200","label":"和田县","provinceId":"650000","value":"653221"},{"cityId":"653200","label":"墨玉县","provinceId":"650000","value":"653222"},{"cityId":"653200","label":"皮山县","provinceId":"650000","value":"653223"},{"cityId":"653200","label":"洛浦县","provinceId":"650000","value":"653224"},{"cityId":"653200","label":"策勒县","provinceId":"650000","value":"653225"},{"cityId":"653200","label":"于田县","provinceId":"650000","value":"653226"},{"cityId":"653200","label":"民丰县","provinceId":"650000","value":"653227"}],"label":"和田地区","provinceId":"650000","value":"653200"},{"children":[{"cityId":"654000","label":"伊宁市","provinceId":"650000","value":"654002"},{"cityId":"654000","label":"奎屯市","provinceId":"650000","value":"654003"},{"cityId":"654000","label":"霍尔果斯市","provinceId":"650000","value":"654004"},{"cityId":"654000","label":"伊宁县","provinceId":"650000","value":"654021"},{"cityId":"654000","label":"察布查尔锡伯自治县","provinceId":"650000","value":"654022"},{"cityId":"654000","label":"霍城县","provinceId":"650000","value":"654023"},{"cityId":"654000","label":"巩留县","provinceId":"650000","value":"654024"},{"cityId":"654000","label":"新源县","provinceId":"650000","value":"654025"},{"cityId":"654000","label":"昭苏县","provinceId":"650000","value":"654026"},{"cityId":"654000","label":"特克斯县","provinceId":"650000","value":"654027"},{"cityId":"654000","label":"尼勒克县","provinceId":"650000","value":"654028"}],"label":"伊犁哈萨克自治州","provinceId":"650000","value":"654000"},{"children":[{"cityId":"654200","label":"塔城市","provinceId":"650000","value":"654201"},{"cityId":"654200","label":"乌苏市","provinceId":"650000","value":"654202"},{"cityId":"654200","label":"额敏县","provinceId":"650000","value":"654221"},{"cityId":"654200","label":"沙湾县","provinceId":"650000","value":"654223"},{"cityId":"654200","label":"托里县","provinceId":"650000","value":"654224"},{"cityId":"654200","label":"裕民县","provinceId":"650000","value":"654225"},{"cityId":"654200","label":"和布克赛尔蒙古自治县","provinceId":"650000","value":"654226"}],"label":"塔城地区","provinceId":"650000","value":"654200"},{"children":[{"cityId":"654300","label":"阿勒泰市","provinceId":"650000","value":"654301"},{"cityId":"654300","label":"布尔津县","provinceId":"650000","value":"654321"},{"cityId":"654300","label":"富蕴县","provinceId":"650000","value":"654322"},{"cityId":"654300","label":"福海县","provinceId":"650000","value":"654323"},{"cityId":"654300","label":"哈巴河县","provinceId":"650000","value":"654324"},{"cityId":"654300","label":"青河县","provinceId":"650000","value":"654325"},{"cityId":"654300","label":"吉木乃县","provinceId":"650000","value":"654326"},{"cityId":"654300","label":"北屯","provinceId":"650000","value":"654350"}],"label":"阿勒泰地区","provinceId":"650000","value":"654300"},{"children":[{"cityId":"659000","label":"石河子市","provinceId":"650000","value":"659001"},{"cityId":"659000","label":"阿拉尔市","provinceId":"650000","value":"659002"},{"cityId":"659000","label":"图木舒克市","provinceId":"650000","value":"659003"},{"cityId":"659000","label":"五家渠市","provinceId":"650000","value":"659004"},{"cityId":"659000","label":"铁门关市","provinceId":"650000","value":"659006"}],"label":"省直辖行政单位","provinceId":"650000","value":"659000"},{"children":[{"cityId":"659800","label":"第一师","provinceId":"650000","value":"659801"},{"cityId":"659800","label":"第二师","provinceId":"650000","value":"659802"},{"cityId":"659800","label":"农三师","provinceId":"650000","value":"659803"},{"cityId":"659800","label":"第四师","provinceId":"650000","value":"659804"},{"cityId":"659800","label":"第五师","provinceId":"650000","value":"659805"},{"cityId":"659800","label":"第六师","provinceId":"650000","value":"659806"},{"cityId":"659800","label":"第七师","provinceId":"650000","value":"659807"},{"cityId":"659800","label":"第八师","provinceId":"650000","value":"659808"},{"cityId":"659800","label":"第九师","provinceId":"650000","value":"659809"},{"cityId":"659800","label":"第十师","provinceId":"650000","value":"659810"},{"cityId":"659800","label":"第十二师","provinceId":"650000","value":"659812"},{"cityId":"659800","label":"第十三师","provinceId":"650000","value":"659813"},{"cityId":"659800","label":"第十四师","provinceId":"650000","value":"659814"},{"cityId":"659800","label":"新疆兵团兵直","provinceId":"650000","value":"659815"},{"cityId":"659800","label":"新疆兵团兵直乌市","provinceId":"650000","value":"659816"},{"cityId":"659800","label":"其他","provinceId":"650000","value":"659899"}],"label":"新疆兵团","provinceId":"650000","value":"659800"}],"label":"新疆维吾尔自治区","value":"650000"}]
    return area;
  },

  /**
   * 城市列表
   */
  chinaAreaList() {
    //省市级数据
    const chinaArea = [{
      "children": [{
        "children": [{
          "label": "东城区"
        }, {
          "label": "延庆区"
        }, {
          "label": "朝阳区"
        }, {
          "label": "丰台区"
        }, {
          "label": "石景山区"
        }, {
          "label": "海淀区"
        }, {
          "label": "门头沟区"
        }, {
          "label": "房山区"
        }, {
          "label": "通州区"
        }, {
          "label": "顺义区"
        }, {
          "label": "昌平区"
        }, {
          "label": "大兴区"
        }, {
          "label": "怀柔区"
        }, {
          "label": "平谷区"
        }, {
          "label": "密云区"
        }, {
          "label": "西城区"
        }],
        "label": "北京市"
      }],
      "label": "北京市"
    }, {
      "children": [{
        "children": [{
          "label": "河西区"
        }, {
          "label": "河东区"
        }, {
          "label": "河北区"
        }, {
          "label": "红桥区"
        }, {
          "label": "东丽区"
        }, {
          "label": "西青区"
        }, {
          "label": "津南区"
        }, {
          "label": "北辰区"
        }, {
          "label": "武清区"
        }, {
          "label": "宝坻区"
        }, {
          "label": "滨海新区"
        }, {
          "label": "宁河区"
        }, {
          "label": "静海区"
        }, {
          "label": "蓟州区"
        }, {
          "label": "和平区"
        }, {
          "label": "南开区"
        }],
        "label": "天津市"
      }],
      "label": "天津市"
    }, {
      "children": [{
        "children": [{
          "label": "雄县"
        }, {
          "label": "涿州市"
        }, {
          "label": "定州市"
        }, {
          "label": "安国市"
        }, {
          "label": "高碑店市"
        }, {
          "label": "满城区"
        }, {
          "label": "清苑区"
        }, {
          "label": "徐水区"
        }, {
          "label": "莲池区"
        }, {
          "label": "市辖区"
        }, {
          "label": "新市区"
        }, {
          "label": "涞水县"
        }, {
          "label": "阜平县"
        }, {
          "label": "定兴县"
        }, {
          "label": "唐县"
        }, {
          "label": "高阳县"
        }, {
          "label": "容城县"
        }, {
          "label": "涞源县"
        }, {
          "label": "望都县"
        }, {
          "label": "安新县"
        }, {
          "label": "易县"
        }, {
          "label": "曲阳县"
        }, {
          "label": "蠡县"
        }, {
          "label": "顺平县"
        }, {
          "label": "博野县"
        }],
        "label": "保定市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "双桥区"
        }, {
          "label": "双滦区"
        }, {
          "label": "鹰手营子矿区"
        }, {
          "label": "承德县"
        }, {
          "label": "兴隆县"
        }, {
          "label": "滦平县"
        }, {
          "label": "隆化县"
        }, {
          "label": "丰宁满族自治县"
        }, {
          "label": "宽城满族自治县"
        }, {
          "label": "围场满族蒙古族自治县"
        }, {
          "label": "平泉市"
        }],
        "label": "承德市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "新华区"
        }, {
          "label": "运河区"
        }, {
          "label": "沧县"
        }, {
          "label": "青县"
        }, {
          "label": "东光县"
        }, {
          "label": "海兴县"
        }, {
          "label": "盐山县"
        }, {
          "label": "肃宁县"
        }, {
          "label": "南皮县"
        }, {
          "label": "吴桥县"
        }, {
          "label": "献县"
        }, {
          "label": "孟村回族自治县"
        }, {
          "label": "泊头市"
        }, {
          "label": "任丘市"
        }, {
          "label": "黄骅市"
        }, {
          "label": "河间市"
        }],
        "label": "沧州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "安次区"
        }, {
          "label": "广阳区"
        }, {
          "label": "固安县"
        }, {
          "label": "永清县"
        }, {
          "label": "香河县"
        }, {
          "label": "大城县"
        }, {
          "label": "文安县"
        }, {
          "label": "大厂回族自治县"
        }, {
          "label": "霸州市"
        }, {
          "label": "三河市"
        }],
        "label": "廊坊市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "桥东区"
        }, {
          "label": "桥西区"
        }, {
          "label": "邢台县"
        }, {
          "label": "临城县"
        }, {
          "label": "内丘县"
        }, {
          "label": "柏乡县"
        }, {
          "label": "隆尧县"
        }, {
          "label": "任县"
        }, {
          "label": "南和县"
        }, {
          "label": "宁晋县"
        }, {
          "label": "巨鹿县"
        }, {
          "label": "新河县"
        }, {
          "label": "广宗县"
        }, {
          "label": "平乡县"
        }, {
          "label": "威县"
        }, {
          "label": "清河县"
        }, {
          "label": "临西县"
        }, {
          "label": "南宫市"
        }, {
          "label": "沙河市"
        }],
        "label": "邢台市"
      }, {
        "children": [{
          "label": "辛集市"
        }, {
          "label": "晋州市"
        }, {
          "label": "新乐市"
        }, {
          "label": "市辖区"
        }, {
          "label": "藁城区"
        }, {
          "label": "鹿泉区"
        }, {
          "label": "栾城区"
        }, {
          "label": "长安区"
        }, {
          "label": "桥西区"
        }, {
          "label": "新华区"
        }, {
          "label": "井陉矿区"
        }, {
          "label": "裕华区"
        }, {
          "label": "井陉县"
        }, {
          "label": "正定县"
        }, {
          "label": "行唐县"
        }, {
          "label": "灵寿县"
        }, {
          "label": "高邑县"
        }, {
          "label": "深泽县"
        }, {
          "label": "赞皇县"
        }, {
          "label": "无极县"
        }, {
          "label": "平山县"
        }, {
          "label": "元氏县"
        }, {
          "label": "赵县"
        }],
        "label": "石家庄市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "路南区"
        }, {
          "label": "路北区"
        }, {
          "label": "古冶区"
        }, {
          "label": "开平区"
        }, {
          "label": "丰南区"
        }, {
          "label": "丰润区"
        }, {
          "label": "滦南县"
        }, {
          "label": "乐亭县"
        }, {
          "label": "迁西县"
        }, {
          "label": "玉田县"
        }, {
          "label": "遵化市"
        }, {
          "label": "迁安市"
        }, {
          "label": "曹妃甸区"
        }, {
          "label": "滦州市"
        }],
        "label": "唐山市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "海港区"
        }, {
          "label": "山海关区"
        }, {
          "label": "北戴河区"
        }, {
          "label": "青龙满族自治县"
        }, {
          "label": "昌黎县"
        }, {
          "label": "卢龙县"
        }, {
          "label": "抚宁区"
        }],
        "label": "秦皇岛市"
      }, {
        "children": [{
          "label": "赤城县"
        }, {
          "label": "市辖区"
        }, {
          "label": "桥东区"
        }, {
          "label": "桥西区"
        }, {
          "label": "宣化区"
        }, {
          "label": "下花园区"
        }, {
          "label": "张北县"
        }, {
          "label": "康保县"
        }, {
          "label": "沽源县"
        }, {
          "label": "尚义县"
        }, {
          "label": "蔚县"
        }, {
          "label": "阳原县"
        }, {
          "label": "怀安县"
        }, {
          "label": "怀来县"
        }, {
          "label": "涿鹿县"
        }, {
          "label": "万全区"
        }, {
          "label": "崇礼区"
        }],
        "label": "张家口市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "桃城区"
        }, {
          "label": "枣强县"
        }, {
          "label": "武邑县"
        }, {
          "label": "武强县"
        }, {
          "label": "饶阳县"
        }, {
          "label": "安平县"
        }, {
          "label": "故城县"
        }, {
          "label": "景县"
        }, {
          "label": "阜城县"
        }, {
          "label": "深州市"
        }, {
          "label": "冀州区"
        }],
        "label": "衡水市"
      }, {
        "children": [{
          "label": "魏县"
        }, {
          "label": "曲周县"
        }, {
          "label": "武安市"
        }, {
          "label": "市辖区"
        }, {
          "label": "邯山区"
        }, {
          "label": "丛台区"
        }, {
          "label": "复兴区"
        }, {
          "label": "峰峰矿区"
        }, {
          "label": "临漳县"
        }, {
          "label": "成安县"
        }, {
          "label": "大名县"
        }, {
          "label": "涉县"
        }, {
          "label": "磁县"
        }, {
          "label": "邱县"
        }, {
          "label": "鸡泽县"
        }, {
          "label": "广平县"
        }, {
          "label": "馆陶县"
        }, {
          "label": "肥乡区"
        }, {
          "label": "永年区"
        }],
        "label": "邯郸市"
      }],
      "label": "河北省"
    }, {
      "children": [{
        "children": [{
          "label": "市辖区"
        }, {
          "label": "城区"
        }, {
          "label": "矿区"
        }, {
          "label": "郊区"
        }, {
          "label": "平定县"
        }, {
          "label": "盂县"
        }],
        "label": "阳泉市"
      }, {
        "children": [{
          "label": "武乡县"
        }, {
          "label": "沁县"
        }, {
          "label": "沁源县"
        }, {
          "label": "市辖区"
        }, {
          "label": "襄垣县"
        }, {
          "label": "平顺县"
        }, {
          "label": "黎城县"
        }, {
          "label": "壶关县"
        }, {
          "label": "长子县"
        }, {
          "label": "潞州区"
        }, {
          "label": "上党区"
        }, {
          "label": "屯留区"
        }, {
          "label": "潞城区"
        }],
        "label": "长治市"
      }, {
        "children": [{
          "label": "万柏林区"
        }, {
          "label": "晋源区"
        }, {
          "label": "清徐县"
        }, {
          "label": "阳曲县"
        }, {
          "label": "娄烦县"
        }, {
          "label": "古交市"
        }, {
          "label": "市辖区"
        }, {
          "label": "小店区"
        }, {
          "label": "迎泽区"
        }, {
          "label": "杏花岭区"
        }, {
          "label": "尖草坪区"
        }],
        "label": "太原市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "盐湖区"
        }, {
          "label": "临猗县"
        }, {
          "label": "万荣县"
        }, {
          "label": "闻喜县"
        }, {
          "label": "稷山县"
        }, {
          "label": "新绛县"
        }, {
          "label": "绛县"
        }, {
          "label": "垣曲县"
        }, {
          "label": "夏县"
        }, {
          "label": "平陆县"
        }, {
          "label": "芮城县"
        }, {
          "label": "永济市"
        }, {
          "label": "河津市"
        }],
        "label": "运城市"
      }, {
        "children": [{
          "label": "安泽县"
        }, {
          "label": "浮山县"
        }, {
          "label": "吉县"
        }, {
          "label": "乡宁县"
        }, {
          "label": "大宁县"
        }, {
          "label": "隰县"
        }, {
          "label": "永和县"
        }, {
          "label": "蒲县"
        }, {
          "label": "汾西县"
        }, {
          "label": "市辖区"
        }, {
          "label": "侯马市"
        }, {
          "label": "霍州市"
        }, {
          "label": "尧都区"
        }, {
          "label": "曲沃县"
        }, {
          "label": "翼城县"
        }, {
          "label": "襄汾县"
        }, {
          "label": "洪洞县"
        }, {
          "label": "古县"
        }],
        "label": "临汾市"
      }, {
        "children": [{
          "label": "御东区"
        }, {
          "label": "市辖区"
        }, {
          "label": "新荣区"
        }, {
          "label": "阳高县"
        }, {
          "label": "天镇县"
        }, {
          "label": "广灵县"
        }, {
          "label": "灵丘县"
        }, {
          "label": "浑源县"
        }, {
          "label": "左云县"
        }, {
          "label": "云冈区"
        }, {
          "label": "云州区"
        }, {
          "label": "平城区"
        }],
        "label": "大同市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "离石区"
        }, {
          "label": "文水县"
        }, {
          "label": "交城县"
        }, {
          "label": "兴县"
        }, {
          "label": "临县"
        }, {
          "label": "柳林县"
        }, {
          "label": "石楼县"
        }, {
          "label": "岚县"
        }, {
          "label": "方山县"
        }, {
          "label": "中阳县"
        }, {
          "label": "交口县"
        }, {
          "label": "孝义市"
        }, {
          "label": "汾阳市"
        }],
        "label": "吕梁市"
      }, {
        "children": [{
          "label": "祁县"
        }, {
          "label": "平遥县"
        }, {
          "label": "灵石县"
        }, {
          "label": "介休市"
        }, {
          "label": "市辖区"
        }, {
          "label": "榆次区"
        }, {
          "label": "榆社县"
        }, {
          "label": "左权县"
        }, {
          "label": "和顺县"
        }, {
          "label": "昔阳县"
        }, {
          "label": "寿阳县"
        }, {
          "label": "太谷县"
        }],
        "label": "晋中市"
      }, {
        "children": [{
          "label": "忻府区"
        }, {
          "label": "定襄县"
        }, {
          "label": "五台县"
        }, {
          "label": "代县"
        }, {
          "label": "繁峙县"
        }, {
          "label": "宁武县"
        }, {
          "label": "静乐县"
        }, {
          "label": "神池县"
        }, {
          "label": "五寨县"
        }, {
          "label": "岢岚县"
        }, {
          "label": "河曲县"
        }, {
          "label": "保德县"
        }, {
          "label": "偏关县"
        }, {
          "label": "原平市"
        }, {
          "label": "市辖区"
        }],
        "label": "忻州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "城区"
        }, {
          "label": "沁水县"
        }, {
          "label": "阳城县"
        }, {
          "label": "陵川县"
        }, {
          "label": "泽州县"
        }, {
          "label": "高平市"
        }],
        "label": "晋城市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "朔城区"
        }, {
          "label": "平鲁区"
        }, {
          "label": "山阴县"
        }, {
          "label": "应县"
        }, {
          "label": "右玉县"
        }, {
          "label": "怀仁市"
        }],
        "label": "朔州市"
      }],
      "label": "山西省"
    }, {
      "children": [{
        "children": [{
          "label": "市辖区"
        }, {
          "label": "东河区"
        }, {
          "label": "昆都仑区"
        }, {
          "label": "青山区"
        }, {
          "label": "石拐区"
        }, {
          "label": "白云鄂博矿区"
        }, {
          "label": "九原区"
        }, {
          "label": "土默特右旗"
        }, {
          "label": "固阳县"
        }, {
          "label": "达尔罕茂明安联合旗"
        }],
        "label": "包头市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "海勃湾区"
        }, {
          "label": "海南区"
        }, {
          "label": "乌达区"
        }],
        "label": "乌海市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "红山区"
        }, {
          "label": "元宝山区"
        }, {
          "label": "松山区"
        }, {
          "label": "阿鲁科尔沁旗"
        }, {
          "label": "宁城县"
        }, {
          "label": "敖汉旗"
        }, {
          "label": "巴林左旗"
        }, {
          "label": "巴林右旗"
        }, {
          "label": "林西县"
        }, {
          "label": "克什克腾旗"
        }, {
          "label": "翁牛特旗"
        }, {
          "label": "喀喇沁旗"
        }],
        "label": "赤峰市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "新城区"
        }, {
          "label": "回民区"
        }, {
          "label": "玉泉区"
        }, {
          "label": "赛罕区"
        }, {
          "label": "土默特左旗"
        }, {
          "label": "托克托县"
        }, {
          "label": "和林格尔县"
        }, {
          "label": "清水河县"
        }, {
          "label": "武川县"
        }],
        "label": "呼和浩特市"
      }, {
        "children": [{
          "label": "乌兰浩特市"
        }, {
          "label": "阿尔山市"
        }, {
          "label": "科尔沁右翼前旗"
        }, {
          "label": "科尔沁右翼中旗"
        }, {
          "label": "扎赉特旗"
        }, {
          "label": "突泉县"
        }],
        "label": "兴安盟"
      }, {
        "children": [{
          "label": "二连浩特市"
        }, {
          "label": "锡林浩特市"
        }, {
          "label": "阿巴嘎旗"
        }, {
          "label": "苏尼特左旗"
        }, {
          "label": "苏尼特右旗"
        }, {
          "label": "东乌珠穆沁旗"
        }, {
          "label": "西乌珠穆沁旗"
        }, {
          "label": "太仆寺旗"
        }, {
          "label": "镶黄旗"
        }, {
          "label": "正镶白旗"
        }, {
          "label": "正蓝旗"
        }, {
          "label": "多伦县"
        }],
        "label": "锡林郭勒盟"
      }, {
        "children": [{
          "label": "阿拉善左旗"
        }, {
          "label": "阿拉善右旗"
        }, {
          "label": "额济纳旗"
        }],
        "label": "阿拉善盟"
      }, {
        "children": [{
          "label": "察哈尔右翼前旗"
        }, {
          "label": "察哈尔右翼中旗"
        }, {
          "label": "察哈尔右翼后旗"
        }, {
          "label": "四子王旗"
        }, {
          "label": "丰镇市"
        }, {
          "label": "市辖区"
        }, {
          "label": "集宁区"
        }, {
          "label": "卓资县"
        }, {
          "label": "化德县"
        }, {
          "label": "商都县"
        }, {
          "label": "兴和县"
        }, {
          "label": "凉城县"
        }],
        "label": "乌兰察布市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "科尔沁区"
        }, {
          "label": "科尔沁左翼中旗"
        }, {
          "label": "科尔沁左翼后旗"
        }, {
          "label": "开鲁县"
        }, {
          "label": "库伦旗"
        }, {
          "label": "奈曼旗"
        }, {
          "label": "扎鲁特旗"
        }, {
          "label": "霍林郭勒市"
        }],
        "label": "通辽市"
      }, {
        "children": [{
          "label": "康巴什区"
        }, {
          "label": "市辖区"
        }, {
          "label": "东胜区"
        }, {
          "label": "达拉特旗"
        }, {
          "label": "准格尔旗"
        }, {
          "label": "鄂托克前旗"
        }, {
          "label": "鄂托克旗"
        }, {
          "label": "杭锦旗"
        }, {
          "label": "乌审旗"
        }, {
          "label": "伊金霍洛旗"
        }],
        "label": "鄂尔多斯市"
      }, {
        "children": [{
          "label": "扎赉诺尔区"
        }, {
          "label": "市辖区"
        }, {
          "label": "海拉尔区"
        }, {
          "label": "阿荣旗"
        }, {
          "label": "莫力达瓦达斡尔族自治旗"
        }, {
          "label": "鄂伦春自治旗"
        }, {
          "label": "鄂温克族自治旗"
        }, {
          "label": "陈巴尔虎旗"
        }, {
          "label": "新巴尔虎左旗"
        }, {
          "label": "新巴尔虎右旗"
        }, {
          "label": "满洲里市"
        }, {
          "label": "牙克石市"
        }, {
          "label": "扎兰屯市"
        }, {
          "label": "额尔古纳市"
        }, {
          "label": "根河市"
        }],
        "label": "呼伦贝尔市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "临河区"
        }, {
          "label": "五原县"
        }, {
          "label": "磴口县"
        }, {
          "label": "乌拉特前旗"
        }, {
          "label": "乌拉特中旗"
        }, {
          "label": "乌拉特后旗"
        }, {
          "label": "杭锦后旗"
        }],
        "label": "巴彦淖尔市"
      }],
      "label": "内蒙古自治区"
    }, {
      "children": [{
        "children": [{
          "label": "市辖区"
        }, {
          "label": "平山区"
        }, {
          "label": "溪湖区"
        }, {
          "label": "明山区"
        }, {
          "label": "南芬区"
        }, {
          "label": "本溪满族自治县"
        }, {
          "label": "桓仁满族自治县"
        }],
        "label": "本溪市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "元宝区"
        }, {
          "label": "振兴区"
        }, {
          "label": "振安区"
        }, {
          "label": "宽甸满族自治县"
        }, {
          "label": "东港市"
        }, {
          "label": "凤城市"
        }],
        "label": "丹东市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "古塔区"
        }, {
          "label": "凌河区"
        }, {
          "label": "太和区"
        }, {
          "label": "黑山县"
        }, {
          "label": "义县"
        }, {
          "label": "凌海市"
        }, {
          "label": "北镇市"
        }],
        "label": "锦州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "站前区"
        }, {
          "label": "西市区"
        }, {
          "label": "鲅鱼圈区"
        }, {
          "label": "老边区"
        }, {
          "label": "盖州市"
        }, {
          "label": "大石桥市"
        }],
        "label": "营口市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "海州区"
        }, {
          "label": "新邱区"
        }, {
          "label": "太平区"
        }, {
          "label": "清河门区"
        }, {
          "label": "细河区"
        }, {
          "label": "阜新蒙古族自治县"
        }, {
          "label": "彰武县"
        }],
        "label": "阜新市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "白塔区"
        }, {
          "label": "文圣区"
        }, {
          "label": "宏伟区"
        }, {
          "label": "弓长岭区"
        }, {
          "label": "太子河区"
        }, {
          "label": "辽阳县"
        }, {
          "label": "灯塔市"
        }],
        "label": "辽阳市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "双台子区"
        }, {
          "label": "兴隆台区"
        }, {
          "label": "盘山县"
        }, {
          "label": "大洼区"
        }],
        "label": "盘锦市"
      }, {
        "children": [{
          "label": "银州区"
        }, {
          "label": "清河区"
        }, {
          "label": "铁岭县"
        }, {
          "label": "西丰县"
        }, {
          "label": "昌图县"
        }, {
          "label": "调兵山市"
        }, {
          "label": "开原市"
        }, {
          "label": "市辖区"
        }],
        "label": "铁岭市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "中山区"
        }, {
          "label": "西岗区"
        }, {
          "label": "沙河口区"
        }, {
          "label": "甘井子区"
        }, {
          "label": "旅顺口区"
        }, {
          "label": "金州区"
        }, {
          "label": "长海县"
        }, {
          "label": "瓦房店市"
        }, {
          "label": "庄河市"
        }, {
          "label": "普兰店区"
        }],
        "label": "大连市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "铁东区"
        }, {
          "label": "铁西区"
        }, {
          "label": "立山区"
        }, {
          "label": "千山区"
        }, {
          "label": "台安县"
        }, {
          "label": "岫岩满族自治县"
        }, {
          "label": "海城市"
        }],
        "label": "鞍山市"
      }, {
        "children": [{
          "label": "东洲区"
        }, {
          "label": "望花区"
        }, {
          "label": "顺城区"
        }, {
          "label": "抚顺县"
        }, {
          "label": "新宾满族自治县"
        }, {
          "label": "清原满族自治县"
        }, {
          "label": "市辖区"
        }, {
          "label": "新抚区"
        }],
        "label": "抚顺市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "双塔区"
        }, {
          "label": "龙城区"
        }, {
          "label": "朝阳县"
        }, {
          "label": "建平县"
        }, {
          "label": "喀喇沁左翼蒙古族自治县"
        }, {
          "label": "北票市"
        }, {
          "label": "凌源市"
        }],
        "label": "朝阳市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "连山区"
        }, {
          "label": "龙港区"
        }, {
          "label": "南票区"
        }, {
          "label": "绥中县"
        }, {
          "label": "建昌县"
        }, {
          "label": "兴城市"
        }],
        "label": "葫芦岛市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "和平区"
        }, {
          "label": "沈河区"
        }, {
          "label": "大东区"
        }, {
          "label": "皇姑区"
        }, {
          "label": "铁西区"
        }, {
          "label": "苏家屯区"
        }, {
          "label": "东陵区"
        }, {
          "label": "沈北新区"
        }, {
          "label": "于洪区"
        }, {
          "label": "康平县"
        }, {
          "label": "法库县"
        }, {
          "label": "新民市"
        }, {
          "label": "辽中区"
        }],
        "label": "沈阳市"
      }],
      "label": "辽宁省"
    }, {
      "children": [{
        "children": [{
          "label": "丰满区"
        }, {
          "label": "永吉县"
        }, {
          "label": "蛟河市"
        }, {
          "label": "桦甸市"
        }, {
          "label": "舒兰市"
        }, {
          "label": "磐石市"
        }, {
          "label": "市辖区"
        }, {
          "label": "昌邑区"
        }, {
          "label": "龙潭区"
        }, {
          "label": "船营区"
        }],
        "label": "吉林市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "铁西区"
        }, {
          "label": "铁东区"
        }, {
          "label": "梨树县"
        }, {
          "label": "伊通满族自治县"
        }, {
          "label": "公主岭市"
        }, {
          "label": "双辽市"
        }],
        "label": "四平市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "龙山区"
        }, {
          "label": "西安区"
        }, {
          "label": "东丰县"
        }, {
          "label": "东辽县"
        }],
        "label": "辽源市"
      }, {
        "children": [{
          "label": "通化县"
        }, {
          "label": "辉南县"
        }, {
          "label": "柳河县"
        }, {
          "label": "梅河口市"
        }, {
          "label": "集安市"
        }, {
          "label": "市辖区"
        }, {
          "label": "东昌区"
        }, {
          "label": "二道江区"
        }],
        "label": "通化市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "南关区"
        }, {
          "label": "宽城区"
        }, {
          "label": "朝阳区"
        }, {
          "label": "二道区"
        }, {
          "label": "绿园区"
        }, {
          "label": "双阳区"
        }, {
          "label": "农安县"
        }, {
          "label": "榆树市"
        }, {
          "label": "德惠市"
        }, {
          "label": "九台区"
        }],
        "label": "长春市"
      }, {
        "children": [{
          "label": "洮北区"
        }, {
          "label": "镇赉县"
        }, {
          "label": "通榆县"
        }, {
          "label": "洮南市"
        }, {
          "label": "大安市"
        }, {
          "label": "市辖区"
        }],
        "label": "白城市"
      }, {
        "children": [{
          "label": "延吉市"
        }, {
          "label": "图们市"
        }, {
          "label": "敦化市"
        }, {
          "label": "珲春市"
        }, {
          "label": "龙井市"
        }, {
          "label": "和龙市"
        }, {
          "label": "汪清县"
        }, {
          "label": "安图县"
        }],
        "label": "延边朝鲜族自治州"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "八道江区"
        }, {
          "label": "江源区"
        }, {
          "label": "抚松县"
        }, {
          "label": "靖宇县"
        }, {
          "label": "长白朝鲜族自治县"
        }, {
          "label": "临江市"
        }],
        "label": "白山市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "宁江区"
        }, {
          "label": "前郭尔罗斯蒙古族自治县"
        }, {
          "label": "长岭县"
        }, {
          "label": "乾安县"
        }, {
          "label": "扶余市"
        }],
        "label": "松原市"
      }],
      "label": "吉林省"
    }, {
      "children": [{
        "children": [{
          "label": "富拉尔基区"
        }, {
          "label": "碾子山区"
        }, {
          "label": "梅里斯达斡尔族区"
        }, {
          "label": "龙江县"
        }, {
          "label": "依安县"
        }, {
          "label": "泰来县"
        }, {
          "label": "甘南县"
        }, {
          "label": "富裕县"
        }, {
          "label": "克山县"
        }, {
          "label": "克东县"
        }, {
          "label": "拜泉县"
        }, {
          "label": "讷河市"
        }, {
          "label": "市辖区"
        }, {
          "label": "龙沙区"
        }, {
          "label": "建华区"
        }, {
          "label": "铁锋区"
        }, {
          "label": "昂昂溪区"
        }],
        "label": "齐齐哈尔市"
      }, {
        "children": [{
          "label": "五营区"
        }, {
          "label": "乌马河区"
        }, {
          "label": "汤旺河区"
        }, {
          "label": "带岭区"
        }, {
          "label": "乌伊岭区"
        }, {
          "label": "红星区"
        }, {
          "label": "上甘岭区"
        }, {
          "label": "嘉荫县"
        }, {
          "label": "铁力市"
        }, {
          "label": "市辖区"
        }, {
          "label": "伊春区"
        }, {
          "label": "南岔区"
        }, {
          "label": "友好区"
        }, {
          "label": "西林区"
        }, {
          "label": "翠峦区"
        }, {
          "label": "新青区"
        }, {
          "label": "美溪区"
        }, {
          "label": "金山屯区"
        }],
        "label": "伊春市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "向阳区"
        }, {
          "label": "前进区"
        }, {
          "label": "东风区"
        }, {
          "label": "郊区"
        }, {
          "label": "桦南县"
        }, {
          "label": "桦川县"
        }, {
          "label": "汤原县"
        }, {
          "label": "同江市"
        }, {
          "label": "富锦市"
        }, {
          "label": "抚远市"
        }],
        "label": "佳木斯市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "新兴区"
        }, {
          "label": "桃山区"
        }, {
          "label": "茄子河区"
        }, {
          "label": "勃利县"
        }],
        "label": "七台河市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "东安区"
        }, {
          "label": "阳明区"
        }, {
          "label": "爱民区"
        }, {
          "label": "西安区"
        }, {
          "label": "林口县"
        }, {
          "label": "绥芬河市"
        }, {
          "label": "海林市"
        }, {
          "label": "宁安市"
        }, {
          "label": "穆棱市"
        }, {
          "label": "东宁市"
        }],
        "label": "牡丹江市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "爱辉区"
        }, {
          "label": "嫩江县"
        }, {
          "label": "逊克县"
        }, {
          "label": "孙吴县"
        }, {
          "label": "北安市"
        }, {
          "label": "五大连池市"
        }],
        "label": "黑河市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "北林区"
        }, {
          "label": "望奎县"
        }, {
          "label": "兰西县"
        }, {
          "label": "青冈县"
        }, {
          "label": "庆安县"
        }, {
          "label": "明水县"
        }, {
          "label": "绥棱县"
        }, {
          "label": "安达市"
        }, {
          "label": "肇东市"
        }, {
          "label": "海伦市"
        }],
        "label": "绥化市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "道里区"
        }, {
          "label": "南岗区"
        }, {
          "label": "道外区"
        }, {
          "label": "平房区"
        }, {
          "label": "松北区"
        }, {
          "label": "香坊区"
        }, {
          "label": "呼兰区"
        }, {
          "label": "阿城区"
        }, {
          "label": "依兰县"
        }, {
          "label": "方正县"
        }, {
          "label": "宾县"
        }, {
          "label": "巴彦县"
        }, {
          "label": "木兰县"
        }, {
          "label": "通河县"
        }, {
          "label": "延寿县"
        }, {
          "label": "尚志市"
        }, {
          "label": "五常市"
        }, {
          "label": "双城区"
        }],
        "label": "哈尔滨市"
      }, {
        "children": [{
          "label": "呼玛县"
        }, {
          "label": "塔河县"
        }, {
          "label": "加格达奇区"
        }],
        "label": "大兴安岭地区"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "鸡冠区"
        }, {
          "label": "恒山区"
        }, {
          "label": "滴道区"
        }, {
          "label": "梨树区"
        }, {
          "label": "城子河区"
        }, {
          "label": "麻山区"
        }, {
          "label": "鸡东县"
        }, {
          "label": "虎林市"
        }, {
          "label": "密山市"
        }],
        "label": "鸡西市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "向阳区"
        }, {
          "label": "工农区"
        }, {
          "label": "南山区"
        }, {
          "label": "兴安区"
        }, {
          "label": "东山区"
        }, {
          "label": "兴山区"
        }, {
          "label": "萝北县"
        }, {
          "label": "绥滨县"
        }],
        "label": "鹤岗市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "尖山区"
        }, {
          "label": "岭东区"
        }, {
          "label": "四方台区"
        }, {
          "label": "宝山区"
        }, {
          "label": "集贤县"
        }, {
          "label": "友谊县"
        }, {
          "label": "宝清县"
        }, {
          "label": "饶河县"
        }],
        "label": "双鸭山市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "萨尔图区"
        }, {
          "label": "龙凤区"
        }, {
          "label": "让胡路区"
        }, {
          "label": "红岗区"
        }, {
          "label": "大同区"
        }, {
          "label": "肇州县"
        }, {
          "label": "肇源县"
        }, {
          "label": "林甸县"
        }, {
          "label": "杜尔伯特蒙古族自治县"
        }],
        "label": "大庆市"
      }],
      "label": "黑龙江省"
    }, {
      "children": [{
        "children": [{
          "label": "奉贤区"
        }, {
          "label": "青浦区"
        }, {
          "label": "黄浦区"
        }, {
          "label": "徐汇区"
        }, {
          "label": "长宁区"
        }, {
          "label": "静安区"
        }, {
          "label": "普陀区"
        }, {
          "label": "虹口区"
        }, {
          "label": "杨浦区"
        }, {
          "label": "闵行区"
        }, {
          "label": "宝山区"
        }, {
          "label": "嘉定区"
        }, {
          "label": "浦东新区"
        }, {
          "label": "金山区"
        }, {
          "label": "松江区"
        }, {
          "label": "崇明区"
        }],
        "label": "上海市"
      }],
      "label": "上海市"
    }, {
      "children": [{
        "children": [{
          "label": "金坛区"
        }, {
          "label": "市辖区"
        }, {
          "label": "天宁区"
        }, {
          "label": "钟楼区"
        }, {
          "label": "新北区"
        }, {
          "label": "武进区"
        }, {
          "label": "溧阳市"
        }],
        "label": "常州市"
      }, {
        "children": [{
          "label": "姑苏区"
        }, {
          "label": "吴江区"
        }, {
          "label": "虎丘区"
        }, {
          "label": "吴中区"
        }, {
          "label": "相城区"
        }, {
          "label": "常熟市"
        }, {
          "label": "张家港市"
        }, {
          "label": "昆山市"
        }, {
          "label": "太仓市"
        }, {
          "label": "工业园区"
        }, {
          "label": "高新区"
        }],
        "label": "苏州市"
      }, {
        "children": [{
          "label": "梁溪区"
        }, {
          "label": "新吴区"
        }, {
          "label": "市辖区"
        }, {
          "label": "锡山区"
        }, {
          "label": "惠山区"
        }, {
          "label": "滨湖区"
        }, {
          "label": "江阴市"
        }, {
          "label": "宜兴市"
        }],
        "label": "无锡市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "鼓楼区"
        }, {
          "label": "云龙区"
        }, {
          "label": "贾汪区"
        }, {
          "label": "泉山区"
        }, {
          "label": "铜山区"
        }, {
          "label": "丰县"
        }, {
          "label": "沛县"
        }, {
          "label": "睢宁县"
        }, {
          "label": "新沂市"
        }, {
          "label": "邳州市"
        }],
        "label": "徐州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "玄武区"
        }, {
          "label": "秦淮区"
        }, {
          "label": "建邺区"
        }, {
          "label": "鼓楼区"
        }, {
          "label": "浦口区"
        }, {
          "label": "栖霞区"
        }, {
          "label": "雨花台区"
        }, {
          "label": "溧水区"
        }, {
          "label": "高淳区"
        }, {
          "label": "江宁区"
        }, {
          "label": "六合区"
        }],
        "label": "南京市"
      }, {
        "children": [{
          "label": "姜堰区"
        }, {
          "label": "高港区"
        }, {
          "label": "兴化市"
        }, {
          "label": "靖江市"
        }, {
          "label": "泰兴市"
        }, {
          "label": "市辖区"
        }, {
          "label": "海陵区"
        }],
        "label": "泰州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "宿城区"
        }, {
          "label": "宿豫区"
        }, {
          "label": "沭阳县"
        }, {
          "label": "泗阳县"
        }, {
          "label": "泗洪县"
        }],
        "label": "宿迁市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "京口区"
        }, {
          "label": "润州区"
        }, {
          "label": "丹徒区"
        }, {
          "label": "丹阳市"
        }, {
          "label": "扬中市"
        }, {
          "label": "句容市"
        }],
        "label": "镇江市"
      }, {
        "children": [{
          "label": "海安市"
        }, {
          "label": "市辖区"
        }, {
          "label": "崇川区"
        }, {
          "label": "港闸区"
        }, {
          "label": "通州区"
        }, {
          "label": "如东县"
        }, {
          "label": "启东市"
        }, {
          "label": "如皋市"
        }, {
          "label": "海门市"
        }],
        "label": "南通市"
      }, {
        "children": [{
          "label": "赣榆区"
        }, {
          "label": "市辖区"
        }, {
          "label": "连云区"
        }, {
          "label": "海州区"
        }, {
          "label": "东海县"
        }, {
          "label": "灌云县"
        }, {
          "label": "灌南县"
        }],
        "label": "连云港市"
      }, {
        "children": [{
          "label": "清江浦区"
        }, {
          "label": "洪泽区"
        }, {
          "label": "市辖区"
        }, {
          "label": "楚州区"
        }, {
          "label": "淮阴区"
        }, {
          "label": "涟水县"
        }, {
          "label": "盱眙县"
        }, {
          "label": "金湖县"
        }],
        "label": "淮安市"
      }, {
        "children": [{
          "label": "大丰区"
        }, {
          "label": "市辖区"
        }, {
          "label": "亭湖区"
        }, {
          "label": "盐都区"
        }, {
          "label": "响水县"
        }, {
          "label": "滨海县"
        }, {
          "label": "阜宁县"
        }, {
          "label": "射阳县"
        }, {
          "label": "建湖县"
        }, {
          "label": "东台市"
        }],
        "label": "盐城市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "广陵区"
        }, {
          "label": "邗江区"
        }, {
          "label": "江都区"
        }, {
          "label": "宝应县"
        }, {
          "label": "仪征市"
        }, {
          "label": "高邮市"
        }],
        "label": "扬州市"
      }],
      "label": "江苏省"
    }, {
      "children": [{
        "children": [{
          "label": "岱山县"
        }, {
          "label": "嵊泗县"
        }, {
          "label": "市辖区"
        }, {
          "label": "定海区"
        }, {
          "label": "普陀区"
        }],
        "label": "舟山市"
      }, {
        "children": [{
          "label": "玉环市"
        }, {
          "label": "市辖区"
        }, {
          "label": "椒江区"
        }, {
          "label": "黄岩区"
        }, {
          "label": "路桥区"
        }, {
          "label": "三门县"
        }, {
          "label": "天台县"
        }, {
          "label": "仙居县"
        }, {
          "label": "温岭市"
        }, {
          "label": "临海市"
        }],
        "label": "台州市"
      }, {
        "children": [{
          "label": "青田县"
        }, {
          "label": "缙云县"
        }, {
          "label": "遂昌县"
        }, {
          "label": "松阳县"
        }, {
          "label": "云和县"
        }, {
          "label": "庆元县"
        }, {
          "label": "景宁畲族自治县"
        }, {
          "label": "龙泉市"
        }, {
          "label": "市辖区"
        }, {
          "label": "莲都区"
        }],
        "label": "丽水市"
      }, {
        "children": [{
          "label": "柯桥区"
        }, {
          "label": "上虞区"
        }, {
          "label": "市辖区"
        }, {
          "label": "越城区"
        }, {
          "label": "新昌县"
        }, {
          "label": "诸暨市"
        }, {
          "label": "嵊州市"
        }],
        "label": "绍兴市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "婺城区"
        }, {
          "label": "金东区"
        }, {
          "label": "武义县"
        }, {
          "label": "浦江县"
        }, {
          "label": "磐安县"
        }, {
          "label": "兰溪市"
        }, {
          "label": "义乌市"
        }, {
          "label": "东阳市"
        }, {
          "label": "永康市"
        }],
        "label": "金华市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "吴兴区"
        }, {
          "label": "南浔区"
        }, {
          "label": "德清县"
        }, {
          "label": "长兴县"
        }, {
          "label": "安吉县"
        }],
        "label": "湖州市"
      }, {
        "children": [{
          "label": "富阳区"
        }, {
          "label": "临安区"
        }, {
          "label": "市辖区"
        }, {
          "label": "上城区"
        }, {
          "label": "下城区"
        }, {
          "label": "江干区"
        }, {
          "label": "拱墅区"
        }, {
          "label": "西湖区"
        }, {
          "label": "滨江区"
        }, {
          "label": "萧山区"
        }, {
          "label": "余杭区"
        }, {
          "label": "桐庐县"
        }, {
          "label": "淳安县"
        }, {
          "label": "建德市"
        }],
        "label": "杭州市"
      }, {
        "children": [{
          "label": "奉化区"
        }, {
          "label": "市辖区"
        }, {
          "label": "海曙区"
        }, {
          "label": "江北区"
        }, {
          "label": "北仑区"
        }, {
          "label": "镇海区"
        }, {
          "label": "鄞州区"
        }, {
          "label": "象山县"
        }, {
          "label": "宁海县"
        }, {
          "label": "余姚市"
        }, {
          "label": "慈溪市"
        }],
        "label": "宁波市"
      }, {
        "children": [{
          "label": "洞头区"
        }, {
          "label": "市辖区"
        }, {
          "label": "鹿城区"
        }, {
          "label": "龙湾区"
        }, {
          "label": "瓯海区"
        }, {
          "label": "永嘉县"
        }, {
          "label": "平阳县"
        }, {
          "label": "苍南县"
        }, {
          "label": "文成县"
        }, {
          "label": "泰顺县"
        }, {
          "label": "瑞安市"
        }, {
          "label": "乐清市"
        }],
        "label": "温州市"
      }, {
        "children": [{
          "label": "南湖区"
        }, {
          "label": "秀洲区"
        }, {
          "label": "嘉善县"
        }, {
          "label": "海盐县"
        }, {
          "label": "海宁市"
        }, {
          "label": "平湖市"
        }, {
          "label": "桐乡市"
        }, {
          "label": "市辖区"
        }],
        "label": "嘉兴市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "柯城区"
        }, {
          "label": "衢江区"
        }, {
          "label": "常山县"
        }, {
          "label": "开化县"
        }, {
          "label": "龙游县"
        }, {
          "label": "江山市"
        }],
        "label": "衢州市"
      }],
      "label": "浙江省"
    }, {
      "children": [{
        "children": [{
          "label": "凤阳县"
        }, {
          "label": "天长市"
        }, {
          "label": "明光市"
        }, {
          "label": "市辖区"
        }, {
          "label": "琅琊区"
        }, {
          "label": "南谯区"
        }, {
          "label": "来安县"
        }, {
          "label": "全椒县"
        }, {
          "label": "定远县"
        }],
        "label": "滁州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "颍州区"
        }, {
          "label": "颍东区"
        }, {
          "label": "颍泉区"
        }, {
          "label": "临泉县"
        }, {
          "label": "太和县"
        }, {
          "label": "阜南县"
        }, {
          "label": "颍上县"
        }, {
          "label": "界首市"
        }],
        "label": "阜阳市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "埇桥区"
        }, {
          "label": "砀山县"
        }, {
          "label": "萧县"
        }, {
          "label": "灵璧县"
        }, {
          "label": "泗县"
        }],
        "label": "宿州市"
      }, {
        "children": [{
          "label": "叶集区"
        }, {
          "label": "市辖区"
        }, {
          "label": "金安区"
        }, {
          "label": "裕安区"
        }, {
          "label": "霍邱县"
        }, {
          "label": "舒城县"
        }, {
          "label": "金寨县"
        }, {
          "label": "霍山县"
        }],
        "label": "六安市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "镜湖区"
        }, {
          "label": "弋江区"
        }, {
          "label": "鸠江区"
        }, {
          "label": "三山区"
        }, {
          "label": "芜湖县"
        }, {
          "label": "繁昌县"
        }, {
          "label": "南陵县"
        }, {
          "label": "无为县"
        }],
        "label": "芜湖市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "龙子湖区"
        }, {
          "label": "蚌山区"
        }, {
          "label": "禹会区"
        }, {
          "label": "淮上区"
        }, {
          "label": "怀远县"
        }, {
          "label": "五河县"
        }, {
          "label": "固镇县"
        }],
        "label": "蚌埠市"
      }, {
        "children": [{
          "label": "寿县"
        }, {
          "label": "市辖区"
        }, {
          "label": "大通区"
        }, {
          "label": "田家庵区"
        }, {
          "label": "谢家集区"
        }, {
          "label": "八公山区"
        }, {
          "label": "潘集区"
        }, {
          "label": "凤台县"
        }],
        "label": "淮南市"
      }, {
        "children": [{
          "label": "瑶海区"
        }, {
          "label": "庐阳区"
        }, {
          "label": "蜀山区"
        }, {
          "label": "包河区"
        }, {
          "label": "市辖区"
        }, {
          "label": "长丰县"
        }, {
          "label": "肥东县"
        }, {
          "label": "肥西县"
        }, {
          "label": "庐江县"
        }, {
          "label": "巢湖市"
        }],
        "label": "合肥市"
      }, {
        "children": [{
          "label": "郎溪县"
        }, {
          "label": "广德县"
        }, {
          "label": "泾县"
        }, {
          "label": "绩溪县"
        }, {
          "label": "旌德县"
        }, {
          "label": "宁国市"
        }, {
          "label": "市辖区"
        }, {
          "label": "宣州区"
        }],
        "label": "宣城市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "迎江区"
        }, {
          "label": "大观区"
        }, {
          "label": "宜秀区"
        }, {
          "label": "怀宁县"
        }, {
          "label": "太湖县"
        }, {
          "label": "宿松县"
        }, {
          "label": "望江县"
        }, {
          "label": "岳西县"
        }, {
          "label": "桐城市"
        }, {
          "label": "潜山市"
        }],
        "label": "安庆市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "贵池区"
        }, {
          "label": "东至县"
        }, {
          "label": "石台县"
        }, {
          "label": "青阳县"
        }],
        "label": "池州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "谯城区"
        }, {
          "label": "涡阳县"
        }, {
          "label": "蒙城县"
        }, {
          "label": "利辛县"
        }],
        "label": "亳州市"
      }, {
        "children": [{
          "label": "博望区"
        }, {
          "label": "市辖区"
        }, {
          "label": "花山区"
        }, {
          "label": "雨山区"
        }, {
          "label": "当涂县"
        }, {
          "label": "含山县"
        }, {
          "label": "和县"
        }],
        "label": "马鞍山市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "杜集区"
        }, {
          "label": "相山区"
        }, {
          "label": "烈山区"
        }, {
          "label": "濉溪县"
        }],
        "label": "淮北市"
      }, {
        "children": [{
          "label": "枞阳县"
        }, {
          "label": "铜官区"
        }, {
          "label": "义安区"
        }, {
          "label": "市辖区"
        }, {
          "label": "郊区"
        }],
        "label": "铜陵市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "屯溪区"
        }, {
          "label": "黄山区"
        }, {
          "label": "徽州区"
        }, {
          "label": "歙县"
        }, {
          "label": "休宁县"
        }, {
          "label": "黟县"
        }, {
          "label": "祁门县"
        }],
        "label": "黄山市"
      }],
      "label": "安徽省"
    }, {
      "children": [{
        "children": [{
          "label": "建阳区"
        }, {
          "label": "市辖区"
        }, {
          "label": "延平区"
        }, {
          "label": "顺昌县"
        }, {
          "label": "浦城县"
        }, {
          "label": "光泽县"
        }, {
          "label": "松溪县"
        }, {
          "label": "政和县"
        }, {
          "label": "邵武市"
        }, {
          "label": "武夷山市"
        }, {
          "label": "建瓯市"
        }],
        "label": "南平市"
      }, {
        "children": [{
          "label": "永定区"
        }, {
          "label": "市辖区"
        }, {
          "label": "新罗区"
        }, {
          "label": "长汀县"
        }, {
          "label": "上杭县"
        }, {
          "label": "武平县"
        }, {
          "label": "连城县"
        }, {
          "label": "漳平市"
        }],
        "label": "龙岩市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "蕉城区"
        }, {
          "label": "霞浦县"
        }, {
          "label": "古田县"
        }, {
          "label": "屏南县"
        }, {
          "label": "寿宁县"
        }, {
          "label": "周宁县"
        }, {
          "label": "柘荣县"
        }, {
          "label": "福安市"
        }, {
          "label": "福鼎市"
        }],
        "label": "宁德市"
      }, {
        "children": [{
          "label": "石狮市"
        }, {
          "label": "晋江市"
        }, {
          "label": "南安市"
        }, {
          "label": "市辖区"
        }, {
          "label": "鲤城区"
        }, {
          "label": "丰泽区"
        }, {
          "label": "洛江区"
        }, {
          "label": "泉港区"
        }, {
          "label": "惠安县"
        }, {
          "label": "安溪县"
        }, {
          "label": "永春县"
        }, {
          "label": "德化县"
        }, {
          "label": "金门县"
        }],
        "label": "泉州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "东山县"
        }, {
          "label": "南靖县"
        }, {
          "label": "平和县"
        }, {
          "label": "华安县"
        }, {
          "label": "龙海市"
        }, {
          "label": "芗城区"
        }, {
          "label": "龙文区"
        }, {
          "label": "云霄县"
        }, {
          "label": "漳浦县"
        }, {
          "label": "诏安县"
        }, {
          "label": "长泰县"
        }],
        "label": "漳州市"
      }, {
        "children": [{
          "label": "鼓楼区"
        }, {
          "label": "台江区"
        }, {
          "label": "仓山区"
        }, {
          "label": "马尾区"
        }, {
          "label": "晋安区"
        }, {
          "label": "闽侯县"
        }, {
          "label": "连江县"
        }, {
          "label": "罗源县"
        }, {
          "label": "闽清县"
        }, {
          "label": "永泰县"
        }, {
          "label": "平潭县"
        }, {
          "label": "福清市"
        }, {
          "label": "市辖区"
        }, {
          "label": "长乐区"
        }],
        "label": "福州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "思明区"
        }, {
          "label": "海沧区"
        }, {
          "label": "湖里区"
        }, {
          "label": "集美区"
        }, {
          "label": "同安区"
        }, {
          "label": "翔安区"
        }],
        "label": "厦门市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "城厢区"
        }, {
          "label": "涵江区"
        }, {
          "label": "荔城区"
        }, {
          "label": "秀屿区"
        }, {
          "label": "仙游县"
        }],
        "label": "莆田市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "梅列区"
        }, {
          "label": "三元区"
        }, {
          "label": "明溪县"
        }, {
          "label": "清流县"
        }, {
          "label": "宁化县"
        }, {
          "label": "大田县"
        }, {
          "label": "尤溪县"
        }, {
          "label": "沙县"
        }, {
          "label": "将乐县"
        }, {
          "label": "泰宁县"
        }, {
          "label": "建宁县"
        }, {
          "label": "永安市"
        }],
        "label": "三明市"
      }],
      "label": "福建省"
    }, {
      "children": [{
        "children": [{
          "label": "进贤县"
        }, {
          "label": "新建区"
        }, {
          "label": "市辖区"
        }, {
          "label": "东湖区"
        }, {
          "label": "西湖区"
        }, {
          "label": "青云谱区"
        }, {
          "label": "湾里区"
        }, {
          "label": "青山湖区"
        }, {
          "label": "南昌县"
        }, {
          "label": "安义县"
        }],
        "label": "南昌市"
      }, {
        "children": [{
          "label": "昌江区"
        }, {
          "label": "珠山区"
        }, {
          "label": "浮梁县"
        }, {
          "label": "乐平市"
        }, {
          "label": "市辖区"
        }],
        "label": "景德镇市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "安源区"
        }, {
          "label": "湘东区"
        }, {
          "label": "莲花县"
        }, {
          "label": "上栗县"
        }, {
          "label": "芦溪县"
        }],
        "label": "萍乡市"
      }, {
        "children": [{
          "label": "高安市"
        }, {
          "label": "市辖区"
        }, {
          "label": "袁州区"
        }, {
          "label": "奉新县"
        }, {
          "label": "万载县"
        }, {
          "label": "上高县"
        }, {
          "label": "宜丰县"
        }, {
          "label": "靖安县"
        }, {
          "label": "铜鼓县"
        }, {
          "label": "丰城市"
        }, {
          "label": "樟树市"
        }],
        "label": "宜春市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "临川区"
        }, {
          "label": "南城县"
        }, {
          "label": "黎川县"
        }, {
          "label": "南丰县"
        }, {
          "label": "崇仁县"
        }, {
          "label": "乐安县"
        }, {
          "label": "宜黄县"
        }, {
          "label": "金溪县"
        }, {
          "label": "资溪县"
        }, {
          "label": "广昌县"
        }, {
          "label": "东乡区"
        }],
        "label": "抚州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "信州区"
        }, {
          "label": "上饶县"
        }, {
          "label": "玉山县"
        }, {
          "label": "铅山县"
        }, {
          "label": "横峰县"
        }, {
          "label": "弋阳县"
        }, {
          "label": "余干县"
        }, {
          "label": "鄱阳县"
        }, {
          "label": "万年县"
        }, {
          "label": "婺源县"
        }, {
          "label": "德兴市"
        }, {
          "label": "广丰区"
        }],
        "label": "上饶市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "渝水区"
        }, {
          "label": "分宜县"
        }],
        "label": "新余市"
      }, {
        "children": [{
          "label": "余江区"
        }, {
          "label": "市辖区"
        }, {
          "label": "月湖区"
        }, {
          "label": "贵溪市"
        }],
        "label": "鹰潭市"
      }, {
        "children": [{
          "label": "南康区"
        }, {
          "label": "赣县区"
        }, {
          "label": "市辖区"
        }, {
          "label": "章贡区"
        }, {
          "label": "信丰县"
        }, {
          "label": "大余县"
        }, {
          "label": "上犹县"
        }, {
          "label": "崇义县"
        }, {
          "label": "安远县"
        }, {
          "label": "龙南县"
        }, {
          "label": "定南县"
        }, {
          "label": "全南县"
        }, {
          "label": "宁都县"
        }, {
          "label": "于都县"
        }, {
          "label": "兴国县"
        }, {
          "label": "会昌县"
        }, {
          "label": "寻乌县"
        }, {
          "label": "石城县"
        }, {
          "label": "瑞金市"
        }],
        "label": "赣州市"
      }, {
        "children": [{
          "label": "遂川县"
        }, {
          "label": "万安县"
        }, {
          "label": "安福县"
        }, {
          "label": "永新县"
        }, {
          "label": "井冈山市"
        }, {
          "label": "市辖区"
        }, {
          "label": "吉州区"
        }, {
          "label": "青原区"
        }, {
          "label": "吉安县"
        }, {
          "label": "吉水县"
        }, {
          "label": "峡江县"
        }, {
          "label": "新干县"
        }, {
          "label": "永丰县"
        }, {
          "label": "泰和县"
        }],
        "label": "吉安市"
      }, {
        "children": [{
          "label": "柴桑区"
        }, {
          "label": "庐山市"
        }, {
          "label": "市辖区"
        }, {
          "label": "庐山区"
        }, {
          "label": "浔阳区"
        }, {
          "label": "武宁县"
        }, {
          "label": "修水县"
        }, {
          "label": "永修县"
        }, {
          "label": "德安县"
        }, {
          "label": "都昌县"
        }, {
          "label": "湖口县"
        }, {
          "label": "彭泽县"
        }, {
          "label": "瑞昌市"
        }, {
          "label": "共青城市"
        }],
        "label": "九江市"
      }],
      "label": "江西省"
    }, {
      "children": [{
        "children": [{
          "label": "市南区"
        }, {
          "label": "市北区"
        }, {
          "label": "黄岛区"
        }, {
          "label": "崂山区"
        }, {
          "label": "李沧区"
        }, {
          "label": "城阳区"
        }, {
          "label": "胶州市"
        }, {
          "label": "平度市"
        }, {
          "label": "莱西市"
        }, {
          "label": "即墨区"
        }, {
          "label": "市辖区"
        }],
        "label": "青岛市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "淄川区"
        }, {
          "label": "张店区"
        }, {
          "label": "博山区"
        }, {
          "label": "临淄区"
        }, {
          "label": "周村区"
        }, {
          "label": "桓台县"
        }, {
          "label": "高青县"
        }, {
          "label": "沂源县"
        }],
        "label": "淄博市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "东港区"
        }, {
          "label": "岚山区"
        }, {
          "label": "五莲县"
        }, {
          "label": "莒县"
        }],
        "label": "日照市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "兰山区"
        }, {
          "label": "罗庄区"
        }, {
          "label": "河东区"
        }, {
          "label": "沂南县"
        }, {
          "label": "郯城县"
        }, {
          "label": "沂水县"
        }, {
          "label": "苍山县"
        }, {
          "label": "费县"
        }, {
          "label": "平邑县"
        }, {
          "label": "莒南县"
        }, {
          "label": "蒙阴县"
        }, {
          "label": "临沭县"
        }],
        "label": "临沂市"
      }, {
        "children": [{
          "label": "宁津县"
        }, {
          "label": "庆云县"
        }, {
          "label": "临邑县"
        }, {
          "label": "齐河县"
        }, {
          "label": "平原县"
        }, {
          "label": "夏津县"
        }, {
          "label": "武城县"
        }, {
          "label": "乐陵市"
        }, {
          "label": "禹城市"
        }, {
          "label": "陵城区"
        }, {
          "label": "市辖区"
        }, {
          "label": "德城区"
        }],
        "label": "德州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "东昌府区"
        }, {
          "label": "阳谷县"
        }, {
          "label": "莘县"
        }, {
          "label": "茌平县"
        }, {
          "label": "东阿县"
        }, {
          "label": "冠县"
        }, {
          "label": "高唐县"
        }, {
          "label": "临清市"
        }],
        "label": "聊城市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "滨城区"
        }, {
          "label": "惠民县"
        }, {
          "label": "阳信县"
        }, {
          "label": "无棣县"
        }, {
          "label": "博兴县"
        }, {
          "label": "沾化区"
        }, {
          "label": "邹平市"
        }],
        "label": "滨州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "牡丹区"
        }, {
          "label": "曹县"
        }, {
          "label": "单县"
        }, {
          "label": "成武县"
        }, {
          "label": "鄄城县"
        }, {
          "label": "东明县"
        }, {
          "label": "巨野县"
        }, {
          "label": "郓城县"
        }, {
          "label": "定陶区"
        }],
        "label": "菏泽市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "市中区"
        }, {
          "label": "薛城区"
        }, {
          "label": "峄城区"
        }, {
          "label": "台儿庄区"
        }, {
          "label": "山亭区"
        }, {
          "label": "滕州市"
        }],
        "label": "枣庄市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "东营区"
        }, {
          "label": "河口区"
        }, {
          "label": "利津县"
        }, {
          "label": "广饶县"
        }, {
          "label": "垦利区"
        }],
        "label": "东营市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "历下区"
        }, {
          "label": "市中区"
        }, {
          "label": "槐荫区"
        }, {
          "label": "天桥区"
        }, {
          "label": "历城区"
        }, {
          "label": "长清区"
        }, {
          "label": "平阴县"
        }, {
          "label": "商河县"
        }, {
          "label": "章丘区"
        }, {
          "label": "济阳区"
        }, {
          "label": "莱芜区"
        }, {
          "label": "钢城区"
        }],
        "label": "济南市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "芝罘区"
        }, {
          "label": "福山区"
        }, {
          "label": "牟平区"
        }, {
          "label": "莱山区"
        }, {
          "label": "长岛县"
        }, {
          "label": "龙口市"
        }, {
          "label": "莱阳市"
        }, {
          "label": "莱州市"
        }, {
          "label": "蓬莱市"
        }, {
          "label": "招远市"
        }, {
          "label": "栖霞市"
        }, {
          "label": "海阳市"
        }],
        "label": "烟台市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "潍城区"
        }, {
          "label": "寒亭区"
        }, {
          "label": "坊子区"
        }, {
          "label": "奎文区"
        }, {
          "label": "临朐县"
        }, {
          "label": "昌乐县"
        }, {
          "label": "青州市"
        }, {
          "label": "诸城市"
        }, {
          "label": "寿光市"
        }, {
          "label": "安丘市"
        }, {
          "label": "高密市"
        }, {
          "label": "昌邑市"
        }],
        "label": "潍坊市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "任城区"
        }, {
          "label": "微山县"
        }, {
          "label": "鱼台县"
        }, {
          "label": "金乡县"
        }, {
          "label": "嘉祥县"
        }, {
          "label": "汶上县"
        }, {
          "label": "泗水县"
        }, {
          "label": "梁山县"
        }, {
          "label": "曲阜市"
        }, {
          "label": "邹城市"
        }, {
          "label": "兖州区"
        }],
        "label": "济宁市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "泰山区"
        }, {
          "label": "岱岳区"
        }, {
          "label": "宁阳县"
        }, {
          "label": "东平县"
        }, {
          "label": "新泰市"
        }, {
          "label": "肥城市"
        }],
        "label": "泰安市"
      }, {
        "children": [{
          "label": "环翠区"
        }, {
          "label": "荣成市"
        }, {
          "label": "乳山市"
        }, {
          "label": "市辖区"
        }, {
          "label": "文登区"
        }],
        "label": "威海市"
      }],
      "label": "山东省"
    }, {
      "children": [{
        "children": [{
          "label": "郾城区"
        }, {
          "label": "召陵区"
        }, {
          "label": "舞阳县"
        }, {
          "label": "临颍县"
        }, {
          "label": "市辖区"
        }, {
          "label": "源汇区"
        }],
        "label": "漯河市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "湖滨区"
        }, {
          "label": "渑池县"
        }, {
          "label": "卢氏县"
        }, {
          "label": "义马市"
        }, {
          "label": "灵宝市"
        }, {
          "label": "陕州区"
        }],
        "label": "三门峡市"
      }, {
        "children": [{
          "label": "济源市"
        }],
        "label": "省直辖县级行政区划"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "宛城区"
        }, {
          "label": "卧龙区"
        }, {
          "label": "南召县"
        }, {
          "label": "方城县"
        }, {
          "label": "西峡县"
        }, {
          "label": "镇平县"
        }, {
          "label": "内乡县"
        }, {
          "label": "淅川县"
        }, {
          "label": "社旗县"
        }, {
          "label": "唐河县"
        }, {
          "label": "新野县"
        }, {
          "label": "桐柏县"
        }, {
          "label": "邓州市"
        }],
        "label": "南阳市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "梁园区"
        }, {
          "label": "睢阳区"
        }, {
          "label": "民权县"
        }, {
          "label": "睢县"
        }, {
          "label": "宁陵县"
        }, {
          "label": "柘城县"
        }, {
          "label": "虞城县"
        }, {
          "label": "夏邑县"
        }, {
          "label": "永城市"
        }],
        "label": "商丘市"
      }, {
        "children": [{
          "label": "淮滨县"
        }, {
          "label": "息县"
        }, {
          "label": "市辖区"
        }, {
          "label": "浉河区"
        }, {
          "label": "平桥区"
        }, {
          "label": "罗山县"
        }, {
          "label": "光山县"
        }, {
          "label": "新县"
        }, {
          "label": "商城县"
        }, {
          "label": "固始县"
        }, {
          "label": "潢川县"
        }],
        "label": "信阳市"
      }, {
        "children": [{
          "label": "涧西区"
        }, {
          "label": "吉利区"
        }, {
          "label": "洛龙区"
        }, {
          "label": "孟津县"
        }, {
          "label": "新安县"
        }, {
          "label": "栾川县"
        }, {
          "label": "嵩县"
        }, {
          "label": "汝阳县"
        }, {
          "label": "宜阳县"
        }, {
          "label": "洛宁县"
        }, {
          "label": "伊川县"
        }, {
          "label": "偃师市"
        }, {
          "label": "市辖区"
        }, {
          "label": "老城区"
        }, {
          "label": "西工区"
        }, {
          "label": "瀍河回族区"
        }],
        "label": "洛阳市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "新华区"
        }, {
          "label": "卫东区"
        }, {
          "label": "石龙区"
        }, {
          "label": "湛河区"
        }, {
          "label": "宝丰县"
        }, {
          "label": "叶县"
        }, {
          "label": "鲁山县"
        }, {
          "label": "郏县"
        }, {
          "label": "舞钢市"
        }, {
          "label": "汝州市"
        }],
        "label": "平顶山市"
      }, {
        "children": [{
          "label": "汤阴县"
        }, {
          "label": "滑县"
        }, {
          "label": "内黄县"
        }, {
          "label": "林州市"
        }, {
          "label": "市辖区"
        }, {
          "label": "文峰区"
        }, {
          "label": "北关区"
        }, {
          "label": "殷都区"
        }, {
          "label": "龙安区"
        }, {
          "label": "安阳县"
        }],
        "label": "安阳市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "川汇区"
        }, {
          "label": "扶沟县"
        }, {
          "label": "西华县"
        }, {
          "label": "商水县"
        }, {
          "label": "沈丘县"
        }, {
          "label": "郸城县"
        }, {
          "label": "淮阳县"
        }, {
          "label": "太康县"
        }, {
          "label": "鹿邑县"
        }, {
          "label": "项城市"
        }],
        "label": "周口市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "驿城区"
        }, {
          "label": "西平县"
        }, {
          "label": "上蔡县"
        }, {
          "label": "平舆县"
        }, {
          "label": "正阳县"
        }, {
          "label": "确山县"
        }, {
          "label": "泌阳县"
        }, {
          "label": "汝南县"
        }, {
          "label": "遂平县"
        }, {
          "label": "新蔡县"
        }],
        "label": "驻马店市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "魏都区"
        }, {
          "label": "鄢陵县"
        }, {
          "label": "襄城县"
        }, {
          "label": "禹州市"
        }, {
          "label": "长葛市"
        }, {
          "label": "建安区"
        }],
        "label": "许昌市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "鹤山区"
        }, {
          "label": "山城区"
        }, {
          "label": "淇滨区"
        }, {
          "label": "浚县"
        }, {
          "label": "淇县"
        }],
        "label": "鹤壁市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "红旗区"
        }, {
          "label": "卫滨区"
        }, {
          "label": "凤泉区"
        }, {
          "label": "牧野区"
        }, {
          "label": "新乡县"
        }, {
          "label": "获嘉县"
        }, {
          "label": "原阳县"
        }, {
          "label": "延津县"
        }, {
          "label": "封丘县"
        }, {
          "label": "长垣县"
        }, {
          "label": "卫辉市"
        }, {
          "label": "辉县市"
        }],
        "label": "新乡市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "解放区"
        }, {
          "label": "中站区"
        }, {
          "label": "马村区"
        }, {
          "label": "山阳区"
        }, {
          "label": "修武县"
        }, {
          "label": "博爱县"
        }, {
          "label": "武陟县"
        }, {
          "label": "温县"
        }, {
          "label": "沁阳市"
        }, {
          "label": "孟州市"
        }],
        "label": "焦作市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "华龙区"
        }, {
          "label": "清丰县"
        }, {
          "label": "南乐县"
        }, {
          "label": "范县"
        }, {
          "label": "台前县"
        }, {
          "label": "濮阳县"
        }],
        "label": "濮阳市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "中原区"
        }, {
          "label": "二七区"
        }, {
          "label": "管城回族区"
        }, {
          "label": "金水区"
        }, {
          "label": "上街区"
        }, {
          "label": "惠济区"
        }, {
          "label": "中牟县"
        }, {
          "label": "巩义市"
        }, {
          "label": "荥阳市"
        }, {
          "label": "新密市"
        }, {
          "label": "新郑市"
        }, {
          "label": "登封市"
        }],
        "label": "郑州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "龙亭区"
        }, {
          "label": "顺河回族区"
        }, {
          "label": "鼓楼区"
        }, {
          "label": "禹王台区"
        }, {
          "label": "杞县"
        }, {
          "label": "通许县"
        }, {
          "label": "尉氏县"
        }, {
          "label": "兰考县"
        }, {
          "label": "祥符区"
        }],
        "label": "开封市"
      }],
      "label": "河南省"
    }, {
      "children": [{
        "children": [{
          "label": "市辖区"
        }, {
          "label": "西陵区"
        }, {
          "label": "伍家岗区"
        }, {
          "label": "点军区"
        }, {
          "label": "猇亭区"
        }, {
          "label": "夷陵区"
        }, {
          "label": "远安县"
        }, {
          "label": "兴山县"
        }, {
          "label": "秭归县"
        }, {
          "label": "长阳土家族自治县"
        }, {
          "label": "五峰土家族自治县"
        }, {
          "label": "宜都市"
        }, {
          "label": "当阳市"
        }, {
          "label": "枝江市"
        }],
        "label": "宜昌市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "江岸区"
        }, {
          "label": "江汉区"
        }, {
          "label": "硚口区"
        }, {
          "label": "汉阳区"
        }, {
          "label": "武昌区"
        }, {
          "label": "青山区"
        }, {
          "label": "洪山区"
        }, {
          "label": "东西湖区"
        }, {
          "label": "汉南区"
        }, {
          "label": "蔡甸区"
        }, {
          "label": "江夏区"
        }, {
          "label": "黄陂区"
        }, {
          "label": "新洲区"
        }],
        "label": "武汉市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "黄石港区"
        }, {
          "label": "西塞山区"
        }, {
          "label": "下陆区"
        }, {
          "label": "铁山区"
        }, {
          "label": "阳新县"
        }, {
          "label": "大冶市"
        }],
        "label": "黄石市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "茅箭区"
        }, {
          "label": "张湾区"
        }, {
          "label": "郧西县"
        }, {
          "label": "竹山县"
        }, {
          "label": "竹溪县"
        }, {
          "label": "房县"
        }, {
          "label": "丹江口市"
        }, {
          "label": "郧阳区"
        }],
        "label": "十堰市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "咸安区"
        }, {
          "label": "嘉鱼县"
        }, {
          "label": "通城县"
        }, {
          "label": "崇阳县"
        }, {
          "label": "通山县"
        }, {
          "label": "赤壁市"
        }],
        "label": "咸宁市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "曾都区"
        }, {
          "label": "随县"
        }, {
          "label": "广水市"
        }],
        "label": "随州市"
      }, {
        "children": [{
          "label": "恩施市"
        }, {
          "label": "利川市"
        }, {
          "label": "建始县"
        }, {
          "label": "巴东县"
        }, {
          "label": "宣恩县"
        }, {
          "label": "咸丰县"
        }, {
          "label": "来凤县"
        }, {
          "label": "鹤峰县"
        }],
        "label": "恩施土家族苗族自治州"
      }, {
        "children": [{
          "label": "仙桃市"
        }, {
          "label": "潜江市"
        }, {
          "label": "天门市"
        }, {
          "label": "神农架林区"
        }],
        "label": "省直辖县级行政区划"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "襄城区"
        }, {
          "label": "樊城区"
        }, {
          "label": "襄州区"
        }, {
          "label": "南漳县"
        }, {
          "label": "谷城县"
        }, {
          "label": "保康县"
        }, {
          "label": "老河口市"
        }, {
          "label": "枣阳市"
        }, {
          "label": "宜城市"
        }],
        "label": "襄阳市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "梁子湖区"
        }, {
          "label": "华容区"
        }, {
          "label": "鄂城区"
        }],
        "label": "鄂州市"
      }, {
        "children": [{
          "label": "京山市"
        }, {
          "label": "市辖区"
        }, {
          "label": "东宝区"
        }, {
          "label": "掇刀区"
        }, {
          "label": "沙洋县"
        }, {
          "label": "钟祥市"
        }],
        "label": "荆门市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "孝南区"
        }, {
          "label": "孝昌县"
        }, {
          "label": "大悟县"
        }, {
          "label": "云梦县"
        }, {
          "label": "应城市"
        }, {
          "label": "安陆市"
        }, {
          "label": "汉川市"
        }],
        "label": "孝感市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "沙市区"
        }, {
          "label": "荆州区"
        }, {
          "label": "公安县"
        }, {
          "label": "监利县"
        }, {
          "label": "江陵县"
        }, {
          "label": "石首市"
        }, {
          "label": "洪湖市"
        }, {
          "label": "松滋市"
        }],
        "label": "荆州市"
      }, {
        "children": [{
          "label": "武穴市"
        }, {
          "label": "市辖区"
        }, {
          "label": "黄州区"
        }, {
          "label": "团风县"
        }, {
          "label": "红安县"
        }, {
          "label": "罗田县"
        }, {
          "label": "英山县"
        }, {
          "label": "浠水县"
        }, {
          "label": "蕲春县"
        }, {
          "label": "黄梅县"
        }, {
          "label": "麻城市"
        }],
        "label": "黄冈市"
      }],
      "label": "湖北省"
    }, {
      "children": [{
        "children": [{
          "label": "泸溪县"
        }, {
          "label": "凤凰县"
        }, {
          "label": "花垣县"
        }, {
          "label": "保靖县"
        }, {
          "label": "古丈县"
        }, {
          "label": "永顺县"
        }, {
          "label": "龙山县"
        }, {
          "label": "吉首市"
        }],
        "label": "湘西土家族苗族自治州"
      }, {
        "children": [{
          "label": "会同县"
        }, {
          "label": "通道侗族自治县"
        }, {
          "label": "洪江市"
        }, {
          "label": "市辖区"
        }, {
          "label": "麻阳苗族自治县"
        }, {
          "label": "新晃侗族自治县"
        }, {
          "label": "芷江侗族自治县"
        }, {
          "label": "靖州苗族侗族自治县"
        }, {
          "label": "鹤城区"
        }, {
          "label": "中方县"
        }, {
          "label": "沅陵县"
        }, {
          "label": "辰溪县"
        }, {
          "label": "溆浦县"
        }],
        "label": "怀化市"
      }, {
        "children": [{
          "label": "桑植县"
        }, {
          "label": "市辖区"
        }, {
          "label": "永定区"
        }, {
          "label": "武陵源区"
        }, {
          "label": "慈利县"
        }],
        "label": "张家界市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "资阳区"
        }, {
          "label": "赫山区"
        }, {
          "label": "南县"
        }, {
          "label": "桃江县"
        }, {
          "label": "安化县"
        }, {
          "label": "沅江市"
        }],
        "label": "益阳市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "北湖区"
        }, {
          "label": "苏仙区"
        }, {
          "label": "桂阳县"
        }, {
          "label": "宜章县"
        }, {
          "label": "永兴县"
        }, {
          "label": "嘉禾县"
        }, {
          "label": "临武县"
        }, {
          "label": "汝城县"
        }, {
          "label": "桂东县"
        }, {
          "label": "安仁县"
        }, {
          "label": "资兴市"
        }],
        "label": "郴州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "零陵区"
        }, {
          "label": "冷水滩区"
        }, {
          "label": "祁阳县"
        }, {
          "label": "东安县"
        }, {
          "label": "双牌县"
        }, {
          "label": "道县"
        }, {
          "label": "江永县"
        }, {
          "label": "宁远县"
        }, {
          "label": "蓝山县"
        }, {
          "label": "新田县"
        }, {
          "label": "江华瑶族自治县"
        }],
        "label": "永州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "武陵区"
        }, {
          "label": "鼎城区"
        }, {
          "label": "安乡县"
        }, {
          "label": "汉寿县"
        }, {
          "label": "澧县"
        }, {
          "label": "临澧县"
        }, {
          "label": "桃源县"
        }, {
          "label": "石门县"
        }, {
          "label": "津市市"
        }],
        "label": "常德市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "岳阳楼区"
        }, {
          "label": "云溪区"
        }, {
          "label": "平江县"
        }, {
          "label": "汨罗市"
        }, {
          "label": "临湘市"
        }, {
          "label": "君山区"
        }, {
          "label": "岳阳县"
        }, {
          "label": "华容县"
        }, {
          "label": "湘阴县"
        }],
        "label": "岳阳市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "娄星区"
        }, {
          "label": "双峰县"
        }, {
          "label": "新化县"
        }, {
          "label": "冷水江市"
        }, {
          "label": "涟源市"
        }],
        "label": "娄底市"
      }, {
        "children": [{
          "label": "北塔区"
        }, {
          "label": "邵东县"
        }, {
          "label": "新邵县"
        }, {
          "label": "邵阳县"
        }, {
          "label": "隆回县"
        }, {
          "label": "洞口县"
        }, {
          "label": "绥宁县"
        }, {
          "label": "新宁县"
        }, {
          "label": "城步苗族自治县"
        }, {
          "label": "武冈市"
        }, {
          "label": "市辖区"
        }, {
          "label": "双清区"
        }, {
          "label": "大祥区"
        }],
        "label": "邵阳市"
      }, {
        "children": [{
          "label": "宁乡市"
        }, {
          "label": "市辖区"
        }, {
          "label": "芙蓉区"
        }, {
          "label": "天心区"
        }, {
          "label": "岳麓区"
        }, {
          "label": "开福区"
        }, {
          "label": "雨花区"
        }, {
          "label": "望城区"
        }, {
          "label": "长沙县"
        }, {
          "label": "浏阳市"
        }],
        "label": "长沙市"
      }, {
        "children": [{
          "label": "渌口区"
        }, {
          "label": "市辖区"
        }, {
          "label": "荷塘区"
        }, {
          "label": "芦淞区"
        }, {
          "label": "石峰区"
        }, {
          "label": "天元区"
        }, {
          "label": "攸县"
        }, {
          "label": "茶陵县"
        }, {
          "label": "炎陵县"
        }, {
          "label": "醴陵市"
        }],
        "label": "株洲市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "雨湖区"
        }, {
          "label": "岳塘区"
        }, {
          "label": "湘潭县"
        }, {
          "label": "湘乡市"
        }, {
          "label": "韶山市"
        }],
        "label": "湘潭市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "珠晖区"
        }, {
          "label": "雁峰区"
        }, {
          "label": "石鼓区"
        }, {
          "label": "蒸湘区"
        }, {
          "label": "南岳区"
        }, {
          "label": "衡阳县"
        }, {
          "label": "衡南县"
        }, {
          "label": "衡山县"
        }, {
          "label": "衡东县"
        }, {
          "label": "祁东县"
        }, {
          "label": "耒阳市"
        }, {
          "label": "常宁市"
        }],
        "label": "衡阳市"
      }],
      "label": "湖南省"
    }, {
      "children": [{
        "children": [{
          "label": "海丰县"
        }, {
          "label": "陆河县"
        }, {
          "label": "陆丰市"
        }, {
          "label": "市辖区"
        }, {
          "label": "城区"
        }],
        "label": "汕尾市"
      }, {
        "children": [{
          "label": "梅县区"
        }, {
          "label": "市辖区"
        }, {
          "label": "梅江区"
        }, {
          "label": "大埔县"
        }, {
          "label": "丰顺县"
        }, {
          "label": "五华县"
        }, {
          "label": "平远县"
        }, {
          "label": "蕉岭县"
        }, {
          "label": "兴宁市"
        }],
        "label": "梅州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "香洲区"
        }, {
          "label": "斗门区"
        }, {
          "label": "金湾区"
        }],
        "label": "珠海市"
      }, {
        "children": [{
          "label": "南澳县"
        }, {
          "label": "市辖区"
        }, {
          "label": "龙湖区"
        }, {
          "label": "金平区"
        }, {
          "label": "濠江区"
        }, {
          "label": "潮阳区"
        }, {
          "label": "潮南区"
        }, {
          "label": "澄海区"
        }],
        "label": "汕头市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "源城区"
        }, {
          "label": "紫金县"
        }, {
          "label": "龙川县"
        }, {
          "label": "连平县"
        }, {
          "label": "和平县"
        }, {
          "label": "东源县"
        }],
        "label": "河源市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "江城区"
        }, {
          "label": "阳西县"
        }, {
          "label": "阳春市"
        }, {
          "label": "阳东区"
        }],
        "label": "阳江市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "清城区"
        }, {
          "label": "佛冈县"
        }, {
          "label": "阳山县"
        }, {
          "label": "连山壮族瑶族自治县"
        }, {
          "label": "连南瑶族自治县"
        }, {
          "label": "英德市"
        }, {
          "label": "连州市"
        }, {
          "label": "清新区"
        }],
        "label": "清远市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "湘桥区"
        }, {
          "label": "饶平县"
        }, {
          "label": "潮安区"
        }],
        "label": "潮州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "榕城区"
        }, {
          "label": "揭西县"
        }, {
          "label": "惠来县"
        }, {
          "label": "普宁市"
        }, {
          "label": "揭东区"
        }],
        "label": "揭阳市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "云城区"
        }, {
          "label": "新兴县"
        }, {
          "label": "郁南县"
        }, {
          "label": "罗定市"
        }, {
          "label": "云安区"
        }],
        "label": "云浮市"
      }, {
        "children": [{
          "label": "罗湖区"
        }, {
          "label": "福田区"
        }, {
          "label": "南山区"
        }, {
          "label": "宝安区"
        }, {
          "label": "龙岗区"
        }, {
          "label": "盐田区"
        }, {
          "label": "龙华区"
        }, {
          "label": "光明区"
        }, {
          "label": "坪山区"
        }, {
          "label": "市辖区"
        }],
        "label": "深圳市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "禅城区"
        }, {
          "label": "南海区"
        }, {
          "label": "顺德区"
        }, {
          "label": "三水区"
        }, {
          "label": "高明区"
        }],
        "label": "佛山市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "蓬江区"
        }, {
          "label": "江海区"
        }, {
          "label": "新会区"
        }, {
          "label": "台山市"
        }, {
          "label": "开平市"
        }, {
          "label": "鹤山市"
        }, {
          "label": "恩平市"
        }],
        "label": "江门市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "赤坎区"
        }, {
          "label": "霞山区"
        }, {
          "label": "坡头区"
        }, {
          "label": "麻章区"
        }, {
          "label": "遂溪县"
        }, {
          "label": "徐闻县"
        }, {
          "label": "廉江市"
        }, {
          "label": "雷州市"
        }, {
          "label": "吴川市"
        }],
        "label": "湛江市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "茂南区"
        }, {
          "label": "高州市"
        }, {
          "label": "化州市"
        }, {
          "label": "信宜市"
        }, {
          "label": "电白区"
        }],
        "label": "茂名市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "端州区"
        }, {
          "label": "鼎湖区"
        }, {
          "label": "广宁县"
        }, {
          "label": "怀集县"
        }, {
          "label": "封开县"
        }, {
          "label": "德庆县"
        }, {
          "label": "四会市"
        }, {
          "label": "高要区"
        }],
        "label": "肇庆市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "惠城区"
        }, {
          "label": "惠阳区"
        }, {
          "label": "博罗县"
        }, {
          "label": "惠东县"
        }, {
          "label": "龙门县"
        }],
        "label": "惠州市"
      }, {
        "children": [{
          "label": "市辖区"
        }],
        "label": "东莞市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "01\t石岐区"
        }, {
          "label": "02\t东区"
        }, {
          "label": "03\t火炬区"
        }, {
          "label": "04\t西区"
        }, {
          "label": "05\t南区"
        }, {
          "label": "00\t小榄镇"
        }, {
          "label": "01\t黄圃镇"
        }, {
          "label": "02\t民众镇"
        }, {
          "label": "03\t东凤镇"
        }, {
          "label": "04\t东升镇"
        }, {
          "label": "05\t古镇镇"
        }, {
          "label": "06\t沙溪镇"
        }, {
          "label": "07\t坦洲镇"
        }, {
          "label": "08\t港口镇"
        }, {
          "label": "09\t三角镇"
        }, {
          "label": "10\t横栏镇"
        }, {
          "label": "11\t南头镇"
        }, {
          "label": "12\t阜沙镇"
        }, {
          "label": "13\t南朗镇"
        }, {
          "label": "14\t三乡镇"
        }, {
          "label": "15\t板芙镇"
        }, {
          "label": "16\t大涌镇"
        }, {
          "label": "17\t神湾镇"
        }, {
          "label": "18\t五桂山镇"
        }],
        "label": "中山市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "荔湾区"
        }, {
          "label": "越秀区"
        }, {
          "label": "海珠区"
        }, {
          "label": "天河区"
        }, {
          "label": "白云区"
        }, {
          "label": "黄埔区"
        }, {
          "label": "番禺区"
        }, {
          "label": "花都区"
        }, {
          "label": "南沙区"
        }, {
          "label": "从化区"
        }, {
          "label": "增城区"
        }],
        "label": "广州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "武江区"
        }, {
          "label": "浈江区"
        }, {
          "label": "曲江区"
        }, {
          "label": "始兴县"
        }, {
          "label": "仁化县"
        }, {
          "label": "翁源县"
        }, {
          "label": "乳源瑶族自治县"
        }, {
          "label": "新丰县"
        }, {
          "label": "乐昌市"
        }, {
          "label": "南雄市"
        }],
        "label": "韶关市"
      }],
      "label": "广东省"
    }, {
      "children": [{
        "children": [{
          "label": "凤山县"
        }, {
          "label": "东兰县"
        }, {
          "label": "罗城仫佬族自治县"
        }, {
          "label": "环江毛南族自治县"
        }, {
          "label": "巴马瑶族自治县"
        }, {
          "label": "都安瑶族自治县"
        }, {
          "label": "大化瑶族自治县"
        }, {
          "label": "宜州区"
        }, {
          "label": "市辖区"
        }, {
          "label": "金城江区"
        }, {
          "label": "南丹县"
        }, {
          "label": "天峨县"
        }],
        "label": "河池市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "兴宾区"
        }, {
          "label": "忻城县"
        }, {
          "label": "象州县"
        }, {
          "label": "武宣县"
        }, {
          "label": "金秀瑶族自治县"
        }, {
          "label": "合山市"
        }],
        "label": "来宾市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "江洲区"
        }, {
          "label": "扶绥县"
        }, {
          "label": "宁明县"
        }, {
          "label": "龙州县"
        }, {
          "label": "大新县"
        }, {
          "label": "天等县"
        }, {
          "label": "凭祥市"
        }],
        "label": "崇左市"
      }, {
        "children": [{
          "label": "临桂区"
        }, {
          "label": "荔浦市"
        }, {
          "label": "市辖区"
        }, {
          "label": "秀峰区"
        }, {
          "label": "叠彩区"
        }, {
          "label": "象山区"
        }, {
          "label": "七星区"
        }, {
          "label": "雁山区"
        }, {
          "label": "阳朔县"
        }, {
          "label": "灵川县"
        }, {
          "label": "全州县"
        }, {
          "label": "兴安县"
        }, {
          "label": "永福县"
        }, {
          "label": "灌阳县"
        }, {
          "label": "龙胜各族自治县"
        }, {
          "label": "资源县"
        }, {
          "label": "平乐县"
        }, {
          "label": "恭城瑶族自治县"
        }],
        "label": "桂林市"
      }, {
        "children": [{
          "label": "福绵区"
        }, {
          "label": "市辖区"
        }, {
          "label": "玉州区"
        }, {
          "label": "容县"
        }, {
          "label": "陆川县"
        }, {
          "label": "博白县"
        }, {
          "label": "兴业县"
        }, {
          "label": "北流市"
        }],
        "label": "玉林市"
      }, {
        "children": [{
          "label": "靖西市"
        }, {
          "label": "市辖区"
        }, {
          "label": "右江区"
        }, {
          "label": "田阳县"
        }, {
          "label": "田东县"
        }, {
          "label": "平果县"
        }, {
          "label": "德保县"
        }, {
          "label": "那坡县"
        }, {
          "label": "凌云县"
        }, {
          "label": "乐业县"
        }, {
          "label": "田林县"
        }, {
          "label": "西林县"
        }, {
          "label": "隆林各族自治县"
        }],
        "label": "百色市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "兴宁区"
        }, {
          "label": "青秀区"
        }, {
          "label": "武鸣区"
        }, {
          "label": "江南区"
        }, {
          "label": "西乡塘区"
        }, {
          "label": "良庆区"
        }, {
          "label": "邕宁区"
        }, {
          "label": "隆安县"
        }, {
          "label": "马山县"
        }, {
          "label": "上林县"
        }, {
          "label": "宾阳县"
        }, {
          "label": "横县"
        }],
        "label": "南宁市"
      }, {
        "children": [{
          "label": "龙圩区"
        }, {
          "label": "市辖区"
        }, {
          "label": "万秀区"
        }, {
          "label": "长洲区"
        }, {
          "label": "苍梧县"
        }, {
          "label": "藤县"
        }, {
          "label": "蒙山县"
        }, {
          "label": "岑溪市"
        }],
        "label": "梧州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "海城区"
        }, {
          "label": "银海区"
        }, {
          "label": "铁山港区"
        }, {
          "label": "合浦县"
        }],
        "label": "北海市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "港口区"
        }, {
          "label": "防城区"
        }, {
          "label": "上思县"
        }, {
          "label": "东兴市"
        }],
        "label": "防城港市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "钦南区"
        }, {
          "label": "钦北区"
        }, {
          "label": "灵山县"
        }, {
          "label": "浦北县"
        }],
        "label": "钦州市"
      }, {
        "children": [{
          "label": "柳江区"
        }, {
          "label": "柳北区"
        }, {
          "label": "柳城县"
        }, {
          "label": "鹿寨县"
        }, {
          "label": "融安县"
        }, {
          "label": "融水苗族自治县"
        }, {
          "label": "三江侗族自治县"
        }, {
          "label": "市辖区"
        }, {
          "label": "城中区"
        }, {
          "label": "鱼峰区"
        }, {
          "label": "柳南区"
        }],
        "label": "柳州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "港北区"
        }, {
          "label": "港南区"
        }, {
          "label": "覃塘区"
        }, {
          "label": "平南县"
        }, {
          "label": "桂平市"
        }],
        "label": "贵港市"
      }, {
        "children": [{
          "label": "平桂区"
        }, {
          "label": "市辖区"
        }, {
          "label": "八步区"
        }, {
          "label": "昭平县"
        }, {
          "label": "钟山县"
        }, {
          "label": "富川瑶族自治县"
        }],
        "label": "贺州市"
      }],
      "label": "广西壮族自治区"
    }, {
      "children": [{
        "children": [{
          "label": "崖州区"
        }, {
          "label": "海棠区"
        }, {
          "label": "吉阳区"
        }, {
          "label": "天涯区"
        }, {
          "label": "市辖区"
        }],
        "label": "三亚市"
      }, {
        "children": [{
          "label": "儋州市"
        }],
        "label": "儋州市"
      }, {
        "children": [{
          "label": "文昌市"
        }, {
          "label": "万宁市"
        }, {
          "label": "东方市"
        }, {
          "label": "定安县"
        }, {
          "label": "屯昌县"
        }, {
          "label": "澄迈县"
        }, {
          "label": "临高县"
        }, {
          "label": "白沙黎族自治县"
        }, {
          "label": "昌江黎族自治县"
        }, {
          "label": "乐东黎族自治县"
        }, {
          "label": "陵水黎族自治县"
        }, {
          "label": "保亭黎族苗族自治县"
        }, {
          "label": "琼中黎族苗族自治县"
        }, {
          "label": "五指山市"
        }, {
          "label": "琼海市"
        }],
        "label": "省直辖县级行政区划"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "秀英区"
        }, {
          "label": "龙华区"
        }, {
          "label": "琼山区"
        }, {
          "label": "美兰区"
        }],
        "label": "海口市"
      }],
      "label": "海南省"
    }, {
      "children": [{
        "children": [{
          "label": "城口县"
        }, {
          "label": "彭水苗族土家族自治县"
        }, {
          "label": "垫江县"
        }, {
          "label": "璧山区"
        }, {
          "label": "铜梁区"
        }, {
          "label": "潼南区"
        }, {
          "label": "荣昌区"
        }, {
          "label": "开州区"
        }, {
          "label": "梁平区"
        }, {
          "label": "武隆区"
        }, {
          "label": "万州区"
        }, {
          "label": "涪陵区"
        }, {
          "label": "渝中区"
        }, {
          "label": "大渡口区"
        }, {
          "label": "江北区"
        }, {
          "label": "沙坪坝区"
        }, {
          "label": "九龙坡区"
        }, {
          "label": "南岸区"
        }, {
          "label": "北碚区"
        }, {
          "label": "綦江区"
        }, {
          "label": "大足区"
        }, {
          "label": "渝北区"
        }, {
          "label": "巴南区"
        }, {
          "label": "黔江区"
        }, {
          "label": "长寿区"
        }, {
          "label": "江津区"
        }, {
          "label": "合川区"
        }, {
          "label": "永川区"
        }, {
          "label": "南川区"
        }, {
          "label": "丰都县"
        }],
        "label": "重庆市"
      }],
      "label": "重庆市"
    }, {
      "children": [{
        "children": [{
          "label": "市辖区"
        }, {
          "label": "涪城区"
        }, {
          "label": "游仙区"
        }, {
          "label": "三台县"
        }, {
          "label": "盐亭县"
        }, {
          "label": "梓潼县"
        }, {
          "label": "北川羌族自治县"
        }, {
          "label": "平武县"
        }, {
          "label": "江油市"
        }, {
          "label": "安州区"
        }],
        "label": "绵阳市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "利州区"
        }, {
          "label": "元坝区"
        }, {
          "label": "朝天区"
        }, {
          "label": "旺苍县"
        }, {
          "label": "青川县"
        }, {
          "label": "剑阁县"
        }, {
          "label": "苍溪县"
        }],
        "label": "广元市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "市中区"
        }, {
          "label": "东兴区"
        }, {
          "label": "威远县"
        }, {
          "label": "资中县"
        }, {
          "label": "隆昌市"
        }],
        "label": "内江市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "市中区"
        }, {
          "label": "沙湾区"
        }, {
          "label": "五通桥区"
        }, {
          "label": "金口河区"
        }, {
          "label": "犍为县"
        }, {
          "label": "井研县"
        }, {
          "label": "夹江县"
        }, {
          "label": "沐川县"
        }, {
          "label": "峨边彝族自治县"
        }, {
          "label": "马边彝族自治县"
        }, {
          "label": "峨眉山市"
        }],
        "label": "乐山市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "自流井区"
        }, {
          "label": "贡井区"
        }, {
          "label": "大安区"
        }, {
          "label": "沿滩区"
        }, {
          "label": "荣县"
        }, {
          "label": "富顺县"
        }],
        "label": "自贡市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "东区"
        }, {
          "label": "西区"
        }, {
          "label": "仁和区"
        }, {
          "label": "米易县"
        }, {
          "label": "盐边县"
        }],
        "label": "攀枝花市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "江阳区"
        }, {
          "label": "纳溪区"
        }, {
          "label": "龙马潭区"
        }, {
          "label": "泸县"
        }, {
          "label": "合江县"
        }, {
          "label": "叙永县"
        }, {
          "label": "古蔺县"
        }],
        "label": "泸州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "东坡区"
        }, {
          "label": "仁寿县"
        }, {
          "label": "洪雅县"
        }, {
          "label": "丹棱县"
        }, {
          "label": "青神县"
        }, {
          "label": "彭山区"
        }],
        "label": "眉山市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "翠屏区"
        }, {
          "label": "南溪区"
        }, {
          "label": "江安县"
        }, {
          "label": "长宁县"
        }, {
          "label": "高县"
        }, {
          "label": "珙县"
        }, {
          "label": "筠连县"
        }, {
          "label": "兴文县"
        }, {
          "label": "屏山县"
        }, {
          "label": "叙州区"
        }],
        "label": "宜宾市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "广安区"
        }, {
          "label": "岳池县"
        }, {
          "label": "武胜县"
        }, {
          "label": "邻水县"
        }, {
          "label": "华蓥市"
        }, {
          "label": "前锋区"
        }],
        "label": "广安市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "旌阳区"
        }, {
          "label": "中江县"
        }, {
          "label": "广汉市"
        }, {
          "label": "什邡市"
        }, {
          "label": "绵竹市"
        }, {
          "label": "罗江区"
        }],
        "label": "德阳市"
      }, {
        "children": [{
          "label": "盐源县"
        }, {
          "label": "德昌县"
        }, {
          "label": "会理县"
        }, {
          "label": "会东县"
        }, {
          "label": "宁南县"
        }, {
          "label": "普格县"
        }, {
          "label": "布拖县"
        }, {
          "label": "金阳县"
        }, {
          "label": "昭觉县"
        }, {
          "label": "喜德县"
        }, {
          "label": "冕宁县"
        }, {
          "label": "越西县"
        }, {
          "label": "甘洛县"
        }, {
          "label": "美姑县"
        }, {
          "label": "雷波县"
        }, {
          "label": "西昌市"
        }, {
          "label": "木里藏族自治县"
        }],
        "label": "凉山彝族自治州"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "通川区"
        }, {
          "label": "宣汉县"
        }, {
          "label": "开江县"
        }, {
          "label": "大竹县"
        }, {
          "label": "渠县"
        }, {
          "label": "万源市"
        }, {
          "label": "达川区"
        }],
        "label": "达州市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "雨城区"
        }, {
          "label": "荥经县"
        }, {
          "label": "汉源县"
        }, {
          "label": "石棉县"
        }, {
          "label": "天全县"
        }, {
          "label": "芦山县"
        }, {
          "label": "宝兴县"
        }, {
          "label": "名山区"
        }],
        "label": "雅安市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "巴州区"
        }, {
          "label": "通江县"
        }, {
          "label": "南江县"
        }, {
          "label": "平昌县"
        }, {
          "label": "恩阳区"
        }],
        "label": "巴中市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "雁江区"
        }, {
          "label": "安岳县"
        }, {
          "label": "乐至县"
        }],
        "label": "资阳市"
      }, {
        "children": [{
          "label": "汶川县"
        }, {
          "label": "理县"
        }, {
          "label": "茂县"
        }, {
          "label": "松潘县"
        }, {
          "label": "九寨沟县"
        }, {
          "label": "金川县"
        }, {
          "label": "小金县"
        }, {
          "label": "黑水县"
        }, {
          "label": "壤塘县"
        }, {
          "label": "阿坝县"
        }, {
          "label": "若尔盖县"
        }, {
          "label": "红原县"
        }, {
          "label": "马尔康市"
        }],
        "label": "阿坝藏族羌族自治州"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "船山区"
        }, {
          "label": "安居区"
        }, {
          "label": "蓬溪县"
        }, {
          "label": "射洪县"
        }, {
          "label": "大英县"
        }],
        "label": "遂宁市"
      }, {
        "children": [{
          "label": "成华区"
        }, {
          "label": "龙泉驿区"
        }, {
          "label": "青白江区"
        }, {
          "label": "新都区"
        }, {
          "label": "温江区"
        }, {
          "label": "金堂县"
        }, {
          "label": "大邑县"
        }, {
          "label": "蒲江县"
        }, {
          "label": "新津县"
        }, {
          "label": "都江堰市"
        }, {
          "label": "彭州市"
        }, {
          "label": "邛崃市"
        }, {
          "label": "崇州市"
        }, {
          "label": "简阳市"
        }, {
          "label": "双流区"
        }, {
          "label": "双流区"
        }, {
          "label": "郫都区"
        }, {
          "label": "简阳市"
        }, {
          "label": "市辖区"
        }, {
          "label": "锦江区"
        }, {
          "label": "青羊区"
        }, {
          "label": "金牛区"
        }, {
          "label": "武侯区"
        }],
        "label": "成都市"
      }, {
        "children": [{
          "label": "阆中市"
        }, {
          "label": "市辖区"
        }, {
          "label": "顺庆区"
        }, {
          "label": "高坪区"
        }, {
          "label": "嘉陵区"
        }, {
          "label": "南部县"
        }, {
          "label": "营山县"
        }, {
          "label": "蓬安县"
        }, {
          "label": "仪陇县"
        }, {
          "label": "西充县"
        }],
        "label": "南充市"
      }, {
        "children": [{
          "label": "泸定县"
        }, {
          "label": "丹巴县"
        }, {
          "label": "九龙县"
        }, {
          "label": "雅江县"
        }, {
          "label": "道孚县"
        }, {
          "label": "炉霍县"
        }, {
          "label": "甘孜县"
        }, {
          "label": "新龙县"
        }, {
          "label": "德格县"
        }, {
          "label": "白玉县"
        }, {
          "label": "石渠县"
        }, {
          "label": "色达县"
        }, {
          "label": "理塘县"
        }, {
          "label": "巴塘县"
        }, {
          "label": "乡城县"
        }, {
          "label": "稻城县"
        }, {
          "label": "得荣县"
        }, {
          "label": "康定市"
        }],
        "label": "甘孜藏族自治州"
      }],
      "label": "四川省"
    }, {
      "children": [{
        "children": [{
          "label": "瓮安县"
        }, {
          "label": "独山县"
        }, {
          "label": "平塘县"
        }, {
          "label": "罗甸县"
        }, {
          "label": "长顺县"
        }, {
          "label": "龙里县"
        }, {
          "label": "惠水县"
        }, {
          "label": "三都水族自治县"
        }, {
          "label": "都匀市"
        }, {
          "label": "福泉市"
        }, {
          "label": "荔波县"
        }, {
          "label": "贵定县"
        }],
        "label": "黔南布依族苗族自治州"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "碧江区"
        }, {
          "label": "万山区"
        }, {
          "label": "江口县"
        }, {
          "label": "玉屏侗族自治县"
        }, {
          "label": "石阡县"
        }, {
          "label": "思南县"
        }, {
          "label": "印江土家族苗族自治县"
        }, {
          "label": "德江县"
        }, {
          "label": "沿河土家族自治县"
        }, {
          "label": "松桃苗族自治县"
        }],
        "label": "铜仁市"
      }, {
        "children": [{
          "label": "兴义市"
        }, {
          "label": "普安县"
        }, {
          "label": "晴隆县"
        }, {
          "label": "贞丰县"
        }, {
          "label": "望谟县"
        }, {
          "label": "册亨县"
        }, {
          "label": "安龙县"
        }, {
          "label": "兴仁市"
        }],
        "label": "黔西南布依族苗族自治州"
      }, {
        "children": [{
          "label": "凯里市"
        }, {
          "label": "黄平县"
        }, {
          "label": "施秉县"
        }, {
          "label": "三穗县"
        }, {
          "label": "镇远县"
        }, {
          "label": "岑巩县"
        }, {
          "label": "天柱县"
        }, {
          "label": "锦屏县"
        }, {
          "label": "剑河县"
        }, {
          "label": "台江县"
        }, {
          "label": "黎平县"
        }, {
          "label": "榕江县"
        }, {
          "label": "从江县"
        }, {
          "label": "雷山县"
        }, {
          "label": "麻江县"
        }, {
          "label": "丹寨县"
        }],
        "label": "黔东南苗族侗族自治州"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "南明区"
        }, {
          "label": "云岩区"
        }, {
          "label": "花溪区"
        }, {
          "label": "乌当区"
        }, {
          "label": "白云区"
        }, {
          "label": "开阳县"
        }, {
          "label": "息烽县"
        }, {
          "label": "修文县"
        }, {
          "label": "清镇市"
        }, {
          "label": "观山湖区"
        }],
        "label": "贵阳市"
      }, {
        "children": [{
          "label": "钟山区"
        }, {
          "label": "六枝特区"
        }, {
          "label": "水城县"
        }, {
          "label": "盘州市"
        }],
        "label": "六盘水市"
      }, {
        "children": [{
          "label": "桐梓县"
        }, {
          "label": "绥阳县"
        }, {
          "label": "正安县"
        }, {
          "label": "道真仡佬族苗族自治县"
        }, {
          "label": "务川仡佬族苗族自治县"
        }, {
          "label": "凤冈县"
        }, {
          "label": "湄潭县"
        }, {
          "label": "余庆县"
        }, {
          "label": "习水县"
        }, {
          "label": "赤水市"
        }, {
          "label": "仁怀市"
        }, {
          "label": "市辖区"
        }, {
          "label": "红花岗区"
        }, {
          "label": "汇川区"
        }, {
          "label": "播州区"
        }],
        "label": "遵义市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "西秀区"
        }, {
          "label": "普定县"
        }, {
          "label": "镇宁布依族苗族自治县"
        }, {
          "label": "关岭布依族苗族自治县"
        }, {
          "label": "紫云苗族布依族自治县"
        }, {
          "label": "平坝区"
        }],
        "label": "安顺市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "七星关区"
        }, {
          "label": "大方县"
        }, {
          "label": "黔西县"
        }, {
          "label": "金沙县"
        }, {
          "label": "织金县"
        }, {
          "label": "纳雍县"
        }, {
          "label": "威宁彝族回族苗族自治县"
        }, {
          "label": "赫章县"
        }],
        "label": "毕节市"
      }],
      "label": "贵州省"
    }, {
      "children": [{
        "children": [{
          "label": "隆阳区"
        }, {
          "label": "施甸县"
        }, {
          "label": "龙陵县"
        }, {
          "label": "昌宁县"
        }, {
          "label": "腾冲市"
        }, {
          "label": "市辖区"
        }],
        "label": "保山市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "昭阳区"
        }, {
          "label": "鲁甸县"
        }, {
          "label": "巧家县"
        }, {
          "label": "盐津县"
        }, {
          "label": "大关县"
        }, {
          "label": "永善县"
        }, {
          "label": "绥江县"
        }, {
          "label": "镇雄县"
        }, {
          "label": "彝良县"
        }, {
          "label": "威信县"
        }, {
          "label": "水富市"
        }],
        "label": "昭通市"
      }, {
        "children": [{
          "label": "凤庆县"
        }, {
          "label": "云县"
        }, {
          "label": "永德县"
        }, {
          "label": "镇康县"
        }, {
          "label": "双江拉祜族佤族布朗族傣族自治县"
        }, {
          "label": "耿马傣族佤族自治县"
        }, {
          "label": "沧源佤族自治县"
        }, {
          "label": "市辖区"
        }, {
          "label": "临翔区"
        }],
        "label": "临沧市"
      }, {
        "children": [{
          "label": "楚雄市"
        }, {
          "label": "双柏县"
        }, {
          "label": "牟定县"
        }, {
          "label": "南华县"
        }, {
          "label": "姚安县"
        }, {
          "label": "大姚县"
        }, {
          "label": "永仁县"
        }, {
          "label": "元谋县"
        }, {
          "label": "武定县"
        }, {
          "label": "禄丰县"
        }],
        "label": "楚雄彝族自治州"
      }, {
        "children": [{
          "label": "个旧市"
        }, {
          "label": "开远市"
        }, {
          "label": "蒙自市"
        }, {
          "label": "屏边苗族自治县"
        }, {
          "label": "建水县"
        }, {
          "label": "石屏县"
        }, {
          "label": "泸西县"
        }, {
          "label": "元阳县"
        }, {
          "label": "红河县"
        }, {
          "label": "金平苗族瑶族傣族自治县"
        }, {
          "label": "绿春县"
        }, {
          "label": "河口瑶族自治县"
        }, {
          "label": "弥勒市"
        }],
        "label": "红河哈尼族彝族自治州"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "古城区"
        }, {
          "label": "玉龙纳西族自治县"
        }, {
          "label": "永胜县"
        }, {
          "label": "华坪县"
        }, {
          "label": "宁蒗彝族自治县"
        }],
        "label": "丽江市"
      }, {
        "children": [{
          "label": "景谷傣族彝族自治县"
        }, {
          "label": "镇沅彝族哈尼族拉祜族自治县"
        }, {
          "label": "江城哈尼族彝族自治县"
        }, {
          "label": "市辖区"
        }, {
          "label": "思茅区"
        }, {
          "label": "宁洱哈尼族彝族自治县"
        }, {
          "label": "墨江哈尼族自治县"
        }, {
          "label": "景东彝族自治县"
        }, {
          "label": "孟连傣族拉祜族佤族自治县"
        }, {
          "label": "澜沧拉祜族自治县"
        }, {
          "label": "西盟佤族自治县"
        }],
        "label": "普洱市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "麒麟区"
        }, {
          "label": "陆良县"
        }, {
          "label": "师宗县"
        }, {
          "label": "罗平县"
        }, {
          "label": "富源县"
        }, {
          "label": "会泽县"
        }, {
          "label": "宣威市"
        }, {
          "label": "沾益区"
        }, {
          "label": "马龙区"
        }],
        "label": "曲靖市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "红塔区"
        }, {
          "label": "澄江县"
        }, {
          "label": "通海县"
        }, {
          "label": "华宁县"
        }, {
          "label": "易门县"
        }, {
          "label": "峨山彝族自治县"
        }, {
          "label": "新平彝族傣族自治县"
        }, {
          "label": "元江哈尼族彝族傣族自治县"
        }, {
          "label": "江川区"
        }],
        "label": "玉溪市"
      }, {
        "children": [{
          "label": "文山市"
        }, {
          "label": "砚山县"
        }, {
          "label": "西畴县"
        }, {
          "label": "麻栗坡县"
        }, {
          "label": "马关县"
        }, {
          "label": "丘北县"
        }, {
          "label": "广南县"
        }, {
          "label": "富宁县"
        }],
        "label": "文山壮族苗族自治州"
      }, {
        "children": [{
          "label": "景洪市"
        }, {
          "label": "勐海县"
        }, {
          "label": "勐腊县"
        }],
        "label": "西双版纳傣族自治州"
      }, {
        "children": [{
          "label": "鹤庆县"
        }, {
          "label": "大理市"
        }, {
          "label": "漾濞彝族自治县"
        }, {
          "label": "祥云县"
        }, {
          "label": "宾川县"
        }, {
          "label": "弥渡县"
        }, {
          "label": "南涧彝族自治县"
        }, {
          "label": "巍山彝族回族自治县"
        }, {
          "label": "永平县"
        }, {
          "label": "云龙县"
        }, {
          "label": "洱源县"
        }, {
          "label": "剑川县"
        }],
        "label": "大理白族自治州"
      }, {
        "children": [{
          "label": "宜良县"
        }, {
          "label": "石林彝族自治县"
        }, {
          "label": "嵩明县"
        }, {
          "label": "禄劝彝族苗族自治县"
        }, {
          "label": "寻甸回族彝族自治县"
        }, {
          "label": "安宁市"
        }, {
          "label": "市辖区"
        }, {
          "label": "五华区"
        }, {
          "label": "盘龙区"
        }, {
          "label": "官渡区"
        }, {
          "label": "西山区"
        }, {
          "label": "东川区"
        }, {
          "label": "呈贡区"
        }, {
          "label": "富民县"
        }, {
          "label": "晋宁区"
        }],
        "label": "昆明市"
      }, {
        "children": [{
          "label": "瑞丽市"
        }, {
          "label": "芒市"
        }, {
          "label": "梁河县"
        }, {
          "label": "盈江县"
        }, {
          "label": "陇川县"
        }],
        "label": "德宏傣族景颇族自治州"
      }, {
        "children": [{
          "label": "福贡县"
        }, {
          "label": "贡山独龙族怒族自治县"
        }, {
          "label": "兰坪白族普米族自治县"
        }, {
          "label": "泸水市"
        }],
        "label": "怒江傈僳族自治州"
      }, {
        "children": [{
          "label": "德钦县"
        }, {
          "label": "维西傈僳族自治县"
        }, {
          "label": "香格里拉市"
        }],
        "label": "迪庆藏族自治州"
      }],
      "label": "云南省"
    }, {
      "children": [{
        "children": [{
          "label": "洛隆县"
        }, {
          "label": "边坝县"
        }, {
          "label": "卡若区"
        }, {
          "label": "江达县"
        }, {
          "label": "贡觉县"
        }, {
          "label": "类乌齐县"
        }, {
          "label": "丁青县"
        }, {
          "label": "察雅县"
        }, {
          "label": "八宿县"
        }, {
          "label": "左贡县"
        }, {
          "label": "芒康县"
        }],
        "label": "昌都市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "城关区"
        }, {
          "label": "林周县"
        }, {
          "label": "当雄县"
        }, {
          "label": "尼木县"
        }, {
          "label": "曲水县"
        }, {
          "label": "墨竹工卡县"
        }, {
          "label": "堆龙德庆区"
        }, {
          "label": "达孜区"
        }],
        "label": "拉萨市"
      }, {
        "children": [{
          "label": "革吉县"
        }, {
          "label": "改则县"
        }, {
          "label": "措勤县"
        }, {
          "label": "普兰县"
        }, {
          "label": "札达县"
        }, {
          "label": "噶尔县"
        }, {
          "label": "日土县"
        }],
        "label": "阿里地区"
      }, {
        "children": [{
          "label": "巴宜区"
        }, {
          "label": "工布江达县"
        }, {
          "label": "米林县"
        }, {
          "label": "墨脱县"
        }, {
          "label": "波密县"
        }, {
          "label": "察隅县"
        }, {
          "label": "朗县"
        }],
        "label": "林芝市"
      }, {
        "children": [{
          "label": "乃东区"
        }, {
          "label": "扎囊县"
        }, {
          "label": "贡嘎县"
        }, {
          "label": "桑日县"
        }, {
          "label": "琼结县"
        }, {
          "label": "曲松县"
        }, {
          "label": "措美县"
        }, {
          "label": "洛扎县"
        }, {
          "label": "加查县"
        }, {
          "label": "隆子县"
        }, {
          "label": "错那县"
        }, {
          "label": "浪卡子县"
        }],
        "label": "山南市"
      }, {
        "children": [{
          "label": "比如县"
        }, {
          "label": "聂荣县"
        }, {
          "label": "安多县"
        }, {
          "label": "申扎县"
        }, {
          "label": "索县"
        }, {
          "label": "班戈县"
        }, {
          "label": "巴青县"
        }, {
          "label": "尼玛县"
        }, {
          "label": "双湖县"
        }, {
          "label": "色尼区"
        }, {
          "label": "嘉黎县"
        }],
        "label": "那曲市"
      }, {
        "children": [{
          "label": "桑珠孜区"
        }, {
          "label": "南木林县"
        }, {
          "label": "江孜县"
        }, {
          "label": "定日县"
        }, {
          "label": "萨迦县"
        }, {
          "label": "拉孜县"
        }, {
          "label": "昂仁县"
        }, {
          "label": "谢通门县"
        }, {
          "label": "白朗县"
        }, {
          "label": "仁布县"
        }, {
          "label": "康马县"
        }, {
          "label": "定结县"
        }, {
          "label": "仲巴县"
        }, {
          "label": "亚东县"
        }, {
          "label": "吉隆县"
        }, {
          "label": "聂拉木县"
        }, {
          "label": "萨嘎县"
        }, {
          "label": "岗巴县"
        }],
        "label": "日喀则市"
      }],
      "label": "西藏"
    }, {
      "children": [{
        "children": [{
          "label": "渭城区"
        }, {
          "label": "三原县"
        }, {
          "label": "泾阳县"
        }, {
          "label": "乾县"
        }, {
          "label": "礼泉县"
        }, {
          "label": "永寿县"
        }, {
          "label": "长武县"
        }, {
          "label": "旬邑县"
        }, {
          "label": "淳化县"
        }, {
          "label": "武功县"
        }, {
          "label": "兴平市"
        }, {
          "label": "彬州市"
        }, {
          "label": "市辖区"
        }, {
          "label": "秦都区"
        }, {
          "label": "杨陵区"
        }],
        "label": "咸阳市"
      }, {
        "children": [{
          "label": "华州区"
        }, {
          "label": "市辖区"
        }, {
          "label": "临渭区"
        }, {
          "label": "潼关县"
        }, {
          "label": "大荔县"
        }, {
          "label": "合阳县"
        }, {
          "label": "澄城县"
        }, {
          "label": "蒲城县"
        }, {
          "label": "白水县"
        }, {
          "label": "富平县"
        }, {
          "label": "韩城市"
        }, {
          "label": "华阴市"
        }],
        "label": "渭南市"
      }, {
        "children": [{
          "label": "安塞区"
        }, {
          "label": "富县"
        }, {
          "label": "洛川县"
        }, {
          "label": "宜川县"
        }, {
          "label": "黄龙县"
        }, {
          "label": "黄陵县"
        }, {
          "label": "市辖区"
        }, {
          "label": "宝塔区"
        }, {
          "label": "延长县"
        }, {
          "label": "延川县"
        }, {
          "label": "子长县"
        }, {
          "label": "志丹县"
        }, {
          "label": "吴起县"
        }, {
          "label": "甘泉县"
        }],
        "label": "延安市"
      }, {
        "children": [{
          "label": "南郑区"
        }, {
          "label": "市辖区"
        }, {
          "label": "汉台区"
        }, {
          "label": "城固县"
        }, {
          "label": "洋县"
        }, {
          "label": "西乡县"
        }, {
          "label": "勉县"
        }, {
          "label": "宁强县"
        }, {
          "label": "略阳县"
        }, {
          "label": "镇巴县"
        }, {
          "label": "留坝县"
        }, {
          "label": "佛坪县"
        }],
        "label": "汉中市"
      }, {
        "children": [{
          "label": "横山区"
        }, {
          "label": "神木市"
        }, {
          "label": "市辖区"
        }, {
          "label": "榆阳区"
        }, {
          "label": "府谷县"
        }, {
          "label": "靖边县"
        }, {
          "label": "定边县"
        }, {
          "label": "绥德县"
        }, {
          "label": "米脂县"
        }, {
          "label": "佳县"
        }, {
          "label": "吴堡县"
        }, {
          "label": "清涧县"
        }, {
          "label": "子洲县"
        }],
        "label": "榆林市"
      }, {
        "children": [{
          "label": "岐山县"
        }, {
          "label": "麟游县"
        }, {
          "label": "凤县"
        }, {
          "label": "太白县"
        }, {
          "label": "扶风县"
        }, {
          "label": "眉县"
        }, {
          "label": "陇县"
        }, {
          "label": "千阳县"
        }, {
          "label": "市辖区"
        }, {
          "label": "渭滨区"
        }, {
          "label": "金台区"
        }, {
          "label": "陈仓区"
        }, {
          "label": "凤翔县"
        }],
        "label": "宝鸡市"
      }, {
        "children": [{
          "label": "高陵区"
        }, {
          "label": "鄠邑区"
        }, {
          "label": "市辖区"
        }, {
          "label": "新城区"
        }, {
          "label": "碑林区"
        }, {
          "label": "莲湖区"
        }, {
          "label": "灞桥区"
        }, {
          "label": "未央区"
        }, {
          "label": "雁塔区"
        }, {
          "label": "阎良区"
        }, {
          "label": "临潼区"
        }, {
          "label": "长安区"
        }, {
          "label": "蓝田县"
        }, {
          "label": "周至县"
        }],
        "label": "西安市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "王益区"
        }, {
          "label": "印台区"
        }, {
          "label": "耀州区"
        }, {
          "label": "宜君县"
        }],
        "label": "铜川市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "汉滨区"
        }, {
          "label": "汉阴县"
        }, {
          "label": "石泉县"
        }, {
          "label": "宁陕县"
        }, {
          "label": "紫阳县"
        }, {
          "label": "岚皋县"
        }, {
          "label": "平利县"
        }, {
          "label": "镇坪县"
        }, {
          "label": "旬阳县"
        }, {
          "label": "白河县"
        }],
        "label": "安康市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "商州区"
        }, {
          "label": "洛南县"
        }, {
          "label": "丹凤县"
        }, {
          "label": "商南县"
        }, {
          "label": "山阳县"
        }, {
          "label": "镇安县"
        }, {
          "label": "柞水县"
        }],
        "label": "商洛市"
      }],
      "label": "陕西省"
    }, {
      "children": [{
        "children": [{
          "label": "安定区"
        }, {
          "label": "通渭县"
        }, {
          "label": "陇西县"
        }, {
          "label": "渭源县"
        }, {
          "label": "临洮县"
        }, {
          "label": "漳县"
        }, {
          "label": "岷县"
        }, {
          "label": "市辖区"
        }],
        "label": "定西市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "武都区"
        }, {
          "label": "成县"
        }, {
          "label": "文县"
        }, {
          "label": "宕昌县"
        }, {
          "label": "康县"
        }, {
          "label": "西和县"
        }, {
          "label": "礼县"
        }, {
          "label": "徽县"
        }, {
          "label": "两当县"
        }],
        "label": "陇南市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "城关区"
        }, {
          "label": "七里河区"
        }, {
          "label": "西固区"
        }, {
          "label": "安宁区"
        }, {
          "label": "红古区"
        }, {
          "label": "永登县"
        }, {
          "label": "皋兰县"
        }, {
          "label": "榆中县"
        }],
        "label": "兰州市"
      }, {
        "children": [{
          "label": "市辖区"
        }],
        "label": "嘉峪关市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "金川区"
        }, {
          "label": "永昌县"
        }],
        "label": "金昌市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "白银区"
        }, {
          "label": "平川区"
        }, {
          "label": "靖远县"
        }, {
          "label": "会宁县"
        }, {
          "label": "景泰县"
        }],
        "label": "白银市"
      }, {
        "children": [{
          "label": "临夏县"
        }, {
          "label": "康乐县"
        }, {
          "label": "永靖县"
        }, {
          "label": "广河县"
        }, {
          "label": "和政县"
        }, {
          "label": "东乡族自治县"
        }, {
          "label": "积石山保安族东乡族撒拉族自治县"
        }, {
          "label": "临夏市"
        }],
        "label": "临夏回族自治州"
      }, {
        "children": [{
          "label": "合作市"
        }, {
          "label": "临潭县"
        }, {
          "label": "卓尼县"
        }, {
          "label": "舟曲县"
        }, {
          "label": "迭部县"
        }, {
          "label": "玛曲县"
        }, {
          "label": "碌曲县"
        }, {
          "label": "夏河县"
        }],
        "label": "甘南藏族自治州"
      }, {
        "children": [{
          "label": "古浪县"
        }, {
          "label": "天祝藏族自治县"
        }, {
          "label": "市辖区"
        }, {
          "label": "凉州区"
        }, {
          "label": "民勤县"
        }],
        "label": "武威市"
      }, {
        "children": [{
          "label": "武山县"
        }, {
          "label": "张家川回族自治县"
        }, {
          "label": "市辖区"
        }, {
          "label": "秦州区"
        }, {
          "label": "麦积区"
        }, {
          "label": "清水县"
        }, {
          "label": "秦安县"
        }, {
          "label": "甘谷县"
        }],
        "label": "天水市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "甘州区"
        }, {
          "label": "肃南裕固族自治县"
        }, {
          "label": "民乐县"
        }, {
          "label": "临泽县"
        }, {
          "label": "高台县"
        }, {
          "label": "山丹县"
        }],
        "label": "张掖市"
      }, {
        "children": [{
          "label": "华亭市"
        }, {
          "label": "市辖区"
        }, {
          "label": "崆峒区"
        }, {
          "label": "泾川县"
        }, {
          "label": "灵台县"
        }, {
          "label": "崇信县"
        }, {
          "label": "庄浪县"
        }, {
          "label": "静宁县"
        }],
        "label": "平凉市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "肃州区"
        }, {
          "label": "金塔县"
        }, {
          "label": "瓜州县"
        }, {
          "label": "肃北蒙古族自治县"
        }, {
          "label": "阿克塞哈萨克族自治县"
        }, {
          "label": "玉门市"
        }, {
          "label": "敦煌市"
        }],
        "label": "酒泉市"
      }, {
        "children": [{
          "label": "市辖区"
        }, {
          "label": "西峰区"
        }, {
          "label": "庆城县"
        }, {
          "label": "环县"
        }, {
          "label": "华池县"
        }, {
          "label": "合水县"
        }, {
          "label": "正宁县"
        }, {
          "label": "宁县"
        }, {
          "label": "镇原县"
        }],
        "label": "庆阳市"
      }],
      "label": "甘肃省"
    }];
    return chinaArea;
  }


}



// WEBPACK FOOTER //
// ./src/tool/sinosafeAccidentDistrict.js